import Cropper from 'react-easy-crop';
import CircularImageCropper from './CircularImageCropper';
import ImageCropper from './ImageCropper';
import FittableImage from './FittableImage';
import FAQAccordion from './FAQAccordion';
import ComparisonTable from './ComparisonTable';
import ResizableButton from './ResizableButton';
import TwoColumnComparisonTable from './TwoColumnComparisonTable';
import InlineRowLayout from './InlineRowLayout';
import SimplePresetSelector from './SimplePresetSelector';
import ButtonPresetSelector from './ButtonPresetSelector';
import ComparisonTablePresetSelector from './ComparisonTablePresetSelector';
import { getPreset, getPresetFontFamilies } from '../textStyle.js';
import React, { useState, useCallback, useEffect, useMemo, forwardRef, useImperativeHandle, useRef } from 'react';
// Drag-and-drop removed per new design; use arrow controls instead
import { API_URL } from '../config';
import { getPreBuiltTemplates, getPreBuiltTemplatesByType, getAllTemplatesByType } from '../services/offerTemplateService';
import brandService from '../services/brandService';
import { getOffersByBrand } from '../services/offerService';
import { uploadToS3WithProgress } from '../services/s3UploadService';
import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Tabs,
  Tab,
  Divider,
  Chip,
  useTheme,
  useMediaQuery,
  SwipeableDrawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,

  Card,
  CardContent,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Switch,
  Alert,
  AlertTitle,
  Slider

} from '@mui/material';
import {
  Title as TitleIcon,
  TextFields as TextIcon,
  Image as ImageIcon,
  SmartButton as ButtonIcon,
  Code as CodeIcon,
  VideoLibrary as VideoIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as PreviewIcon,
  GetApp as ExportIcon,
  Link as LinkIcon,
  Settings as SettingsIcon,
  ArrowUpward as MoveUpIcon,
  KeyboardArrowDown as MoveDownIcon,
  Save as SaveIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  Phone as PhoneIcon,
  Tablet as TabletIcon,
  Computer as ComputerIcon,
  Verified as VerifiedIcon,
  Lock as LockIcon,
  ViewModule as TemplateIcon,
  ViewColumn as ColumnIcon,
  CloudUpload as UploadIcon,
  ShoppingCart as ShoppingCartIcon,
  ArrowForward as ArrowForwardIcon,
  Star as StarIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  Timeline as TimelineIcon,
  ExpandMore as ExpandMoreIcon,
  DragIndicator as DragIcon,
  FileCopy as DuplicateIcon,
  Cancel as CancelIcon,
  CallSplit as CallSplitIcon,
  CheckCircle as CheckCircleIcon,
  Refresh as RefreshIcon,
  FormatListBulleted as ListIcon
} from '@mui/icons-material';
import Checklist from './Checklist';
import api from '../services/api';
import S3FileUpload from './S3FileUpload';
import CenteredVideoPlayer from './CenteredVideoPlayer';

function getListIcon(icon, idx) {
  switch (icon) {
    case 'green-number':
      return (
        <Box sx={{
          width: 28, height: 28, borderRadius: '6px', background: '#22c55e',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontWeight: 'bold', fontSize: '1.2rem'
        }}>
          {idx !== undefined ? idx + 1 : ''}
        </Box>
      );
    case 'circle-number':
      return (
        <Box sx={{
          width: 28, height: 28, borderRadius: '50%', border: '2px solid #22c55e',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#22c55e', fontWeight: 'bold', fontSize: '1.2rem', background: 'white'
        }}>
          {idx !== undefined ? idx + 1 : ''}
        </Box>
      );
    case 'check': return <VerifiedIcon sx={{ color: '#b6ff3c', fontSize: '2rem' }} />;
    case 'star': return <StarIcon sx={{ color: '#ffe066', fontSize: '2rem' }} />;
    case 'info': return <InfoIcon sx={{ color: '#40c4ff', fontSize: '2rem' }} />;
    case 'warning': return <WarningIcon sx={{ color: '#ffb347', fontSize: '2rem' }} />;
    case 'red-x': return (
      <Box sx={{
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        color: '#e53e3e',
        fontWeight: 'bold'
      }}>
        ✗
      </Box>
    );
    case 'pink-check': return (
      <Box sx={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: '#ff9a9e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1rem',
        color: 'white',
        fontWeight: 'bold'
      }}>
        ✓
      </Box>
    );
    case 'dark-check': return (
      <Box sx={{
        width: '24px',
        height: '24px',
        borderRadius: '4px',
        backgroundColor: '#2d3748',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1rem',
        color: 'white',
        fontWeight: 'bold'
      }}>
        ✓
      </Box>
    );
    case 'green-badge': return (
      <Box sx={{
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: '#68d391',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.2rem',
        color: 'white',
        fontWeight: 'bold',
        border: '2px solid #48bb78'
      }}>
        ✓
      </Box>
    );
    case 'star-badge': return (
      <Box sx={{
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.2rem',
        color: 'white',
        fontWeight: 'bold',
        border: '2px solid #5a67d8'
      }}>
        ⭐
      </Box>
    );
    default: return <VerifiedIcon sx={{ color: '#b6ff3c', fontSize: '2rem' }} />;
  }
}

// For HTML export (returns SVG or emoji as a string)
function getListIconHTML(icon) {
  switch (icon) {
    case 'check':
      return '<svg style="color: #b6ff3c; width: 2rem; height: 2rem;" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';
    case 'star':
      return '<svg style="color: #ffe066; width: 2rem; height: 2rem;" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>';
    case 'info':
      return '<svg style="color: #40c4ff; width: 2rem; height: 2rem;" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>';
    case 'warning':
      return '<svg style="color: #ffb347; width: 2rem; height: 2rem;" viewBox="0 0 24 24" fill="currentColor"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>';
    case 'red-x':
      return '<span style="color: #e53e3e; font-size: 1.5rem; font-weight: bold;">✗</span>';
    case 'pink-check':
      return '<span style="display: inline-block; width: 24px; height: 24px; border-radius: 50%; background-color: #ff9a9e; color: white; text-align: center; line-height: 24px; font-size: 1rem; font-weight: bold;">✓</span>';
    case 'dark-check':
      return '<span style="display: inline-block; width: 24px; height: 24px; border-radius: 4px; background-color: #2d3748; color: white; text-align: center; line-height: 24px; font-size: 1rem; font-weight: bold;">✓</span>';
    case 'green-badge':
      return '<span style="display: inline-block; width: 32px; height: 32px; border-radius: 50%; background-color: #68d391; color: white; text-align: center; line-height: 32px; font-size: 1.2rem; font-weight: bold; border: 2px solid #48bb78;">✓</span>';
    case 'star-badge':
      return '<span style="display: inline-block; width: 32px; height: 32px; border-radius: 50%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; text-align: center; line-height: 32px; font-size: 1.2rem; font-weight: bold; border: 2px solid #5a67d8;">⭐</span>';
    default:
      return '<svg style="color: #b6ff3c; width: 2rem; height: 2rem;" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';
  }
}



// Element types
const ELEMENT_TYPES = {
  HEADING: 'heading',
  TEXT: 'text',
  IMAGE: 'image',
  CROPPABLE_IMAGE: 'croppable_image',
  FITTABLE_IMAGE: 'fittable_image',
  BUTTON: 'button',
  VIDEO: 'video',
  VIDEO_WITH_BUTTON_OVERLAY: 'video_with_button_overlay',
  MEDIA: 'media',
  HTML: 'html',
  DIVIDER: 'divider',
  LAYOUT: 'layout',
  CHECKLIST: 'checklist',
  BUTTON_WITH_NOTICE: 'BUTTON_WITH_NOTICE',
  BUTTON_IMAGE_CALLOUT: 'BUTTON_IMAGE_CALLOUT',
  BUTTON_TEXT_VARIANT: 'BUTTON_TEXT_VARIANT',
  BUTTON_HEADLINE_PRODUCT_IMAGE: 'Button + headline + Product Image',
  CUSTOM_LIST: 'CUSTOM_LIST',
  CUSTOM_LIST_TWO_LINE: 'CUSTOM_LIST_TWO_LINE',
  TIMELINE_LIST: 'TIMELINE_LIST',
  PROCESS_STEPS: 'PROCESS_STEPS',
  TEXT_WITH_RIGHT_IMAGE: 'TEXT_WITH_RIGHT_IMAGE',
  LEFT_IMAGE_TEXT: 'LEFT_IMAGE_TEXT',
  QUOTATION_BLOCK: 'QUOTATION_BLOCK',
  CIRCULAR_IMAGE: 'CIRCULAR_IMAGE',
  FAQ_ACCORDION: 'faq_accordion',
  COMPARISON_TABLE: 'comparison_table',
  TWO_COLUMN_COMPARISON: 'two_column_comparison',
};

// Layout types
const LAYOUT_TYPES = {
  SINGLE: 'single',
  SINGLE_ROW_2: 'single-row-2',
  SINGLE_ROW_3: 'single-row-3',
  SINGLE_ROW_4: 'single-row-4',
  SINGLE_ROW_5: 'single-row-5',
  TWO_COLUMN: 'two-column',
  THREE_COLUMN: 'three-column',
  HERO: 'hero',
  FEATURE: 'feature',
  CTA: 'cta',
  INLINE_ROW: 'inline-row'
};

// Template type and subtype options
const TEMPLATE_TYPE_OPTIONS = {
  'Buttons': [
    'Button w/notice',
    'Button w/Image Call out',
    'Button w/text',
    'Button + headline + Product Image',
    'Call to Action Button',
    'Navigation Button',
    'Hero Button',
    'Submit Button',
    'Download Button'
  ],

  'Lists': [
    'List - Bad things',
    'List - Check boxes',
    'List - Numbered',
    'List - steps/how to'
  ],
  'Icons': [
    'Feature Icons',
    'Features - Guaranteed Service Icons'
    // Add more subtypes as needed
  ],
  'Features': [
    'Features - Header + paragraph + expandable',
    'Features - Media Awards',
    'Ingredients',
    'Product Features',
    'Service Features',
    'Feature Comparison'
  ],
  'Testimonial': [
    'Testimonial - headline + customer images',
    'Testimonial - single'
  ],
  'Comparison': [
    'comparison w competitor'
  ],
  'Highlight block': [
    'pull quote',
    'image + headline + text'
  ],
  'Images': [
    'Image + headline + text + bullets + Button'
  ],
  'Videos': [
    'Video + headline + text + bullets + Button'
  ],
  'Video with button overlay': [
    'Single button overlay',
    'Multiple buttons overlay',
    'Interactive hotspots'
  ],
  'Headline/Subheadline': [
    'Headline w/ highlight bg color, Subheadline',
    'subheadline + paragraph text',
    'Subheadline w/ highlight bg color'
  ],
  'FAQ': [
    'common questions'
  ],
};

// Default elements
const DEFAULT_ELEMENTS = {
  [ELEMENT_TYPES.HEADING]: {
    type: ELEMENT_TYPES.HEADING,
    content: 'Your Amazing Offer Title',
    styles: {
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#333333',
      textAlign: 'center',
      marginBottom: '2px'
    }
  },
  [ELEMENT_TYPES.TEXT]: {
    type: ELEMENT_TYPES.TEXT,
    content: 'Add your compelling offer description here. Explain the benefits and value proposition that makes this offer irresistible.',
    styles: {
      fontSize: '16px',
      color: '#666666',
      lineHeight: '1.6',
      marginBottom: '8px'
    }
  },
  [ELEMENT_TYPES.IMAGE]: {
    type: ELEMENT_TYPES.IMAGE,
    content: 'https://via.placeholder.com/400x200?text=Product+Image',
    alt: 'Product Image',
    styles: {
      width: '100%',
      maxWidth: '400px',
      height: 'auto',
      marginBottom: '8px',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.CROPPABLE_IMAGE]: {
    type: ELEMENT_TYPES.CROPPABLE_IMAGE,
    imageSrc: '',
    croppedImage: '',
    crop: { x: 0, y: 0 },
    zoom: 1,
    croppedAreaPixels: null,
    styles: {
      width: 300,
      height: 200,
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
      borderRadius: '8px',
      maintainAspectRatio: true
    },
  },
  [ELEMENT_TYPES.CIRCULAR_IMAGE]: {
    type: ELEMENT_TYPES.CIRCULAR_IMAGE,
    imageSrc: '',
    croppedImage: '',
    crop: { x: 0, y: 0 },
    zoom: 1,
    croppedAreaPixels: null,
    styles: {
      width: 200,
      height: 200,
      borderRadius: '50%',
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
    },
  },
  [ELEMENT_TYPES.FITTABLE_IMAGE]: {
    type: ELEMENT_TYPES.FITTABLE_IMAGE,
    imageSrc: '',
    imagePosition: { x: 0, y: 0 },
    imageScale: 1,
    styles: {
      width: '100%',
      height: 300,
      backgroundColor: '#f9f9f9',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      overflow: 'hidden',
      position: 'relative',
    },
  },
  [ELEMENT_TYPES.BUTTON]: {
    type: ELEMENT_TYPES.BUTTON,
    content: 'Get This Offer Now!',
    url: '#',
    styles: {
      backgroundColor: '#ff6b35',
      color: '#ffffff',
      padding: '15px 30px',
      fontSize: '18px',
      fontWeight: 400,
      border: 'none',
      borderRadius: '5px',
      textDecoration: 'none',
      display: 'inline-block',
      width: '100%',
      marginBottom: '8px',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.VIDEO]: {
    type: ELEMENT_TYPES.VIDEO,
    content: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    videoFile: '',
    thumbnailUrl: '',
    styles: {
      width: '100%',
      height: '315px',
      marginBottom: '0px'
    }
  },
  [ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY]: {
    type: ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY,
    content: 'Get Started Now',
    url: '#',
    videoFile: '',
    thumbnailUrl: '',
    styles: {
      backgroundColor: '#1976d2',
      color: '#ffffff',
      padding: '12px 24px',
      borderRadius: '8px',
      fontWeight: 'bold',
      fontSize: '16px',
      width: '100%',
      border: 'none',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    }
  },
  [ELEMENT_TYPES.MEDIA]: {
    type: ELEMENT_TYPES.MEDIA,
    mediaUrl: '',
    thumbnailUrl: '',
    styles: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      marginBottom: '0px'
    }
  },
  [ELEMENT_TYPES.HTML]: {
    type: ELEMENT_TYPES.HTML,
    content: '<div style="text-align: center; padding: 20px; background: #f5f5f5; border-radius: 8px;">🎉 Custom HTML Content - Add any code here! 🎉</div>',
    styles: {
      marginBottom: '0px'
    }
  },
  [ELEMENT_TYPES.DIVIDER]: {
    type: ELEMENT_TYPES.DIVIDER,
    styles: {
      height: '1px',
      backgroundColor: '#e0e0e0',
      margin: '0px 0',
      border: 'none'
    }
  },
  [ELEMENT_TYPES.LAYOUT]: {
    type: ELEMENT_TYPES.LAYOUT,
    layoutType: LAYOUT_TYPES.SINGLE,
    zones: [{ id: 'zone-1', elements: [] }],
    styles: {
      marginBottom: '0px',
      padding: '4px',
      border: '2px dashed #e0e0e0',
      borderRadius: '8px'
    }
  },
  [ELEMENT_TYPES.CHECKLIST]: {
    type: ELEMENT_TYPES.CHECKLIST,
    title: "Why FluffCo Gets Oprah's Seal of Approval",
    items: [
      { icon: 'verified', text: 'The Deepest Sleep\nWake up refreshed each morning.' },
      { icon: 'verified', text: 'Tailored Comfort\nPerfectly cradles your neck and head.' },
      { icon: 'verified', text: 'Cool and Dry\nBreathable cotton for a cool, moisture-free sleep.' },
      { icon: 'verified', text: 'Allergy-Free\nHypoallergenic filling protects against allergies.' },
      { icon: 'verified', text: 'The Highest Quality\n300 thread count with durable, double-edge seams.' },
      { icon: 'verified', text: 'Machine-Washable\nFast and easy to clean and maintain.' },
    ],
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.BUTTON_WITH_NOTICE]: {
    type: ELEMENT_TYPES.BUTTON_WITH_NOTICE,
    variant: 'urgent-sale',
    styleVariant: 'default',
    content: {
      notice: 'UPDATE June 11, 2025: You can access the 70% OFF SALE by clicking this exclusive link below. Due to HIGH DEMAND, stock is currently reduced in several regions, and the sale is ending very soon.',
      callToAction: 'Don\'t miss out – act now to secure your discount!',
      buttonText: 'Limited time only - Get 70% OFF Now!>>>',
      buttonUrl: '#'
    },
    styles: {
      backgroundColor: '#fce4ec',
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '10px',
      textAlign: 'center'
    }
  },
  [ELEMENT_TYPES.CUSTOM_LIST]: {
    type: ELEMENT_TYPES.CUSTOM_LIST,
    rows: [
      { icon: 'check', text: 'List item 1' },
      { icon: 'check', text: 'List item 2' },
      { icon: 'check', text: 'List item 3' },
    ],
    textStylePreset: 'paragraph1',
    styles: {
      backgroundColor: '#ffffff',
      color: '#101022',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.25rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 8px 0',
    },
  },
  [ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE]: {
    type: ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE,
    rows: [
      { icon: 'check', text1: 'Feature Title 1', text2: 'Detailed description of the first feature' },
      { icon: 'check', text1: 'Feature Title 2', text2: 'Detailed description of the second feature' },
      { icon: 'check', text1: 'Feature Title 3', text2: 'Detailed description of the third feature' },
    ],
    textStylePreset1: 'subheading1', // For first line (titles)
    textStylePreset2: 'paragraph1', // For second line (descriptions)
    styles: {
      backgroundColor: '#ffffff',
      color: '#101022',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.25rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 8px 0',
    },
  },
  [ELEMENT_TYPES.FAQ_ACCORDION]: {
    type: ELEMENT_TYPES.FAQ_ACCORDION,
    title: 'MoonBrew FAQs',
    items: [
      { question: 'What are the benefits of MoonBrew?*', answer: 'MoonBrew offers a variety of benefits including ...' },
      { question: 'How might MoonBrew affect my sleep?', answer: 'MoonBrew is designed to support restful sleep by ...' },
      { question: 'Is there melatonin in MoonBrew?', answer: 'No, MoonBrew does not contain melatonin.' },
      { question: 'Is there caffeine in MoonBrew?', answer: 'No, MoonBrew is caffeine-free.' },
      { question: 'Is there sugar in MoonBrew?', answer: 'MoonBrew contains no added sugar.' },
      { question: 'How is MoonBrew made?', answer: 'MoonBrew is crafted using ...' },
      { question: 'Can I drink MoonBrew while pregnant?', answer: 'Please consult your healthcare provider before consuming MoonBrew while pregnant.' },
    ],
    iconType: 'plusMinus',
    iconColor: '#36C3D6',
    iconSize: 'large',
    showIcon: true,
    // New styling options
    textAlign: 'left',
    containerBackgroundColor: 'transparent',
    questionBackgroundColor: 'transparent',
    answerBackgroundColor: 'rgba(0, 0, 0, 0.02)',
    questionTextColor: '#4B329A',
    answerTextColor: '#4B329A',
    titleTextColor: 'primary',
    showDivider: true,
    dividerColor: '#C1A7F1',
    itemBorderRadius: '4px',
    itemSpacing: '12px',
    questionPadding: '16px',
    answerPadding: '16px',
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.COMPARISON_TABLE]: {
    type: ELEMENT_TYPES.COMPARISON_TABLE,
    title: 'Product Comparison',
    productA: 'AlphaCleanse',
    productB: 'Brand X',
    productAImage: '',
    productBImage: '',
    rows: [
      { feature: 'Nutrient Diversity', description: 'From 12 science-backed superfoods', productA: true, productB: false },
      { feature: 'Organic Ingredients', description: '100% all-natural & toxin free', productA: true, productB: false },
      { feature: 'Full Transparency', description: 'No hidden "proprietary blends"', productA: true, productB: false },
    ],
    titleStylePreset: 'compareTableTableTitle',
    productNameStylePreset: 'compareTableProdctName',
    featureTitleStylePreset: 'compareTableFeatureTitle',
    featureDescStylePreset: 'compareTableFeatureDescription',
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.TWO_COLUMN_COMPARISON]: {
    type: ELEMENT_TYPES.TWO_COLUMN_COMPARISON,
    leftColumnTitle: 'My Old Pillow',
    rightColumnTitle: 'My New Fluffco Pillow',
    leftColumnImage: '',
    rightColumnImage: '',
    leftItems: [
      'Was hard to find a comfortable sleeping position',
      'I constantly woke up with neck and shoulder pain',
      'I felt tired and groggy most mornings'
    ],
    rightItems: [
      "I've had the best sleep of my life in a long time",
      'I wake up every morning feeling refreshed and pain-free',
      'I fall asleep faster and stay asleep for longer'
    ],
    titleStylePreset: 'compareTableTwoColumnColumnTitle',
    itemStylePreset: 'compareTableTwoColumnItemTitle',
    styles: { marginBottom: '10px' }
  },
  [ELEMENT_TYPES.TIMELINE_LIST]: {
    type: ELEMENT_TYPES.TIMELINE_LIST,
    steps: [
      {
        stageLabel: 'STAGE 1',
        stageLabelColor: '#1976d2',
        title: 'Initial Setup',
        description: 'Begin the process with basic configuration and setup.',
        dotColor: '#1976d2',
      },
      {
        stageLabel: 'STAGE 2',
        stageLabelColor: '#1976d2',
        title: 'Core Processing',
        description: 'Execute the main functionality and process the data.',
        dotColor: '#1976d2',
      },
      {
        stageLabel: 'STAGE 3',
        stageLabelColor: '#1976d2',
        title: 'Final Results',
        description: 'Complete the process and deliver the final results.',
        dotColor: '#1976d2',
      },
    ],
    styles: {
      backgroundColor: '#fff',
      color: '#222',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.1rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 16px 0',
    },
  },
  [ELEMENT_TYPES.PROCESS_STEPS]: {
    type: ELEMENT_TYPES.PROCESS_STEPS,
    steps: [
      {
        number: 1,
        title: 'Remove From Case',
        description: 'It requires zero preparation, visits to a specialist, or boiling and molding.',
        image: 'https://via.placeholder.com/150x150?text=Step+1',
        numberColor: '#1976d2',
        backgroundColor: '#f8f9fa',
      },
      {
        number: 2,
        title: 'Insert Product',
        description: 'Unlike alternatives that lock your jaw, the product allows you to move your mouth freely.',
        image: 'https://via.placeholder.com/150x150?text=Step+2',
        numberColor: '#1976d2',
        backgroundColor: '#f8f9fa',
      },
      {
        number: 3,
        title: 'Enjoy Results!',
        description: 'The product instantly widens your airway to stop tissue vibration - and with it, snoring!',
        image: 'https://via.placeholder.com/150x150?text=Step+3',
        numberColor: '#1976d2',
        backgroundColor: '#f8f9fa',
      },
    ],
    styles: {
      backgroundColor: '#fff',
      color: '#333',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1rem',
      borderRadius: '12px',
      padding: '24px',
      margin: '0 0 16px 0',
    },
  },
  [ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE]: {
    type: ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE,
    content: {
      text: 'How might MoonBrew affect my sleep?',
      image: 'https://via.placeholder.com/200x150?text=Image'
    },
    styles: {
      backgroundColor: '#fff',
      color: '#333',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '1.1rem',
      borderRadius: '12px',
      padding: '20px',
      margin: '0 0 16px 0',
    },
  },
  [ELEMENT_TYPES.LEFT_IMAGE_TEXT]: {
    type: ELEMENT_TYPES.LEFT_IMAGE_TEXT,
    content: {
      text: 'Your text content goes here. This is flexible text that can be edited inline.',
      image: 'https://via.placeholder.com/150x150?text=Profile'
    },
    styles: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      marginBottom: '20px',
      flexWrap: 'wrap'
    },
    imageSize: 120,
    spacing: 20,
    imageAlignment: 'center',
    textStyles: {
      fontSize: '16px',
      color: '#333333',
      backgroundColor: 'transparent',
      fontWeight: 'normal',
      fontFamily: 'inherit',
      lineHeight: '1.6',
      textAlign: 'left',
      padding: '0px',
      borderRadius: '0px'
    }
  },
  [ELEMENT_TYPES.QUOTATION_BLOCK]: {
    type: ELEMENT_TYPES.QUOTATION_BLOCK,
    content: 'Korem ipsum <strong>dolor</strong> sit amet, consectetur fvfe adipiscing elit. <strong>Nunc vulputate libero etz df</strong> vvbbzj <strong>dffgnhncvh</strong> velit interdum, ac aliquet',
    styles: {
      backgroundColor: '#fce7f3',
      color: '#101022',
      borderRadius: '15px',
      padding: '24px 32px', // Simple padding like TEXT elements
      marginBottom: '20px',
      textAlign: 'left',
      position: 'relative',
      fontStyle: 'italic',
      fontSize: '18px',
      fontWeight: '400',
      lineHeight: '1.5',
      fontFamily: "'Inter', sans-serif"
    },
    textStylePreset: 'quotation1'
  },
};

// Layout configurations
const LAYOUT_CONFIGS = {
  [LAYOUT_TYPES.SINGLE]: {
    name: 'Single Column',
    description: 'One full-width column',
    zones: [{ id: 'zone-1', width: '100%' }]
  },
  [LAYOUT_TYPES.SINGLE_ROW_2]: {
    name: '2 Columns',
    description: 'Horizontal row with 2 equal columns',
    zones: [
      { id: 'zone-1', width: '50%' },
      { id: 'zone-2', width: '50%' }
    ]
  },
  [LAYOUT_TYPES.SINGLE_ROW_3]: {
    name: '3 Columns',
    description: 'Horizontal row with 3 equal columns',
    zones: [
      { id: 'zone-1', width: '33.33%' },
      { id: 'zone-2', width: '33.33%' },
      { id: 'zone-3', width: '33.33%' }
    ]
  },
  [LAYOUT_TYPES.SINGLE_ROW_4]: {
    name: '4 Columns',
    description: 'Horizontal row with 4 equal columns',
    zones: [
      { id: 'zone-1', width: '25%' },
      { id: 'zone-2', width: '25%' },
      { id: 'zone-3', width: '25%' },
      { id: 'zone-4', width: '25%' }
    ]
  },
  [LAYOUT_TYPES.SINGLE_ROW_5]: {
    name: '5 Columns',
    description: 'Horizontal row with 5 equal columns',
    zones: [
      { id: 'zone-1', width: '20%' },
      { id: 'zone-2', width: '20%' },
      { id: 'zone-3', width: '20%' },
      { id: 'zone-4', width: '20%' },
      { id: 'zone-5', width: '20%' }
    ]
  },
  [LAYOUT_TYPES.TWO_COLUMN]: {
    name: 'Two Columns',
    description: 'Side by side columns',
    zones: [
      { id: 'zone-1', width: '50%' },
      { id: 'zone-2', width: '50%' }
    ]
  },
  [LAYOUT_TYPES.THREE_COLUMN]: {
    name: 'Three Columns',
    description: 'Three equal columns',
    zones: [
      { id: 'zone-1', width: '33.33%' },
      { id: 'zone-2', width: '33.33%' },
      { id: 'zone-3', width: '33.33%' }
    ]
  },
  [LAYOUT_TYPES.HERO]: {
    name: 'Hero Section',
    description: 'Large header with content below',
    zones: [
      { id: 'zone-1', width: '100%', height: '200px' },
      { id: 'zone-2', width: '100%' }
    ]
  },
  [LAYOUT_TYPES.FEATURE]: {
    name: 'Feature Layout',
    description: 'Image left, content right',
    zones: [
      { id: 'zone-1', width: '40%' },
      { id: 'zone-2', width: '60%' }
    ]
  },
  [LAYOUT_TYPES.CTA]: {
    name: 'Call to Action',
    description: 'Centered content with action',
    zones: [
      { id: 'zone-1', width: '100%', textAlign: 'center' }
    ]
  },
  [LAYOUT_TYPES.INLINE_ROW]: {
    name: 'Inline Row',
    description: 'Flexible row with adjustable element positions',
    zones: [
      { id: 'inline-zone-1', width: 'auto', position: 'relative', display: 'flex', alignItems: 'center', gap: '10px' }
    ]
  }
};

// Predefined color palette for backgrounds
const COLOR_PRESETS = {
  blue: '#2630f3',
  yellow: '#e7cb16',
  pink: '#eabbc3',
  black: '#101022',
  white: '#FFFFFF',
  transparent: 'transparent'
};

// Limited color palette for Brands page only
const BRANDS_COLOR_PRESETS = {
  blue: '#2630f3',
  yellow: '#e7cb16',
  pink: '#eabbc3',
  black: '#101022',
  white: '#FFFFFF',
  transparent: 'transparent'
};

// Predefined text color presets that work well with background colors
const TEXT_COLOR_PRESETS = {
  white: '#FFFFFF',
  black: '#101022',
  darkGray: '#333333',
  lightGray: '#666666',
  blue: '#1976D2',
  red: '#D32F2F',
  green: '#2E7D32',
  orange: '#F57C00',
  purple: '#7B1FA2',
  teal: '#00796B'
};

// Limited text color palette for Brands page only
const BRANDS_TEXT_COLOR_PRESETS = {
  blue: '#2630f3',
  yellow: '#e7cb16',
  pink: '#eabbc3',
  black: '#101022',
  white: '#FFFFFF'
};

// Smart color suggestions based on background color
const getSuggestedTextColors = (backgroundColor) => {
  if (!backgroundColor || backgroundColor === 'transparent') {
    return ['#101022', '#333333', '#666666', '#FFFFFF'];
  }

  // Convert hex to RGB for better color analysis
  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate brightness (0-255)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  if (brightness > 128) {
    // Light background - suggest dark text colors
    return ['#101022', '#333333', '#1976D2', '#2E7D32', '#D32F2F'];
  } else {
    // Dark background - suggest light text colors
    return ['#FFFFFF', '#F5F5F5', '#E0E0E0', '#e7cb16', '#81C784'];
  }
};



const OfferPageBuilderSimple = forwardRef(({ templatesOnly = false, customElementsOnly = false, hideCustomElements = false, hideLoadTemplate = false, templateSelectionOnly = false, typeAndSubtypeOnly = false, templatesOnlyMode = false, isBrandsPage = false, sharedElements = null, setSharedElements = null, sharedPages = null, setSharedPages = null, sharedSelectedElement = null, setSharedSelectedElement = null, sharedSelectedElementContext = null, setSharedSelectedElementContext = null, sharedSelectedCategory = null, setSharedSelectedCategory = null, sharedSelectedSubtype = null, setSharedSelectedSubtype = null, sharedSelectedBrand = null, setSharedSelectedBrand = null, sharedSelectedOffer = null, setSharedSelectedOffer = null, sharedSelectedTemplateId = null, setSharedSelectedTemplateId = null }, ref) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Helper functions to get appropriate color presets based on context
  const getBackgroundColorPresets = () => isBrandsPage ? BRANDS_COLOR_PRESETS : COLOR_PRESETS;
  const getTextColorPresets = () => isBrandsPage ? BRANDS_TEXT_COLOR_PRESETS : TEXT_COLOR_PRESETS;

  // Helper function to get inline color arrays for background colors
  const getInlineBackgroundColors = () => {
    if (isBrandsPage) {
      return [
        { name: 'Blue', value: '#2630f3' },
        { name: 'Yellow', value: '#e7cb16' },
        { name: 'Pink', value: '#eabbc3' },
        { name: 'Black', value: '#101022' },
        { name: 'White', value: '#ffffff' },
        { name: 'Transparent', value: 'transparent' }
      ];
    }
    return [
      // Full color array for Setups page
      { name: 'None', value: 'transparent' },
      { name: 'White', value: '#ffffff' },
      { name: 'Black', value: '#101022' },
      { name: 'Light Gray', value: '#f5f5f5' },
      { name: 'Gray', value: '#9e9e9e' },
      { name: 'Dark Gray', value: '#424242' },
      { name: 'Light Blue', value: '#e3f2fd' },
      { name: 'Blue', value: '#2630f3' },
      { name: 'Dark Blue', value: '#1976d2' },
      { name: 'Light Green', value: '#e8f5e8' },
      { name: 'Green', value: '#4caf50' },
      { name: 'Dark Green', value: '#388e3c' },
      { name: 'Light Red', value: '#ffebee' },
      { name: 'Red', value: '#f44336' },
      { name: 'Dark Red', value: '#d32f2f' },
      { name: 'Light Orange', value: '#fff3e0' },
      { name: 'Orange', value: '#ff9800' },
      { name: 'Dark Orange', value: '#f57c00' },
      { name: 'Light Purple', value: '#f3e5f5' },
      { name: 'Purple', value: '#9c27b0' },
      { name: 'Dark Purple', value: '#7b1fa2' },
      { name: 'Light Pink', value: '#fce4ec' },
      { name: 'Pink', value: '#eabbc3' },
      { name: 'Dark Pink', value: '#c2185b' },
      { name: 'Light Yellow', value: '#fffde7' },
      { name: 'Yellow', value: '#e7cb16' },
      { name: 'Dark Yellow', value: '#fbc02d' },
      { name: 'Light Teal', value: '#e0f2f1' },
      { name: 'Teal', value: '#009688' },
      { name: 'Dark Teal', value: '#00695c' },
      { name: 'Light Brown', value: '#efebe9' },
      { name: 'Brown', value: '#795548' },
      { name: 'Dark Brown', value: '#5d4037' }
    ];
  };

  // Helper function to get inline color arrays for text colors
  const getInlineTextColors = () => {
    if (isBrandsPage) {
      return [
        { name: 'Blue', value: '#2630f3' },
        { name: 'Yellow', value: '#e7cb16' },
        { name: 'Pink', value: '#eabbc3' },
        { name: 'Black', value: '#101022' },
        { name: 'White', value: '#ffffff' }
      ];
    }
    return [
      // Full color array for Setups page
      { name: 'Black', value: '#101022' },
      { name: 'Dark Gray', value: '#424242' },
      { name: 'Gray', value: '#757575' },
      { name: 'Light Gray', value: '#9e9e9e' },
      { name: 'White', value: '#ffffff' },
      { name: 'Blue', value: '#1976d2' },
      { name: 'Light Blue', value: '#42a5f5' },
      { name: 'Dark Blue', value: '#0d47a1' },
      { name: 'Green', value: '#388e3c' },
      { name: 'Light Green', value: '#66bb6a' },
      { name: 'Dark Green', value: '#1b5e20' },
      { name: 'Red', value: '#d32f2f' },
      { name: 'Light Red', value: '#ef5350' },
      { name: 'Dark Red', value: '#b71c1c' },
      { name: 'Orange', value: '#f57c00' },
      { name: 'Light Orange', value: '#ff9800' },
      { name: 'Dark Orange', value: '#e65100' }
    ];
  };

  // Helper function to get the current font family for an element
  const getCurrentFontFamily = (element, subElement = null) => {
    if (subElement && element.type === 'BUTTON_WITH_NOTICE') {
      return element.subElementStyles?.[subElement]?.fontFamily || 'inherit';
    }

    // If fontFamily is explicitly set, use it
    if (element.styles?.fontFamily) {
      return element.styles.fontFamily;
    }

    // Try to detect font family based on element type and existing styles
    const { fontSize, fontWeight, fontStyle } = element.styles || {};

    // Map common style combinations to likely font families
    if (fontSize === '32px' && fontWeight === 400) {
      return "'Gilroy-Heavy', sans-serif";
    }
    if (fontSize === '18px' && fontWeight === 700) {
      return "'Poppins', sans-serif";
    }
    if (fontSize === '20px' && fontWeight === 400) {
      return "'Gilroy-Black', sans-serif";
    }
    if (fontSize === '18px' && fontWeight === 400) {
      return "'Gilroy-Medium', sans-serif";
    }
    if (fontSize === '16px' && fontWeight === 400) {
      return "'Gilroy-Medium', sans-serif";
    }
    if (fontSize === '14px' && fontWeight === 500) {
      return "'Akatab', sans-serif";
    }
    if (fontSize === '16px' && fontWeight === 700 && fontStyle === 'italic') {
      return "'Jost', sans-serif";
    }
    if (fontSize === '12px' && fontWeight === 700) {
      return "'Open Sans', sans-serif";
    }
    if (fontSize === '14px' && fontWeight === 700) {
      return "'Geist', sans-serif";
    }

    // Default to inherit if no specific font can be determined
    return 'inherit';
  };

  // const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  // Use shared state if provided, otherwise use local state
  const [localElements, setLocalElements] = useState([]);
  const [localSelectedElement, setLocalSelectedElement] = useState(null);
  const [localSelectedElementContext, setLocalSelectedElementContext] = useState(null);

  // Pagination state for offer elements
  // Use shared pages state if provided, otherwise override with local state
  const [localPages, setLocalPages] = useState([{ id: 1, elements: [] }]);
  const pages = sharedPages || localPages;
  const setPages = setSharedPages || setLocalPages;
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [nextPageId, setNextPageId] = useState(2);
  const [paginationEnabled, setPaginationEnabled] = useState(true); // Always enabled for manual page control
  const [isLoadingExistingContent, setIsLoadingExistingContent] = useState(false); // Flag to prevent auto-pagination
  const [insertAfterElementId, setInsertAfterElementId] = useState(null); // Store element ID to insert after when using add button

  // Determine which state to use
  const getCurrentPage = useCallback(() => {
    return pages[currentPageIndex] || pages[0];
  }, [pages, currentPageIndex]);

  const currentPageElements = getCurrentPage()?.elements || [];
  // Smart elements logic: use pagination when enabled and pages exist
  // Smart elements logic: use pagination when enabled and pages exist
  const elements = (paginationEnabled && pages.length > 0)
    ? currentPageElements
    : (sharedPages
      ? sharedPages.reduce((acc, p) => [...acc, ...(p.elements || [])], [])
      : (sharedElements !== null ? sharedElements : localElements));
  const setElements = setSharedElements !== null ? setSharedElements : setLocalElements;
  const selectedElement = sharedSelectedElement !== null ? sharedSelectedElement : localSelectedElement;
  const setSelectedElement = setSharedSelectedElement !== null ? setSharedSelectedElement : setLocalSelectedElement;
  const selectedElementContext = sharedSelectedElementContext !== null ? sharedSelectedElementContext : localSelectedElementContext;
  const setSelectedElementContext = setSharedSelectedElementContext !== null ? setSharedSelectedElementContext : setLocalSelectedElementContext;

  // Determine if we're in editing mode (actively creating/editing content)
  const isEditingMode = useMemo(() => {
    // We're in editing mode if:
    // 1. We're not in templatesOnly mode (viewing templates)
    // 2. We're not on Brands page (viewing saved elements in read-only)
    // 3. We have content to edit OR we have a selected element (indicating active editing)
    const hasContent = localElements.length > 0 || (sharedElements !== null && Array.isArray(sharedElements) && sharedElements.length > 0);
    const hasSelectedElement = selectedElement !== null;

    const result = (hasContent || hasSelectedElement) && !templatesOnly && !isBrandsPage;

    console.log('🔍 isEditingMode calculation:', {
      hasContent,
      hasSelectedElement,
      templatesOnly,
      isBrandsPage,
      result,
      localElementsLength: localElements.length,
      sharedElementsLength: sharedElements?.length || 0,
      selectedElementId: selectedElement?.id
    });

    // Allow editing if we have content OR if we have a selected element (indicating we're actively editing)
    return result;
  }, [localElements.length, templatesOnly, isBrandsPage, sharedElements, selectedElement]);

  const [selectedSubElement, setSelectedSubElement] = useState(null); // For sub-element selection within composite elements
  const [drawerOpen, setDrawerOpen] = useState(!templatesOnly); // Open in Setups (template creation), closed in Brands (templatesOnly)
  const [previewPanelOpen, setPreviewPanelOpen] = useState(true);

  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const [pageSettingsOpen, setPageSettingsOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [showLayoutSelector, setShowLayoutSelector] = useState(false);
  const [targetZone, setTargetZone] = useState(null); // For nested layouts
  const [draggedElement, setDraggedElement] = useState(null);
  const [dragOverZone, setDragOverZone] = useState(null);
  const [editingElement, setEditingElement] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [tempValue, setTempValue] = useState('');

  // Undo system state
  const [deletedElementsHistory, setDeletedElementsHistory] = useState([]);
  const [showUndoNotification, setShowUndoNotification] = useState(false);

  // Content tab editing state
  const [contentTabTempValue, setContentTabTempValue] = useState('');
  const [buttonContentTabTempValue, setButtonContentTabTempValue] = useState('');
  const [buttonUrlTabTempValue, setButtonUrlTabTempValue] = useState('');
  const [listItemTextValues, setListItemTextValues] = useState({});
  const [savedTemplates, setSavedTemplates] = useState([]);
  const [preBuiltTemplates, setPreBuiltTemplates] = useState([]);
  const [buttonImageCalloutTemplates, setButtonImageCalloutTemplates] = useState([]);
  const [buttonNoticeTemplates, setButtonNoticeTemplates] = useState([]);
  const [buttonTextTemplates, setButtonTextTemplates] = useState([]);
  const [templateName, setTemplateName] = useState('');
  const [templateType, setTemplateType] = useState('');
  const [templateSubtype, setTemplateSubtype] = useState('');
  const [showSaveDialog, setShowSaveDialog] = useState(false);

  // Suppress ResizeObserver errors
  useEffect(() => {
    const errorHandler = (e) => {
      if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
        e.stopImmediatePropagation();
        console.log('ResizeObserver error suppressed - this is normal and harmless');
        return;
      }
    };

    const unhandledRejectionHandler = (e) => {
      if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
        e.preventDefault();
        console.log('ResizeObserver promise rejection suppressed - this is normal and harmless');
      }
    };

    window.addEventListener('error', errorHandler);
    window.addEventListener('unhandledrejection', unhandledRejectionHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
      window.removeEventListener('unhandledrejection', unhandledRejectionHandler);
    };
  }, []);
  const [showTemplatesList, setShowTemplatesList] = useState(false);
  const [currentTemplateId, setCurrentTemplateId] = useState(null); // Track currently loaded template
  const [pageSettings, setPageSettings] = useState({
    title: 'My Offer Page',
    backgroundColor: '#ffffff',
    maxWidth: '800px',
    fontFamily: 'Arial, sans-serif'
  });

  // Mobile-specific state
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  // Right panel state
  const [rightPanelOpen, setRightPanelOpen] = useState(false);
  const [previewDevice, setPreviewDevice] = useState('mobile'); // mobile, tablet, desktop
  // const [showMobileToolbar, setShowMobileToolbar] = useState(false);
  const [forceRender, setForceRender] = useState(0);
  const textEditorRef = useRef(null);

  // Local state for category and subtype
  const [localSelectedCustomCategory, setLocalSelectedCustomCategory] = useState('Headline/Subheadline');
  const [localSelectedCustomSubtype, setLocalSelectedCustomSubtype] = useState(null);

  // Determine which state to use - shared if available, otherwise local
  const selectedCustomCategory = setSharedSelectedCategory ? sharedSelectedCategory : localSelectedCustomCategory;
  const setSelectedCustomCategory = setSharedSelectedCategory || setLocalSelectedCustomCategory;
  const selectedCustomSubtype = setSharedSelectedSubtype ? sharedSelectedSubtype : localSelectedCustomSubtype;
  const setSelectedCustomSubtype = setSharedSelectedSubtype || setLocalSelectedCustomSubtype;

  // Debug effect to monitor category changes
  useEffect(() => {
    console.log('🏷️ selectedCustomCategory changed to:', selectedCustomCategory);
  }, [selectedCustomCategory]);

  // Debug effect to monitor selectedElement changes
  useEffect(() => {
    console.log('🎯 selectedElement changed:', selectedElement?.id, selectedElement?.styles?.fontFamily);
    if (selectedElement) {
      console.log('🎨 Full selectedElement styles:', selectedElement.styles);
      console.log('🎨 Full selectedElement textStyles:', selectedElement.textStyles);
    }
  }, [selectedElement]);

  // Add state for filtered templates by type and subtype
  const [filteredTemplates, setFilteredTemplates] = useState([]);

  // Add state for selected variant key
  const [selectedVariantKey, setSelectedVariantKey] = useState(null);

  // Add state for selected template (use shared if available)
  const [localSelectedTemplateId, setLocalSelectedTemplateId] = useState(null);
  const selectedTemplateId = setSharedSelectedTemplateId ? sharedSelectedTemplateId : localSelectedTemplateId;
  const setSelectedTemplateId = setSharedSelectedTemplateId || setLocalSelectedTemplateId;

  // Add state for icon selector in custom lists
  const [iconSelectorOpen, setIconSelectorOpen] = useState(null);

  // Image upload state
  const [imageUploading, setImageUploading] = useState(false);
  const [uploadingElementId, setUploadingElementId] = useState(null);

  // Link generation state
  const [generatingLink, setGeneratingLink] = useState(false);

  // Saved offer elements state
  const [savedOfferElements, setSavedOfferElements] = useState([]);
  const [filteredSavedElements, setFilteredSavedElements] = useState([]);
  const [currentElementName, setCurrentElementName] = useState('');
  const [showSaveElementDialog, setShowSaveElementDialog] = useState(false);
  const [showBrandOfferAlert, setShowBrandOfferAlert] = useState(false);
  const [showLoadTemplateAlert, setShowLoadTemplateAlert] = useState(false);
  const [loadTemplateError, setLoadTemplateError] = useState('');
  const [showStatusAlert, setShowStatusAlert] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [statusTitle, setStatusTitle] = useState('');
  const [showReplaceConfirm, setShowReplaceConfirm] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmDialogTitle, setConfirmDialogTitle] = useState('');
  const [confirmDialogMessage, setConfirmDialogMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);
  const [showPromptDialog, setShowPromptDialog] = useState(false);
  const [promptDialogTitle, setPromptDialogTitle] = useState('');
  const [promptDialogMessage, setPromptDialogMessage] = useState('');
  const [promptDialogValue, setPromptDialogValue] = useState('');
  const [promptAction, setPromptAction] = useState(null);
  const [pendingTemplateData, setPendingTemplateData] = useState(null);
  const [showRenameDialog, setShowRenameDialog] = useState(false);
  const [renameElementId, setRenameElementId] = useState(null);
  const [renameElementValue, setRenameElementValue] = useState('');
  const [isUpdatingElement, setIsUpdatingElement] = useState(false);
  const [selectedSavedElementId, setSelectedSavedElementId] = useState(null);
  const [saveType, setSaveType] = useState('element'); // 'element' or 'template'

  // Brand and Offer selection state
  const [localSelectedBrand, setLocalSelectedBrand] = useState('');
  const [localSelectedOffer, setLocalSelectedOffer] = useState('');

  // Use shared state if provided, otherwise use local state
  const selectedBrand = sharedSelectedBrand !== null ? sharedSelectedBrand : localSelectedBrand;
  const setSelectedBrand = setSharedSelectedBrand !== null ? setSharedSelectedBrand : setLocalSelectedBrand;
  const selectedOffer = sharedSelectedOffer !== null ? sharedSelectedOffer : localSelectedOffer;
  const setSelectedOffer = setSharedSelectedOffer !== null ? setSharedSelectedOffer : setLocalSelectedOffer;
  const [brands, setBrands] = useState([]);
  const [offers, setOffers] = useState([]);

  // Helper function to auto-populate offer links in elements
  const populateOfferLinkInElements = useCallback((elementsToUpdate, offerUrl) => {
    if (!offerUrl || offerUrl === '#' || offerUrl === '') return elementsToUpdate;

    let anyChanged = false;
    const updatedElements = elementsToUpdate.map(el => {
      let elementChanged = false;
      const newEl = JSON.parse(JSON.stringify(el));

      // 1. Check for buttons array (e.g. VIDEO_WITH_BUTTON_OVERLAY)
      if (newEl.buttons && Array.isArray(newEl.buttons)) {
        newEl.buttons = newEl.buttons.map(btn => {
          if (btn.url !== offerUrl) {
            elementChanged = true;
            return { ...btn, url: offerUrl };
          }
          return btn;
        });
      }

      // 2. Check for button types or types that typically have a URL
      const isButtonType = newEl.type === ELEMENT_TYPES.BUTTON ||
        newEl.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY ||
        newEl.type === 'BUTTON_TEXT_VARIANT' ||
        newEl.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE';

      if ((isButtonType || newEl.url !== undefined) && newEl.url !== offerUrl) {
        newEl.url = offerUrl;
        elementChanged = true;
      }

      // 3. Check for content.buttonUrl (used by some button variants)
      if (newEl.content && typeof newEl.content === 'object' && newEl.content.buttonUrl !== undefined && newEl.content.buttonUrl !== offerUrl) {
        newEl.content.buttonUrl = offerUrl;
        elementChanged = true;
      }

      // 4. Handle nested layouts
      if (newEl.type === ELEMENT_TYPES.LAYOUT && newEl.zones) {
        let zonesChanged = false;
        Object.keys(newEl.zones).forEach(zoneId => {
          if (newEl.zones[zoneId].elements) {
            const updatedZoneElements = populateOfferLinkInElements(newEl.zones[zoneId].elements, offerUrl);
            if (updatedZoneElements !== newEl.zones[zoneId].elements) {
              newEl.zones[zoneId].elements = updatedZoneElements;
              zonesChanged = true;
            }
          }
        });
        if (zonesChanged) {
          elementChanged = true;
        }
      }

      if (elementChanged) {
        anyChanged = true;
        return newEl;
      }
      return el;
    });

    return anyChanged ? updatedElements : elementsToUpdate;
  }, []);

  // Auto-load offers when selectedBrand changes (e.g. from props)
  useEffect(() => {
    if (selectedBrand) {
      console.log('🏷️ Automatically loading offers for brand:', selectedBrand);
      loadOffersForBrand(selectedBrand);
    } else {
      setOffers([]);
    }
  }, [selectedBrand]);

  // Auto-populate offer link on offer selection change
  useEffect(() => {
    // If we have a selected offer but no offers list yet, it might still be loading.
    // The dependency on 'offers' will re-trigger this once they are loaded.
    if (selectedOffer && offers.length > 0 && !templateSelectionOnly) {
      const selectedOfferObj = offers.find(o => o._id === selectedOffer || o.id === selectedOffer);

      if (selectedOfferObj) {
        // Log the available properties to debug
        console.log('🔗 Found selected offer object:', {
          id: selectedOfferObj._id,
          title: selectedOfferObj.title,
          purchaseUrl: selectedOfferObj.purchaseUrl,
          link: selectedOfferObj.link
        });

        const offerUrl = selectedOfferObj.purchaseUrl || selectedOfferObj.link;

        if (offerUrl && offerUrl !== '#' && offerUrl !== '') {
          console.log('🔗 Auto-populating offer link from useEffect:', offerUrl);

          // 1. Update current elements on canvas
          setElements(prev => {
            const updated = populateOfferLinkInElements(prev, offerUrl);
            if (updated !== prev) {
              console.log('✅ Elements updated with offer link');
              return updated;
            }
            return prev;
          });

          // 2. Update all pages if pagination is active
          if (pages.length > 0) {
            setPages(prevPages => {
              let pagesChanged = false;
              const updatedPages = prevPages.map(page => {
                const updatedElements = populateOfferLinkInElements(page.elements || [], offerUrl);
                if (updatedElements !== page.elements) {
                  pagesChanged = true;
                  return { ...page, elements: updatedElements };
                }
                return page;
              });
              return pagesChanged ? updatedPages : prevPages;
            });
          }

          // 3. Sync selectedElement
          if (selectedElement) {
            const updatedArr = populateOfferLinkInElements([selectedElement], offerUrl);
            if (updatedArr[0] !== selectedElement) {
              console.log('✅ Syncing selectedElement with auto-populated offer link');
              setSelectedElement(updatedArr[0]);
              // Clear temp values so the UI uses updated selectedElement values
              setButtonContentTabTempValue('');
              setButtonUrlTabTempValue('');
            }
          }
        } else {
          console.warn('⚠️ Selected offer has no valid purchaseUrl or link:', selectedOfferObj);
        }
      } else {
        console.warn('⚠️ Could not find selected offer in offers list:', selectedOffer);
      }
    }
  }, [selectedOffer, offers, templateSelectionOnly, setElements, setPages, setSelectedElement, selectedElement?.id, setButtonContentTabTempValue, setButtonUrlTabTempValue, populateOfferLinkInElements]);

  // Zone height management state
  const [zoneHeightModes, setZoneHeightModes] = useState({}); // zoneId -> 'third' | 'half' | 'full'
  const [heightOverflowAlerts, setHeightOverflowAlerts] = useState({}); // zoneId -> { hasOverflow: boolean, overflowHeight: number }

  // Brands page height limit (full mobile phone height)
  const BRANDS_PAGE_MAX_HEIGHT = 878; // Full mobile phone height for brands page



  // Standard mobile phone specifications (1080×2340 logical, 405×878 display)
  const STANDARD_MOBILE = {
    // Logical dimensions (for calculations)
    logicalWidth: 1080,
    logicalHeight: 2340,
    safeAreaTop: 100, // Status bar and notch area
    safeAreaBottom: 80, // Home indicator area
    usableHeight: 2160, // logicalHeight - safeAreaTop - safeAreaBottom

    // Display dimensions (~37.5% scale for UI)
    displayWidth: 405, // 1080 * 0.375
    displayHeight: 878, // 2340 * 0.375
    displaySafeAreaTop: 38, // 100 * 0.375 (rounded)
    displaySafeAreaBottom: 30, // 80 * 0.375
    displayUsableHeight: 810, // 2160 * 0.375

    // Scale factor
    scale: 0.375 // 405/1080
  };

  // Height calculation based on mode
  const getZoneHeight = (zoneId, defaultHeight) => {
    const mode = zoneHeightModes[zoneId] || 'third';
    switch (mode) {
      case 'third':
        return '33vh';
      case 'half':
        return '50vh';
      case 'twoThirds':
        return '67vh';
      case 'full':
        return '100vh';
      default:
        return defaultHeight || '60px';
    }
  };

  // Get height style object based on standard mobile dimensions
  const getZoneHeightStyle = (zoneId, defaultHeight) => {
    // Only apply custom heights if the zone has been explicitly set to a mode
    if (!zoneHeightModes.hasOwnProperty(zoneId)) {
      return { minHeight: defaultHeight || '60px' };
    }

    const mode = zoneHeightModes[zoneId];

    // Calculate heights based on logical 2340px full height (but display at 37.5% scale)
    const thirdHeight = Math.floor(STANDARD_MOBILE.logicalHeight / 3); // 1/3 = 780px logical (293px display)
    const halfHeight = Math.floor(STANDARD_MOBILE.logicalHeight / 2); // 1/2 = 1170px logical (439px display)  
    const twoThirdsHeight = Math.floor(STANDARD_MOBILE.logicalHeight * 2 / 3); // 2/3 = 1560px logical (585px display)
    const fullHeight = STANDARD_MOBILE.logicalHeight; // Full = 2340px logical (878px display)

    // For display, we scale down by 37.5%
    const displayThirdHeight = Math.floor(thirdHeight * STANDARD_MOBILE.scale);
    const displayHalfHeight = Math.floor(halfHeight * STANDARD_MOBILE.scale);
    const displayTwoThirdsHeight = Math.floor(twoThirdsHeight * STANDARD_MOBILE.scale);
    const displayFullHeight = Math.floor(fullHeight * STANDARD_MOBILE.scale);

    switch (mode) {
      case 'third':
        return {
          height: `${displayThirdHeight}px`, // 293px display (represents 780px logical)
          maxHeight: `${displayThirdHeight}px`,
          border: '2px solid #4caf50' // Green border to indicate 1/3 mode
        };
      case 'half':
        return {
          height: `${displayHalfHeight}px`, // 439px display (represents 1170px logical)
          maxHeight: `${displayHalfHeight}px`,
          border: '2px solid #ff9800' // Orange border to indicate 1/2 mode
        };
      case 'twoThirds':
        return {
          height: `${displayTwoThirdsHeight}px`, // 585px display (represents 1560px logical)
          maxHeight: `${displayTwoThirdsHeight}px`,
          border: '2px solid #9c27b0' // Purple border to indicate 2/3 mode
        };
      case 'full':
        return {
          height: `${displayFullHeight}px`, // 878px display (represents 2340px logical)
          maxHeight: `${displayFullHeight}px`,
          border: '2px solid #f44336' // Red border to indicate full mode
        };
      default:
        return { minHeight: defaultHeight || '60px' };
    }
  };

  // Check if content exceeds zone height
  const checkZoneHeightOverflow = useCallback((zoneId) => {
    const mode = zoneHeightModes[zoneId];
    if (!mode) return false; // No height mode set, no overflow possible

    // Get the zone element
    const zoneElement = document.querySelector(`[data-zone-id="${zoneId}"]`);
    if (!zoneElement) return false;

    // Get zone height limits
    const thirdHeight = Math.floor(STANDARD_MOBILE.logicalHeight / 3 * STANDARD_MOBILE.scale); // 293px
    const halfHeight = Math.floor(STANDARD_MOBILE.logicalHeight / 2 * STANDARD_MOBILE.scale); // 439px
    const twoThirdsHeight = Math.floor(STANDARD_MOBILE.logicalHeight * 2 / 3 * STANDARD_MOBILE.scale); // 585px
    const fullHeight = Math.floor(STANDARD_MOBILE.logicalHeight * STANDARD_MOBILE.scale); // 878px

    let maxHeight;
    switch (mode) {
      case 'third':
        maxHeight = thirdHeight;
        break;
      case 'half':
        maxHeight = halfHeight;
        break;
      case 'twoThirds':
        maxHeight = twoThirdsHeight;
        break;
      case 'full':
        maxHeight = fullHeight;
        break;
      default:
        return false;
    }

    // Get actual content height
    const contentHeight = zoneElement.scrollHeight;
    const hasOverflow = contentHeight > maxHeight;

    // Update overflow state
    setHeightOverflowAlerts(prev => ({
      ...prev,
      [zoneId]: {
        hasOverflow,
        overflowHeight: hasOverflow ? contentHeight - maxHeight : 0,
        contentHeight,
        maxHeight,
        mode
      }
    }));

    return hasOverflow;
  }, [zoneHeightModes, setHeightOverflowAlerts]);

  // Clear overflow alert for a zone
  const clearOverflowAlert = useCallback((zoneId) => {
    setHeightOverflowAlerts(prev => {
      const newAlerts = { ...prev };
      delete newAlerts[zoneId];
      return newAlerts;
    });
  }, []);


  // Get overflow message for a zone
  const getOverflowMessage = (zoneId) => {
    const alert = heightOverflowAlerts[zoneId];
    if (!alert || !alert.hasOverflow) return null;

    const modeNames = {
      'third': '1/3 screen',
      'half': '1/2 screen',
      'twoThirds': '2/3 screen',
      'full': 'full screen'
    };

    return `Content in this zone exceeds ${modeNames[alert.mode]} height by ${alert.overflowHeight}px. Current content: ${alert.contentHeight}px, Max allowed: ${alert.maxHeight}px.`;
  };

  // Check if any zone has overflow for canvas alert
  const getCanvasOverflowAlert = () => {
    const overflowingZones = Object.keys(heightOverflowAlerts).filter(
      zoneId => heightOverflowAlerts[zoneId]?.hasOverflow
    );

    if (overflowingZones.length === 0) return null;

    if (overflowingZones.length === 1) {
      const alert = heightOverflowAlerts[overflowingZones[0]];
      const modeNames = { 'third': '1/3', 'half': '1/2', 'twoThirds': '2/3', 'full': 'full' };
      const modeName = modeNames[alert.mode] || alert.mode;
      return `⚠️ Zone content exceeds ${modeName} screen height (+${alert.overflowHeight}px)`;
    } else {
      return `⚠️ ${overflowingZones.length} zones exceed height limits`;
    }
  };


  // Toggle zone height mode
  const toggleZoneHeight = (zoneId) => {
    setZoneHeightModes(prev => {
      const currentMode = prev[zoneId] || 'third';
      let nextMode;
      switch (currentMode) {
        case 'third':
          nextMode = 'half';
          break;
        case 'half':
          nextMode = 'twoThirds';
          break;
        case 'twoThirds':
          nextMode = 'full';
          break;
        case 'full':
          nextMode = 'third';
          break;
        default:
          nextMode = 'third';
      }
      return { ...prev, [zoneId]: nextMode };
    });
  };

  // Get expand button icon based on current mode
  const getExpandIcon = (zoneId) => {
    const mode = zoneHeightModes[zoneId] || 'third';
    switch (mode) {
      case 'third':
        return <MoveDownIcon />; // Down arrow: can expand height (increase)
      case 'half':
        return <MoveDownIcon />; // Down arrow: can still expand height (increase to 2/3)
      case 'twoThirds':
        return <MoveDownIcon />; // Down arrow: can still expand height (increase to full)
      case 'full':
        return <MoveUpIcon />; // Up arrow: can only collapse height (decrease)
      default:
        return <MoveDownIcon />;
    }
  };

  // Get tooltip text for current mode
  const getHeightTooltip = (zoneId) => {
    if (!zoneHeightModes.hasOwnProperty(zoneId)) {
      return 'Click to enable dynamic height (1080×2340 logical screen)';
    }

    const thirdHeight = 780; // 2340 / 3 (logical)
    const halfHeight = 1170; // 2340 / 2 (logical)
    const twoThirdsHeight = 1560; // 2340 * 2/3 (logical)
    const fullHeight = 2340; // Full height (logical)

    const mode = zoneHeightModes[zoneId];
    switch (mode) {
      case 'third':
        return `Current: 1/3 screen height (${thirdHeight}px logical). Click to expand to 1/2`;
      case 'half':
        return `Current: 1/2 screen height (${halfHeight}px logical). Click to expand to 2/3`;
      case 'twoThirds':
        return `Current: 2/3 screen height (${twoThirdsHeight}px logical). Click to expand to full`;
      case 'full':
        return `Current: Full screen height (${fullHeight}px logical). Click to collapse to 1/3`;
      default:
        return 'Click to cycle zone height';
    }
  };

  // Get height mode display text
  const getHeightModeText = (zoneId) => {
    if (!zoneHeightModes.hasOwnProperty(zoneId)) {
      return '';
    }

    const thirdHeight = 780; // 2340 / 3 (logical)
    const halfHeight = 1170; // 2340 / 2 (logical)
    const twoThirdsHeight = 1560; // 2340 * 2/3 (logical)
    const fullHeight = 2340; // Full height (logical)

    const mode = zoneHeightModes[zoneId];
    switch (mode) {
      case 'third':
        return ` [1/3: ${thirdHeight}px]`;
      case 'half':
        return ` [1/2: ${halfHeight}px]`;
      case 'twoThirds':
        return ` [2/3: ${twoThirdsHeight}px]`;
      case 'full':
        return ` [Full: ${fullHeight}px]`;
      default:
        return '';
    }
  };
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [loadingOffers, setLoadingOffers] = useState(false);

  // Monitor elements and zone height modes for overflow detection
  useEffect(() => {
    // Use a short delay to allow DOM to update
    const timeoutId = setTimeout(() => {
      Object.keys(zoneHeightModes).forEach(zoneId => {
        checkZoneHeightOverflow(zoneId);
      });
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [elements, zoneHeightModes, checkZoneHeightOverflow]);

  // Monitor window resize for overflow recalculation
  useEffect(() => {
    const handleResize = () => {
      Object.keys(zoneHeightModes).forEach(zoneId => {
        checkZoneHeightOverflow(zoneId);
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [zoneHeightModes, checkZoneHeightOverflow]);

  // Expose import method to parent
  useImperativeHandle(ref, () => ({
    loadTemplateFromImport: (templateObj) => {
      console.log('🔄 Starting template import:', templateObj);

      // Set flag to prevent auto-pagination for imported templates
      setIsLoadingExistingContent(true);

      // Recursive function to process elements and nested layouts
      const processElement = (element) => {
        console.log('🔍 Processing element:', element);

        const processedElement = {
          ...element,
          id: element.id || generateId()
        };

        // Normalize element types to constants
        if (element.type === 'heading') processedElement.type = ELEMENT_TYPES.HEADING;
        if (element.type === 'text') processedElement.type = ELEMENT_TYPES.TEXT;
        if (element.type === 'image') processedElement.type = ELEMENT_TYPES.IMAGE;
        if (element.type === 'button') processedElement.type = ELEMENT_TYPES.BUTTON;
        if (element.type === 'comparison_table') {
          processedElement.type = ELEMENT_TYPES.COMPARISON_TABLE;
          console.log('🔍 Processing comparison_table:', {
            original: element,
            processed: processedElement,
            hasProductAImage: !!element.productAImage,
            hasProductBImage: !!element.productBImage,
            productAImage: element.productAImage,
            productBImage: element.productBImage
          });
        }

        // Handle layout elements with zones (including nested layouts)
        if ((element.type === 'layout' || element.type === 'LAYOUT') && element.zones) {
          processedElement.type = ELEMENT_TYPES.LAYOUT; // Normalize to constant

          // Normalize layout type - convert underscores to hyphens
          if (element.layoutType) {
            processedElement.layoutType = element.layoutType.replace(/_/g, '-');
          }

          processedElement.zones = element.zones.map(zone => ({
            ...zone,
            id: zone.id || generateId(),
            elements: (zone.elements || []).map(zoneElement => processElement(zoneElement)) // Recursive call
          }));
        }

        console.log('✅ Processed element:', processedElement);
        return processedElement;
      };

      // Process all elements recursively
      const processedElements = (templateObj.elements || []).map(element => processElement(element));

      console.log('🔄 Final processed elements for import:', processedElements);
      console.log('🔄 Page settings:', templateObj.pageSettings);

      setElements(processedElements);
      setPageSettings(templateObj.pageSettings || {
        title: 'My Offer Page',
        backgroundColor: '#ffffff',
        maxWidth: '800px',
        fontFamily: 'Arial, sans-serif'
      });

      // Handle pagination data if present
      if (templateObj.pagination && templateObj.pagination.enabled) {
        console.log('🔄 Loading with pagination data:', templateObj.pagination);
        console.log('🔍 Template import pagination structure:', {
          hasPagination: !!templateObj.pagination,
          paginationEnabled: templateObj.pagination?.enabled,
          pagesCount: templateObj.pagination?.pages?.length,
          currentPageIndex: templateObj.pagination?.currentPageIndex,
          totalElements: processedElements.length
        });

        // Reconstruct pages from saved pagination data
        const savedPagination = templateObj.pagination;
        const reconstructedPages = [];
        let elementIndex = 0;

        for (let i = 0; i < savedPagination.pages.length; i++) {
          const pageInfo = savedPagination.pages[i];
          const pageElements = processedElements.slice(elementIndex, elementIndex + pageInfo.elementCount);

          reconstructedPages.push({
            id: pageInfo.id,
            elements: pageElements
          });

          console.log(`📄 Import reconstructed page ${i + 1}:`, {
            pageId: pageInfo.id,
            elementCount: pageInfo.elementCount,
            actualElements: pageElements.length,
            elementIds: pageElements.map(el => el.id)
          });

          elementIndex += pageInfo.elementCount;
        }

        setPages(reconstructedPages);
        setCurrentPageIndex(savedPagination.currentPageIndex || 0);
        setNextPageId(Math.max(...reconstructedPages.map(p => p.id)) + 1);
        setPaginationEnabled(true);

        console.log('✅ Pagination restored:', {
          pagesCount: reconstructedPages.length,
          currentPageIndex: savedPagination.currentPageIndex,
          totalElements: processedElements.length,
          reconstructedPages: reconstructedPages.map((page, i) => ({
            pageIndex: i,
            pageId: page.id,
            elementCount: page.elements.length
          }))
        });
      } else {
        console.log('🔄 Loading without pagination', {
          hasPagination: !!templateObj.pagination,
          paginationEnabled: templateObj.pagination?.enabled,
          totalElements: processedElements.length
        });
        // Ensure pagination is disabled for non-paginated elements
        setPaginationEnabled(false);
        setPages([{ id: 1, elements: [] }]);
        setCurrentPageIndex(0);
      }

      console.log('✅ Import completed');
    },
    togglePagination
  }));

  // Debug effect to track selectedElement changes
  useEffect(() => {
    console.log('🎯 selectedElement changed:', selectedElement);
    console.log('🎯 selectedElementContext:', selectedElementContext);
    console.log('🎯 rightPanelOpen:', rightPanelOpen);
    console.log('🎯 tabValue:', tabValue);
  }, [selectedElement, selectedElementContext, rightPanelOpen, tabValue]);


  // Close icon selector when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (iconSelectorOpen && !event.target.closest('.icon-selector-popup')) {
        setIconSelectorOpen(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [iconSelectorOpen]);

  const generateId = () => `element_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  // Video upload function
  const handleVideoUpload = useCallback(async (file, elementId, zoneContext = null) => {
    if (!file) return null;

    try {
      setImageUploading(true);
      setUploadingElementId(elementId);

      const formData = new FormData();
      formData.append('files', file);

      const response = await api.post('/offer-templates/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.attachments && response.data.attachments.length > 0) {
        const videoUrl = response.data.attachments[0].fileUrl;

        return videoUrl;
      }
    } catch (error) {
      console.error('Error uploading video:', error);
      const errorMessage = error.response?.data?.message || 'Failed to upload video. Please try again.';
      setStatusTitle('Upload Failed');
      setStatusMessage(errorMessage);
      setShowStatusAlert(true);
    } finally {
      setImageUploading(false);
      setUploadingElementId(null);
    }

    return null;
  }, []);

  // Thumbnail upload function - using same approach as BlogsPage
  const handleThumbnailUpload = useCallback(async (file, elementId, zoneContext = null) => {
    if (!file) return null;

    try {
      setImageUploading(true);
      setUploadingElementId(elementId);

      // Use the same upload approach as BlogsPage
      const uploadedUrl = await uploadToS3WithProgress(file, 'offer-templates/thumbnails', (progress) => {
        console.log('Thumbnail upload progress:', progress);
      });

      return uploadedUrl;
    } catch (error) {
      console.error('Error uploading thumbnail:', error);
      const errorMessage = error.response?.data?.message || 'Failed to upload thumbnail. Please try again.';
      setStatusTitle('Upload Failed');
      setStatusMessage(errorMessage);
      setShowStatusAlert(true);
    } finally {
      setImageUploading(false);
      setUploadingElementId(null);
    }

    return null;
  }, []);

  // Image upload function
  const handleImageUpload = useCallback(async (file, elementId, isForCallout = false, zoneContext = null, fieldName = 'content') => {
    if (!file) return null;

    try {
      setImageUploading(true);
      setUploadingElementId(elementId);

      const formData = new FormData();
      formData.append('files', file);

      const response = await api.post('/offer-templates/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.attachments && response.data.attachments.length > 0) {
        const imageUrl = response.data.attachments[0].fileUrl;

        // Update the element with the uploaded image URL
        if (!isForCallout) {
          // Use zone context if provided, otherwise use selectedElementContext
          const context = zoneContext || selectedElementContext;
          updateElement(
            elementId,
            { [fieldName]: imageUrl },
            context?.isInZone,
            context?.layoutId,
            context?.zoneId
          );

          // Force immediate re-render for image updates
          console.log('🔄 Forcing immediate re-render after image upload');
          setForceRender(prev => prev + 1);
        }

        return imageUrl;
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      const errorMessage = error.response?.data?.message || 'Failed to upload image. Please try again.';
      setStatusTitle('Upload Failed');
      setStatusMessage(errorMessage);
      setShowStatusAlert(true);
    } finally {
      setImageUploading(false);
      setUploadingElementId(null);
    }

    return null;
  }, [selectedElementContext]);

  // Pagination helper functions
  const MOBILE_PHONE_HEIGHT = 700; // Standard mobile phone height for pagination

  const calculateElementHeight = useCallback((element) => {
    // Base height estimates for different element types
    const baseHeights = {
      [ELEMENT_TYPES.HEADING]: 60,
      [ELEMENT_TYPES.TEXT]: 80,
      [ELEMENT_TYPES.IMAGE]: 200,
      [ELEMENT_TYPES.CROPPABLE_IMAGE]: 200,
      [ELEMENT_TYPES.FITTABLE_IMAGE]: 200,
      [ELEMENT_TYPES.CIRCULAR_IMAGE]: 200,
      [ELEMENT_TYPES.BUTTON]: 50,
      [ELEMENT_TYPES.VIDEO]: 250,
      [ELEMENT_TYPES.HTML]: 100,
      [ELEMENT_TYPES.DIVIDER]: 20,
      [ELEMENT_TYPES.LAYOUT]: 150,
      [ELEMENT_TYPES.CHECKLIST]: 120,
      [ELEMENT_TYPES.BUTTON_WITH_NOTICE]: 100,
      [ELEMENT_TYPES.BUTTON_IMAGE_CALLOUT]: 200,
      [ELEMENT_TYPES.BUTTON_TEXT_VARIANT]: 80,
      [ELEMENT_TYPES.BUTTON_HEADLINE_PRODUCT_IMAGE]: 300,
      [ELEMENT_TYPES.CUSTOM_LIST]: 150,
      [ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE]: 200,
      [ELEMENT_TYPES.TIMELINE_LIST]: 250,
      [ELEMENT_TYPES.PROCESS_STEPS]: 300,
      [ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE]: 250,
      [ELEMENT_TYPES.LEFT_IMAGE_TEXT]: 250,
      [ELEMENT_TYPES.QUOTATION_BLOCK]: 150,
      [ELEMENT_TYPES.FAQ_ACCORDION]: 200,
      [ELEMENT_TYPES.COMPARISON_TABLE]: 300,
      [ELEMENT_TYPES.TWO_COLUMN_COMPARISON]: 250
    };

    let height = baseHeights[element.type] || 100;

    // Adjust height based on content length for text elements
    if (element.type === ELEMENT_TYPES.TEXT || element.type === ELEMENT_TYPES.HEADING) {
      const contentLength = element.content?.length || 0;
      const lines = Math.ceil(contentLength / 50); // Rough estimate of lines
      height = Math.max(height, lines * 25);
    }

    // Adjust height for list elements based on number of items
    if (element.type === ELEMENT_TYPES.CUSTOM_LIST || element.type === ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE) {
      const itemCount = element.rows?.length || 0;
      height = Math.max(height, itemCount * 40 + 60); // 40px per item + 60px base
    }

    // Adjust height for FAQ accordion based on number of items
    if (element.type === ELEMENT_TYPES.FAQ_ACCORDION) {
      const itemCount = element.items?.length || 0;
      height = Math.max(height, itemCount * 60 + 80); // 60px per item + 80px base
    }

    // Adjust height for timeline list based on number of steps
    if (element.type === ELEMENT_TYPES.TIMELINE_LIST) {
      const stepCount = element.steps?.length || 0;
      height = Math.max(height, stepCount * 80 + 100); // 80px per step + 100px base
    }

    // Adjust height for process steps based on number of steps
    if (element.type === ELEMENT_TYPES.PROCESS_STEPS) {
      const stepCount = element.steps?.length || 0;
      height = Math.max(height, stepCount * 100 + 120); // 100px per step + 120px base
    }

    // Adjust height for layout elements based on zones - recursively calculate
    if (element.type === ELEMENT_TYPES.LAYOUT && element.zones) {
      // Find the tallest zone by recursively calculating heights of elements within zones
      const zoneHeights = element.zones.map(zone => {
        return (zone.elements || []).reduce((total, el) => {
          return total + calculateElementHeight(el) + 10; // 10px margin in zones
        }, 20); // 20px padding in zones
      });
      height = Math.max(100, ...zoneHeights); // At least 100px
    }

    return height;
  }, []);

  const calculatePageHeight = useCallback((pageElements) => {
    return pageElements.reduce((total, element) => {
      return total + calculateElementHeight(element) + 20; // Add 20px margin between elements
    }, 40); // Add 40px for page padding
  }, [calculateElementHeight]);

  // Check if brands page content exceeds height limit
  const checkBrandsPageOverflow = useCallback(() => {
    if (!isBrandsPage) return false;

    // Calculate total content height
    const totalHeight = calculatePageHeight(elements);
    return totalHeight > BRANDS_PAGE_MAX_HEIGHT;
  }, [isBrandsPage, elements, calculatePageHeight]);

  // Get brands page overflow info
  const getBrandsPageOverflowInfo = useCallback(() => {
    if (!isBrandsPage) return null;

    const totalHeight = calculatePageHeight(elements);
    const overflowHeight = totalHeight - BRANDS_PAGE_MAX_HEIGHT;

    if (overflowHeight > 0) {
      return {
        hasOverflow: true,
        totalHeight,
        maxHeight: BRANDS_PAGE_MAX_HEIGHT,
        overflowHeight
      };
    }

    return null;
  }, [isBrandsPage, elements, calculatePageHeight]);

  const getMaxPageHeight = useCallback(() => {
    // Mobile phone height minus bottom bar (60px) and content padding (32px total)
    return MOBILE_PHONE_HEIGHT - 92; // 60px bottom bar + 32px content padding
  }, []);

  const checkPageOverflow = useCallback((pageElements, newElement = null) => {
    const elementsToCheck = newElement ? [...pageElements, newElement] : pageElements;
    const pageHeight = calculatePageHeight(elementsToCheck);
    const maxHeight = getMaxPageHeight();
    const willOverflow = pageHeight > maxHeight;

    console.log('🔍 Overflow check:', {
      elementCount: elementsToCheck.length,
      pageHeight,
      maxHeight,
      willOverflow,
      elements: elementsToCheck.map(el => ({
        type: el.type,
        height: calculateElementHeight(el),
        rows: el.rows?.length || 0,
        items: el.items?.length || 0,
        steps: el.steps?.length || 0
      }))
    });

    return willOverflow;
  }, [calculatePageHeight, getMaxPageHeight]);





  // Check if elements are too long - DISABLED (manual pagination only)
  const checkAndEnablePagination = useCallback((elementsToCheck) => {
    if (!elementsToCheck || elementsToCheck.length === 0) return;

    // AUTO-PAGINATION COMPLETELY DISABLED
    // Users must manually enable pagination and split pages
    console.log('ℹ️ Auto-pagination disabled - users must manually enable pagination');
    return;
  }, []);


  // Handle sharedElements (Brands page) - Check for saved pagination data
  useEffect(() => {
    // Only apply on Brands page
    if (!isBrandsPage) return;

    if (sharedElements !== null && Array.isArray(sharedElements) && sharedElements.length > 0) {
      console.log('🔍 Brands page - loading sharedElements:', {
        isBrandsPage,
        sharedElementsLength: sharedElements.length,
        pagesLength: pages.length,
        currentPageElementsLength: pages[0]?.elements?.length || 0,
        paginationEnabled
      });

      // Skip pagination restoration if pagination is already enabled and either:
      // 1. We have multiple pages
      // 2. We have one page that's already in sync with sharedElements
      const totalElementsOnPages = pages.reduce((acc, p) => acc + (p.elements?.length || 0), 0);
      if (paginationEnabled && (pages.length > 1 || (totalElementsOnPages > 0 && totalElementsOnPages === sharedElements.length))) {
        console.log('⏭️ Brands page - Pagination already restored or in sync, skipping override', {
          pagesLength: pages.length,
          totalElementsOnPages,
          sharedElementsLength: sharedElements.length
        });
        setIsLoadingExistingContent(false);
        return;
      }

      // Check if any element has pagination data saved in content field
      let elementWithPagination = null;
      let savedPagination = null;

      // Look for pagination data in the content field of any element
      for (const element of sharedElements) {
        if (element.content) {
          try {
            const contentData = JSON.parse(element.content);
            if (contentData.pagination && contentData.pagination.enabled) {
              elementWithPagination = element;
              savedPagination = contentData.pagination;
              break;
            }
          } catch (e) {
            // Content is not JSON, skip
          }
        }
      }

      if (elementWithPagination && savedPagination) {
        console.log('🔄 Brands page - Found saved pagination data:', savedPagination);

        // Restore pagination from saved data
        const reconstructedPages = [];
        let elementIndex = 0;

        for (let i = 0; i < savedPagination.pages.length; i++) {
          const pageInfo = savedPagination.pages[i];
          const pageElements = sharedElements.slice(elementIndex, elementIndex + pageInfo.elementCount);

          reconstructedPages.push({
            id: pageInfo.id,
            elements: pageElements
          });

          console.log(`📄 Brands reconstructed page ${i + 1}:`, {
            pageId: pageInfo.id,
            elementCount: pageInfo.elementCount,
            actualElements: pageElements.length,
            elementIds: pageElements.map(el => el.id)
          });

          elementIndex += pageInfo.elementCount;
        }

        setPages(reconstructedPages);
        setCurrentPageIndex(savedPagination.currentPageIndex || 0);
        setNextPageId(Math.max(...reconstructedPages.map(p => p.id)) + 1);
        setPaginationEnabled(true);

        console.log('✅ Brands page - Restored pagination:', {
          pagesCount: reconstructedPages.length,
          currentPageIndex: savedPagination.currentPageIndex,
          totalElements: sharedElements.length,
          reconstructedPages: reconstructedPages.map((page, i) => ({
            pageIndex: i,
            pageId: page.id,
            elementCount: page.elements.length
          }))
        });
      } else {
        // No saved pagination - only set as single page if not already active with content
        const totalElementsOnPages = pages.reduce((acc, p) => acc + (p.elements?.length || 0), 0);

        if (paginationEnabled && totalElementsOnPages > 0) {
          console.log('⏭️ Brands page - Fallback reached but pagination is active and has elements. Skipping single-page override.');
        } else {
          console.log('📄 Brands page - No saved pagination, setting as single page');
          setPages([{ id: 1, elements: sharedElements }]);
          setCurrentPageIndex(0);
          setNextPageId(2);
          setPaginationEnabled(true);
        }
      }

      setIsLoadingExistingContent(false);
    }
  }, [isBrandsPage, sharedElements, pages, paginationEnabled, selectedBrand, selectedOffer]);

  // Long elements check DISABLED - manual pagination only
  useEffect(() => {
    // AUTO-PAGINATION COMPLETELY DISABLED
    // Users must manually enable pagination and split pages
    console.log('ℹ️ Long elements check disabled - manual pagination only');
  }, []);

  // Debug effect to track pagination state changes
  useEffect(() => {
    console.log('🔄 Pagination state changed:', {
      paginationEnabled,
      pagesCount: pages.length,
      currentPageIndex,
      elementsCount: elements.length
    });
  }, [paginationEnabled, pages.length, currentPageIndex, elements.length]);


  // Manual pagination toggle function
  const togglePagination = useCallback(() => {
    console.log('🔄 togglePagination clicked!', {
      paginationEnabled,
      elementsLength: elements.length,
      localElementsLength: localElements.length,
      pagesLength: pages.length,
      isBrandsPage,
      isEditingMode
    });

    if (paginationEnabled) {
      // Disable pagination - merge all pages into one
      const allElements = pages.flatMap(page => page.elements);
      setPaginationEnabled(false);
      setPages([{ id: 1, elements: allElements }]);
      setCurrentPageIndex(0);
      setNextPageId(2);
      console.log('✅ Pagination disabled, all elements merged into single page');
    } else {
      // Enable pagination - start with current elements as single page
      // Users will manually split pages using the split button
      const elementsToUse = elements.length > 0 ? elements : localElements;
      console.log('🔍 Elements to use:', elementsToUse.length, 'elements');

      if (elementsToUse.length > 0) {
        setPaginationEnabled(true);
        setPages([{ id: 1, elements: elementsToUse }]);
        setCurrentPageIndex(0);
        setNextPageId(2);
        console.log('✅ Pagination enabled - use manual split to create pages');
      } else {
        console.log('⚠️ No elements found to enable pagination');
      }
    }
  }, [paginationEnabled, pages, elements, localElements, isBrandsPage, isEditingMode]);

  // Manual page split function - split current page at a specific element
  const splitPageAtElement = useCallback((elementId) => {
    if (!paginationEnabled) {
      console.log('🚫 Pagination not enabled - cannot split page');
      return;
    }

    const currentPage = pages[currentPageIndex];
    if (!currentPage) return;

    const elementIndex = currentPage.elements.findIndex(el => el.id === elementId);
    if (elementIndex === -1 || elementIndex === 0) {
      console.log('🚫 Cannot split at this element');
      return;
    }

    // Split the current page at the element
    const elementsBeforeSplit = currentPage.elements.slice(0, elementIndex);
    const elementsAfterSplit = currentPage.elements.slice(elementIndex);

    // Create new pages
    const newPages = [...pages];
    newPages[currentPageIndex] = { ...currentPage, elements: elementsBeforeSplit };
    newPages.splice(currentPageIndex + 1, 0, { id: nextPageId, elements: elementsAfterSplit });

    setPages(newPages);
    setNextPageId(prev => prev + 1);
    setCurrentPageIndex(currentPageIndex + 1); // Move to the new page

    // Open right panel for adding new elements
    setTabValue(2); // "Add new element" tab
    setRightPanelOpen(true);

    console.log('✅ Page split at element:', elementId);
  }, [paginationEnabled, isEditingMode, pages, currentPageIndex, nextPageId, setPages, setCurrentPageIndex, setNextPageId, setTabValue, setRightPanelOpen]);

  // Manual page merge function - merge current page with next page
  const mergeWithNextPage = useCallback(() => {
    if (!paginationEnabled) {
      console.log('🚫 Pagination not enabled - cannot merge pages');
      return;
    }

    if (!isEditingMode) {
      console.log('🚫 Not in editing mode - cannot merge pages');
      return;
    }

    if (currentPageIndex >= pages.length - 1) {
      console.log('🚫 No next page to merge with');
      return;
    }

    const currentPage = pages[currentPageIndex];
    const nextPage = pages[currentPageIndex + 1];

    // Merge elements
    const mergedElements = [...currentPage.elements, ...nextPage.elements];

    // Create new pages
    const newPages = [...pages];
    newPages[currentPageIndex] = { ...currentPage, elements: mergedElements };
    newPages.splice(currentPageIndex + 1, 1);

    setPages(newPages);

    console.log('✅ Merged current page with next page');
  }, [paginationEnabled, isEditingMode, pages, currentPageIndex]);

  const moveToNewPage = useCallback(() => {
    console.log('🔄 moveToNewPage function called');

    if (!paginationEnabled) {
      console.log('🚫 Pagination not enabled - cannot move to new page');
      return;
    }

    // More permissive check: allow if we have selectedElement and pagination is enabled
    // regardless of editing mode restrictions
    if (!selectedElement) {
      console.log('🚫 No element selected - cannot move to new page');
      return;
    }

    const currentPage = pages[currentPageIndex];
    if (!currentPage) {
      console.log('🚫 No current page found');
      return;
    }

    console.log('🔍 Current page elements:', currentPage.elements.map(el => ({ id: el.id, type: el.type })));

    const elementIndex = currentPage.elements.findIndex(el => el.id === selectedElement.id);
    console.log('🔍 Element index:', elementIndex, 'for selected element:', selectedElement.id);

    if (elementIndex === -1) {
      console.log('🚫 Selected element not found in current page');
      return;
    }

    // Get elements from selected element onwards
    const elementsToMove = currentPage.elements.slice(elementIndex);
    const elementsToKeep = currentPage.elements.slice(0, elementIndex);

    console.log('🔍 Elements to move:', elementsToMove.length, elementsToMove.map(el => ({ id: el.id, type: el.type })));
    console.log('🔍 Elements to keep:', elementsToKeep.length, elementsToKeep.map(el => ({ id: el.id, type: el.type })));

    if (elementsToMove.length === 0) {
      console.log('🚫 No elements to move');
      return;
    }

    // Create new page with elements to move
    const newPage = { id: nextPageId, elements: elementsToMove };

    // Update current page to keep only elements before the selected one
    const newPages = [...pages];
    newPages[currentPageIndex] = { ...currentPage, elements: elementsToKeep };

    // Insert new page after current page
    newPages.splice(currentPageIndex + 1, 0, newPage);

    console.log('🔍 New pages structure:', newPages.map((page, idx) => ({
      index: idx,
      id: page.id,
      elementsCount: page.elements.length
    })));

    setPages(newPages);
    setNextPageId(prev => prev + 1);
    setCurrentPageIndex(currentPageIndex + 1);

    console.log('✅ Moved elements to new page:', {
      elementsMoved: elementsToMove.length,
      elementsKept: elementsToKeep.length,
      newPageId: newPage.id,
      newCurrentPageIndex: currentPageIndex + 1
    });
  }, [paginationEnabled, selectedElement, pages, currentPageIndex, nextPageId]);

  // Add new empty page - similar to blog creation
  const addPage = useCallback(() => {
    console.log('📄 addPage function called');

    // Add a new empty page right after the current page
    setPages(prev => {
      const newPage = {
        id: nextPageId,
        elements: []
      };

      // Insert the new page right after the current page
      const newPages = [
        ...prev.slice(0, currentPageIndex + 1),
        newPage,
        ...prev.slice(currentPageIndex + 1)
      ];

      // Switch to the new page
      setTimeout(() => {
        setCurrentPageIndex(currentPageIndex + 1);

        // Deselect any current element to focus on the new page
        setSelectedElement(null);

        // Open right panel for adding new elements
        setTabValue(2); // "Add new element" tab
        setRightPanelOpen(true);
      }, 0);

      return newPages;
    });

    setNextPageId(prev => prev + 1);
    console.log('📄 Added new empty page after current page');
  }, [currentPageIndex, nextPageId, setSelectedElement, setTabValue, setRightPanelOpen, setPages, setNextPageId, setCurrentPageIndex]);

  // Reset pagination - merge all pages back into one


  // Page navigation functions
  const goToPage = useCallback((pageIndex) => {
    if (pageIndex >= 0 && pageIndex < pages.length) {
      setCurrentPageIndex(pageIndex);
    }
  }, [pages.length]);

  const goToNextPage = useCallback(() => {
    if (currentPageIndex < pages.length - 1) {
      setCurrentPageIndex(prev => prev + 1);
    }
  }, [currentPageIndex, pages.length]);

  const goToPreviousPage = useCallback(() => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(prev => prev - 1);
    }
  }, [currentPageIndex]);


  const deletePage = useCallback((pageIndex) => {
    if (pages.length > 1) {
      // Multiple pages: just remove the specified page
      setPages(prev => prev.filter((_, index) => index !== pageIndex));
      if (currentPageIndex >= pageIndex && currentPageIndex > 0) {
        setCurrentPageIndex(prev => prev - 1);
      }
    } else {
      // Only one page: clear its content instead of deleting
      setPages([{ id: 1, elements: [] }]);
      setCurrentPageIndex(0);
    }
  }, [pages.length, currentPageIndex]);

  const addElement = useCallback((elementType) => {
    // Special handling for Layout element - show layout selector dialog
    if (elementType === ELEMENT_TYPES.LAYOUT) {
      setShowLayoutSelector(true);
      return;
    }

    // In brands page mode, use FITTABLE_IMAGE instead of IMAGE for better zoom/positioning functionality
    let actualElementType = elementType;
    if (isBrandsPage && elementType === ELEMENT_TYPES.IMAGE) {
      actualElementType = ELEMENT_TYPES.FITTABLE_IMAGE;
    }

    const newElement = {
      id: generateId(),
      ...DEFAULT_ELEMENTS[actualElementType]
    };

    // Check if we should insert after a specific element (from add button click)
    let insertIndex = -1;
    let targetElementId = insertAfterElementId;

    // Clear the insertAfterElementId after using it
    if (targetElementId) {
      setInsertAfterElementId(null);
    }

    if (targetElementId) {
      // Find the target element's position in the current page
      const currentPage = pages[currentPageIndex] || pages[0];
      insertIndex = currentPage.elements.findIndex(el => el.id === targetElementId);
      if (insertIndex !== -1) {
        insertIndex = insertIndex + 1; // Insert right after target element
      }
    }

    // Always add to current page (no overflow detection)
    setPages(prevPages => {
      const safeIndex = Math.min(currentPageIndex, prevPages.length - 1);
      const currentPage = prevPages[safeIndex];

      // Insert after selected element if found, otherwise append to end
      let newPageElements;
      if (insertIndex !== -1 && insertIndex <= currentPage.elements.length) {
        newPageElements = [...currentPage.elements];
        newPageElements.splice(insertIndex, 0, newElement);
      } else {
        newPageElements = [...currentPage.elements, newElement];
      }

      // Update the current page with new elements
      const updatedPages = prevPages.map((page, index) =>
        index === safeIndex
          ? { ...page, elements: newPageElements }
          : page
      );

      return updatedPages;
    });

    // Update flat elements array for non-paginated views
    setElements(prev => [...prev, newElement]);

    console.log('✅ Element added to current page:', { elementType: actualElementType, pageIndex: currentPageIndex });
  }, [insertAfterElementId, pages, currentPageIndex, setPages, setElements, isBrandsPage]);


  const PaginationControls = () => {
    if (!paginationEnabled) return null;

    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
        backgroundColor: '#f5f5f5',
        borderRadius: 1,
        mb: 2,
        border: '1px solid #e0e0e0'
      }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Page {currentPageIndex + 1} of {pages.length}
        </Typography>

        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            variant="outlined"
            disabled={currentPageIndex === 0}
            onClick={goToPreviousPage}
          >
            ← Previous
          </Button>

          <Button
            size="small"
            variant="outlined"
            disabled={currentPageIndex === pages.length - 1}
            onClick={goToNextPage}
          >
            Next →
          </Button>
        </Box>


        {/* Manual page management buttons - only in editing mode */}
        {isEditingMode && (
          <>
            {pages.length > 1 && currentPageIndex < pages.length - 1 && (
              <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={mergeWithNextPage}
              >
                Merge with Next Page
              </Button>
            )}

            {pages.length > 1 && (
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={() => deletePage(currentPageIndex)}
              >
                Delete Page
              </Button>
            )}
          </>
        )}

        {/* Page Navigation Dots */}
        <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
          {pages.map((_, index) => (
            <Button
              key={index}
              size="small"
              variant={index === currentPageIndex ? "contained" : "outlined"}
              onClick={() => goToPage(index)}
              sx={{ minWidth: '32px', height: '32px', p: 0 }}
            >
              {index + 1}
            </Button>
          ))}
        </Box>
      </Box>
    );
  };

  // Helper function to recursively find and update nested layouts
  const findAndUpdateLayout = useCallback((elements, layoutId, zoneId, updateFn) => {
    const updateElements = (elementsArray) => {
      let foundInThisLevel = false;

      const result = elementsArray.map(el => {
        // Check if this element is the target layout
        if (el.id === layoutId && el.type === ELEMENT_TYPES.LAYOUT) {
          console.log('✅ Found target layout:', layoutId);
          foundInThisLevel = true;
          return {
            ...el,
            zones: el.zones.map(zone => {
              if (zone.id === zoneId) {
                console.log('✅ Found target zone:', zoneId);
                const updatedZone = updateFn(zone);
                console.log('🔄 Zone updated from', zone.elements?.length, 'to', updatedZone.elements?.length, 'elements');
                return updatedZone;
              }
              return zone;
            })
          };
        }

        // If this element is a layout and we haven't found the target yet, recursively search its zones
        if (!foundInThisLevel && el.type === ELEMENT_TYPES.LAYOUT && el.zones) {
          let foundInNested = false;
          const updatedZones = el.zones.map(zone => {
            const recursiveResult = updateElements(zone.elements);
            const wasUpdated = recursiveResult.some((newEl, index) =>
              newEl !== zone.elements[index]
            );

            if (wasUpdated) {
              foundInNested = true;
              return { ...zone, elements: recursiveResult };
            }
            return zone;
          });

          if (foundInNested) {
            console.log('🔄 Updated nested layout in zone');
            foundInThisLevel = true;
            return { ...el, zones: updatedZones };
          }
        }

        return el;
      });

      return result;
    };

    return updateElements(elements);
  }, []);

  const addLayout = useCallback((layoutType) => {
    console.log('🏗️ addLayout called:', { layoutType, targetZone });

    const config = LAYOUT_CONFIGS[layoutType];
    const newLayout = {
      id: generateId(),
      type: ELEMENT_TYPES.LAYOUT,
      layoutType,
      zones: config.zones.map(zone => ({
        ...zone,
        id: `${generateId()}-${zone.id}`,
        elements: []
      })),
      styles: {
        marginBottom: '20px',
        padding: '20px',
        border: '2px dashed #e0e0e0',
        borderRadius: '8px'
      }
    };

    console.log('🆕 Created new layout:', newLayout);

    if (targetZone) {
      console.log('🎯 Adding layout to zone:', targetZone);

      // Update pages if pagination enabled
      if (paginationEnabled) {
        setPages(prevPages => {
          const safeIndex = Math.min(currentPageIndex, prevPages.length - 1);
          return prevPages.map((page, index) => {
            if (index === safeIndex) {
              const result = findAndUpdateLayout(page.elements, targetZone.layoutId, targetZone.zoneId, (zone) => ({
                ...zone,
                elements: [...zone.elements, newLayout]
              }));
              return { ...page, elements: result };
            }
            return page;
          });
        });
      }

      // Add layout to a specific zone (nested layout) - supports deeply nested layouts
      setElements(prev => {
        const result = findAndUpdateLayout(prev, targetZone.layoutId, targetZone.zoneId, (zone) => {
          console.log('✅ Adding nested layout to zone:', zone.id);
          return {
            ...zone,
            elements: [...zone.elements, newLayout]
          };
        });
        console.log('📋 Updated elements array with nested layout:', result);
        return result;
      });
      setTargetZone(null); // Clear target zone
    } else {
      console.log('🎨 Adding layout to main canvas');

      // Update pages if pagination enabled
      if (paginationEnabled) {
        setPages(prevPages => {
          const safeIndex = Math.min(currentPageIndex, prevPages.length - 1);
          return prevPages.map((page, index) =>
            index === safeIndex
              ? { ...page, elements: [...page.elements, newLayout] }
              : page
          );
        });
      }

      // Add layout to main canvas
      setElements(prev => [...prev, newLayout]);
    }

    setShowLayoutSelector(false);
  }, [targetZone, paginationEnabled, currentPageIndex, findAndUpdateLayout]);



  const addElementToZone = useCallback((elementType, layoutId, zoneId) => {
    console.log('🎯 addElementToZone called:', { elementType, layoutId, zoneId });

    // Ignore calls with undefined layoutId or zoneId (can happen during dialog transitions)
    if (!layoutId || !zoneId) {
      console.log('⚠️ Ignoring addElementToZone call with undefined layoutId or zoneId');
      return;
    }

    // Special handling for Layout element - show layout selector dialog for nested layouts
    if (elementType === ELEMENT_TYPES.LAYOUT) {
      console.log('📐 Layout element detected - showing layout selector');
      setTargetZone({ layoutId, zoneId }); // Store where to add the layout
      setShowLayoutSelector(true);
      console.log('🔄 Set showLayoutSelector to true, targetZone:', { layoutId, zoneId });
      return;
    }

    // In brands page mode, use FITTABLE_IMAGE instead of IMAGE for better zoom/positioning functionality
    let actualElementType = elementType;
    if (isBrandsPage && elementType === ELEMENT_TYPES.IMAGE) {
      actualElementType = ELEMENT_TYPES.FITTABLE_IMAGE;
    }

    const newElement = {
      id: generateId(),
      ...DEFAULT_ELEMENTS[actualElementType]
    };

    console.log('🆕 Creating new element:', newElement);

    // Update pages if pagination enabled
    if (paginationEnabled) {
      setPages(prevPages => {
        const safeIndex = Math.min(currentPageIndex, prevPages.length - 1);
        return prevPages.map((page, index) => {
          if (index === safeIndex) {
            const result = findAndUpdateLayout(page.elements, layoutId, zoneId, (zone) => ({
              ...zone,
              elements: [...zone.elements, newElement]
            }));
            return { ...page, elements: result };
          }
          return page;
        });
      });
    }

    // Use recursive function to find and update the target layout (supports nested layouts)
    setElements(prev => {
      const result = findAndUpdateLayout(prev, layoutId, zoneId, (zone) => ({
        ...zone,
        elements: [...zone.elements, newElement]
      }));

      console.log('📋 Element added to nested layout successfully');
      return result;
    });
  }, [findAndUpdateLayout, paginationEnabled, currentPageIndex, isBrandsPage]);

  // Helper function to delete element from nested layouts
  const deleteElementFromZone = useCallback((elementId, layoutId, zoneId) => {
    console.log('🗑️ Deleting element from zone:', { elementId, layoutId, zoneId });

    // Find the element to be deleted from the zone
    const elementToDelete = elements.find(el => {
      if (el.id === layoutId && el.zones) {
        const zone = el.zones.find(z => z.id === zoneId);
        return zone && zone.elements.some(zoneEl => zoneEl.id === elementId);
      }
      return false;
    });

    if (elementToDelete) {
      const zone = elementToDelete.zones.find(z => z.id === zoneId);
      const zoneElement = zone?.elements.find(el => el.id === elementId);

      if (zoneElement) {
        // Find the original index of the element in the zone
        const originalIndex = zone.elements.findIndex(el => el.id === elementId);

        // Add to deletion history for undo functionality
        console.log('🔄 Adding zone element to deletion history:', zoneElement, 'at index:', originalIndex);
        setDeletedElementsHistory(prev => [...prev, {
          element: zoneElement,
          zone: { layoutId, zoneId },
          originalIndex: originalIndex,
          timestamp: Date.now()
        }]);
        setShowUndoNotification(true);
      }
    }

    // Update pages if pagination enabled
    if (paginationEnabled) {
      setPages(prevPages => {
        return prevPages.map(page => ({
          ...page,
          elements: findAndUpdateLayout(page.elements, layoutId, zoneId, (zone) => ({
            ...zone,
            elements: zone.elements.filter(el => el.id !== elementId)
          }))
        }));
      });
    }

    setElements(prev =>
      findAndUpdateLayout(prev, layoutId, zoneId, (zone) => ({
        ...zone,
        elements: zone.elements.filter(el => el.id !== elementId)
      }))
    );
  }, [findAndUpdateLayout, paginationEnabled]);

  // Drag and drop handlers
  const handleDragStart = useCallback((e, elementType) => {
    console.log('🚀 handleDragStart called:', { elementType });
    setDraggedElement(elementType);
    e.dataTransfer.effectAllowed = 'copy';
  }, []);

  const handleDragOver = useCallback((e, zoneInfo) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling to parent layouts
    e.dataTransfer.dropEffect = 'copy';
    setDragOverZone(zoneInfo);
  }, []);

  const handleDragLeave = useCallback(() => {
    setDragOverZone(null);
  }, []);

  const handleDrop = useCallback((e, layoutId, zoneId) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling to parent layouts
    console.log('💧 handleDrop called:', { draggedElement, layoutId, zoneId });

    // Only process valid drops with draggedElement and valid layoutId/zoneId
    if (draggedElement && layoutId && zoneId) {
      addElementToZone(draggedElement, layoutId, zoneId);
      setDraggedElement(null);
      setDragOverZone(null);
    } else {
      console.log('⚠️ Ignoring invalid drop:', { draggedElement, layoutId, zoneId });
    }
  }, [draggedElement, addElementToZone]);

  // Enhanced drag and drop for repositioning elements
  const onDragEnd = useCallback((result) => {
    console.log('🎯 onDragEnd called with result:', result);

    const { destination, source, draggableId } = result;

    // Dropped outside the list
    if (!destination) {
      console.log('❌ Dropped outside list, returning');
      return;
    }

    // Dropped in the same position
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      console.log('❌ Dropped in same position, returning');
      return;
    }

    console.log('🔄 Element repositioning:', { source, destination, draggableId });
    console.log('📊 Current elements before update:', elements.length);

    // Parse source and destination
    const sourceId = source.droppableId;
    const destId = destination.droppableId;

    // Helper function to move element between containers
    const moveElementBetweenContainers = () => {
      console.log('🚀 Moving element between containers', { sourceId, destId });
      setElements(prev => {
        let sourceElement = null;
        let newElements = [...prev];

        console.log('📦 Extracting from source:', sourceId);
        // Extract element from source
        if (sourceId === 'main-canvas') {
          console.log('📤 Extracting from main canvas, index:', source.index);
          // From main canvas
          sourceElement = newElements[source.index];
          newElements.splice(source.index, 1);
          console.log('📤 Extracted element:', sourceElement?.type, sourceElement?.id);
        } else if (sourceId.startsWith('zone-')) {
          // From a zone: format is "zone-layoutId-zoneId"
          const parts = sourceId.split('-');
          const layoutId = parts[1];
          const zoneId = parts.slice(2).join('-'); // Rejoin remaining parts as zoneId may contain dashes
          console.log('📤 Extracting from zone:', { layoutId, zoneId, index: source.index });
          newElements = findAndUpdateLayout(newElements, layoutId, zoneId, (zone) => {
            sourceElement = zone.elements[source.index];
            const newZoneElements = [...zone.elements];
            newZoneElements.splice(source.index, 1);
            console.log('📤 Extracted element from zone:', sourceElement?.type, sourceElement?.id);
            return { ...zone, elements: newZoneElements };
          });
        }

        if (!sourceElement) {
          console.log('❌ No source element found, returning original state');
          return prev;
        }

        console.log('📥 Inserting into destination:', destId);
        // Insert element into destination
        if (destId === 'main-canvas') {
          console.log('📥 Inserting into main canvas, index:', destination.index);
          // To main canvas
          newElements.splice(destination.index, 0, sourceElement);
        } else if (destId.startsWith('zone-')) {
          // To a zone: format is "zone-layoutId-zoneId"
          const parts = destId.split('-');
          const layoutId = parts[1];
          const zoneId = parts.slice(2).join('-'); // Rejoin remaining parts as zoneId may contain dashes
          console.log('📥 Inserting into zone:', { layoutId, zoneId, index: destination.index });
          newElements = findAndUpdateLayout(newElements, layoutId, zoneId, (zone) => {
            const newZoneElements = [...zone.elements];
            newZoneElements.splice(destination.index, 0, sourceElement);
            console.log('📥 Inserted element into zone');
            return { ...zone, elements: newZoneElements };
          });
        }

        console.log('✅ Cross-container move complete');
        return newElements;
      });
    };

    // Same container reordering
    if (sourceId === destId) {
      console.log('🔄 Same container reordering');
      if (sourceId === 'main-canvas') {
        console.log('🎯 Reordering in main canvas');
        // Reorder in main canvas
        setElements(prev => {
          console.log('📝 Main canvas reorder - before:', prev.length);
          const result = Array.from(prev);
          const [removed] = result.splice(source.index, 1);
          result.splice(destination.index, 0, removed);
          console.log('📝 Main canvas reorder - after:', result.length);
          return result;
        });
      } else if (sourceId.startsWith('zone-')) {
        console.log('🎯 Reordering within zone:', sourceId);
        // Reorder within zone
        const parts = sourceId.split('-');
        const layoutId = parts[1];
        const zoneId = parts.slice(2).join('-'); // Rejoin remaining parts as zoneId may contain dashes
        console.log('🔍 Parsed zone info:', { layoutId, zoneId });
        setElements(prev =>
          findAndUpdateLayout(prev, layoutId, zoneId, (zone) => {
            console.log('📝 Zone reorder - before:', zone.elements.length);
            const result = Array.from(zone.elements);
            const [removed] = result.splice(source.index, 1);
            result.splice(destination.index, 0, removed);
            console.log('📝 Zone reorder - after:', result.length);
            return { ...zone, elements: result };
          })
        );
      }
    } else {
      console.log('🔄 Cross-container movement');
      // Cross-container movement
      moveElementBetweenContainers();
    }
  }, [findAndUpdateLayout]);

  // Inline editing handlers
  const startInlineEdit = useCallback((elementId, field, currentValue, isInZone = false, layoutId = null, zoneId = null) => {
    setEditingElement({ elementId, isInZone, layoutId, zoneId });
    setEditingField(field);
    setTempValue(currentValue || '');
  }, []);

  const saveInlineEdit = useCallback(() => {
    if (!editingElement || !editingField) return;

    const updateElementField = (element) => {
      // Handle nested fields for CUSTOM_LIST rows
      if (element.type === ELEMENT_TYPES.CUSTOM_LIST && editingField.startsWith('rows.')) {
        const match = editingField.match(/^rows\.(\d+)\.text$/);
        if (match) {
          const idx = parseInt(match[1], 10);
          const newRows = [...element.rows];
          newRows[idx] = { ...newRows[idx], text: tempValue };
          return { ...element, rows: newRows };
        }
      }
      // Handle nested fields for FAQAccordion
      if (element.type === ELEMENT_TYPES.FAQ_ACCORDION && editingField.startsWith('items.')) {
        const match = editingField.match(/^items\.(\d+)\.(question|answer)$/);
        if (match) {
          const idx = parseInt(match[1], 10);
          const field = match[2];
          const newItems = [...element.items];
          newItems[idx] = { ...newItems[idx], [field]: tempValue };
          return { ...element, items: newItems };
        }
      }
      if (element.type === ELEMENT_TYPES.FAQ_ACCORDION && editingField === 'title') {
        return { ...element, title: tempValue };
      }
      // Handle nested fields for ComparisonTable
      if (element.type === ELEMENT_TYPES.COMPARISON_TABLE && editingField.startsWith('rows.')) {
        const match = editingField.match(/^rows\.(\d+)\.(feature|description)$/);
        if (match) {
          const idx = parseInt(match[1], 10);
          const field = match[2];
          const newRows = [...element.rows];
          newRows[idx] = { ...newRows[idx], [field]: tempValue };
          return { ...element, rows: newRows };
        }
      }
      if (element.type === ELEMENT_TYPES.COMPARISON_TABLE && (editingField === 'title' || editingField === 'productA' || editingField === 'productB')) {
        return { ...element, [editingField]: tempValue };
      }
      // Handle nested fields for TIMELINE_LIST steps
      if (element.type === ELEMENT_TYPES.TIMELINE_LIST && editingField.startsWith('steps.')) {
        const match = editingField.match(/^steps\.(\d+)\.(stageLabel|title|description)$/);
        if (match) {
          const idx = parseInt(match[1], 10);
          const field = match[2];
          const newSteps = [...element.steps];
          newSteps[idx] = { ...newSteps[idx], [field]: tempValue };
          return { ...element, steps: newSteps };
        }
      }
      // Handle nested fields for PROCESS_STEPS steps
      if (element.type === ELEMENT_TYPES.PROCESS_STEPS && editingField.startsWith('steps.')) {
        const match = editingField.match(/^steps\.(\d+)\.(title|description|image)$/);
        if (match) {
          const idx = parseInt(match[1], 10);
          const field = match[2];
          const newSteps = [...element.steps];
          newSteps[idx] = { ...newSteps[idx], [field]: tempValue };
          return { ...element, steps: newSteps };
        }
      }
      // Handle nested fields for TEXT_WITH_RIGHT_IMAGE content
      if (element.type === ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE && editingField.startsWith('content.')) {
        const match = editingField.match(/^content\.(text|image)$/);
        if (match) {
          const field = match[1];
          return {
            ...element,
            content: {
              ...element.content,
              [field]: tempValue
            }
          };
        }
      }
      // Handle nested fields for LEFT_IMAGE_TEXT content
      if (element.type === ELEMENT_TYPES.LEFT_IMAGE_TEXT && editingField.startsWith('content.')) {
        const match = editingField.match(/^content\.(text|image)$/);
        if (match) {
          const field = match[1];
          return {
            ...element,
            content: {
              ...element.content,
              [field]: tempValue
            }
          };
        }
      }
      // Handle nested fields for BUTTON_WITH_NOTICE
      if (element.type === ELEMENT_TYPES.BUTTON_WITH_NOTICE && editingField.includes('.')) {
        const [parentField, childField] = editingField.split('.');
        return {
          ...element,
          [parentField]: {
            ...element[parentField],
            [childField]: tempValue
          }
        };
      }
      // Handle direct fields for other elements
      else {
        return { ...element, [editingField]: tempValue };
      }
    };

    if (editingElement.isInZone) {
      // Update element in zone (supports deeply nested layouts)
      if (paginationEnabled) {
        // Pagination mode - update current page
        setPages(prev => prev.map((page, pageIndex) => {
          if (pageIndex === currentPageIndex) {
            return {
              ...page,
              elements: findAndUpdateLayout(page.elements, editingElement.layoutId, editingElement.zoneId, (zone) => ({
                ...zone,
                elements: zone.elements.map(zoneEl => {
                  if (zoneEl.id === editingElement.elementId) {
                    return updateElementField(zoneEl);
                  }
                  return zoneEl;
                })
              }))
            };
          }
          return page;
        }));
      } else {
        // Non-pagination mode - update elements directly
        setElements(prev => findAndUpdateLayout(prev, editingElement.layoutId, editingElement.zoneId, (zone) => ({
          ...zone,
          elements: zone.elements.map(zoneEl => {
            if (zoneEl.id === editingElement.elementId) {
              return updateElementField(zoneEl);
            }
            return zoneEl;
          })
        })));
      }
    } else {
      // Update element in main canvas
      if (paginationEnabled) {
        // Pagination mode - update current page
        setPages(prev => prev.map((page, pageIndex) => {
          if (pageIndex === currentPageIndex) {
            return {
              ...page,
              elements: page.elements.map(el =>
                el.id === editingElement.elementId
                  ? updateElementField(el)
                  : el
              )
            };
          }
          return page;
        }));
      } else {
        // Non-pagination mode - update elements directly
        setElements(prev => prev.map(el =>
          el.id === editingElement.elementId
            ? updateElementField(el)
            : el
        ));
      }
    }

    // Update selectedElement if it matches the edited element to sync with Content tab
    if (selectedElement?.id === editingElement.elementId) {
      const updatedSelectedElement = updateElementField(selectedElement);
      console.log('🔄 Syncing selectedElement after inline edit:', updatedSelectedElement);
      setSelectedElement(updatedSelectedElement);
    }

    setEditingElement(null);
    setEditingField(null);
    setTempValue('');
    // Reset text editor initialization flag for next editing session
    window.textEditorInitialized = false;
  }, [editingElement, editingField, tempValue, selectedElement, paginationEnabled, currentPageIndex]);

  const cancelInlineEdit = useCallback(() => {
    setEditingElement(null);
    setEditingField(null);
    setTempValue('');
    // Reset text editor initialization flag for next editing session
    window.textEditorInitialized = false;
  }, []);

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      saveInlineEdit();
    } else if (e.key === 'Escape') {
      cancelInlineEdit();
    }
  }, [saveInlineEdit, cancelInlineEdit]);


  // Drag handlers for popover
  const handleMouseDown = useCallback((e) => {
    if (e.target.closest('[data-draggable-handle]')) {
      setIsDragging(true);
      const rect = e.currentTarget.getBoundingClientRect();
      setDragOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      });
      e.preventDefault();
      e.stopPropagation();
    }
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (isDragging) {
      const newX = e.clientX - dragOffset.x;
      const newY = e.clientY - dragOffset.y;

      // Keep popover within viewport bounds
      const maxX = window.innerWidth - 520; // 500px width + some margin
      const maxY = window.innerHeight - 100; // Some margin from bottom

      setPopoverPosition({
        x: Math.max(0, Math.min(newX, maxX)),
        y: Math.max(0, Math.min(newY, maxY))
      });
    }
  }, [isDragging, dragOffset]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  // Image resize handlers
  const [isResizing, setIsResizing] = useState(false);
  const [resizeDirection, setResizeDirection] = useState(null);
  const [resizeStartData, setResizeStartData] = useState(null);
  const isResizingRef = useRef(false);
  const resizeStartDataRef = useRef(null);
  const resizeDirectionRef = useRef(null);

  const handleResizeMove = useCallback((e) => {
    if (!isResizingRef.current || !resizeStartDataRef.current) {
      console.log('🔴 Resize move skipped:', {
        isResizing: isResizingRef.current,
        hasResizeData: !!resizeStartDataRef.current
      });
      return;
    }

    console.log('🔴 Resize move:', {
      clientX: e.clientX,
      clientY: e.clientY,
      deltaX: e.clientX - resizeStartDataRef.current.startX,
      deltaY: e.clientY - resizeStartDataRef.current.startY,
      direction: resizeDirectionRef.current
    });

    const deltaX = e.clientX - resizeStartDataRef.current.startX;
    const deltaY = e.clientY - resizeStartDataRef.current.startY;

    let newWidth = resizeStartDataRef.current.startWidth;
    let newHeight = resizeStartDataRef.current.startHeight;

    // Calculate new dimensions based on resize direction
    switch (resizeDirectionRef.current) {
      case 'se':
        newWidth = Math.max(50, resizeStartDataRef.current.startWidth + deltaX);
        newHeight = Math.max(50, resizeStartDataRef.current.startHeight + deltaY);
        break;
      case 'sw':
        newWidth = Math.max(50, resizeStartDataRef.current.startWidth - deltaX);
        newHeight = Math.max(50, resizeStartDataRef.current.startHeight + deltaY);
        break;
      case 'ne':
        newWidth = Math.max(50, resizeStartDataRef.current.startWidth + deltaX);
        newHeight = Math.max(50, resizeStartDataRef.current.startHeight - deltaY);
        break;
      case 'nw':
        newWidth = Math.max(50, resizeStartDataRef.current.startWidth - deltaX);
        newHeight = Math.max(50, resizeStartDataRef.current.startHeight - deltaY);
        break;
      case 'e':
        newWidth = Math.max(50, resizeStartDataRef.current.startWidth + deltaX);
        break;
      case 'w':
        newWidth = Math.max(50, resizeStartDataRef.current.startWidth - deltaX);
        break;
      case 's':
        newHeight = Math.max(50, resizeStartDataRef.current.startHeight + deltaY);
        break;
      case 'n':
        newHeight = Math.max(50, resizeStartDataRef.current.startHeight - deltaY);
        break;
    }

    // Update element styles
    const updateElementStyles = (element) => ({
      ...element,
      styles: {
        ...element.styles,
        width: `${newWidth}px`,
        height: `${newHeight}px`
      }
    });

    // Find and update the element
    const updateElementInArray = (elements) => {
      return elements.map(el => {
        if (el.id === resizeStartDataRef.current.elementId) {
          return updateElementStyles(el);
        }
        // Check if element is in a layout zone
        if (el.type === ELEMENT_TYPES.LAYOUT && el.zones) {
          return {
            ...el,
            zones: el.zones.map(zone => ({
              ...zone,
              elements: zone.elements.map(zoneEl =>
                zoneEl.id === resizeStartDataRef.current.elementId
                  ? updateElementStyles(zoneEl)
                  : zoneEl
              )
            }))
          };
        }
        return el;
      });
    };

    setElements(prev => updateElementInArray(prev));

    // Update selectedElement if it matches
    if (selectedElement?.id === resizeStartDataRef.current.elementId) {
      setSelectedElement(updateElementStyles(selectedElement));
    }
  }, [isResizing, resizeStartData, resizeDirection, selectedElement]);

  const handleResizeEnd = useCallback(() => {
    setIsResizing(false);
    setResizeDirection(null);
    setResizeStartData(null);
    isResizingRef.current = false;
    resizeDirectionRef.current = null;
    resizeStartDataRef.current = null;

    // Remove global event listeners
    document.removeEventListener('mousemove', handleResizeMove);
    document.removeEventListener('mouseup', handleResizeEnd);
  }, [handleResizeMove]);

  const handleResizeStart = useCallback((e, element, direction) => {
    console.log('🔴 Resize start:', { direction, elementId: element.id });
    e.preventDefault();
    e.stopPropagation();

    setIsResizing(true);
    setResizeDirection(direction);
    isResizingRef.current = true;
    resizeDirectionRef.current = direction;

    // Get the image element to measure its actual size
    const imageElement = e.currentTarget.closest('.resize-handles')?.previousElementSibling;
    const imageRect = imageElement?.getBoundingClientRect() || e.currentTarget.getBoundingClientRect();

    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = imageRect.width;
    const startHeight = imageRect.height;

    console.log('🔴 Resize data:', { startX, startY, startWidth, startHeight });

    const resizeData = {
      startX,
      startY,
      startWidth,
      startHeight,
      elementId: element.id
    };

    setResizeStartData(resizeData);
    resizeStartDataRef.current = resizeData;

    // Add global event listeners
    document.addEventListener('mousemove', handleResizeMove);
    document.addEventListener('mouseup', handleResizeEnd);
  }, [handleResizeMove, handleResizeEnd]);

  // Add/remove global event listeners
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'grabbing';
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.style.cursor = 'default';
      };
    }
  }, [isDragging, handleMouseMove, handleMouseUp]);

  // Helper function to filter out unwanted templates
  const filterLegitimateTemplates = (templates) => {
    if (!templates || !Array.isArray(templates)) return [];

    return templates.filter(template => {
      // Filter out converted templates only
      if (template.description && template.description.toLowerCase().includes('converted')) {
        console.log(`🗑️  Filtering out converted template: ${template.name}`);
        return false;
      }

      return true;
    });
  };

  // Helper function to group templates by type and subtype
  const groupTemplatesByType = (templates) => {
    if (!templates || !Array.isArray(templates)) return {};

    console.log('🔍 Grouping templates:', templates.map(t => ({ name: t.name, type: t.type, subtype: t.subtype })));

    const grouped = templates.reduce((acc, template) => {
      const type = template.type || 'Other';
      const subtype = template.subtype || 'Other';

      console.log(`📁 Processing template: ${template.name} with type: "${type}" and subtype: "${subtype}"`);

      if (!acc[type]) {
        acc[type] = {};
      }
      if (!acc[type][subtype]) {
        acc[type][subtype] = [];
      }
      acc[type][subtype].push(template);
      return acc;
    }, {});

    console.log('📊 Grouped templates:', grouped);

    // Sort types alphabetically and sort subtypes and templates within each
    const sortedGrouped = {};
    Object.keys(grouped).sort().forEach(type => {
      sortedGrouped[type] = {};
      Object.keys(grouped[type]).sort().forEach(subtype => {
        sortedGrouped[type][subtype] = grouped[type][subtype].sort((a, b) => a.name.localeCompare(b.name));
      });
    });

    console.log('🎯 Final sorted grouped templates:', sortedGrouped);
    return sortedGrouped;
  };

  // Template management functions
  const loadTemplates = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      console.log('Loading templates with token:', token ? 'Token exists' : 'No token found');

      // Determine which endpoint to use based on user role
      // Check if user is admin by looking at the token payload
      let isAdmin = false;
      try {
        const tokenPayload = JSON.parse(atob(token.split('.')[1]));
        isAdmin = tokenPayload.role === 'admin';
        console.log('User role from token:', tokenPayload.role, 'isAdmin:', isAdmin);
      } catch (e) {
        console.log('Could not decode token, defaulting to user endpoint');
      }

      const endpoint = isAdmin
        ? `${API_URL}/offer-templates/admin/all-templates?limit=100`
        : `${API_URL}/offer-templates/user/my-templates?limit=100`;

      console.log('Using endpoint:', endpoint);

      const response = await fetch(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('Load templates response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        console.log('Templates loaded:', data);
        console.log('🔍 LOADED TEMPLATES FROM SERVER:', data.templates?.map(t => ({
          name: t.name,
          id: t._id,
          type: t.type,
          subtype: t.subtype,
          createdBy: t.createdBy,
          elements: t.elements ? t.elements.length : 0,
          firstElement: t.elements?.[0]
        })));

        // Filter out unwanted templates
        const filteredTemplates = filterLegitimateTemplates(data.templates);
        console.log(`📊 Filtered templates: ${data.templates?.length || 0} → ${filteredTemplates.length}`);

        // Create deep copies to prevent reference sharing
        const templatesCopy = filteredTemplates.map(template => ({
          ...template,
          elements: template.elements ? JSON.parse(JSON.stringify(template.elements)) : [],
          pageSettings: template.pageSettings ? JSON.parse(JSON.stringify(template.pageSettings)) : null
        })) || [];

        setSavedTemplates(templatesCopy);
      } else {
        console.error('Failed to load templates - Status:', response.status);
        const errorText = await response.text();
        console.error('Error response:', errorText);
      }
    } catch (error) {
      console.error('Failed to load templates:', error);
    }
  }, []);

  const saveTemplate = useCallback(async () => {
    if (!templateName.trim()) {
      setStatusTitle('Missing Information');
      setStatusMessage('Please enter a template name');
      setShowStatusAlert(true);
      return;
    }

    if (!templateType) {
      setStatusTitle('Missing Information');
      setStatusMessage('Please select a template type');
      setShowStatusAlert(true);
      return;
    }

    if (!templateSubtype) {
      setStatusTitle('Missing Information');
      setStatusMessage('Please select a template subtype');
      setShowStatusAlert(true);
      return;
    }

    try {
      const templateData = {
        name: templateName,
        description: `Page builder template with ${elements.length} elements`,
        category: 'product', // Default category
        type: templateType,
        subtype: templateSubtype,
        elements: elements,
        pageSettings: pageSettings,
        template: {
          title: pageSettings.title || 'My Offer Page',
          description: `Page builder template with ${elements.length} elements`,
          callToAction: 'Get This Deal',
          urgencyText: 'Limited Time Offer',
          validityDays: 7
        }
      };

      console.log('Saving template with data:', templateData);

      const token = localStorage.getItem('token');
      console.log('Using token:', token ? 'Token exists' : 'No token found');

      const isUpdate = currentTemplateId !== null;
      const url = isUpdate ? `${API_URL}/offer-templates/${currentTemplateId}` : `${API_URL}/offer-templates`;
      const method = isUpdate ? 'PUT' : 'POST';

      console.log(`${isUpdate ? 'Updating' : 'Creating'} template with method: ${method}, URL: ${url}`);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(templateData)
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', Object.fromEntries(response.headers.entries()));

      if (response.ok) {
        const savedTemplate = await response.json();

        if (isUpdate) {
          // Update existing template in the list
          setSavedTemplates(prev => prev.map(t =>
            t._id === currentTemplateId ? savedTemplate : t
          ));
          setStatusTitle('Success');
          setStatusMessage('Template updated successfully!');
        } else {
          // Add new template to the list
          setSavedTemplates(prev => [...prev, savedTemplate]);
          setCurrentTemplateId(savedTemplate._id); // Now tracking this template
          setStatusTitle('Success');
          setStatusMessage('Template saved successfully!');
        }
        setShowStatusAlert(true);

        setShowSaveDialog(false);
      } else {
        console.error('Save template error - Status:', response.status);
        let errorMessage = 'Unknown error';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || 'Unknown error';
          console.error('Save template error - Data:', errorData);
        } catch (e) {
          console.error('Could not parse error response:', e);
        }
        setStatusTitle('Error');
        setStatusMessage(`Failed to ${isUpdate ? 'update' : 'save'} template: ${errorMessage}`);
        setShowStatusAlert(true);
      }
    } catch (error) {
      console.error('Failed to save template:', error);
      setStatusTitle('Error');
      setStatusMessage('Failed to save template');
      setShowStatusAlert(true);
    }
  }, [templateName, templateType, templateSubtype, elements, pageSettings, currentTemplateId]);

  const loadTemplate = useCallback(async (templateId) => {
    try {
      // Clear any existing state to prevent pollution
      setSelectedElement(null);
      setSelectedTemplateId(null);
      setSelectedVariantKey(null);

      // CRITICAL FIX: Immediately clear pages state to prevent old pages from persisting
      setPages([{ id: 1, elements: [] }]);
      setCurrentPageIndex(0);
      setNextPageId(2);

      const response = await fetch(`${API_URL}/offer-templates/${templateId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const template = await response.json();

        // Load elements and page settings if they exist (page builder templates)
        if (template.elements && Array.isArray(template.elements)) {
          console.log('🔄 Loading template elements:', template.elements.length, 'elements');
          setElements(template.elements);
          // Set as single page without auto-splitting
          setPages([{ id: 1, elements: template.elements }]);
          setCurrentPageIndex(0);
          setNextPageId(2);
          setPaginationEnabled(false);
          console.log('📄 Template loaded as single page without auto-split');
        } else {
          console.log('🔄 No template elements found, setting empty array');
          setElements([]);
        }

        // Reset update state when loading a template
        setSelectedSavedElementId(null);
        setCurrentElementName('');
        setIsUpdatingElement(false);

        if (template.pageSettings) {
          setPageSettings(template.pageSettings);
        } else {
          setPageSettings({
            title: template.template?.title || 'My Offer Page',
            backgroundColor: '#ffffff',
            maxWidth: '800px',
            fontFamily: 'Arial, sans-serif'
          });
        }

        // Track the currently loaded template
        setCurrentTemplateId(templateId);
        setTemplateName(template.name); // Pre-fill the name for updates
        setTemplateType(template.type || ''); // Pre-fill the type for updates
        setTemplateSubtype(template.subtype || ''); // Pre-fill the subtype for updates

        setShowTemplatesList(false);

        // Increment usage count
        fetch(`${API_URL}/offer-templates/${templateId}/apply`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }).catch(err => console.log('Failed to update usage count:', err));

      } else {
        const errorData = await response.json();
        setStatusTitle('Error');
        setStatusMessage(`Failed to load template: ${errorData.message || 'Unknown error'}`);
        setShowStatusAlert(true);
      }
    } catch (error) {
      console.error('Failed to load template:', error);
      setStatusTitle('Error');
      setStatusMessage('Failed to load template');
      setShowStatusAlert(true);
    }
  }, []);

  const deleteTemplate = useCallback(async (templateId) => {
    setConfirmDialogTitle('Delete Template');
    setConfirmDialogMessage('Are you sure you want to delete this template?');
    setConfirmAction(() => async () => {
      try {
        const response = await fetch(`${API_URL}/offer-templates/${templateId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.ok) {
          setSavedTemplates(prev => prev.filter(t => t._id !== templateId));

          // If we just deleted the currently loaded template, clear the state
          if (templateId === currentTemplateId) {
            setCurrentTemplateId(null);
            setTemplateName('');
            setTemplateType('');
            setTemplateSubtype('');
          }

          setStatusTitle('Success');
          setStatusMessage('Template deleted successfully!');
          setShowStatusAlert(true);
        } else {
          const errorData = await response.json();
          setStatusTitle('Error');
          setStatusMessage(`Failed to delete template: ${errorData.message || 'Unknown error'}`);
          setShowStatusAlert(true);
        }
      } catch (error) {
        console.error('Failed to delete template:', error);
        setStatusTitle('Error');
        setStatusMessage('Failed to delete template');
        setShowStatusAlert(true);
      }
    });
    setShowConfirmDialog(true);
  }, [currentTemplateId]);

  // Create a new template (reset current template state)
  const createNewTemplate = useCallback(() => {
    setCurrentTemplateId(null);
    setTemplateName('');
    setTemplateType('');
    setTemplateSubtype('');
    setElements([]);
    setPageSettings({
      title: 'My Offer Page',
      backgroundColor: '#ffffff',
      maxWidth: '800px',
      fontFamily: 'Arial, sans-serif'
    });
    // Reset update state when creating new template
    setSelectedSavedElementId(null);
    setCurrentElementName('');
    setIsUpdatingElement(false);
  }, []);

  const loadPreBuiltTemplate = useCallback((templateData, forceNewPage = false) => {
    // Clear any existing state to prevent pollution
    setSelectedElement(null);

    // Create deep copies to prevent reference sharing
    let elementsCopy = templateData.elements ? JSON.parse(JSON.stringify(templateData.elements)) : [];
    const pageSettingsCopy = templateData.pageSettings ? JSON.parse(JSON.stringify(templateData.pageSettings)) : {
      title: 'My Offer Page',
      backgroundColor: '#ffffff',
      maxWidth: '800px',
      fontFamily: 'Arial, sans-serif'
    };

    // Auto-populate offer link if selected
    if (selectedOffer && offers.length > 0) {
      const selectedOfferObj = offers.find(o => o._id === selectedOffer);
      if (selectedOfferObj && selectedOfferObj.purchaseUrl && selectedOfferObj.purchaseUrl !== '#' && selectedOfferObj.purchaseUrl !== '') {
        console.log('🔗 Auto-populating offer link for prebuilt template:', selectedOfferObj.purchaseUrl);
        elementsCopy = populateOfferLinkInElements(elementsCopy, selectedOfferObj.purchaseUrl);
      }
    }

    console.log('🔍 Loading prebuilt template with deep copies:', {
      templateName: templateData.name,
      templateId: templateData._id,
      originalElements: templateData.elements ? templateData.elements.length : 0,
      copiedElements: elementsCopy.length,
      firstElementId: elementsCopy[0]?.id,
      type: templateData.type,
      subtype: templateData.subtype
    });

    // CRITICAL FIX: Immediately clear pages state to prevent old pages from persisting
    // However, if we are in sharedPages mode (Brands), we want to append.

    // Define wasPaginationEnabled at top scope of this block
    const wasPaginationEnabled = paginationEnabled;
    const shouldAppend = (sharedPages || setSharedPages) && elementsCopy.length > 0;

    if (shouldAppend && setSharedPages) {
      console.log('📄 Shared pages detected. Determining if we should append or replace.');

      setSharedPages(currentPages => {
        // Ensure currentPages is an array
        const safePages = Array.isArray(currentPages) && currentPages.length > 0
          ? currentPages
          : [{ id: 1, elements: [] }];

        const lastPage = safePages[safePages.length - 1];
        const lastPageHasContent = lastPage && lastPage.elements && lastPage.elements.length > 0;

        console.log('📄 Inside setSharedPages update:', {
          currentPagesLength: safePages.length,
          lastPageId: lastPage.id,
          lastPageHasContent,
          forceNewPage
        });

        if (forceNewPage || lastPageHasContent) {
          // Special case: if this is the very first page and it's empty, populate it instead of creating page 2
          const isFirstPageEmpty = safePages.length === 1 && !lastPageHasContent;

          if (isFirstPageEmpty) {
            console.log('📄 First page is empty. Populating it instead of creating page 2.');
            const updatedPages = [...safePages];
            const updatedFirstPage = { ...updatedPages[0], elements: elementsCopy };
            updatedPages[0] = updatedFirstPage;

            setTimeout(() => {
              setPages(updatedPages);
              setCurrentPageIndex(0);
              setPaginationEnabled(true);
            }, 0);

            return updatedPages;
          } else {
            console.log('📄 Appending new page (forceNewPage:', forceNewPage, 'hasContent:', lastPageHasContent, ')');
            const maxId = safePages.reduce((max, p) => Math.max(max, p.id || 0), 0);
            const newPageId = maxId + 1;
            const newPage = { id: newPageId, elements: elementsCopy };
            const updatedPages = [...safePages, newPage];

            // Side-effects should be outside strict reducer, but for state sync we do it here or via useEffect
            // We'll update local state after this using the result if possible,
            // but since we are inside the callback, we can't easily extract it synchronously.
            // Instead, we will rely on the fact that sharedPages prop update will trigger local sync
            // (if there is an effect for that, otherwise we might need a separate effect).
            // However, to be safe, we can defer local updates.

            // Ideally we shouldn't do side effects here, but we need updatedPages for setPages/setCurrentPageIndex.
            // We will schedule them.
            setTimeout(() => {
              setPages(updatedPages);
              setCurrentPageIndex(updatedPages.length - 1);
              setPaginationEnabled(true);
            }, 0);

            return updatedPages;
          }
        } else {
          console.log('📄 Current page is empty. Replacing content on current page.');
          const updatedPages = [...safePages];
          // Create a new object for the last page to ensure immutability
          const updatedLastPage = { ...updatedPages[updatedPages.length - 1], elements: elementsCopy };
          updatedPages[updatedPages.length - 1] = updatedLastPage;

          setTimeout(() => {
            setPages(updatedPages);
            setPaginationEnabled(true);
          }, 0);

          return updatedPages;
        }
      });
    } else {
      // Legacy behavior for single-page mode or non-shared pages
      setPages([{ id: 1, elements: [] }]);
      setCurrentPageIndex(0);
      setNextPageId(2);

      // Disable pagination completely during template load for legacy mode
      setPaginationEnabled(false);

      console.log('🔧 About to call setElements with:', elementsCopy.length, 'elements');

      // CRITICAL: Call setSharedElements DIRECTLY instead of through setElements
      if (isBrandsPage && setSharedElements) {
        console.log('🔧 Calling setSharedElements DIRECTLY for Brands page');
        setSharedElements([]);
        setTimeout(() => {
          setSharedElements(elementsCopy);
        }, 50);
      } else {
        console.log('🔧 Calling setLocalElements for non-Brands page');
        setElements(elementsCopy);
      }
    }
    console.log('✅ setElements called - waiting for state update');

    // Verify the update in next tick
    setTimeout(() => {
      console.log('🔍 After setElements - sharedElements:', sharedElements?.length || 0);
      console.log('🔍 After setElements - localElements:', localElements?.length || 0);
      console.log('🔍 After setElements - sharedElements IDs:', sharedElements?.map(e => e.id) || []);
    }, 10);

    // ONLY re-enable pagination if it was previously enabled
    if (wasPaginationEnabled) {
      // Set as single page without auto-splitting
      setPages([{ id: 1, elements: elementsCopy }]);
      setCurrentPageIndex(0);
      setNextPageId(2);
      setPaginationEnabled(true);
      console.log('📄 Template import completed as single page with pagination enabled');
    }

    setPageSettings(pageSettingsCopy);
    setShowTemplatesList(false);

    // Track the currently loaded template for updates
    setCurrentTemplateId(templateData._id);
    setTemplateName(templateData.name); // Pre-fill the name for updates
    setTemplateType(templateData.type || ''); // Pre-fill the type for updates
    setTemplateSubtype(templateData.subtype || ''); // Pre-fill the subtype for updates

    // Set selected template ID and clear variant selection
    setSelectedTemplateId(templateData._id);
    setSelectedVariantKey(null);

    // Reset update state when loading a prebuilt template
    setSelectedSavedElementId(null);
    setCurrentElementName('');
    setIsUpdatingElement(false);
  }, [
    paginationEnabled,
    localElements,
    setLocalElements,
    isBrandsPage,
    setSharedElements,
    sharedElements,
    sharedPages,
    setSharedPages,
    setShowTemplatesList,
    setPageSettings,
    setTemplateName,
    setTemplateType,
    setTemplateSubtype,
    setSelectedTemplateId,
    setSelectedVariantKey,
    setSelectedSavedElementId,
    setCurrentElementName,
    setIsUpdatingElement,
    setPages,
    setCurrentPageIndex,
    setNextPageId,
    setPaginationEnabled,
    setCurrentTemplateId,
    selectedOffer,
    offers,
    populateOfferLinkInElements
  ]);



  // Load pre-built templates from API
  const loadPreBuiltTemplates = useCallback(async () => {
    try {
      const data = await getPreBuiltTemplates();

      // Filter out unwanted templates
      const filteredTemplates = filterLegitimateTemplates(data.templates);
      console.log(`📊 Filtered prebuilt templates: ${data.templates?.length || 0} → ${filteredTemplates.length}`);

      // Create deep copies to prevent reference sharing
      const templatesCopy = filteredTemplates.map(template => ({
        ...template,
        elements: template.elements ? JSON.parse(JSON.stringify(template.elements)) : [],
        pageSettings: template.pageSettings ? JSON.parse(JSON.stringify(template.pageSettings)) : null
      })) || [];
      setPreBuiltTemplates(templatesCopy);
    } catch (error) {
      console.error('Failed to load pre-built templates:', error);
    }
  }, []);

  // Load all templates for popup using the same API as Brands page (no authentication issues)
  const loadAllTemplatesForPopup = useCallback(async () => {
    try {
      console.log('🔄 Loading all templates for popup using unified API...');

      // Get all templates from all main types
      const templateTypes = ['Buttons', 'Headline/Subheadline', 'Highlight block', 'Lists', 'Icons', 'Features', 'Testimonial', 'Comparison', 'FAQ', 'Images', 'Videos', 'Video with button overlay'];

      const allTemplatesPromises = templateTypes.map(type =>
        getAllTemplatesByType(type).catch(error => {
          console.warn(`Failed to load ${type} templates:`, error);
          return { templates: [] };
        })
      );

      const allResponses = await Promise.all(allTemplatesPromises);
      const allTemplates = allResponses.flatMap(response => response.templates || []);

      console.log(`📦 Loaded ${allTemplates.length} total templates from all types`);

      // Filter out unwanted templates
      const filteredTemplates = filterLegitimateTemplates(allTemplates);
      console.log(`📊 Filtered all templates: ${allTemplates.length} → ${filteredTemplates.length}`);

      // Create deep copies and separate by type
      const templatesCopy = filteredTemplates.map(template => ({
        ...template,
        elements: template.elements ? JSON.parse(JSON.stringify(template.elements)) : [],
        pageSettings: template.pageSettings ? JSON.parse(JSON.stringify(template.pageSettings)) : null
      }));

      // Separate into user templates and prebuilt templates
      const userTemplates = templatesCopy.filter(t => !t.isPreBuilt);
      const prebuiltTemplates = templatesCopy.filter(t => t.isPreBuilt);

      console.log(`📋 Separated templates: ${userTemplates.length} user, ${prebuiltTemplates.length} prebuilt`);

      // Set the state
      setSavedTemplates(userTemplates);
      setPreBuiltTemplates(prebuiltTemplates);

      console.log('✅ All templates loaded successfully for popup');
    } catch (error) {
      console.error('❌ Failed to load templates for popup:', error);
    }
  }, []);



  // Load templates by type and subtype - unified function (both prebuilt and user templates)
  const loadTemplatesByTypeAndSubtype = useCallback(async (type, subtype) => {
    try {
      console.log(`🔄 Loading ALL templates (prebuilt + user) for type: ${type}, subtype: ${subtype}`);
      const data = await getAllTemplatesByType(type, subtype);
      console.log(`📦 Received ${data.templates?.length || 0} templates for ${type}/${subtype}`);
      console.log('📋 Template names:', data.templates?.map(t => `${t.name} (${t.isPreBuilt ? 'prebuilt' : 'user'})`) || []);

      // Filter out unwanted templates
      const filteredTemplates = filterLegitimateTemplates(data.templates);
      console.log(`📊 Filtered ${type}/${subtype} templates: ${data.templates?.length || 0} → ${filteredTemplates.length}`);

      // IMPORTANT: Create deep copies to prevent reference sharing
      const templatesCopy = filteredTemplates.map(template => ({
        ...template,
        elements: template.elements ? JSON.parse(JSON.stringify(template.elements)) : [],
        pageSettings: template.pageSettings ? JSON.parse(JSON.stringify(template.pageSettings)) : null
      })) || [];

      console.log(`🔍 ${subtype} templates with deep copies:`, templatesCopy.map(t => ({
        name: t.name,
        id: t._id,
        type: t.type,
        subtype: t.subtype,
        isPreBuilt: t.isPreBuilt,
        elementsCount: t.elements ? t.elements.length : 0,
        firstElementId: t.elements?.[0]?.id
      })));

      return templatesCopy;
    } catch (error) {
      console.error(`Failed to load ${subtype} templates:`, error);
      return []; // Return empty array on error
    }
  }, []);

  // Load templates by type and subtype
  const loadTemplatesByType = useCallback(async (type, subtype = null) => {
    try {
      const data = await getAllTemplatesByType(type, subtype);

      // Filter out unwanted templates
      const filteredTemplates = filterLegitimateTemplates(data.templates);
      console.log(`📊 Filtered ${type}${subtype ? '/' + subtype : ''} templates: ${data.templates?.length || 0} → ${filteredTemplates.length}`);

      // Create deep copies to prevent reference sharing
      const templatesCopy = filteredTemplates.map(template => ({
        ...template,
        elements: template.elements ? JSON.parse(JSON.stringify(template.elements)) : [],
        pageSettings: template.pageSettings ? JSON.parse(JSON.stringify(template.pageSettings)) : null
      })) || [];
      return templatesCopy;
    } catch (error) {
      console.error('Failed to load templates by type:', error);
      return [];
    }
  }, []);

  // Load templates on component mount
  useEffect(() => {
    const loadAllTemplates = async () => {
      // If customElementsOnly mode, skip user-specific template loading
      if (!customElementsOnly) {
        // Use the same API as Brands page - load all templates without authentication issues
        await loadAllTemplatesForPopup();
      }

      // Load specific button subtype templates using type/subtype
      const [buttonImageCalloutTemplates, buttonNoticeTemplates, buttonTextTemplates] = await Promise.all([
        loadTemplatesByTypeAndSubtype('Buttons', 'Button w/Image Call out'),
        loadTemplatesByTypeAndSubtype('Buttons', 'Button w/notice'),
        loadTemplatesByTypeAndSubtype('Buttons', 'Button w/text')
      ]);

      setButtonImageCalloutTemplates(buttonImageCalloutTemplates);
      setButtonNoticeTemplates(buttonNoticeTemplates);
      setButtonTextTemplates(buttonTextTemplates);

      // If in customElementsOnly mode and Headline/Subheadline is selected, load those templates immediately
      if (customElementsOnly && selectedCustomCategory === 'Headline/Subheadline') {
        console.log('🔄 Loading Headline/Subheadline templates on mount...');
        const headlineTemplates = await loadTemplatesByType('Headline/Subheadline');
        console.log('📦 Loaded headline templates on mount:', headlineTemplates.map(t => ({ name: t.name, type: t.type, subtype: t.subtype })));
        setFilteredTemplates(headlineTemplates);
      }
    };

    loadAllTemplates();
  }, [loadAllTemplatesForPopup, loadTemplatesByTypeAndSubtype, customElementsOnly, selectedCustomCategory, loadTemplatesByType]);

  // Load templates when Load Template dialog opens
  useEffect(() => {
    if (showTemplatesList) {
      console.log('🔄 Load Template dialog opened, loading templates...');
      loadTemplates();
    }
  }, [showTemplatesList, loadTemplates]);

  // Load filtered templates when type and subtype change
  useEffect(() => {
    const loadFilteredTemplates = async () => {
      console.log('🔄 Loading filtered templates:', {
        selectedCustomCategory,
        selectedCustomSubtype: selectedCustomSubtype?.label
      });

      if (selectedCustomCategory && selectedCustomSubtype) {
        console.log(`🔍 Loading templates for ${selectedCustomCategory}/${selectedCustomSubtype.label}`);
        const templates = await loadTemplatesByType(selectedCustomCategory, selectedCustomSubtype.label);
        console.log(`📦 Received ${templates.length} templates for ${selectedCustomCategory}/${selectedCustomSubtype.label}:`, templates.map(t => ({ name: t.name, id: t._id, type: t.type, subtype: t.subtype })));
        setFilteredTemplates(templates);
      } else if (selectedCustomCategory) {
        console.log(`🔍 Loading templates for ${selectedCustomCategory} only`);
        const templates = await loadTemplatesByType(selectedCustomCategory);
        console.log(`📦 Received ${templates.length} templates for ${selectedCustomCategory}:`, templates.map(t => ({ name: t.name, id: t._id, type: t.type, subtype: t.subtype })));
        setFilteredTemplates(templates);
      } else {
        console.log('🔍 No category selected, clearing templates');
        setFilteredTemplates([]);
      }
    };

    loadFilteredTemplates();
  }, [selectedCustomCategory, selectedCustomSubtype, loadTemplatesByType]);

  // Debug effect to monitor filteredTemplates changes
  useEffect(() => {
    console.log('🎯 filteredTemplates changed:', {
      selectedCustomCategory,
      selectedCustomSubtype: selectedCustomSubtype?.label,
      templatesCount: filteredTemplates.length,
      templates: filteredTemplates.map(t => ({ name: t.name, type: t.type, subtype: t.subtype }))
    });
  }, [filteredTemplates, selectedCustomCategory, selectedCustomSubtype]);

  // Clear subtype when template type changes
  useEffect(() => {
    if (templateType) {
      // Clear subtype when type changes to ensure compatibility
      setTemplateSubtype('');
    }
  }, [templateType]);

  // Force complete template state reset and reload
  const forceTemplateStateReset = useCallback(async () => {
    console.log('🔄 Forcing complete template state reset...');

    // Clear all template-related state
    setSavedTemplates([]);
    setPreBuiltTemplates([]);
    setButtonImageCalloutTemplates([]);
    setButtonNoticeTemplates([]);
    setButtonTextTemplates([]);
    setSelectedTemplateId(null);
    setSelectedVariantKey(null);

    // Wait a bit to ensure state is cleared
    await new Promise(resolve => setTimeout(resolve, 100));

    // Reload all templates fresh from database using unified API
    await loadAllTemplatesForPopup();

    // Load specific button subtype templates using type/subtype
    const [buttonImageCalloutTemplates, buttonNoticeTemplates, buttonTextTemplates] = await Promise.all([
      loadTemplatesByTypeAndSubtype('Buttons', 'Button w/Image Call out'),
      loadTemplatesByTypeAndSubtype('Buttons', 'Button w/notice'),
      loadTemplatesByTypeAndSubtype('Buttons', 'Button w/text')
    ]);

    setButtonImageCalloutTemplates(buttonImageCalloutTemplates);
    setButtonNoticeTemplates(buttonNoticeTemplates);
    setButtonTextTemplates(buttonTextTemplates);

    // Force re-render
    setForceRender(prev => prev + 1);

    console.log('✅ Template state reset completed');
  }, [loadAllTemplatesForPopup, loadTemplatesByTypeAndSubtype]);

  // Saved offer elements functions
  const loadSavedOfferElements = useCallback(async (brandFilter = null, offerFilter = null) => {
    try {
      console.log('📥 Loading saved offer elements with filters:', { brandFilter, offerFilter });

      // Build query parameters
      const params = {};
      if (brandFilter) params.brandId = brandFilter;
      if (offerFilter) params.offerId = offerFilter;

      console.log('📤 Client sending request with params:', params);

      const response = await api.get('/offer-elements', { params });
      console.log('✅ Loaded elements:', response.data);
      console.log('✅ Setting filtered elements to:', response.data.length, 'elements');
      setSavedOfferElements(response.data);
      setFilteredSavedElements(response.data);
    } catch (error) {
      console.error('❌ Error loading saved offer elements:', error);
      console.error('Error details:', error.response?.data || error.message);
    }
  }, []);

  const saveCurrentElement = async () => {
    if (!currentElementName.trim() || elements.length === 0) {
      console.log('❌ Save offer elements failed: Missing name or no elements');
      setStatusTitle('Missing Information');
      setStatusMessage('Please enter a name and ensure you have elements on the canvas');
      setShowStatusAlert(true);
      return;
    }

    // Check for video elements without thumbnails
    const videoElementsWithoutThumbnails = elements.filter(element =>
      element.type === ELEMENT_TYPES.VIDEO && element.videoFile && !element.thumbnailUrl
    );

    if (videoElementsWithoutThumbnails.length > 0) {
      console.log('❌ Save offer elements failed: Video elements missing thumbnails');
      setStatusTitle('Missing Thumbnails');
      setStatusMessage(`Cannot save: ${videoElementsWithoutThumbnails.length} video element(s) are missing required thumbnails. Please upload thumbnails for all video elements before saving.`);
      setShowStatusAlert(true);
      return;
    }

    console.log('💾 Saving:', {
      name: currentElementName,
      type: 'template',
      isUpdating: isUpdatingElement,
      elementId: selectedSavedElementId
    });

    try {
      // Determine which elements to save based on pagination mode
      let elementsToSave;
      let paginationData = null;

      if (paginationEnabled && pages.length > 0) {
        // Pagination mode - flatten all pages into a single elements array
        elementsToSave = pages.flatMap(page => page.elements);
        paginationData = {
          enabled: true,
          pages: pages.map(page => ({
            id: page.id,
            elementCount: page.elements.length
          })),
          currentPageIndex: currentPageIndex
        };
        console.log('💾 Saving with pagination:', {
          totalElements: elementsToSave.length,
          pagesCount: pages.length,
          paginationData,
          pagesDetails: pages.map((page, i) => ({
            pageIndex: i,
            pageId: page.id,
            elementCount: page.elements.length,
            elementIds: page.elements.map(el => el.id)
          }))
        });
      } else {
        // Regular mode - use current elements
        elementsToSave = elements;
        paginationData = { enabled: false };
        console.log('💾 Saving without pagination:', {
          totalElements: elementsToSave.length,
          paginationEnabled,
          pagesLength: pages.length
        });
      }

      // Optimize data structure to prevent BSON size limit issues
      // Remove duplicate data storage and compress large elements
      const optimizedElements = elementsToSave.map(element => {
        const optimizedElement = { ...element };

        // For video elements, store only essential data to prevent size issues
        if (element.type === ELEMENT_TYPES.VIDEO && element.videoFile) {
          // Keep videoFile but remove any redundant data
          optimizedElement.videoFile = element.videoFile;
          // Remove any large nested objects that might be duplicated
          delete optimizedElement.videoBlob;
          delete optimizedElement.videoData;
        }

        // For image elements, ensure we're not storing large base64 data unnecessarily
        if (element.type === ELEMENT_TYPES.CROPPABLE_IMAGE || element.type === ELEMENT_TYPES.CIRCULAR_IMAGE) {
          // Keep essential image data but remove any large temporary data
          if (element.croppedImage && element.croppedImage.length > 10000) {
            // If cropped image is very large, it might be base64 - consider compression
            console.warn('Large cropped image detected, consider optimizing');
          }
        }

        return optimizedElement;
      });

      // Store only essential data in content field (as JSON string)
      const elementData = {
        name: currentElementName,
        type: 'template',
        content: JSON.stringify({
          elements: optimizedElements,
          pageSettings: pageSettings,
          elementsCount: optimizedElements.length,
          pagination: paginationData
        }),
        styles: {},
        properties: {
          isTemplate: true,
          elementsCount: optimizedElements.length,
          // Remove duplicate templateData to prevent BSON size issues
          // templateData: { elements: optimizedElements, pageSettings: pageSettings },
          brandName: brands.find(b => b._id === selectedBrand)?.name || '',
          offerName: offers.find(o => o._id === selectedOffer)?.title || ''
        },
        description: `Saved offer elements with ${optimizedElements.length} elements`,
        brandId: selectedBrand || null,
        offerId: selectedOffer || null
      };

      // Debug: Check for video elements with aspectRatio
      optimizedElements.forEach((el, idx) => {
        if (el.type === 'video') {
          console.log(`🎥 [SAVE] Video element ${idx} styles:`, el.styles);
          console.log(`🎥 [SAVE] Video element ${idx} aspectRatio:`, el.styles?.aspectRatio);
          console.log(`🎥 [SAVE] Video element ${idx} height:`, el.styles?.height);
          console.log(`🎥 [SAVE] Video element ${idx} width:`, el.styles?.width);
        }
      });

      console.log('📦 Data to save:', elementData);
      console.log('🔍 Debug - selectedBrand:', selectedBrand, 'selectedOffer:', selectedOffer);
      console.log('🔍 Debug - brandId being sent:', elementData.brandId, 'offerId being sent:', elementData.offerId);

      let response;
      if (isUpdatingElement && selectedSavedElementId) {
        console.log('🔄 Updating existing item:', selectedSavedElementId);
        response = await api.put(`/offer-elements/${selectedSavedElementId}`, elementData);
      } else {
        console.log('🆕 Creating new item');
        response = await api.post('/offer-elements', elementData);
      }

      console.log('✅ Save successful:', response.data);

      // Reload the saved elements list with current filters
      const reloadParams = {};
      if (selectedBrand) reloadParams.brandId = selectedBrand;
      if (selectedOffer) reloadParams.offerId = selectedOffer;
      const reloadResponse = await api.get('/offer-elements', { params: reloadParams });
      setFilteredSavedElements(reloadResponse.data);
      setSavedOfferElements(reloadResponse.data);

      // Show success message
      setStatusTitle('Success');
      setStatusMessage(isUpdatingElement ? 'Offer elements updated successfully!' : 'Offer elements saved successfully!');
      setShowStatusAlert(true);

      // Close dialog
      setShowSaveElementDialog(false);

      // Only reset state if we're not updating an existing element
      if (!isUpdatingElement) {
        setCurrentElementName('');
        setIsUpdatingElement(false);
        setSelectedSavedElementId(null);
        setSaveType('template'); // Reset to default
      }
    } catch (error) {
      console.error('❌ Error saving offer element:', error);
      console.error('Error details:', error.response?.data || error.message);

      // Handle specific error cases
      setStatusTitle('Error Saving');
      if (error.response?.status === 413) {
        const errorData = error.response.data;
        setStatusMessage(`Document too large: ${errorData.message}\n\nSize: ${Math.round(errorData.size / 1024 / 1024)}MB (max: ${Math.round(errorData.maxSize / 1024 / 1024)}MB)\n\nPlease reduce the number of elements or remove large media files.`);
      } else if (error.response?.data?.message) {
        setStatusMessage(`Error: ${error.response.data.message}`);
      } else {
        const errorMessage = error.response?.data?.error || error.message || 'Failed to save';
        setStatusMessage(`Error: ${errorMessage}`);
      }
      setShowStatusAlert(true);
    }
  };

  const loadSavedElement = (savedElement) => {
    // Set flag to prevent auto-pagination for existing content
    setIsLoadingExistingContent(true);

    // Set brand and offer if they exist in the saved element
    if (savedElement.brandId) {
      setSelectedBrand(savedElement.brandId);
      if (savedElement.offerId) {
        setSelectedOffer(savedElement.offerId);
        // Load offers for the brand if not already loaded
        if (!offers.find(o => o._id === savedElement.offerId)) {
          loadOffersForBrand(savedElement.brandId);
        }
      }
    }

    if (savedElement.type === 'template' && savedElement.properties?.isTemplate) {
      // Load entire template
      try {
        // Parse template data from content field (new optimized structure)
        let templateData;
        if (savedElement.content) {
          templateData = JSON.parse(savedElement.content);
        } else if (savedElement.properties?.templateData) {
          // Fallback to old structure for backward compatibility
          templateData = savedElement.properties.templateData;
        }

        if (templateData && templateData.elements) {
          // Store template data for the confirmation dialog
          setPendingTemplateData({
            elements: templateData.elements,
            name: savedElement.name,
            id: savedElement._id,
            pageSettings: templateData.pageSettings,
            pagination: templateData.pagination
          });
          setShowReplaceConfirm(true);
        }
      } catch (error) {
        console.error('Error loading offer elements:', error);
        setShowLoadTemplateAlert(true);
        setLoadTemplateError('Error loading offer elements. The data may be corrupted.');
      }
    } else {
      // Load individual element
      const newElement = {
        id: Date.now(),
        type: savedElement.type,
        content: savedElement.content,
        styles: savedElement.styles || {},
        properties: savedElement.properties || {}
      };

      if (paginationEnabled) {
        setPages(prevPages => {
          const safeIndex = Math.min(currentPageIndex, prevPages.length - 1);
          return prevPages.map((page, index) =>
            index === safeIndex
              ? { ...page, elements: [...page.elements, newElement] }
              : page
          );
        });
      }
      setElements(prev => [...prev, newElement]);

      // Set the loaded element for update functionality
      setSelectedSavedElementId(savedElement._id);
      setCurrentElementName(savedElement.name);
      setIsUpdatingElement(true);
    }
  };

  const deleteSavedElement = async (elementId) => {
    try {
      await api.delete(`/offer-elements/${elementId}`);

      // Reload the saved elements list with current filters
      const reloadParams = {};
      if (selectedBrand) reloadParams.brandId = selectedBrand;
      if (selectedOffer) reloadParams.offerId = selectedOffer;
      const reloadResponse = await api.get('/offer-elements', { params: reloadParams });
      setFilteredSavedElements(reloadResponse.data);
      setSavedOfferElements(reloadResponse.data);
    } catch (error) {
      console.error('Error deleting saved offer element:', error);
    }
  };

  const renameSavedElement = async (elementId, newName) => {
    if (!newName.trim()) {
      setStatusTitle('Missing Information');
      setStatusMessage('Please enter a valid name');
      setShowStatusAlert(true);
      return;
    }

    try {
      await api.put(`/offer-elements/${elementId}`, { name: newName });

      // Reload the saved elements list with current filters
      const reloadParams = {};
      if (selectedBrand) reloadParams.brandId = selectedBrand;
      if (selectedOffer) reloadParams.offerId = selectedOffer;
      const reloadResponse = await api.get('/offer-elements', { params: reloadParams });
      setFilteredSavedElements(reloadResponse.data);
      setSavedOfferElements(reloadResponse.data);

      // If the renamed element is currently being edited, update the currentElementName
      if (selectedSavedElementId === elementId) {
        setCurrentElementName(newName);
      }

      setStatusTitle('Success');
      setStatusMessage(`Renamed to "${newName}" successfully!`);
      setShowStatusAlert(true);
    } catch (error) {
      console.error('Error renaming saved offer element:', error);
      setStatusTitle('Error');
      setStatusMessage('Failed to rename element. Please try again.');
      setShowStatusAlert(true);
    }
  };

  const editSavedElement = (savedElement) => {
    setCurrentElementName(savedElement.name);
    setSelectedSavedElementId(savedElement._id);
    setIsUpdatingElement(true);
    setShowSaveElementDialog(true);

    // Set brand and offer if they exist in the saved element
    if (savedElement.brandId) {
      setSelectedBrand(savedElement.brandId);
      if (savedElement.offerId) {
        setSelectedOffer(savedElement.offerId);
        // Load offers for the brand if not already loaded
        if (!offers.find(o => o._id === savedElement.offerId)) {
          loadOffersForBrand(savedElement.brandId);
        }
      }
    }
  };

  // Load brands on component mount (saved elements will be loaded by filter effect)
  useEffect(() => {
    loadBrands();
  }, []);

  // Initial load of saved elements - removed to avoid conflicts with new API approach

  // Load brands from database
  const loadBrands = async () => {
    try {
      setLoadingBrands(true);
      const response = await brandService.getAllBrands();
      setBrands(response.brands || []);
    } catch (error) {
      console.error('Error loading brands:', error);
    } finally {
      setLoadingBrands(false);
    }
  };

  // Load offers for selected brand
  const loadOffersForBrand = async (brandId) => {
    if (!brandId) {
      setOffers([]);
      return;
    }

    try {
      setLoadingOffers(true);
      const response = await getOffersByBrand(brandId, 1, 100, true); // Include expired offers
      setOffers(response.offers || []);
    } catch (error) {
      console.error('Error loading offers for brand:', error);
      setOffers([]);
    } finally {
      setLoadingOffers(false);
    }
  };

  // Load saved items only when both brand and offer are selected
  useEffect(() => {
    console.log('🔄 Brand/Offer selection changed:', {
      selectedBrand,
      selectedOffer,
      templatesOnly
    });

    // Call API only when both brand and offer are selected
    console.log('🔍 Debug conditions:', {
      templatesOnly,
      selectedBrand: !!selectedBrand,
      selectedOffer: !!selectedOffer,
      shouldLoadElements: selectedBrand && selectedOffer,
      sharedSelectedBrand: !!sharedSelectedBrand,
      sharedSelectedOffer: !!sharedSelectedOffer
    });

    if (selectedBrand && selectedOffer) {
      console.log('🎯 Loading saved items for brand:', selectedBrand, 'offer:', selectedOffer, 'templatesOnly:', templatesOnly);

      const loadItems = async () => {
        try {
          const params = {};

          // Only add brandId if it's a valid value
          if (selectedBrand && selectedBrand !== '') {
            params.brandId = selectedBrand;
          }

          // Only add offerId if it's a valid value
          if (selectedOffer && selectedOffer !== '') {
            params.offerId = selectedOffer;
          }

          console.log('📤 API request params:', params);
          const response = await api.get('/offer-elements', { params });
          console.log('✅ API response:', response.data);
          console.log('✅ API response length:', response.data.length);
          console.log('✅ API response items:', response.data.map(item => `${item.name} (${item.brandId}/${item.offerId})`));

          // Use API response directly - no filtering needed
          setFilteredSavedElements(response.data);
          setSavedOfferElements(response.data);

          console.log('✅ Set saved elements to:', response.data.length, 'items from API');

          // Force a re-render to ensure UI updates
          setForceRender(prev => prev + 1);
        } catch (error) {
          console.error('❌ Error loading saved items:', error);
          setFilteredSavedElements([]);
          setSavedOfferElements([]);
        }
      };

      loadItems();
    } else {
      console.log('⏸️ Skipping API call - brand or offer not selected');
      // Clear saved elements when conditions are not met
      setFilteredSavedElements([]);
      setSavedOfferElements([]);
    }
  }, [selectedBrand, selectedOffer, templatesOnly]);



  // Handle brand selection
  const handleBrandChange = (brandId) => {
    console.log('🏷️ Brand selection changed to:', brandId);
    console.log('🏷️ Previous brand was:', selectedBrand);
    setSelectedBrand(brandId);
    setSelectedOffer(''); // Reset offer when brand changes
    if (brandId) {
      loadOffersForBrand(brandId);
    } else {
      setOffers([]);
    }
  };

  const deleteElement = useCallback((elementId) => {
    // Find the element to be deleted
    const elementToDelete = elements.find(el => el.id === elementId);

    if (elementToDelete) {
      // Find the original index of the element in the main canvas
      const originalIndex = elements.findIndex(el => el.id === elementId);

      let pageIndex = null;
      let indexInPage = null;

      // If pagination is enabled, find which page and position within that page
      if (paginationEnabled) {
        for (let i = 0; i < pages.length; i++) {
          const idx = pages[i].elements.findIndex(el => el.id === elementId);
          if (idx !== -1) {
            pageIndex = i;
            indexInPage = idx;
            break;
          }
        }
      }

      // Add to deletion history for undo functionality
      console.log('🔄 Adding to deletion history:', elementToDelete, 'at index:', originalIndex, 'pageIndex:', pageIndex, 'indexInPage:', indexInPage);
      setDeletedElementsHistory(prev => [...prev, {
        element: elementToDelete,
        zone: null, // Main canvas element, no zone
        originalIndex: originalIndex,
        pageIndex: pageIndex,
        indexInPage: indexInPage,
        timestamp: Date.now()
      }]);
      setShowUndoNotification(true);
    }

    if (paginationEnabled) {
      // Pagination mode - update pages state
      setPages(prev => prev.map(page => ({
        ...page,
        elements: page.elements.filter(el => el.id !== elementId)
      })));
    }

    // Always update flat elements list for consistency
    setElements(prev => prev.filter(el => el.id !== elementId));

    if (selectedElement?.id === elementId) {
      setSelectedElement(null);
    }
  }, [selectedElement, elements, paginationEnabled, pages]);

  // Undo delete functionality
  const undoDelete = useCallback(() => {
    if (deletedElementsHistory.length > 0) {
      // Get the most recent deletion
      const lastDeleted = deletedElementsHistory[deletedElementsHistory.length - 1];

      if (lastDeleted.zone) {
        // Restore to original zone at original position
        console.log('🔄 Restoring element to zone at index:', lastDeleted.originalIndex);

        if (paginationEnabled) {
          setPages(prevPages => prevPages.map(page => ({
            ...page,
            elements: findAndUpdateLayout(page.elements, lastDeleted.zone.layoutId, lastDeleted.zone.zoneId, (zone) => {
              const newElements = [...zone.elements];
              newElements.splice(lastDeleted.originalIndex, 0, lastDeleted.element);
              return { ...zone, elements: newElements };
            })
          })));
        }

        setElements(prev =>
          findAndUpdateLayout(prev, lastDeleted.zone.layoutId, lastDeleted.zone.zoneId, (zone) => {
            const newElements = [...zone.elements];
            newElements.splice(lastDeleted.originalIndex, 0, lastDeleted.element);
            return {
              ...zone,
              elements: newElements
            };
          })
        );
      } else {
        // Restore to main canvas at original position
        console.log('🔄 Restoring element to main canvas at index:', lastDeleted.originalIndex, 'pageIndex:', lastDeleted.pageIndex, 'indexInPage:', lastDeleted.indexInPage);

        if (paginationEnabled && lastDeleted.pageIndex !== null && lastDeleted.indexInPage !== null) {
          // Restore to the exact page and position
          setPages(prevPages => {
            return prevPages.map((page, index) => {
              if (index === lastDeleted.pageIndex) {
                const newElements = [...page.elements];
                // Insert at the original position within the page
                newElements.splice(lastDeleted.indexInPage, 0, lastDeleted.element);
                return { ...page, elements: newElements };
              }
              return page;
            });
          });
        }

        setElements(prev => {
          const newElements = [...prev];
          newElements.splice(lastDeleted.originalIndex, 0, lastDeleted.element);
          return newElements;
        });
      }

      // Remove from history
      setDeletedElementsHistory(prev => prev.slice(0, -1));

      // Hide notification if no more deletions to undo
      if (deletedElementsHistory.length === 1) {
        setShowUndoNotification(false);
      }

      console.log('✅ Element restored to original location:', lastDeleted.element.id);
    }
  }, [deletedElementsHistory, findAndUpdateLayout, paginationEnabled]);

  // Dismiss undo notification
  const dismissUndoNotification = useCallback(() => {
    setShowUndoNotification(false);
    setDeletedElementsHistory([]);
  }, []);

  const updateElement = useCallback((elementId, updates, isInZone = false, layoutId = null, zoneId = null) => {
    console.log('🔄 updateElement called:', { elementId, updates, isInZone, layoutId, zoneId });
    console.log('🎯 Current selectedElement:', selectedElement?.id);
    console.log('📄 Pagination enabled:', paginationEnabled);

    if (paginationEnabled) {
      // Pagination mode - update pages state
      if (isInZone && layoutId && zoneId) {
        // Update element within a layout zone in pagination mode
        console.log('🔄 Updating zone element in pagination mode');
        setPages(prev => prev.map(page => ({
          ...page,
          elements: findAndUpdateLayout(page.elements, layoutId, zoneId, (zone) => ({
            ...zone,
            elements: zone.elements.map(zoneElement => {
              if (zoneElement.id === elementId) {
                const updatedElement = { ...zoneElement, ...updates };
                console.log('✅ Updated zone element in pagination:', updatedElement);
                console.log('🖼️ imageSrc preserved:', !!updatedElement.imageSrc);
                return updatedElement;
              }
              return zoneElement;
            })
          }))
        })));
      } else {
        // Update top-level element in pagination mode
        setPages(prev => prev.map(page => ({
          ...page,
          elements: page.elements.map(el => {
            if (el.id === elementId) {
              const updatedElement = { ...el, ...updates };
              console.log('✅ Updated paginated element:', updatedElement);
              console.log('🎨 Updated element styles:', updatedElement.styles);
              return updatedElement;
            }
            return el;
          })
        })));
      }
    } else {
      // Non-pagination mode - update elements directly
      setElements(prev => {
        console.log('📝 Previous elements:', prev);

        if (isInZone && layoutId && zoneId) {
          // Update element within a layout zone (supports deeply nested layouts)
          const result = findAndUpdateLayout(prev, layoutId, zoneId, (zone) => ({
            ...zone,
            elements: zone.elements.map(zoneElement => {
              if (zoneElement.id === elementId) {
                const updatedElement = { ...zoneElement, ...updates };
                console.log('✅ Updated nested zone element:', updatedElement);
                return updatedElement;
              }
              return zoneElement;
            })
          }));
          console.log('📋 Updated elements array (nested zone):', result);
          return result;
        } else {
          // Update element in main elements array
          const result = prev.map(el => {
            if (el.id === elementId) {
              const updatedElement = { ...el, ...updates };
              console.log('✅ Updated main element:', updatedElement);
              console.log('🎨 Updated element styles:', updatedElement.styles);
              return updatedElement;
            }
            return el;
          });
          console.log('📋 Updated elements array (main):', result);
          return result;
        }
      });
    }

    // Update selectedElement if it exists and matches
    if (selectedElement?.id === elementId) {
      const newSelectedElement = { ...selectedElement, ...updates };
      console.log('🎯 Updating selectedElement:', newSelectedElement);
      console.log('🎨 New selectedElement styles:', newSelectedElement.styles);
      console.log('🎨 New selectedElement textStyles:', newSelectedElement.textStyles);
      setSelectedElement(newSelectedElement);

      // Force a re-render to ensure UI updates
      setTimeout(() => {
        setForceRender(prev => prev + 1);
      }, 0);
    }

    // Force re-render for image updates, video updates, and style changes
    if (updates.styles || updates.productAImage || updates.productBImage || updates.content || updates.videoFile) {
      console.log('🔄 Forcing re-render due to content/image/video/style changes');
      console.log('🔄 Updates that triggered re-render:', updates);
      setForceRender(prev => {
        const newValue = prev + 1;
        console.log('🔄 forceRender updated from', prev, 'to', newValue);
        return newValue;
      });
    }
  }, [selectedElement, findAndUpdateLayout, setElements, setSelectedElement, paginationEnabled]);

  // Media upload function - similar to blog creation flow
  const handleMediaUploadForElement = useCallback(async (file, elementId, zoneContext = null) => {
    if (!file) return null;

    try {
      setImageUploading(true);
      setUploadingElementId(elementId);

      // Determine folder based on file type
      const isVideo = file.type.startsWith('video/');
      const folder = isVideo ? 'offer-templates/videos' : 'offer-templates/images';

      // Upload to S3
      const uploadedUrl = await uploadToS3WithProgress(file, folder, (progress) => {
        console.log('Media upload progress:', progress);
      });

      const context = zoneContext || selectedElementContext;

      // In brands page mode, if it's an image (not video), convert MEDIA element to FITTABLE_IMAGE
      if (isBrandsPage && !isVideo) {
        // Helper function to find element by ID in elements array or nested layouts
        const findElementById = (elementsArray, targetId) => {
          for (const el of elementsArray) {
            if (el.id === targetId) {
              return { element: el, inZone: false };
            }
            // Check nested layouts
            if (el.type === ELEMENT_TYPES.LAYOUT && el.zones) {
              for (const zone of el.zones) {
                const found = findElementById(zone.elements || [], targetId);
                if (found) {
                  return { ...found, layoutId: el.id, zoneId: zone.id, inZone: true };
                }
              }
            }
          }
          return null;
        };

        // Try to find element in current elements array
        let elementInfo = findElementById(elements, elementId);

        // If not found, try in pages
        if (!elementInfo && paginationEnabled) {
          for (const page of pages) {
            elementInfo = findElementById(page.elements || [], elementId);
            if (elementInfo) break;
          }
        }

        if (elementInfo && elementInfo.element && elementInfo.element.type === ELEMENT_TYPES.MEDIA) {
          // Convert to FITTABLE_IMAGE with the uploaded image
          const fittableImageElement = {
            ...elementInfo.element,
            type: ELEMENT_TYPES.FITTABLE_IMAGE,
            imageSrc: uploadedUrl,
            imagePosition: { x: 0, y: 0 },
            imageScale: 1,
            mediaUrl: undefined, // Remove mediaUrl
            thumbnailUrl: undefined // Remove thumbnailUrl
          };

          // Update element using the updateElement function which handles zones
          if (elementInfo.inZone && elementInfo.layoutId && elementInfo.zoneId) {
            // Element is in a zone, use findAndUpdateLayout
            if (paginationEnabled) {
              setPages(prevPages => {
                return prevPages.map(page => ({
                  ...page,
                  elements: findAndUpdateLayout(page.elements, elementInfo.layoutId, elementInfo.zoneId, (zone) => ({
                    ...zone,
                    elements: zone.elements.map(el =>
                      el.id === elementId ? fittableImageElement : el
                    )
                  }))
                }));
              });
            }

            setElements(prev => {
              return findAndUpdateLayout(prev, elementInfo.layoutId, elementInfo.zoneId, (zone) => ({
                ...zone,
                elements: zone.elements.map(el =>
                  el.id === elementId ? fittableImageElement : el
                )
              }));
            });
          } else {
            // Element is in main canvas
            if (paginationEnabled) {
              setPages(prevPages => {
                return prevPages.map(page => ({
                  ...page,
                  elements: page.elements.map(el =>
                    el.id === elementId ? fittableImageElement : el
                  )
                }));
              });
            }

            setElements(prev => prev.map(el =>
              el.id === elementId ? fittableImageElement : el
            ));
          }

          // Update selected element
          setSelectedElement(fittableImageElement);

          setForceRender(prev => prev + 1);
          return uploadedUrl;
        }
      }

      // For videos or non-brands page, update element with media URL normally
      updateElement(
        elementId,
        { mediaUrl: uploadedUrl },
        context?.isInZone,
        context?.layoutId,
        context?.zoneId
      );

      // Also update selectedElement directly for immediate UI update
      setSelectedElement(prev => {
        if (prev?.id === elementId) {
          return { ...prev, mediaUrl: uploadedUrl };
        }
        return prev;
      });

      setForceRender(prev => prev + 1);

      return uploadedUrl;
    } catch (error) {
      console.error('Error uploading media:', error);
      const errorMessage = error.response?.data?.message || 'Failed to upload media. Please try again.';
      setStatusTitle('Upload Failed');
      setStatusMessage(errorMessage);
      setShowStatusAlert(true);
    } finally {
      setImageUploading(false);
      setUploadingElementId(null);
    }

    return null;
  }, [selectedElementContext, updateElement, isBrandsPage, elements, pages, currentPageIndex, paginationEnabled, setPages, setElements, findAndUpdateLayout]);

  // Content tab editing handlers
  const saveContentTabEdit = useCallback(() => {
    if (!selectedElement || contentTabTempValue === '') return;

    updateElement(selectedElement.id, { content: contentTabTempValue });
    setContentTabTempValue('');
  }, [selectedElement, contentTabTempValue, updateElement]);

  const cancelContentTabEdit = useCallback(() => {
    setContentTabTempValue('');
  }, []);

  // Reset Content tab temporary values when selectedElement changes
  useEffect(() => {
    setContentTabTempValue('');
    setButtonContentTabTempValue('');
    setButtonUrlTabTempValue('');
    setListItemTextValues({}); // Clear list item text temp values when element changes
  }, [selectedElement?.id]);

  const handleContentTabKeyPress = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      saveContentTabEdit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      cancelContentTabEdit();
    }
  }, [saveContentTabEdit, cancelContentTabEdit]);

  // Button Content tab editing handlers
  const saveButtonContentTabEdit = useCallback(() => {
    if (!selectedElement || buttonContentTabTempValue === '') return;

    updateElement(
      selectedElement.id,
      { content: buttonContentTabTempValue },
      selectedElementContext?.isInZone,
      selectedElementContext?.layoutId,
      selectedElementContext?.zoneId
    );
    setButtonContentTabTempValue('');
  }, [selectedElement, buttonContentTabTempValue, updateElement, selectedElementContext]);

  const cancelButtonContentTabEdit = useCallback(() => {
    setButtonContentTabTempValue('');
  }, []);

  const handleButtonContentTabKeyPress = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      saveButtonContentTabEdit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      cancelButtonContentTabEdit();
    }
  }, [saveButtonContentTabEdit, cancelButtonContentTabEdit]);

  // Button URL tab editing handlers
  const saveButtonUrlTabEdit = useCallback(() => {
    if (!selectedElement || buttonUrlTabTempValue === '') return;

    updateElement(
      selectedElement.id,
      { url: buttonUrlTabTempValue },
      selectedElementContext?.isInZone,
      selectedElementContext?.layoutId,
      selectedElementContext?.zoneId
    );
    setButtonUrlTabTempValue('');
  }, [selectedElement, buttonUrlTabTempValue, updateElement, selectedElementContext]);

  const cancelButtonUrlTabEdit = useCallback(() => {
    setButtonUrlTabTempValue('');
  }, []);

  const handleButtonUrlTabKeyPress = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      saveButtonUrlTabEdit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      cancelButtonUrlTabEdit();
    }
  }, [saveButtonUrlTabEdit, cancelButtonUrlTabEdit]);

  const moveElement = useCallback((elementId, direction) => {
    if (paginationEnabled) {
      // Pagination mode - allow moving across pages
      setPages(prev => {
        // Find which page contains the element
        let sourcePageIndex = -1;
        let elementIndex = -1;

        for (let i = 0; i < prev.length; i++) {
          const idx = prev[i].elements.findIndex(el => el.id === elementId);
          if (idx !== -1) {
            sourcePageIndex = i;
            elementIndex = idx;
            break;
          }
        }

        if (sourcePageIndex === -1 || elementIndex === -1) return prev;

        const sourcePage = prev[sourcePageIndex];
        const element = sourcePage.elements[elementIndex];

        if (direction === 'up') {
          // Moving up
          if (elementIndex > 0) {
            // Move within same page
            const newElements = [...sourcePage.elements];
            [newElements[elementIndex - 1], newElements[elementIndex]] = [newElements[elementIndex], newElements[elementIndex - 1]];
            return prev.map((page, idx) =>
              idx === sourcePageIndex ? { ...page, elements: newElements } : page
            );
          } else if (sourcePageIndex > 0) {
            // Move to previous page (last position)
            const prevPage = prev[sourcePageIndex - 1];
            const newPrevPageElements = [...prevPage.elements, element];
            const newSourcePageElements = sourcePage.elements.slice(1);

            return prev.map((page, idx) => {
              if (idx === sourcePageIndex - 1) {
                return { ...page, elements: newPrevPageElements };
              } else if (idx === sourcePageIndex) {
                return { ...page, elements: newSourcePageElements };
              }
              return page;
            });
          }
        } else {
          // Moving down
          if (elementIndex < sourcePage.elements.length - 1) {
            // Move within same page
            const newElements = [...sourcePage.elements];
            [newElements[elementIndex], newElements[elementIndex + 1]] = [newElements[elementIndex + 1], newElements[elementIndex]];
            return prev.map((page, idx) =>
              idx === sourcePageIndex ? { ...page, elements: newElements } : page
            );
          } else if (sourcePageIndex < prev.length - 1) {
            // Move to next page (first position)
            const nextPage = prev[sourcePageIndex + 1];
            const newSourcePageElements = sourcePage.elements.slice(0, -1);
            const newNextPageElements = [element, ...nextPage.elements];

            return prev.map((page, idx) => {
              if (idx === sourcePageIndex) {
                return { ...page, elements: newSourcePageElements };
              } else if (idx === sourcePageIndex + 1) {
                return { ...page, elements: newNextPageElements };
              }
              return page;
            });
          }
        }

        return prev;
      });
    } else {
      // Regular mode - update elements directly
      setElements(prev => {
        const currentIndex = prev.findIndex(el => el.id === elementId);
        if (currentIndex === -1) return prev;

        const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
        if (newIndex < 0 || newIndex >= prev.length) return prev;

        const newElements = [...prev];
        [newElements[currentIndex], newElements[newIndex]] = [newElements[newIndex], newElements[currentIndex]];
        return newElements;
      });
    }
  }, [paginationEnabled, currentPageIndex, setElements]);

  // Helper function to apply highlight to selected text
  const applyHighlight = (color, editorRef) => {
    if (!editorRef || !editorRef.current) {
      console.log('No editor reference available');
      return;
    }

    const editor = editorRef.current;
    const selection = window.getSelection();

    if (selection.rangeCount === 0 || selection.isCollapsed) {
      console.log('No text selected for highlighting');
      return;
    }

    // Focus the editor first
    editor.focus();

    // Get the range
    const range = selection.getRangeAt(0);

    // Check if the range is within our editor
    if (!editor.contains(range.commonAncestorContainer)) {
      console.log('Selection is not within the editor');
      return;
    }

    try {
      // Create highlight span
      const span = document.createElement('span');
      span.style.backgroundColor = color;
      span.style.padding = '2px 4px';
      span.style.borderRadius = '3px';
      span.style.display = 'inline';

      // Extract and wrap the selected content
      const contents = range.extractContents();
      span.appendChild(contents);
      range.insertNode(span);

      // Clear selection
      selection.removeAllRanges();

      console.log('Highlight applied successfully');

      // Update the tempValue with the new HTML content to prevent reversion
      const newContent = editor.innerHTML;
      setTempValue(newContent);

    } catch (error) {
      console.error('Highlight failed:', error);
    }
  };

  // Helper function to remove all highlights from the editor
  const removeAllHighlights = (editorRef) => {
    if (!editorRef || !editorRef.current) {
      console.log('No editor reference available');
      return;
    }

    const editor = editorRef.current;
    console.log('Editor HTML before removal:', editor.innerHTML);

    try {
      // Find all highlight spans with different selectors
      const highlightSpans1 = editor.querySelectorAll('span[style*="background-color"]');
      const highlightSpans2 = editor.querySelectorAll('span[style*="background-color:"]');
      const highlightSpans3 = editor.querySelectorAll('span[style*="background-color: #"]');

      // Combine all found spans
      const allSpans = new Set([...highlightSpans1, ...highlightSpans2, ...highlightSpans3]);
      const highlightSpans = Array.from(allSpans);

      console.log(`Found ${highlightSpans.length} highlight spans to remove`);

      if (highlightSpans.length === 0) {
        console.log('No highlights found to remove');
        return;
      }

      // Process each span
      highlightSpans.forEach((span, index) => {
        console.log(`Processing span ${index + 1}:`, span.outerHTML);

        // Create a document fragment to hold the children
        const fragment = document.createDocumentFragment();

        // Move all child nodes to the fragment
        while (span.firstChild) {
          fragment.appendChild(span.firstChild);
        }

        // Insert the fragment before the span
        span.parentNode.insertBefore(fragment, span);

        // Remove the empty span
        span.remove();
      });

      console.log(`Successfully removed ${highlightSpans.length} highlights`);
      console.log('Editor HTML after removal:', editor.innerHTML);

      // Update the tempValue with the cleaned content
      const newContent = editor.innerHTML;
      setTempValue(newContent);

    } catch (error) {
      console.error('Remove highlights failed:', error);
    }
  };

  // Render inline editable element
  const renderInlineEditableElement = (element, isInZone = false, layoutId = null, zoneId = null, elementIndex = 0) => {
    const isEditing = editingElement?.elementId === element.id;
    const isEditingField = (field) => isEditing && editingField === field;

    const handleDoubleClick = (field, value) => {
      startInlineEdit(element.id, field, value, isInZone, layoutId, zoneId);
    };

    // Helper function to check if element is selected
    const isElementSelected = (elementId) => {
      return selectedElement?.id === elementId;
    };

    // Helper function to get selection styles
    const getSelectionStyles = (elementId) => {
      return isElementSelected(elementId) ? {
        outline: '3px solid #1976d2',
        outlineOffset: '2px',
        boxShadow: '0 0 0 1px rgba(25, 118, 210, 0.2)'
      } : {};
    };

    // Element controls component
    const ElementControls = () => (
      <Box
        className="element-controls"
        sx={{
          position: 'absolute',
          top: -8,
          right: -8,
          opacity: 0,
          transition: 'opacity 0.2s',
          display: 'flex',
          gap: 0.5,
          zIndex: 10,
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
      >
        {isBrandsPage && (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              // Store the current element ID so we can insert after it
              setInsertAfterElementId(element.id);
              setTabValue(2); // Go to "Add new element" tab
              setRightPanelOpen(true);
            }}
            title="Add new element"
            sx={{
              width: 24,
              height: 24,
              backgroundColor: '#4caf50',
              color: 'white',
              '&:hover': { backgroundColor: '#388e3c' },
              mr: 0.5
            }}
          >
            <AddIcon sx={{ fontSize: 14 }} />
          </IconButton>
        )}
        {/* Move Up control (replaces drag handle) */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (isInZone && layoutId && zoneId) {
              // Move element up within the zone
              if (paginationEnabled) {
                setPages(prev =>
                  prev.map(page => ({
                    ...page,
                    elements: findAndUpdateLayout(page.elements, layoutId, zoneId, (zone) => {
                      const idx = zone.elements.findIndex(el => el.id === element.id);
                      if (idx <= 0) return zone;
                      const newZoneElements = [...zone.elements];
                      [newZoneElements[idx - 1], newZoneElements[idx]] = [newZoneElements[idx], newZoneElements[idx - 1]];
                      return { ...zone, elements: newZoneElements };
                    })
                  }))
                );
              } else {
                setElements(prev =>
                  findAndUpdateLayout(prev, layoutId, zoneId, (zone) => {
                    const idx = zone.elements.findIndex(el => el.id === element.id);
                    if (idx <= 0) return zone;
                    const newZoneElements = [...zone.elements];
                    [newZoneElements[idx - 1], newZoneElements[idx]] = [newZoneElements[idx], newZoneElements[idx - 1]];
                    return { ...zone, elements: newZoneElements };
                  })
                );
              }
            } else {
              // Move element up on main canvas
              moveElement(element.id, 'up');
            }
          }}
          title="Move Up"
          sx={{
            width: 24,
            height: 24,
            backgroundColor: '#2630f3',
            color: 'white',
            '&:hover': { backgroundColor: '#1976d2' }
          }}
        >
          <MoveUpIcon sx={{ fontSize: 14 }} />
        </IconButton>

        {/* Move Down control */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (isInZone && layoutId && zoneId) {
              // Move element down within the zone
              if (paginationEnabled) {
                setPages(prev =>
                  prev.map(page => ({
                    ...page,
                    elements: findAndUpdateLayout(page.elements, layoutId, zoneId, (zone) => {
                      const idx = zone.elements.findIndex(el => el.id === element.id);
                      if (idx < 0 || idx >= zone.elements.length - 1) return zone;
                      const newZoneElements = [...zone.elements];
                      [newZoneElements[idx], newZoneElements[idx + 1]] = [newZoneElements[idx + 1], newZoneElements[idx]];
                      return { ...zone, elements: newZoneElements };
                    })
                  }))
                );
              } else {
                setElements(prev =>
                  findAndUpdateLayout(prev, layoutId, zoneId, (zone) => {
                    const idx = zone.elements.findIndex(el => el.id === element.id);
                    if (idx < 0 || idx >= zone.elements.length - 1) return zone;
                    const newZoneElements = [...zone.elements];
                    [newZoneElements[idx], newZoneElements[idx + 1]] = [newZoneElements[idx + 1], newZoneElements[idx]];
                    return { ...zone, elements: newZoneElements };
                  })
                );
              }
            } else {
              // Move element down on main canvas
              moveElement(element.id, 'down');
            }
          }}
          title="Move Down"
          sx={{
            width: 24,
            height: 24,
            backgroundColor: '#2630f3',
            color: 'white',
            '&:hover': { backgroundColor: '#1976d2' }
          }}
        >
          <MoveDownIcon sx={{ fontSize: 14 }} />
        </IconButton>

        {/* Duplicate Button */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            console.log('📋 Duplicate button clicked for element:', element.id);

            // Create a duplicate of the current element
            const duplicatedElement = {
              ...element,
              id: generateId(),
              // Add "(copy)" to text-based content if it exists
              content: element.content ? `${element.content} (copy)` : element.content,
              title: element.title ? `${element.title} (copy)` : element.title,
              // For custom lists, duplicate the rows with "(copy)" suffix
              rows: element.rows ? element.rows.map(row => ({
                ...row,
                text: `${row.text} (copy)`
              })) : element.rows,
              // For other elements with text arrays, duplicate with "(copy)" suffix
              items: element.items ? element.items.map(item => ({
                ...item,
                question: item.question ? `${item.question} (copy)` : item.question,
                answer: item.answer ? `${item.answer} (copy)` : item.answer
              })) : element.items,
              steps: element.steps ? element.steps.map(step => ({
                ...step,
                title: step.title ? `${step.title} (copy)` : step.title,
                description: step.description ? `${step.description} (copy)` : step.description
              })) : element.steps
            };

            // Insert the duplicated element below the current one
            if (isInZone && layoutId && zoneId) {
              // For elements in zones, insert into the same zone
              console.log('📋 Duplicating element in zone:', { layoutId, zoneId });

              // Add duplicated element to current page zone (always enabled now)
              setPages(prev => prev.map((page, pageIndex) => {
                if (pageIndex === currentPageIndex) {
                  const updatedElements = findAndUpdateLayout(page.elements, layoutId, zoneId, (zone) => {
                    const currentIndex = zone.elements.findIndex(el => el.id === element.id);
                    const insertIndex = currentIndex + 1;
                    const newZoneElements = [...zone.elements];
                    newZoneElements.splice(insertIndex, 0, duplicatedElement);
                    return { ...zone, elements: newZoneElements };
                  });
                  return { ...page, elements: updatedElements };
                }
                return page;
              }));

              // Also update flat elements list for consistency
              setElements(prev =>
                findAndUpdateLayout(prev, layoutId, zoneId, (zone) => {
                  const currentIndex = zone.elements.findIndex(el => el.id === element.id);
                  const insertIndex = currentIndex + 1;
                  const newZoneElements = [...zone.elements];
                  newZoneElements.splice(insertIndex, 0, duplicatedElement);
                  return { ...zone, elements: newZoneElements };
                })
              );
            } else {
              // For elements in main canvas, insert below current element
              console.log('📋 Duplicating element in main list');

              // Add duplicated element to current page
              setPages(prevPages => {
                const safeIndex = Math.min(currentPageIndex, prevPages.length - 1);
                const currentPage = prevPages[safeIndex];
                const originalIndex = currentPage.elements.findIndex(el => el.id === element.id);

                const newElementsArray = [...currentPage.elements];
                newElementsArray.splice(originalIndex + 1, 0, duplicatedElement);

                return prevPages.map((page, pIdx) =>
                  pIdx === safeIndex ? { ...page, elements: newElementsArray } : page
                );
              });

              // Also update flat elements list
              setElements(prev => {
                const flatIndex = prev.findIndex(el => el.id === element.id);
                const newElements = [...prev];
                // Handle case where element might not be in flat list (though it should be)
                if (flatIndex !== -1) {
                  newElements.splice(flatIndex + 1, 0, duplicatedElement);
                } else {
                  newElements.push(duplicatedElement);
                }
                return newElements;
              });
            }
          }}
          title="Duplicate element"
          sx={{
            width: 24,
            height: 24,
            backgroundColor: '#4caf50',
            color: 'white',
            '&:hover': { backgroundColor: '#388e3c' }
          }}
        >
          <DuplicateIcon sx={{ fontSize: 12 }} />
        </IconButton>

        {/* Delete Button */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            console.log('🗑️ Delete button clicked for element:', element.id);
            console.log('🗑️ Delete context:', { isInZone, layoutId, zoneId });
            console.log('🗑️ Available functions:', {
              hasDeleteElementFromZone: typeof deleteElementFromZone === 'function',
              hasDeleteElement: typeof deleteElement === 'function'
            });

            if (isInZone && layoutId && zoneId) {
              console.log('🗑️ Calling deleteElementFromZone...');
              deleteElementFromZone(element.id, layoutId, zoneId);
            } else {
              console.log('🗑️ Calling deleteElement...');
              deleteElement(element.id);
            }
          }}
          title="Delete element"
          sx={{
            width: 24,
            height: 24,
            backgroundColor: '#f44336',
            color: 'white',
            '&:hover': { backgroundColor: '#d32f2f' }
          }}
        >
          <DeleteIcon sx={{ fontSize: 12 }} />
        </IconButton>
      </Box>
    );

    switch (element.type) {
      case ELEMENT_TYPES.FAQ_ACCORDION:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0,
              ...getSelectionStyles(element.id)
            }}
            onClick={e => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              // For MEDIA elements, show Content tab (0) where upload controls are
              // For other elements, show Style tab (1)
              setTabValue(element.type === ELEMENT_TYPES.MEDIA ? 0 : 1);
              setRightPanelOpen(true);
            }}
            title="Click to select and edit FAQAccordion"
          >
            <ElementControls />
            <FAQAccordion
              title={element.title}
              items={element.items}
              iconType={element.iconType || 'plusMinus'}
              iconColor={element.iconColor || '#36C3D6'}
              iconSize={element.iconSize || 'large'}
              showIcon={element.showIcon !== false}
              textAlign={element.textAlign || 'left'}
              containerBackgroundColor={element.containerBackgroundColor || 'transparent'}
              questionBackgroundColor={element.questionBackgroundColor || 'transparent'}
              answerBackgroundColor={element.answerBackgroundColor || 'rgba(0, 0, 0, 0.02)'}
              questionTextColor={element.questionTextColor || '#4B329A'}
              answerTextColor={element.answerTextColor || '#4B329A'}
              titleTextColor={element.titleTextColor || 'primary'}
              showDivider={element.showDivider !== false}
              dividerColor={element.dividerColor || '#C1A7F1'}
              itemBorderRadius={element.itemBorderRadius || '4px'}
              itemSpacing={element.itemSpacing || '12px'}
              questionPadding={element.questionPadding || '16px'}
              answerPadding={element.answerPadding || '16px'}
            />
          </Box>
        );
      case ELEMENT_TYPES.COMPARISON_TABLE:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0,
              ...getSelectionStyles(element.id)
            }}
            onClick={e => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(0); // Content tab for editing
              setRightPanelOpen(true);
            }}
            title="Click to select and edit ComparisonTable"
          >
            <ElementControls />
            <ComparisonTable
              key={`${element.id}-${element.productAImage || 'noA'}-${element.productBImage || 'noB'}`}
              title={element.title}
              productA={element.productA}
              productB={element.productB}
              productAImage={element.productAImage}
              productBImage={element.productBImage}
              rows={element.rows}
              titleStylePreset={element.titleStylePreset}
              productNameStylePreset={element.productNameStylePreset}
              featureTitleStylePreset={element.featureTitleStylePreset}
              featureDescStylePreset={element.featureDescStylePreset}
            />

          </Box>
        );
      case ELEMENT_TYPES.TWO_COLUMN_COMPARISON:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0,
              ...getSelectionStyles(element.id)
            }}
            onClick={e => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(0); // Content tab for editing
              setRightPanelOpen(true);
            }}
            title="Click to select and edit Two Column Comparison"
          >
            <ElementControls />
            <TwoColumnComparisonTable
              key={`${element.id}-${element.leftColumnImage || 'noLeft'}-${element.rightColumnImage || 'noRight'}`}
              leftColumnTitle={element.leftColumnTitle}
              rightColumnTitle={element.rightColumnTitle}
              leftColumnImage={element.leftColumnImage}
              rightColumnImage={element.rightColumnImage}
              leftItems={element.leftItems}
              rightItems={element.rightItems}
              titleStylePreset={element.titleStylePreset}
              itemStylePreset={element.itemStylePreset}
            />
          </Box>
        );
      case ELEMENT_TYPES.HEADING:
        return isEditingField('content') ? (
          <TextField
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            onKeyDown={handleKeyPress}
            onBlur={saveInlineEdit}
            autoFocus
            variant="outlined"
            size="small"
            fullWidth
            sx={{ mb: 0 }}
          />
        ) : (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0
            }}
          >
            <ElementControls />
            <Typography
              variant="h6"
              sx={{
                ...element.styles,
                cursor: 'pointer',
                '&:hover': {
                  outline: '2px dashed #1976d2',
                  outlineOffset: '2px'
                },
                padding: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                  ? element.styles?.padding || '8px 12px'
                  : element.styles?.padding || 0, // Match preview padding exactly
                borderRadius: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                  ? '4px'
                  : 0,
                display: 'block',
                border: (() => {
                  const borderValue = element.styles?.border || 'none';
                  console.log('🎨 Heading element border value:', borderValue, 'for element:', element.id);
                  return borderValue;
                })(),
                ...getSelectionStyles(element.id)
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                console.log('🔴 Heading clicked - selecting element:', element.id);
                console.log('🔴 Event target:', e.target);
                console.log('🔴 Event currentTarget:', e.currentTarget);
                console.log('🔴 Before selection - selectedElement:', selectedElement?.id);
                console.log('🔴 Before selection - rightPanelOpen:', rightPanelOpen);
                setSelectedElement(element);
                setSelectedElementContext({ isInZone, layoutId, zoneId });
                setTabValue(1); // Set to Style tab
                setRightPanelOpen(true); // Ensure right panel is open
                console.log('🔴 After selection calls made');
              }}
              onDoubleClick={() => handleDoubleClick('content', element.content)}
              title="Click to select and edit styles • Double-click to edit text"
            >
              {element.content || 'Double-click to edit heading'}
            </Typography>
          </Box>
        );

      case ELEMENT_TYPES.TEXT:
        return isEditingField('content') ? (
          <Box sx={{ mb: 0.5 }}>
            {/* Rich Text Editor Toolbar */}
            <Box sx={{
              display: 'flex',
              gap: 1,
              mb: 1,
              p: 1,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              flexWrap: 'wrap'
            }}>
              {[
                { color: '#ffd6e0', label: 'Pink' },
                { color: '#ffff59', label: 'Yellow' },
                { color: '#aeefff', label: 'Blue' }
              ].map(({ color, label }) => (
                <Button
                  key={color}
                  size="small"
                  variant="outlined"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    // Use setTimeout to ensure the click event is processed first
                    setTimeout(() => {
                      applyHighlight(color, textEditorRef);
                    }, 10);
                  }}
                  sx={{ minWidth: 'auto', px: 1, backgroundColor: color, borderColor: '#e0e0e0', marginRight: 0.5 }}
                  title={`Highlight ${label} - Select text first`}
                >
                  <span style={{ background: color, padding: '0 4px', fontWeight: 'bold' }}>H</span>
                </Button>
              ))}
              <Button
                size="small"
                variant="outlined"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  console.log('Remove highlights button clicked');

                  // Simple approach: Find the active contentEditable element
                  const activeElement = document.activeElement;
                  const contentEditableElements = document.querySelectorAll('[contenteditable="true"]');

                  console.log('Active element:', activeElement);
                  console.log('ContentEditable elements found:', contentEditableElements.length);

                  // Try to find the editor element
                  let editor = null;
                  if (activeElement && activeElement.contentEditable === 'true') {
                    editor = activeElement;
                  } else if (contentEditableElements.length > 0) {
                    editor = contentEditableElements[contentEditableElements.length - 1]; // Get the last one
                  }

                  if (!editor) {
                    console.log('No editor found');
                    return;
                  }

                  console.log('Using editor:', editor);
                  console.log('Editor HTML before:', editor.innerHTML);

                  // Simple regex replacement to remove highlight spans
                  let newContent = editor.innerHTML;

                  // Remove highlight spans with regex
                  newContent = newContent.replace(/<span[^>]*style="[^"]*background-color:[^"]*"[^>]*>(.*?)<\/span>/gi, '$1');

                  console.log('Editor HTML after regex:', newContent);

                  // Update the editor content
                  editor.innerHTML = newContent;

                  // Update tempValue
                  setTempValue(newContent);

                  console.log('Highlights removed successfully');
                }}
                sx={{ minWidth: 'auto', px: 1, marginLeft: 1 }}
                title="Remove all highlights"
              >
                🔄
              </Button>

            </Box>

            {/* Rich Text Editor */}
            <Box
              contentEditable
              suppressContentEditableWarning
              ref={(el) => {
                textEditorRef.current = el;
                if (el) {
                  // Set initial content when element is first mounted, but don't override if it has highlights
                  if (el.innerHTML === '' || (el.innerHTML !== tempValue && !el.innerHTML.includes('<span style="background-color:'))) {
                    el.innerHTML = tempValue || '';
                  }
                  // Focus the editor when it's first created, but don't move cursor
                  if (editingElement?.elementId === element.id && editingField === 'content') {
                    // Only focus if not already focused to avoid cursor jumping
                    if (document.activeElement !== el) {
                      el.focus();
                      // Only place cursor at the end if this is the initial focus and no text exists
                      if (!window.textEditorInitialized && (!tempValue || tempValue.trim() === '')) {
                        window.textEditorInitialized = true;
                        const range = document.createRange();
                        const selection = window.getSelection();
                        try {
                          range.selectNodeContents(el);
                          range.collapse(false);
                          selection.removeAllRanges();
                          selection.addRange(range);
                        } catch (e) {
                          // If that fails, just focus
                          el.focus();
                        }
                      }
                    }
                  }
                }
              }}
              onPaste={(e) => {
                e.preventDefault();
                e.stopPropagation();

                // Get plain text from clipboard
                const clipboardData = e.clipboardData || window.clipboardData;
                const pastedText = clipboardData.getData('text/plain');

                if (!pastedText) return;

                // Get the current selection
                const selection = window.getSelection();
                if (!selection.rangeCount) return;

                const range = selection.getRangeAt(0);

                // Delete any selected content
                range.deleteContents();

                // Create a text node with the pasted text (plain text, no formatting)
                const textNode = document.createTextNode(pastedText);
                range.insertNode(textNode);

                // Move cursor to the end of inserted text
                range.setStartAfter(textNode);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);

                // Update tempValue to reflect the change
                const editor = e.currentTarget;
                if (editor && editor.innerHTML !== undefined) {
                  setTempValue(editor.innerHTML);
                }
              }}
              onInput={(e) => {
                // Use a timeout to batch updates and avoid constant re-renders
                const currentElement = e.currentTarget;
                if (currentElement && currentElement.innerHTML !== undefined) {
                  clearTimeout(window.textInputTimeout);
                  window.textInputTimeout = setTimeout(() => {
                    // Double-check the element still exists when timeout fires
                    if (currentElement && currentElement.innerHTML !== undefined) {
                      // Only update if the content actually changed to prevent unnecessary re-renders
                      if (currentElement.innerHTML !== tempValue) {
                        setTempValue(currentElement.innerHTML);
                      }
                    }
                  }, 100); // Increased timeout to reduce re-renders
                }
              }}
              onKeyDown={(e) => {
                // Handle immediate save on Enter + Shift/Ctrl
                if (e.key === 'Enter' && (e.shiftKey || e.ctrlKey)) {
                  e.preventDefault();
                  if (e.currentTarget && e.currentTarget.innerHTML !== undefined) {
                    setTempValue(e.currentTarget.innerHTML);
                    saveInlineEdit();
                  }
                } else {
                  handleKeyPress(e);
                }
              }}
              onBlur={(e) => {
                if (e.currentTarget && e.currentTarget.innerHTML !== undefined) {
                  setTempValue(e.currentTarget.innerHTML);
                  saveInlineEdit();
                }
              }}
              sx={{
                border: '1px solid #ccc',
                borderRadius: 1,
                p: 2,
                minHeight: '100px',
                outline: 'none',
                '&:focus': {
                  borderColor: '#1976d2',
                  boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                },
                '& *': {
                  margin: 0,
                  padding: 0
                }
              }}
            />
          </Box>
        ) : (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0, // Remove margin-bottom for inline layouts
              display: 'inline-block' // Force inline-block for inline layouts
            }}
          >
            <ElementControls />
            <Box
              sx={{
                ...element.styles,
                cursor: 'pointer',
                '&:hover': {
                  outline: '2px dashed #1976d2',
                  outlineOffset: '2px'
                },
                padding: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                  ? element.styles?.padding || '8px 12px'
                  : element.styles?.padding || 0, // Match preview padding exactly
                borderRadius: (() => {
                  const hasBackground = element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent';
                  const radiusValue = hasBackground
                    ? element.styles?.borderRadius || '4px'
                    : element.styles?.borderRadius || 0;
                  console.log('🔄 Text element border radius debug:', {
                    elementId: element.id,
                    hasBackground,
                    backgroundColor: element.styles?.backgroundColor,
                    borderRadius: element.styles?.borderRadius,
                    finalRadius: radiusValue
                  });
                  return radiusValue;
                })(),

                display: 'block !important', // Force block for proper text wrapping
                minHeight: '20px',
                wordWrap: 'break-word',
                width: '100%', // Take full width of the zone
                whiteSpace: 'normal',
                border: (() => {
                  const borderValue = element.styles?.border || 'none';
                  console.log('🎨 Text element border value:', borderValue, 'for element:', element.id);
                  return borderValue;
                })(),
                ...getSelectionStyles(element.id)
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                console.log('🔴 Text clicked - selecting element:', element.id);
                console.log('🔴 Event target:', e.target);
                console.log('🔴 Event currentTarget:', e.currentTarget);
                console.log('🔴 Before selection - selectedElement:', selectedElement?.id);
                console.log('🔴 Before selection - rightPanelOpen:', rightPanelOpen);
                setSelectedElement(element);
                setSelectedElementContext({ isInZone, layoutId, zoneId });
                setTabValue(1); // Set to Style tab
                setRightPanelOpen(true); // Ensure right panel is open
                console.log('🔴 After selection calls made');
              }}
              onDoubleClick={() => handleDoubleClick('content', element.content)}
              title="Click to select and edit styles • Double-click to edit text • Use toolbar for styling"
              dangerouslySetInnerHTML={{ __html: element.content || 'Double-click to edit text' }}
            />
          </Box>
        );
      case ELEMENT_TYPES.QUOTATION_BLOCK:
        console.log('🔴 Rendering quotation block:', element.id, element);
        return isEditingField('content') ? (
          <Box sx={{ mb: 1 }}>
            {/* Rich Text Editor Toolbar */}
            <Box sx={{
              display: 'flex',
              gap: 1,
              mb: 1,
              p: 1,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              flexWrap: 'wrap'
            }}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  document.execCommand('bold', false, null);
                }}
                sx={{ minWidth: 'auto', px: 1 }}
              >
                <strong>B</strong>
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  document.execCommand('italic', false, null);
                }}
                sx={{ minWidth: 'auto', px: 1 }}
              >
                <em>I</em>
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setPromptDialogTitle('Enter Color');
                  setPromptDialogMessage('Enter color (e.g., #ff0000, red, blue):');
                  setPromptDialogValue('#ff0000');
                  setPromptAction(() => (color) => {
                    if (color) {
                      document.execCommand('foreColor', false, color);
                    }
                  });
                  setShowPromptDialog(true);
                }}
                sx={{ minWidth: 'auto', px: 1 }}
              >
                🎨
              </Button>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                  value=""
                  onChange={(e) => {
                    if (e.target.value) {
                      document.execCommand('fontName', false, e.target.value);
                    }
                  }}
                  displayEmpty
                  sx={{ fontSize: '0.75rem', height: '32px' }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200
                      }
                    }
                  }}
                >
                  <MenuItem value="" disabled>
                    <em>Font</em>
                  </MenuItem>
                  {getPresetFontFamilies().map((fontFamily) => (
                    <MenuItem key={fontFamily} value={fontFamily}>
                      {fontFamily.replace(/['"]/g, '').replace(', sans-serif', '').replace(', serif', '').replace(', monospace', '')}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setPromptDialogTitle('Enter Font Size');
                  setPromptDialogMessage('Enter font size (e.g., 12px, 1.2em, 120%):');
                  setPromptDialogValue('16px');
                  setPromptAction(() => (size) => {
                    if (size) {
                      document.execCommand('fontSize', false, size);
                    }
                  });
                  setShowPromptDialog(true);
                }}
                sx={{ minWidth: 'auto', px: 1 }}
              >
                📏
              </Button>
              {[
                { color: '#ffd6e0', label: 'Pink' },
                { color: '#ffff59', label: 'Yellow' },
                { color: '#aeefff', label: 'Blue' }
              ].map(({ color, label }) => (
                <Button
                  key={color}
                  size="small"
                  variant="outlined"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    // Use setTimeout to ensure the click event is processed first
                    setTimeout(() => {
                      applyHighlight(color, textEditorRef);
                    }, 10);
                  }}
                  sx={{ minWidth: 'auto', px: 1, backgroundColor: color, borderColor: '#e0e0e0', marginRight: 0.5 }}
                  title={`Highlight ${label} - Select text first`}
                >
                  <span style={{ background: color, padding: '0 4px', fontWeight: 'bold' }}>H</span>
                </Button>
              ))}
              <Button
                size="small"
                variant="outlined"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  console.log('Remove highlights button clicked');

                  // Simple approach: Find the active contentEditable element
                  const activeElement = document.activeElement;
                  const contentEditableElements = document.querySelectorAll('[contenteditable="true"]');

                  console.log('Active element:', activeElement);
                  console.log('ContentEditable elements found:', contentEditableElements.length);

                  // Try to find the editor element
                  let editor = null;
                  if (activeElement && activeElement.contentEditable === 'true') {
                    editor = activeElement;
                  } else if (contentEditableElements.length > 0) {
                    editor = contentEditableElements[contentEditableElements.length - 1]; // Get the last one
                  }

                  if (!editor) {
                    console.log('No editor found');
                    return;
                  }

                  console.log('Using editor:', editor);
                  console.log('Editor HTML before:', editor.innerHTML);

                  // Simple regex replacement to remove highlight spans
                  let newContent = editor.innerHTML;

                  // Remove highlight spans with regex
                  newContent = newContent.replace(/<span[^>]*style="[^"]*background-color:[^"]*"[^>]*>(.*?)<\/span>/gi, '$1');

                  console.log('Editor HTML after regex:', newContent);

                  // Update the editor content
                  editor.innerHTML = newContent;

                  // Update tempValue
                  setTempValue(newContent);

                  console.log('Highlights removed successfully');
                }}
                sx={{ minWidth: 'auto', px: 1, marginLeft: 1 }}
                title="Remove all highlights"
              >
                🔄
              </Button>
            </Box>

            {/* Rich Text Editor */}
            <Box
              contentEditable
              suppressContentEditableWarning
              ref={(el) => {
                textEditorRef.current = el;
                if (el) {
                  // Set initial content when element is first mounted, but don't override if it has highlights
                  if (el.innerHTML === '' || (el.innerHTML !== tempValue && !el.innerHTML.includes('<span style="background-color:'))) {
                    el.innerHTML = tempValue || '';
                  }
                  // Focus the editor when it's first created, but don't move cursor
                  if (editingElement?.elementId === element.id && editingField === 'content') {
                    // Only focus if not already focused to avoid cursor jumping
                    if (document.activeElement !== el) {
                      el.focus();
                      // Only place cursor at the end if this is the initial focus and no text exists
                      if (!window.textEditorInitialized && (!tempValue || tempValue.trim() === '')) {
                        window.textEditorInitialized = true;
                        const range = document.createRange();
                        const selection = window.getSelection();
                        try {
                          range.selectNodeContents(el);
                          range.collapse(false);
                          selection.removeAllRanges();
                          selection.addRange(range);
                        } catch (e) {
                          // If that fails, just focus
                          el.focus();
                        }
                      }
                    }
                  }
                }
              }}
              onPaste={(e) => {
                e.preventDefault();
                e.stopPropagation();

                // Get plain text from clipboard
                const clipboardData = e.clipboardData || window.clipboardData;
                const pastedText = clipboardData.getData('text/plain');

                if (!pastedText) return;

                // Get the current selection
                const selection = window.getSelection();
                if (!selection.rangeCount) return;

                const range = selection.getRangeAt(0);

                // Delete any selected content
                range.deleteContents();

                // Create a text node with the pasted text (plain text, no formatting)
                const textNode = document.createTextNode(pastedText);
                range.insertNode(textNode);

                // Move cursor to the end of inserted text
                range.setStartAfter(textNode);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);

                // Update tempValue to reflect the change
                const editor = e.currentTarget;
                if (editor && editor.innerHTML !== undefined) {
                  setTempValue(editor.innerHTML);
                }
              }}
              onInput={(e) => {
                // Use a timeout to batch updates and avoid constant re-renders
                const currentElement = e.currentTarget;
                if (currentElement && currentElement.innerHTML !== undefined) {
                  clearTimeout(window.textInputTimeout);
                  window.textInputTimeout = setTimeout(() => {
                    // Double-check the element still exists when timeout fires
                    if (currentElement && currentElement.innerHTML !== undefined) {
                      // Only update if the content actually changed to prevent unnecessary re-renders
                      if (currentElement.innerHTML !== tempValue) {
                        setTempValue(currentElement.innerHTML);
                      }
                    }
                  }, 100); // Increased timeout to reduce re-renders
                }
              }}
              onKeyDown={(e) => {
                // Handle immediate save on Enter + Shift/Ctrl
                if (e.key === 'Enter' && (e.shiftKey || e.ctrlKey)) {
                  e.preventDefault();
                  if (e.currentTarget && e.currentTarget.innerHTML !== undefined) {
                    setTempValue(e.currentTarget.innerHTML);
                    saveInlineEdit();
                  }
                } else {
                  handleKeyPress(e);
                }
              }}
              onBlur={(e) => {
                if (e.currentTarget && e.currentTarget.innerHTML !== undefined) {
                  setTempValue(e.currentTarget.innerHTML);
                  saveInlineEdit();
                }
              }}
              sx={{
                border: '1px solid #ccc',
                borderRadius: 1,
                p: 2,
                minHeight: '100px',
                outline: 'none',
                fontStyle: 'italic',
                fontSize: element.styles?.fontSize || '18px',
                fontWeight: element.styles?.fontWeight || '400',
                lineHeight: element.styles?.lineHeight || '1.5',
                fontFamily: element.styles?.fontFamily || "'Inter', sans-serif",
                '&:focus': {
                  borderColor: '#1976d2',
                  boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                },
                '& *': {
                  margin: 0,
                  padding: 0
                }
              }}
            />
          </Box>
        ) : (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 1, // Remove margin-bottom for inline layouts
              display: 'block' // Force block for proper text wrapping
            }}
          >
            <ElementControls />
            {/* Content container - EXACTLY like TEXT elements */}
            <Box
              sx={{
                cursor: 'pointer',
                backgroundColor: element.styles?.backgroundColor || '#fce7f3',
                color: element.styles?.color || '#101022',
                borderRadius: element.styles?.borderRadius || '16px',
                padding: element.styles?.padding || '24px 32px',
                fontStyle: 'italic',
                minHeight: '120px',
                fontSize: element.styles?.fontSize || '18px',
                fontWeight: element.styles?.fontWeight || '400',
                lineHeight: element.styles?.lineHeight || '1.5',
                fontFamily: element.styles?.fontFamily || "'Inter', sans-serif",
                '&:hover': {
                  outline: '2px dashed #1976d2',
                  outlineOffset: '2px'
                },
                ...element.styles,
                ...getSelectionStyles(element.id)
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                console.log('🔴 Quotation block clicked - selecting element:', element.id);
                setSelectedElement(element);
                setSelectedElementContext({ isInZone, layoutId, zoneId });
                setTabValue(1); // Set to Style tab
                setRightPanelOpen(true); // Ensure right panel is open
                console.log('🔴 After selection calls made');
              }}
              onDoubleClick={() => handleDoubleClick('content', element.content)}
              title="Click to select and edit styles • Double-click to edit text • Use toolbar for styling"
              dangerouslySetInnerHTML={{ __html: element.content || 'Double-click to edit quotation text' }}
            />
          </Box>
        );


      case ELEMENT_TYPES.IMAGE:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              textAlign: 'center',
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              '&:hover .resize-handles': { opacity: 1 },
              mb: 0
            }}
          >
            <ElementControls />
            {isEditingField('content') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Enter image URL"
                sx={{ mb: 0 }}
              />
            ) : (
              <Box
                sx={{
                  cursor: 'pointer',
                  border: '2px dashed transparent',
                  '&:hover': {
                    opacity: 0.8,
                    border: '2px dashed #1976d2'
                  },
                  p: 1,
                  borderRadius: 1,
                  position: 'relative',
                  display: 'inline-block',
                  ...getSelectionStyles(element.id)
                }}
                onClick={(e) => {
                  // Don't handle clicks on resize handles
                  if (e.target.closest('.resize-handles')) {
                    return;
                  }
                  e.stopPropagation();
                  e.preventDefault();
                  console.log('🔴 Image clicked - selecting element:', element.id);
                  console.log('🔴 Event target:', e.target);
                  console.log('🔴 Event currentTarget:', e.currentTarget);
                  console.log('🔴 Before selection - selectedElement:', selectedElement?.id);
                  console.log('🔴 Before selection - rightPanelOpen:', rightPanelOpen);
                  setSelectedElement(element);
                  setSelectedElementContext({ isInZone, layoutId, zoneId });
                  setTabValue(1); // Set to Style tab
                  setRightPanelOpen(true); // Ensure right panel is open
                  console.log('🔴 After selection calls made');
                }}
                onDoubleClick={() => handleDoubleClick('content', element.content)}
                title="Click to select and edit styles • Double-click to change URL"
              >
                {element.content ? (
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <img
                      src={element.content}
                      alt={element.alt || 'Image'}
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        maxHeight: '150px',
                        width: element.styles?.width || 'auto',
                        height: element.styles?.height || 'auto',
                        display: 'block'
                      }}
                      onLoad={(e) => {
                        console.log('🔴 Image loaded:', {
                          naturalWidth: e.target.naturalWidth,
                          naturalHeight: e.target.naturalHeight,
                          currentWidth: e.target.width,
                          currentHeight: e.target.height
                        });
                      }}
                    />
                    {console.log('🔴 Rendering resize handles for image:', element.id)}

                    {/* Resize Handles */}
                    <Box
                      className="resize-handles"
                      sx={{
                        position: 'absolute',
                        top: -6,
                        left: -6,
                        right: -6,
                        bottom: -6,
                        opacity: 1, // Temporarily make visible for debugging
                        transition: 'opacity 0.2s',
                        pointerEvents: 'none',
                        zIndex: 10,
                        border: '2px solid green' // Debug border
                      }}
                    >
                      {/* Corner resize handles */}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -6,
                          left: -6,
                          width: 12,
                          height: 12,
                          backgroundColor: '#ff0000', // Red for debugging
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'nw-resize',
                          pointerEvents: 'auto',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'nw', e);
                          e.stopPropagation();
                          e.preventDefault();
                          handleResizeStart(e, element, 'nw');
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -6,
                          right: -6,
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'ne-resize',
                          pointerEvents: 'auto',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'ne');
                          handleResizeStart(e, element, 'ne');
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: -6,
                          left: -6,
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'sw-resize',
                          pointerEvents: 'auto',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'sw');
                          handleResizeStart(e, element, 'sw');
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: -6,
                          right: -6,
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'se-resize',
                          pointerEvents: 'auto',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'se');
                          handleResizeStart(e, element, 'se');
                        }}
                      />

                      {/* Edge resize handles */}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: -6,
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'w-resize',
                          pointerEvents: 'auto',
                          transform: 'translateY(-50%)',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'w');
                          handleResizeStart(e, element, 'w');
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: -6,
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'e-resize',
                          pointerEvents: 'auto',
                          transform: 'translateY(-50%)',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'e');
                          handleResizeStart(e, element, 'e');
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -6,
                          left: '50%',
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'n-resize',
                          pointerEvents: 'auto',
                          transform: 'translateX(-50%)',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 'n');
                          handleResizeStart(e, element, 'n');
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: -6,
                          left: '50%',
                          width: 12,
                          height: 12,
                          backgroundColor: '#1976d2',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 's-resize',
                          pointerEvents: 'auto',
                          transform: 'translateX(-50%)',
                          zIndex: 11
                        }}
                        onMouseDown={(e) => {
                          console.log('🔴 Resize handle clicked:', 's');
                          handleResizeStart(e, element, 's');
                        }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{
                    width: '100px',
                    height: '100px',
                    backgroundColor: '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1
                  }}>
                    <Typography variant="caption" color="text.secondary">
                      📷 Click to add image
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        );

      case ELEMENT_TYPES.CROPPABLE_IMAGE:
        return (
          <ImageCropper
            element={element}
            updateElement={updateElement}
            ElementControls={ElementControls}
            isInZone={isInZone}
            layoutId={layoutId}
            zoneId={zoneId}
            onElementClick={(element, isInZone, layoutId, zoneId) => {
              console.log('🔴 Croppable Image clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
          />
        );


      // ...inside your render function:
      case ELEMENT_TYPES.CIRCULAR_IMAGE:
        return (
          <CircularImageCropper
            element={element}
            updateElement={updateElement}
            ElementControls={ElementControls}
            isInZone={isInZone}
            layoutId={layoutId}
            zoneId={zoneId}
            onElementClick={(element, isInZone, layoutId, zoneId) => {
              console.log('🔴 Circular Image clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
          />
        );

      case ELEMENT_TYPES.FITTABLE_IMAGE:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mt: 0,
              mb: 0,
              // Don't apply selection styles to avoid double borders
              // The FittableImage component handles its own visual feedback
            }}
            onClick={e => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Style tab for editing dimensions
              setRightPanelOpen(true);
            }}
            title="Click to select and edit fittable image"
          >
            <ElementControls />
            <FittableImage
              element={element}
              updateElement={updateElement}
              ElementControls={ElementControls}
              isInZone={isInZone}
              layoutId={layoutId}
              zoneId={zoneId}
              onElementClick={(element, isInZone, layoutId, zoneId) => {
                console.log('🔴 Fittable Image clicked - selecting element:', element.id);
                setSelectedElement(element);
                setSelectedElementContext({ isInZone, layoutId, zoneId });
                setTabValue(1); // Set to Style tab
                setRightPanelOpen(true); // Ensure right panel is open
              }}
            />
          </Box>
        );

      case ELEMENT_TYPES.BUTTON:
        // Force unique key for button re-rendering - include border specifically to ensure re-render
        const buttonKey = `btn-${element.id}-${JSON.stringify(element.styles)}-${element.styles?.border || 'none'}`;

        return (
          <Box
            key={buttonKey}
            data-element-id={element.id}
            sx={{
              textAlign: 'center',
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0,
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            {isEditingField('content') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                placeholder="Button text"
                sx={{ mb: 1 }}
              />
            ) : isEditingField('url') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                placeholder="Button URL"
                sx={{ mb: 1 }}
              />
            ) : (
              <Box>
                <ResizableButton
                  key={`resizable-${element.id}-${JSON.stringify(element.styles)}-${element.styles?.border || 'none'}`}
                  element={element}
                  updateElement={updateElement}
                  isInZone={isInZone}
                  layoutId={layoutId}
                  zoneId={zoneId}
                  isEditing={isEditingField('content') || isEditingField('url')}
                  disableResize={true}
                >
                  <button
                    ref={(buttonRef) => {
                      if (buttonRef && element.id === selectedElement?.id) {
                        console.log('🔴 BUTTON REF - Element ID:', element.id);
                        console.log('🔴 BUTTON REF - Border style:', element.styles?.border);
                        console.log('🔴 BUTTON REF - All styles:', element.styles);

                        // Aggressive DOM border clearing and setting
                        const borderValue = element.styles?.border || 'none';
                        console.log('🔴 FORCING AGGRESSIVE DOM BORDER UPDATE:', borderValue);

                        // First, completely clear ALL border-related properties
                        buttonRef.style.removeProperty('border');
                        buttonRef.style.removeProperty('border-width');
                        buttonRef.style.removeProperty('border-style');
                        buttonRef.style.removeProperty('border-color');
                        buttonRef.style.removeProperty('border-top');
                        buttonRef.style.removeProperty('border-right');
                        buttonRef.style.removeProperty('border-bottom');
                        buttonRef.style.removeProperty('border-left');

                        // Force a reflow
                        void buttonRef.offsetHeight;

                        // Then set the new border
                        if (borderValue !== 'none') {
                          buttonRef.style.setProperty('border', borderValue, 'important');
                        } else {
                          buttonRef.style.setProperty('border', 'none', 'important');
                        }

                        console.log('🔴 Final computed border:', window.getComputedStyle(buttonRef).border);
                      }
                    }}
                    style={{
                      backgroundColor: element.styles?.backgroundColor || '#ff6b35',
                      color: element.styles?.color || '#ffffff',
                      padding: element.styles?.padding || '12px 24px',
                      fontSize: element.styles?.fontSize || '16px',
                      fontWeight: element.styles?.fontWeight || 400,
                      borderRadius: element.styles?.borderRadius || '4px',
                      width: '100%',
                      height: '100%',
                      cursor: element.styles?.cursor || 'pointer',
                      marginBottom: element.styles?.marginBottom || '8px',
                      // Border is now handled entirely by DOM manipulation in ref callback
                      // Debug border application - removed red outline to avoid confusion
                      // Add background to make border visible if it's there
                      boxSizing: 'border-box',
                      // Force DOM update with unique property
                      '--border-update-id': element.styles?.border ? element.styles.border.replace(/[^a-zA-Z0-9]/g, '-') + '-' + forceRender : 'none-' + forceRender,
                      textTransform: element.styles?.textTransform || 'none',
                      display: element.styles?.display || 'flex',
                      alignItems: element.styles?.alignItems || 'center',
                      justifyContent: element.styles?.justifyContent || 'center',
                      textDecoration: element.styles?.textDecoration || 'none',
                      transition: element.styles?.transition || 'all 0.2s ease',
                      boxShadow: element.styles?.boxShadow || '0 2px 4px rgba(0,0,0,0.1)',
                      background: element.styles?.background || element.styles?.backgroundColor || '#ff6b35',
                      gap: element.styles?.gap || undefined,
                      '&:hover': {
                        opacity: 0.8,
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                      }
                    }}
                    data-text-transform={element.styles?.textTransform || 'none'}
                    data-debug-text-transform={element.styles?.textTransform}
                    data-debug-content={element.content}
                    data-debug-styles={JSON.stringify(element.styles)}
                    onMouseEnter={(e) => {
                      e.target.style.opacity = '0.8';
                      e.target.style.transform = 'translateY(-1px)';
                      // Only apply hover shadow if no custom shadow is set
                      if (!element.styles?.boxShadow) {
                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.opacity = '1';
                      e.target.style.transform = 'translateY(0)';
                      // Restore original shadow from element.styles or default
                      e.target.style.boxShadow = element.styles?.boxShadow || '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log('🔴 Button clicked - selecting element:', element.id);
                      console.log('🔴 Before selection - selectedElement:', selectedElement?.id);
                      console.log('🔴 Before selection - rightPanelOpen:', rightPanelOpen);
                      setSelectedElement(element);
                      setSelectedElementContext({ isInZone, layoutId, zoneId });
                      setTabValue(1); // Set to Style tab
                      setRightPanelOpen(true); // Ensure right panel is open
                      console.log('🔴 After selection calls made');
                    }}
                    onDoubleClick={() => handleDoubleClick('content', element.content)}
                    title="Click to select and edit styles • Double-click to edit text • Drag handles to resize"
                  >
                    {element.iconLeft === 'cart' && <ShoppingCartIcon sx={{ color: '#d4a000', fontSize: '2.2rem', mr: 1 }} />}
                    <span style={{
                      fontWeight: element.styles?.fontWeight || 400,
                      fontSize: element.styles?.fontSize || '2rem',
                      color: element.styles?.color || '#222',
                      letterSpacing: element.styles?.fontWeight === 100 ? '0.5px' : 'normal',
                      textShadow: element.styles?.fontWeight === 100 ? '0.5px 0.5px 0px rgba(0,0,0,0.1)' :
                        element.styles?.fontWeight === 900 ? '1px 1px 0px rgba(0,0,0,0.2)' : 'none'
                    }}>
                      {element.styles?.textTransform === 'titlecase' && element.content
                        ? element.content.toLowerCase().replace(/\b\w/g, l => l.toUpperCase())
                        : element.content || 'Button Text'}
                    </span>
                    {element.iconRight === 'arrow' && <ArrowForwardIcon sx={{ color: '#222', fontSize: '2.2rem', ml: 1 }} />}
                  </button>
                </ResizableButton>

              </Box>
            )}
          </Box>
        );

      case ELEMENT_TYPES.VIDEO:
        // Calculate aspect ratio from element styles
        const canvasAspectRatio = calculateVideoAspectRatio(element);

        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 2, // Match preview margin-bottom (16px)
              mt: 0, // No top margin to match preview
              width: 'calc(100% + 32px)',
              maxWidth: 'calc(100% + 32px)',
              mx: -2, // Negative margin to counteract container padding (16px = 2 * 8px)
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(0); // Content tab for editing
              setRightPanelOpen(true);
            }}
            title="Click to select and edit video"
          >
            <ElementControls />
            {isEditingField('content') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                placeholder="YouTube embed URL (e.g., https://www.youtube.com/embed/VIDEO_ID)"
                sx={{ mb: 1 }}
                helperText="Enter YouTube embed URL or any video iframe src"
              />
            ) : (
              <Box
                sx={{
                  textAlign: 'center',
                  cursor: 'pointer',
                  border: '2px dashed transparent',
                  '&:hover': {
                    opacity: 0.8,
                    border: '2px dashed #1976d2'
                  },
                  p: 0, // Remove padding to match preview
                  borderRadius: 0
                }}
                title="Click to select and edit video"
              >
                {(element.content || element.videoFile) ? (
                  // If content exists, show either iframe or preview
                  element.videoFile ? (
                    // Show uploaded video with calculated aspect ratio
                    // For brands page, always use full width regardless of preset
                    <Box sx={{
                      width: isBrandsPage ? '100%' : (element.styles?.width || '100%'),
                      maxWidth: isBrandsPage ? '100%' : (element.styles?.maxWidth || '100%'),
                      aspectRatio: canvasAspectRatio,
                      position: 'relative',
                      backgroundColor: '#000',
                      borderRadius: 0,
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mx: 0, // Parent Box already handles the negative margin
                      px: 0
                    }}>
                      <CenteredVideoPlayer
                        src={element.videoFile}
                        poster={element.thumbnailUrl || undefined}
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          margin: 0,
                          padding: 0
                        }}
                        videoProps={{ title: 'Uploaded Video' }}
                      />
                      {/* Overlay for editing */}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0,0,0,0.3)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: 0,
                          transition: 'opacity 0.2s',
                          pointerEvents: 'none',
                          zIndex: 3,
                          '&:hover': {
                            opacity: 1
                          }
                        }}
                      >
                        <Typography variant="body2" color="white" sx={{ fontWeight: 'bold' }}>
                          Click to select video
                        </Typography>
                      </Box>
                    </Box>
                  ) : (element.content.includes('youtube.com') || element.content.includes('youtu.be') || element.content.includes('vimeo.com')) ? (
                    <Box sx={{
                      width: isBrandsPage ? '100%' : '100%',
                      maxWidth: isBrandsPage ? '100%' : '100%',
                      aspectRatio: canvasAspectRatio,
                      mx: 0, // Parent Box already handles the negative margin
                      px: 0,
                      position: 'relative',
                      backgroundColor: '#000',
                      borderRadius: 0,
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <iframe
                        src={element.content}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allowFullScreen
                        title="Video Preview"
                        style={{
                          width: '100%',
                          maxWidth: '100%',
                          border: 'none',
                          borderRadius: 0,
                          margin: 0,
                          padding: 0
                        }}
                      />
                      {/* Overlay for editing */}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0,0,0,0.3)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: 0,
                          transition: 'opacity 0.2s',
                          '&:hover': {
                            opacity: 1
                          }
                        }}
                      >
                        <Typography variant="body2" color="white" sx={{
                          textAlign: 'center',
                          backgroundColor: 'rgba(0,0,0,0.7)',
                          padding: 1,
                          borderRadius: 0
                        }}>
                          Click to select video
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    // Non-video URL, show preview
                    <Box sx={{
                      width: element.styles?.width || '100%',
                      height: element.styles?.height || '120px',
                      backgroundColor: '#f44336',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 0,
                      flexDirection: 'column',
                      gap: 1
                    }}>
                      <Typography variant="body2" color="white" sx={{ fontWeight: 'bold' }}>
                        ⚠️ Invalid Video URL
                      </Typography>
                      <Typography variant="caption" color="white" sx={{ textAlign: 'center', px: 2 }}>
                        {element.content.substring(0, 40)}...
                      </Typography>
                      <Typography variant="caption" color="white">
                        Double-click to fix
                      </Typography>
                    </Box>
                  )
                ) : (
                  <Box sx={{
                    width: element.styles?.width || '100%',
                    aspectRatio: canvasAspectRatio,
                    backgroundColor: '#e3f2fd',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 0,
                    border: '2px dashed #1976d2',
                    flexDirection: 'column',
                    gap: 1
                  }}>
                    <Typography variant="h4" color="primary">
                      🎥
                    </Typography>
                    <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold' }}>
                      No video uploaded
                    </Typography>

                  </Box>
                )}
              </Box>
            )}
          </Box>
        );

      case ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY: {
        const videoAspectRatio = calculateVideoAspectRatio(element);

        const getButtonPosition = (button) => {
          const presets = {
            'top-left': { top: '10px', left: '10px' },
            'top-right': { top: '10px', right: '10px' },
            'bottom-left': { bottom: '10px', left: '10px' },
            'bottom-right': { bottom: '10px', right: '10px' },
            'center': { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }
          };

          if (button.position === 'custom') {
            return {
              top: `${button.customY || 50}%`,
              left: `${button.customX || 50}%`,
              transform: 'translate(-50%, -50%)'
            };
          }

          return presets[button.position] || presets['bottom-right'];
        };

        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 2,
              width: 'calc(100% + 32px)',
              maxWidth: 'calc(100% + 32px)',
              mx: -2,
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(0);
              setRightPanelOpen(true);
            }}
          >
            <ElementControls />
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                aspectRatio: videoAspectRatio,
                backgroundColor: '#000',
                borderRadius: 0,
                overflow: 'hidden'
              }}
            >
              {(element.content || element.videoFile) ? (
                element.videoFile ? (
                  <CenteredVideoPlayer
                    src={element.videoFile}
                    poster={element.thumbnailUrl || undefined}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '100%',
                      margin: 0,
                      padding: 0
                    }}
                    videoProps={{ title: 'Uploaded Video' }}
                  />
                ) : (element.content.includes('youtube.com') || element.content.includes('youtu.be') || element.content.includes('vimeo.com')) ? (
                  <iframe
                    src={element.content}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen
                    title="Video Preview"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      border: 'none',
                      borderRadius: 0,
                      margin: 0,
                      padding: 0
                    }}
                  />
                ) : (
                  <Box sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#000',
                    color: 'white'
                  }}>
                    <Typography variant="body2">No video uploaded</Typography>
                  </Box>
                )
              ) : (
                <Box sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1
                }}>
                  <Typography variant="h4" color="primary">🎥</Typography>
                  <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold' }}>
                    No video uploaded
                  </Typography>
                </Box>
              )}

              {/* Centered button at the bottom */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: '32px',
                  left: '32px',
                  width: '55%',
                  zIndex: 20
                }}
              >
                <button
                  style={{
                    ...(element.styles || {}),
                    width: '100%',
                    height: '44px',
                    minHeight: '44px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    textAlign: 'center',
                    border: element.styles?.border || 'none'
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setSelectedElement(element);
                    setSelectedElementContext({ isInZone, layoutId, zoneId });
                    setTabValue(0);
                    setRightPanelOpen(true);
                  }}
                >
                  {element.content || 'Click Here'}
                </button>
              </Box>
            </Box>
          </Box>
        );
      }

      case ELEMENT_TYPES.HTML:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 1,
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            {isEditingField('content') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                multiline
                rows={4}
                placeholder="Enter HTML code"
                sx={{ mb: 1 }}
              />
            ) : (
              <Box
                sx={{
                  backgroundColor: '#f5f5f5',
                  p: 1,
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#e0e0e0' }
                }}
                onDoubleClick={() => handleDoubleClick('content', element.content)}
                title="Double-click to edit HTML • Hover for delete option"
              >
                <Typography variant="body2" color="text.secondary">
                  💻 HTML Code {element.content ? `(${element.content.length} chars)` : '- Click to edit'}
                </Typography>
              </Box>
            )}
          </Box>
        );

      case ELEMENT_TYPES.DIVIDER:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0.5,
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            <Box
              sx={{
                height: '1px',
                backgroundColor: '#e0e0e0',
                margin: '4px 0',
                cursor: 'pointer',
                '&:hover': { backgroundColor: '#1976d2' }
              }}
              title="Divider line • Hover for delete option"
            />
          </Box>
        );

      case ELEMENT_TYPES.CHECKLIST:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0,
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            <Checklist title={element.title} items={element.items} />
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_WITH_NOTICE:
        const getVariantStyles = (variant, styleVariant = 'default') => {
          const styleVariants = {
            'urgent-sale': {
              'default': {
                backgroundColor: '#ff69b4', // pink
                noticeColor: '#101022', // black text on pink
                buttonBg: '#101022', // black button
                buttonColor: '#ffffff', // white text on black
                border: 'none',
                borderRadius: '8px'
              },
              'modern': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white (changed from orange/yellow)
                buttonBg: '#ff69b4', // pink button
                buttonColor: '#101022', // black text on pink
                border: '2px solid #ff69b4',
                borderRadius: '12px'
              },
              'minimal': {
                backgroundColor: '#fafafa', // light gray (close to white)
                noticeColor: '#101022', // black text (changed from orange/yellow)
                buttonBg: '#ff69b4', // pink button
                buttonColor: '#101022', // black text on pink
                border: '1px solid #e0e0e0',
                borderRadius: '4px'
              },
              'gradient': {
                backgroundColor: 'linear-gradient(135deg, #ff69b4, #ff1493)', // pink gradient
                noticeColor: '#ffffff', // white text on pink gradient
                buttonBg: '#ffffff', // white button
                buttonColor: '#101022', // black text on white
                border: 'none',
                borderRadius: '16px'
              }
            },
            'membership-quiz': {
              'default': {
                backgroundColor: '#0000ff', // blue
                noticeColor: '#ffffff', // white text on blue
                buttonBg: '#ffffff', // white button
                buttonColor: '#0000ff', // blue text on white
                border: 'none',
                borderRadius: '8px'
              },
              'elegant': {
                backgroundColor: '#000080', // dark blue
                noticeColor: '#ffffff', // white text on dark blue
                buttonBg: '#ffffff', // white button
                buttonColor: '#000080', // dark blue text on white
                border: '2px solid #4169e1',
                borderRadius: '12px'
              },
              'soft': {
                backgroundColor: '#e6f3ff', // light blue
                noticeColor: '#0000ff', // blue text on light blue
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #b3d9ff',
                borderRadius: '8px'
              },
              'corporate': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '2px solid #e0e0e0',
                borderRadius: '6px'
              }
            },
            'media-buzz': {
              'default': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white
                buttonBg: '#ffff00', // yellow button
                buttonColor: '#101022', // black text on yellow
                border: '2px dashed #101022',
                borderRadius: '8px'
              },
              'news': {
                backgroundColor: '#f8f9fa', // light gray (close to white)
                noticeColor: '#101022', // black text
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #e0e0e0',
                borderRadius: '8px'
              },
              'viral': {
                backgroundColor: '#ffff00', // yellow
                noticeColor: '#101022', // black text on yellow
                buttonBg: '#101022', // black button
                buttonColor: '#ffffff', // white text on black
                border: '2px solid #ffd700',
                borderRadius: '12px'
              },
              'trending': {
                backgroundColor: '#e6f3ff', // light blue
                noticeColor: '#0000ff', // blue text on light blue
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #b3d9ff',
                borderRadius: '10px'
              }
            }
          };

          return styleVariants[variant]?.[styleVariant] || styleVariants[variant]?.['default'] || {
            backgroundColor: '#ff69b4',
            noticeColor: '#101022',
            buttonBg: '#101022',
            buttonColor: '#ffffff',
            border: 'none',
            borderRadius: '8px'
          };
        };

        const variantStyles = getVariantStyles(element.variant, element.styleVariant);

        // Debug: Log the fontWeight being applied
        console.log('🎨 Notice fontWeight:', element.subElementStyles?.notice?.fontWeight || 'bold');

        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 2,
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            <Box
              sx={{
                background: variantStyles.backgroundColor.includes('gradient')
                  ? variantStyles.backgroundColor
                  : variantStyles.backgroundColor,
                padding: '20px',
                borderRadius: variantStyles.borderRadius,
                textAlign: 'center',
                border: variantStyles.border,
                boxShadow: element.styleVariant === 'gradient' ? '0 8px 32px rgba(255, 107, 107, 0.3)' : '0 2px 8px rgba(0,0,0,0.1)'
              }}
            >
              {/* Notice Text */}
              {isEditingField('content.notice') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  multiline
                  rows={3}
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    // Apply custom sub-element styles if available, otherwise use variant styles
                    color: element.subElementStyles?.notice?.color || variantStyles.noticeColor,
                    backgroundColor: element.subElementStyles?.notice?.backgroundColor || 'transparent',
                    fontSize: element.subElementStyles?.notice?.fontSize || 'inherit',
                    fontFamily: element.subElementStyles?.notice?.fontFamily || 'inherit',
                    fontWeight: element.subElementStyles?.notice?.fontWeight || 'bold',
                    textAlign: element.subElementStyles?.notice?.textAlign || 'inherit',
                    border: element.subElementStyles?.notice?.border || 'none',
                    borderRadius: element.subElementStyles?.notice?.borderRadius || '0px',
                    padding: element.subElementStyles?.notice?.padding || '8px',
                    margin: element.subElementStyles?.notice?.margin || '0px',
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                    // Selection styling - use boxShadow for visual feedback, don't override custom border
                    ...(selectedSubElement === 'notice' && {
                      boxShadow: '0 0 0 2px #4caf50, 0 0 0 4px rgba(76, 175, 80, 0.2)'
                    })
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log('🟢 Notice text clicked - selecting sub-element: notice');
                    setSelectedElement(element);
                    setSelectedElementContext({ isInZone, layoutId, zoneId });
                    setSelectedSubElement('notice');
                    setTabValue(1); // Set to Style tab
                    setRightPanelOpen(true);
                  }}
                  onDoubleClick={() => handleDoubleClick('content.notice', element.content?.notice)}
                  title="Click to select for styling • Double-click to edit notice text"
                >
                  {element.content?.notice?.split('\n').map((line, index) => (
                    <span key={index}>
                      {line.includes('70%') ? (
                        <span style={{
                          color: element.subElementStyles?.notice?.color || variantStyles.noticeColor,
                          fontWeight: element.subElementStyles?.notice?.fontWeight || 'bold'
                        }}>{line}</span>
                      ) : line.includes('exclusive link below') ? (
                        <span>
                          {line.replace('exclusive link below', '')}
                          <span style={{ color: '#1976d2', textDecoration: 'underline' }}>exclusive link below</span>
                        </span>
                      ) : (
                        line
                      )}
                      {index < element.content?.notice?.split('\n').length - 1 && <br />}
                    </span>
                  ))}
                </Typography>
              )}

              {/* Call to Action Text */}
              {isEditingField('content.callToAction') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    // Apply custom sub-element styles if available, otherwise use variant styles
                    color: element.subElementStyles?.callToAction?.color || variantStyles.noticeColor,
                    backgroundColor: element.subElementStyles?.callToAction?.backgroundColor || 'transparent',
                    fontSize: element.subElementStyles?.callToAction?.fontSize || 'inherit',
                    fontFamily: element.subElementStyles?.callToAction?.fontFamily || 'inherit',
                    fontWeight: element.subElementStyles?.callToAction?.fontWeight || 'normal',
                    textAlign: element.subElementStyles?.callToAction?.textAlign || 'inherit',
                    border: element.subElementStyles?.callToAction?.border || 'none',
                    borderRadius: element.subElementStyles?.callToAction?.borderRadius || '0px',
                    padding: element.subElementStyles?.callToAction?.padding || '8px',
                    margin: element.subElementStyles?.callToAction?.margin || '0px',
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                    // Selection styling - use boxShadow for visual feedback, don't override custom border
                    ...(selectedSubElement === 'callToAction' && {
                      boxShadow: '0 0 0 2px #4caf50, 0 0 0 4px rgba(76, 175, 80, 0.2)'
                    })
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log('🟡 Call-to-action text clicked - selecting sub-element: callToAction');
                    setSelectedElement(element);
                    setSelectedElementContext({ isInZone, layoutId, zoneId });
                    setSelectedSubElement('callToAction');
                    setTabValue(1); // Set to Style tab
                    setRightPanelOpen(true);
                  }}
                  onDoubleClick={() => handleDoubleClick('content.callToAction', element.content?.callToAction)}
                  title="Click to select for styling • Double-click to edit call to action text"
                >
                  {element.content?.callToAction}
                </Typography>
              )}

              {/* Button */}
              {isEditingField('content.buttonText') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 1 }}
                />
              ) : (
                <ResizableButton
                  element={element}
                  updateElement={updateElement}
                  isInZone={isInZone}
                  layoutId={layoutId}
                  zoneId={zoneId}
                  isEditing={isEditingField('content.buttonText')}
                  disableResize={true}
                >
                  <button
                    style={{
                      // Apply custom sub-element styles if available, otherwise use variant styles
                      backgroundColor: element.subElementStyles?.button?.backgroundColor || variantStyles.buttonBg,
                      color: element.subElementStyles?.button?.color || variantStyles.buttonColor,
                      fontSize: element.subElementStyles?.button?.fontSize || '18px',
                      fontFamily: element.subElementStyles?.button?.fontFamily || 'inherit',
                      fontWeight: element.subElementStyles?.button?.fontWeight || 'bold',
                      textAlign: element.subElementStyles?.button?.textAlign || 'center',
                      border: element.subElementStyles?.button?.border || 'none',
                      borderRadius: element.subElementStyles?.button?.borderRadius || '8px',
                      padding: element.subElementStyles?.button?.padding || '16px 32px',
                      margin: element.subElementStyles?.button?.margin || '0px',
                      cursor: 'pointer',
                      width: '100%',
                      height: '100%',
                      maxWidth: '400px',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      // Selection styling - use boxShadow for visual feedback, don't override custom border
                      boxShadow: selectedSubElement === 'button' ? '0 0 0 2px #4caf50, 0 0 0 4px rgba(76, 175, 80, 0.2), 0 2px 4px rgba(0,0,0,0.1)' : '0 2px 4px rgba(0,0,0,0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log('🔵 Button clicked - selecting sub-element: button');
                      setSelectedElement(element);
                      setSelectedElementContext({ isInZone, layoutId, zoneId });
                      setSelectedSubElement('button');
                      setTabValue(1); // Set to Style tab
                      setRightPanelOpen(true); // Ensure right panel is open
                    }}
                    onDoubleClick={() => handleDoubleClick('content.buttonText', element.content?.buttonText)}
                    title="Click to select for styling • Double-click to edit button text • Drag handles to resize"
                  >
                    {element.content?.buttonText}
                  </button>
                </ResizableButton>
              )}


            </Box>
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_IMAGE_CALLOUT:
        const getImageCalloutVariantStyles = (variant) => {
          const v = element.variants?.[variant] || {};
          return {
            background: v.background || '#fff',
            textColor: v.textColor || '#222',
            border: v.border || 'none',
            buttonColor: v.buttonColor || '#1976d2',
            badgeColor: v.badgeColor || '#ffcc00',
            badge2Color: v.badge2Color || '#ffcc00',
          };
        };
        const imageCalloutStyles = getImageCalloutVariantStyles(element.variant);
        return (
          <Box
            data-element-id={element.id}
            sx={{
              background: imageCalloutStyles.background,
              color: imageCalloutStyles.textColor,
              border: imageCalloutStyles.border,
              borderRadius: '16px',
              mb: 2,
              textAlign: 'center',
              p: { xs: 2, md: 4 },
              boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            {/* Headline */}
            {isEditingField('content.headline') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 2 }}
              />
            ) : (
              <Typography
                variant="h6"
                sx={{
                  color: imageCalloutStyles.textColor,
                  fontWeight: 'bold',
                  mb: 2,
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                  p: 1,
                  borderRadius: 1
                }}
                onDoubleClick={() => handleDoubleClick('content.headline', element.content?.headline)}
                title="Double-click to edit headline"
              >
                {element.content?.headline}
              </Typography>
            )}

            {/* Image and Badges */}
            <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
              {isEditingField('content.image') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                  label="Image URL"
                />
              ) : (
                <img
                  src={element.content?.image}
                  alt="callout"
                  style={{
                    maxWidth: '260px',
                    width: '100%',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                    background: '#fff',
                    cursor: 'pointer',
                    marginBottom: 0
                  }}
                  onDoubleClick={() => handleDoubleClick('content.image', element.content?.image)}
                  title="Double-click to edit image URL"
                />
              )}
              {/* Badge 1 */}
              {element.content?.badge && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    background: element.content?.badgeColor || imageCalloutStyles.badgeColor,
                    color: '#222',
                    fontWeight: 'bold',
                    borderRadius: '50%',
                    px: 2,
                    py: 1,
                    fontSize: '1rem',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                  }}
                >
                  {element.content?.badge}
                </Box>
              )}
              {/* Badge 2 (for wellamoon) */}
              {element.content?.badge2 && (
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    right: 8,
                    background: element.content?.badge2Color || imageCalloutStyles.badge2Color,
                    color: '#222',
                    fontWeight: 'bold',
                    borderRadius: '16px',
                    px: 2,
                    py: 1,
                    fontSize: '0.95rem',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                  }}
                >
                  {element.content?.badge2}
                </Box>
              )}
            </Box>

            {/* Subheadline/Description */}
            {element.content?.subheadline && (
              isEditingField('content.subheadline') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: imageCalloutStyles.textColor,
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                    p: 1,
                    borderRadius: 1
                  }}
                  onDoubleClick={() => handleDoubleClick('content.subheadline', element.content?.subheadline)}
                  title="Double-click to edit subheadline"
                >
                  {element.content?.subheadline?.split('\n').map((line, idx) => (
                    <span key={idx}>{line}<br /></span>
                  ))}
                </Typography>
              )
            )}

            {/* Button */}
            {isEditingField('content.buttonText') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 1 }}
              />
            ) : (
              <button
                style={{
                  backgroundColor: element.content?.buttonColor || imageCalloutStyles.buttonColor,
                  color: '#fff',
                  padding: '18px 0',
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  width: '100%',
                  margin: '16px 0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  console.log('Image callout button clicked - selecting element:', element.id);
                  setSelectedElement(element);
                  setSelectedElementContext({ isInZone, layoutId, zoneId });
                  setTabValue(1); // Set to Style tab
                  setRightPanelOpen(true); // Ensure right panel is open
                }}
                onDoubleClick={() => handleDoubleClick('content.buttonText', element.content?.buttonText)}
                title="Click to select and edit styles • Double-click to edit text"
              >
                {element.content?.buttonText}
              </button>
            )}
            {/* Button URL editing */}
            {isEditingField('content.buttonUrl') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 1 }}
                label="Button URL"
              />
            ) : (
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  cursor: 'pointer',
                  color: '#888',
                  mb: 1
                }}
                onDoubleClick={() => handleDoubleClick('content.buttonUrl', element.content?.buttonUrl)}
                title="Double-click to edit button URL"
              >
                {element.content?.buttonUrl ? `URL: ${element.content?.buttonUrl}` : 'Double-click to set button URL'}
              </Typography>
            )}

            {/* Subheadline Icon (e.g., lock) */}
            {element.content?.subheadlineIcon === 'lock' && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
                <LockIcon fontSize="small" sx={{ color: '#888', mr: 0.5 }} />
                <Typography variant="caption" color="#888">
                  {element.content?.subheadline}
                </Typography>
              </Box>
            )}

            {/* Variant Selector */}
            <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
              {['alpha-brain-dark', 'proactiv-light', 'alpha-brain-horizontal', 'wellamoon-bordered'].map((variant) => (
                <Button
                  key={variant}
                  size="small"
                  variant={selectedVariantKey === variant ? 'contained' : 'outlined'}
                  onClick={() => {
                    const variantContent = element.variants?.[variant] || element.content;
                    const updatedElement = {
                      ...element,
                      variant,
                      content: variantContent
                    };
                    updateElement(element.id, updatedElement);
                    setSelectedVariantKey(variant);
                  }}
                  sx={{ fontSize: '0.75rem' }}
                >
                  {variant.replace(/-/g, ' ')}
                </Button>
              ))}
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_TEXT_VARIANT:
        const getTextVariantStyles = (variant) => {
          switch (variant) {
            case 'red-shadow':
              return {
                buttonText: 'Push Me',
                buttonUrl: '#',
                buttonColor: '#f5003c',
                textColor: '#fff',
                fontWeight: 'bold',
                fontSize: '2rem',
                borderRadius: '20px',
                boxShadow: '0 6px 0 #a8002a',
                icon: '',
                iconPosition: 'none',
                padding: '24px 0',
                width: '260px',
                margin: '0 auto'
              };
            case 'orange-rounded':
              return {
                buttonText: 'Add To Cart',
                buttonUrl: '#',
                buttonColor: '#f53c00',
                textColor: '#fff',
                fontWeight: 'normal',
                fontSize: '2rem',
                borderRadius: '32px',
                boxShadow: 'none',
                icon: '',
                iconPosition: 'none',
                padding: '24px 0',
                width: '100%',
                margin: '0 auto'
              };
            case 'yellow-gradient':
              return {
                buttonText: 'Claim Your Supply Now',
                buttonUrl: '#',
                buttonColor: 'linear-gradient(180deg, #ffe066 0%, #ffb347 100%)',
                textColor: '#222',
                fontWeight: 'bold',
                fontSize: '2rem',
                borderRadius: '16px',
                boxShadow: 'none',
                icon: 'cart',
                iconPosition: 'left',
                iconColor: '#d4a000',
                padding: '20px 0',
                width: '100%',
                margin: '0 auto'
              };
            default:
              return {
                buttonText: 'Push Me',
                buttonUrl: '#',
                buttonColor: '#f5003c',
                textColor: '#fff',
                fontWeight: 'bold',
                fontSize: '2rem',
                borderRadius: '20px',
                boxShadow: '0 6px 0 #a8002a',
                icon: '',
                iconPosition: 'none',
                padding: '24px 0',
                width: '260px',
                margin: '0 auto'
              };
          }
        };

        const buttonTextVariantStyles = getTextVariantStyles(element.variant);

        return (
          <Box
            data-element-id={element.id}
            sx={{
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 2,
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            <Box
              sx={{
                backgroundColor: buttonTextVariantStyles.buttonColor,
                padding: '20px',
                borderRadius: '8px',
                textAlign: 'center',
                border: selectedVariantKey === 'media-buzz' ? '2px dashed #333' : 'none'
              }}
            >
              {/* Notice Text */}
              {isEditingField('content.notice') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  multiline
                  rows={3}
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: buttonTextVariantStyles.noticeColor,
                    fontWeight: 'bold',
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                    p: 1,
                    borderRadius: 1
                  }}
                  onDoubleClick={() => handleDoubleClick('content.notice', element.content?.notice)}
                  title="Double-click to edit notice text"
                >
                  {element.content?.notice?.split('\n').map((line, index) => (
                    <span key={index}>
                      {line.includes('70%') ? (
                        <span style={{ color: variantStyles.noticeColor, fontWeight: 'bold' }}>{line}</span>
                      ) : line.includes('exclusive link below') ? (
                        <span>
                          {line.replace('exclusive link below', '')}
                          <span style={{ color: '#1976d2', textDecoration: 'underline' }}>exclusive link below</span>
                        </span>
                      ) : (
                        line
                      )}
                      {index < element.content?.notice?.split('\n').length - 1 && <br />}
                    </span>
                  ))}
                </Typography>
              )}

              {/* Call to Action Text */}
              {isEditingField('content.callToAction') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: buttonTextVariantStyles.noticeColor,
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                    p: 1,
                    borderRadius: 1
                  }}
                  onDoubleClick={() => handleDoubleClick('content.callToAction', element.content?.callToAction)}
                  title="Double-click to edit call to action text"
                >
                  {element.content?.callToAction}
                </Typography>
              )}

              {/* Button */}
              {isEditingField('content.buttonText') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 1 }}
                />
              ) : (
                <button
                  style={{
                    backgroundColor: buttonTextVariantStyles.buttonColor,
                    color: buttonTextVariantStyles.textColor,
                    padding: '16px 32px',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    width: '100%',
                    maxWidth: '400px',
                    marginBottom: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log('Button text variant clicked - selecting element:', element.id);
                    setSelectedElement(element);
                    setSelectedElementContext({ isInZone, layoutId, zoneId });
                    setTabValue(1); // Set to Style tab
                    setRightPanelOpen(true); // Ensure right panel is open
                  }}
                  onDoubleClick={() => handleDoubleClick('content.buttonText', element.content?.buttonText)}
                  title="Click to select and edit styles • Double-click to edit text"
                >
                  {element.content?.buttonText}
                </button>
              )}

              {/* Variant Selector */}
              <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                {['red-shadow', 'orange-rounded', 'yellow-gradient'].map((variant) => (
                  <Button
                    key={variant}
                    size="small"
                    variant={selectedVariantKey === variant ? 'contained' : 'outlined'}
                    onClick={() => {
                      const variantContent = element.variants?.[variant] || element.content;
                      const updatedElement = {
                        ...element,
                        variant,
                        content: variantContent
                      };
                      updateElement(element.id, updatedElement);
                      setSelectedVariantKey(variant);
                    }}
                    sx={{ fontSize: '0.75rem' }}
                  >
                    {variant.replace('-', ' ')}
                  </Button>
                ))}
              </Box>
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_HEADLINE_PRODUCT_IMAGE:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              background: element.content?.background || '#ffffff',
              color: element.content?.textColor || '#333333',
              borderRadius: '16px',
              mb: 2,
              textAlign: 'center',
              p: { xs: 2, md: 4 },
              boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...getSelectionStyles(element.id)
            }}
          >
            <ElementControls />
            {/* Headline */}
            {isEditingField('content.headline') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 2 }}
              />
            ) : (
              <Typography
                variant="h6"
                sx={{
                  color: element.content?.textColor || '#333333',
                  fontWeight: 'bold',
                  mb: 2,
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                  p: 1,
                  borderRadius: 1
                }}
                onDoubleClick={() => handleDoubleClick('content.headline', element.content?.headline)}
                title="Double-click to edit headline"
              >
                {element.content?.headline}
              </Typography>
            )}

            {/* Product Image */}
            <Box sx={{ mb: 2 }}>
              {isEditingField('content.productImage') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 1 }}
                  label="Image URL"
                />
              ) : (
                <Box
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { opacity: 0.8 },
                    mb: 1
                  }}
                  onDoubleClick={() => handleDoubleClick('content.productImage', element.content?.productImage)}
                  title="Double-click to edit image URL"
                >
                  <img
                    src={element.content?.productImage || '/api/placeholder/400/300'}
                    alt="Product"
                    style={{
                      width: '100%',
                      maxWidth: '400px',
                      height: 'auto',
                      borderRadius: '8px',
                      border: '2px dashed #e0e0e0'
                    }}
                  />
                </Box>
              )}
            </Box>

            {/* Subheadline */}
            {element.content?.subheadline && (
              isEditingField('content.subheadline') ? (
                <TextField
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onKeyDown={handleKeyPress}
                  onBlur={saveInlineEdit}
                  autoFocus
                  multiline
                  rows={2}
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: element.content?.textColor || '#333333',
                    mb: 2,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
                    p: 1,
                    borderRadius: 1
                  }}
                  onDoubleClick={() => handleDoubleClick('content.subheadline', element.content?.subheadline)}
                  title="Double-click to edit subheadline"
                >
                  {element.content?.subheadline?.split('\n').map((line, idx) => (
                    <span key={idx}>{line}<br /></span>
                  ))}
                </Typography>
              )
            )}

            {/* Button */}
            {isEditingField('content.buttonText') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 1 }}
              />
            ) : (
              <button
                style={{
                  backgroundColor: element.content?.buttonColor || '#4caf50',
                  color: '#fff',
                  padding: '18px 0',
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  width: '100%',
                  margin: '16px 0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  console.log('Button headline product image clicked - selecting element:', element.id);
                  setSelectedElement(element);
                  setSelectedElementContext({ isInZone, layoutId, zoneId });
                  setTabValue(1); // Set to Style tab
                  setRightPanelOpen(true); // Ensure right panel is open
                }}
                onDoubleClick={() => handleDoubleClick('content.buttonText', element.content?.buttonText)}
                title="Click to select and edit styles • Double-click to edit text"
              >
                {element.content?.buttonText}
              </button>
            )}

            {/* Button URL editing */}
            {isEditingField('content.buttonUrl') ? (
              <TextField
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={saveInlineEdit}
                autoFocus
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 1 }}
                label="Button URL"
              />
            ) : (
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  cursor: 'pointer',
                  color: '#888',
                  mb: 1
                }}
                onDoubleClick={() => handleDoubleClick('content.buttonUrl', element.content?.buttonUrl)}
                title="Double-click to edit button URL"
              >
                {element.content?.buttonUrl ? `URL: ${element.content?.buttonUrl}` : 'Double-click to set button URL'}
              </Typography>
            )}
          </Box>
        );



      case ELEMENT_TYPES.CUSTOM_LIST:
        const iconOptions = ['check', 'red-x', 'pink-check', 'dark-check', 'green-badge', 'star-badge', 'star', 'info', 'warning'];

        // Debug padding
        console.log('🔍 CUSTOM_LIST rendering - element.styles:', element.styles);
        console.log('🔍 CUSTOM_LIST padding value:', element.styles?.padding);

        return (
          <Box
            sx={{ ...element.styles, mb: 0.5, position: 'relative', '&:hover .element-controls': { opacity: 1 }, ...getSelectionStyles(element.id) }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Custom List clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
              // Close icon selector when clicking elsewhere
              setIconSelectorOpen(null);
            }}
            title="Click to select and edit styles • Double-click to edit text"
          >
            <ElementControls />
            {element.rows.map((row, idx) => (
              isEditingField(`rows.${idx}.text`) ? (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  {getListIcon(row.icon, idx)}
                  <TextField
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onBlur={saveInlineEdit}
                    autoFocus
                    variant="outlined"
                    size="small"
                    sx={{
                      ml: 1,
                      flex: 1,
                      '& .MuiInputBase-input': {
                        color: (() => {
                          const presetColor = getPreset(element.textStylePreset || 'bullet1')?.color;
                          const elementColor = element.styles?.color;
                          const finalColor = presetColor || elementColor || '#000000';
                          console.log('🎨 Custom list text color debug:', {
                            textStylePreset: element.textStylePreset,
                            presetColor,
                            elementColor,
                            finalColor
                          });
                          return `${finalColor} !important`;
                        })()
                      }
                    }}
                  />
                </Box>
              ) : (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 0.5, fontFamily: element.styles?.fontFamily, fontSize: element.styles?.fontSize, color: element.styles?.color }}>
                  <Box
                    sx={{
                      mr: 1,
                      cursor: 'pointer',
                      position: 'relative',
                      '&:hover': { opacity: 0.7 }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const selectorKey = `${element.id}-${idx}`;
                      setIconSelectorOpen(iconSelectorOpen === selectorKey ? null : selectorKey);
                    }}
                    title="Click to change icon"
                  >
                    {getListIcon(row.icon, idx)}

                    {/* Icon Selector Popup */}
                    {iconSelectorOpen === `${element.id}-${idx}` && (
                      <Box
                        className="icon-selector-popup"
                        sx={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          zIndex: 1000,
                          backgroundColor: 'white',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          p: 1,
                          display: 'grid',
                          gridTemplateColumns: 'repeat(3, 1fr)',
                          gap: 1,
                          minWidth: '150px'
                        }}
                      >
                        {iconOptions.map((iconType) => (
                          <Box
                            key={iconType}
                            sx={{
                              p: 1,
                              cursor: 'pointer',
                              borderRadius: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              '&:hover': { backgroundColor: '#f5f5f5' },
                              border: row.icon === iconType ? '2px solid #1976d2' : '1px solid transparent'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              // Update the icon for this row
                              const updatedRows = [...element.rows];
                              updatedRows[idx] = { ...updatedRows[idx], icon: iconType };
                              updateElement(element.id, { rows: updatedRows }, isInZone, layoutId, zoneId);
                              setIconSelectorOpen(null);
                            }}
                            title={iconType}
                          >
                            {getListIcon(iconType, 0)}
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      cursor: 'pointer',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      border: '1px solid transparent',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        border: '1px solid rgba(25, 118, 210, 0.3)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      },
                      transition: 'all 0.2s ease',
                      position: 'relative'
                    }}
                    onDoubleClick={() => handleDoubleClick(`rows.${idx}.text`, row.text)}
                    title="Double-click to edit text"
                  >
                    <span style={{
                      ...getPreset(element.textStylePreset || 'paragraph1'),
                      fontFamily: getPreset(element.textStylePreset || 'paragraph1')?.fontFamily || element.styles?.fontFamily || 'inherit',
                      fontSize: getPreset(element.textStylePreset || 'paragraph1')?.fontSize || element.styles?.fontSize || 'inherit',
                      color: (() => {
                        const presetColor = getPreset(element.textStylePreset || 'paragraph1')?.color;
                        const elementColor = element.styles?.color;
                        const finalColor = elementColor || presetColor || 'inherit';
                        console.log('🎨 Custom list display text color:', {
                          textStylePreset: element.textStylePreset,
                          presetColor,
                          elementColor,
                          finalColor,
                          elementStyles: element.styles
                        });
                        return finalColor;
                      })(),
                      fontWeight: getPreset(element.textStylePreset || 'paragraph1')?.fontWeight || 'inherit',
                      lineHeight: getPreset(element.textStylePreset || 'paragraph1')?.lineHeight || 'inherit',
                      letterSpacing: getPreset(element.textStylePreset || 'paragraph1')?.letterSpacing || 'inherit',
                      textAlign: getPreset(element.textStylePreset || 'paragraph1')?.textAlign || 'inherit'
                    }}>
                      {row.text}
                    </span>

                  </Box>
                </Box>
              )
            ))}
          </Box>
        );

      case ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE:
        const iconOptions2 = ['check', 'red-x', 'pink-check', 'dark-check', 'green-badge', 'star-badge', 'star', 'info', 'warning'];

        return (
          <Box
            sx={{ ...element.styles, mb: 2, position: 'relative', '&:hover .element-controls': { opacity: 1 }, ...getSelectionStyles(element.id) }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Two-Line Custom List clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
              // Close icon selector when clicking elsewhere
              setIconSelectorOpen(null);
            }}
            title="Click to select and edit styles • Double-click to edit text"
          >
            <ElementControls />
            {element.rows.map((row, idx) => (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                <Box
                  sx={{
                    mr: 1,
                    cursor: 'pointer',
                    position: 'relative',
                    '&:hover': { opacity: 0.7 },
                    mt: 0.5 // Slight top margin to align with first line
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const selectorKey = `${element.id}-${idx}`;
                    setIconSelectorOpen(iconSelectorOpen === selectorKey ? null : selectorKey);
                  }}
                  title="Click to change icon"
                >
                  {getListIcon(row.icon, idx)}

                  {/* Icon Selector Popup */}
                  {iconSelectorOpen === `${element.id}-${idx}` && (
                    <Box
                      className="icon-selector-popup"
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        zIndex: 1000,
                        backgroundColor: 'white',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        p: 1,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: 1,
                        minWidth: '150px'
                      }}
                    >
                      {iconOptions2.map((iconType) => (
                        <Box
                          key={iconType}
                          sx={{
                            p: 1,
                            cursor: 'pointer',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            '&:hover': { backgroundColor: '#f5f5f5' },
                            border: row.icon === iconType ? '2px solid #1976d2' : '1px solid transparent'
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            // Update the icon for this row
                            const updatedRows = [...element.rows];
                            updatedRows[idx] = { ...updatedRows[idx], icon: iconType };
                            updateElement(element.id, { rows: updatedRows }, isInZone, layoutId, zoneId);
                            setIconSelectorOpen(null);
                          }}
                          title={iconType}
                        >
                          {getListIcon(iconType, 0)}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>

                {/* Two-line text content */}
                <Box sx={{ flex: 1 }}>
                  {/* First line (title) */}
                  {isEditingField(`rows.${idx}.text1`) ? (
                    <TextField
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      onKeyDown={handleKeyPress}
                      onBlur={saveInlineEdit}
                      autoFocus
                      variant="outlined"
                      size="small"
                      sx={{
                        mb: 0.5,
                        width: '100%',
                        '& .MuiInputBase-input': {
                          color: element.styles?.color || getPreset(element.textStylePreset1 || 'subheading1')?.color || 'inherit'
                        }
                      }}
                      placeholder="Title"
                    />
                  ) : (
                    <Box
                      sx={{
                        cursor: 'pointer',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid transparent',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          border: '1px solid rgba(25, 118, 210, 0.3)',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        },
                        transition: 'all 0.2s ease',
                        position: 'relative',
                        mb: 0.5
                      }}
                      onDoubleClick={() => handleDoubleClick(`rows.${idx}.text1`, row.text1)}
                      title="Double-click to edit title"
                    >
                      <span style={{
                        ...getPreset(element.textStylePreset1 || 'subheading1'),
                        fontFamily: getPreset(element.textStylePreset1 || 'subheading1')?.fontFamily || element.styles?.fontFamily || 'inherit',
                        fontSize: getPreset(element.textStylePreset1 || 'subheading1')?.fontSize || element.styles?.fontSize || 'inherit',
                        color: element.styles?.color || getPreset(element.textStylePreset1 || 'subheading1')?.color || 'inherit',
                        fontWeight: getPreset(element.textStylePreset1 || 'subheading1')?.fontWeight || 'inherit',
                        lineHeight: getPreset(element.textStylePreset1 || 'subheading1')?.lineHeight || 'inherit',
                        letterSpacing: getPreset(element.textStylePreset1 || 'subheading1')?.letterSpacing || 'inherit',
                        textAlign: getPreset(element.textStylePreset1 || 'subheading1')?.textAlign || 'inherit'
                      }}>
                        {row.text1}
                      </span>
                    </Box>
                  )}

                  {/* Second line (description) */}
                  {isEditingField(`rows.${idx}.text2`) ? (
                    <TextField
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      onKeyDown={handleKeyPress}
                      onBlur={saveInlineEdit}
                      autoFocus
                      variant="outlined"
                      size="small"
                      sx={{
                        width: '100%',
                        '& .MuiInputBase-input': {
                          color: element.styles?.color || getPreset(element.textStylePreset2 || 'paragraph1')?.color || 'inherit'
                        }
                      }}
                      placeholder="Description"
                    />
                  ) : (
                    <Box
                      sx={{
                        cursor: 'pointer',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid transparent',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          border: '1px solid rgba(25, 118, 210, 0.3)',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        },
                        transition: 'all 0.2s ease',
                        position: 'relative'
                      }}
                      onDoubleClick={() => handleDoubleClick(`rows.${idx}.text2`, row.text2)}
                      title="Double-click to edit description"
                    >
                      <span style={{
                        ...getPreset(element.textStylePreset2 || 'paragraph1'),
                        fontFamily: getPreset(element.textStylePreset2 || 'paragraph1')?.fontFamily || element.styles?.fontFamily || 'inherit',
                        fontSize: getPreset(element.textStylePreset2 || 'paragraph1')?.fontSize || element.styles?.fontSize || 'inherit',
                        color: element.styles?.color || getPreset(element.textStylePreset2 || 'paragraph1')?.color || 'inherit',
                        fontWeight: getPreset(element.textStylePreset2 || 'paragraph1')?.fontWeight || 'inherit',
                        lineHeight: getPreset(element.textStylePreset2 || 'paragraph1')?.lineHeight || 'inherit',
                        letterSpacing: getPreset(element.textStylePreset2 || 'paragraph1')?.letterSpacing || 'inherit',
                        textAlign: getPreset(element.textStylePreset2 || 'paragraph1')?.textAlign || 'inherit'
                      }}>
                        {row.text2}
                      </span>
                    </Box>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        );

      case ELEMENT_TYPES.TIMELINE_LIST:
        return (
          <Box
            sx={{
              ...element.styles,
              mb: 2,
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Timeline List clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
            title="Click to select and edit styles • Double-click to edit steps"
          >
            <ElementControls />
            {element.steps.map((step, idx) => (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                <Box sx={{ mr: 2, display: 'flex', alignItems: 'center', flexDirection: 'column', position: 'relative' }}>
                  <Box
                    sx={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: step.dotColor,
                      mb: 1,
                      zIndex: 2,
                      position: 'relative'
                    }}
                  />
                  {idx < element.steps.length - 1 && (
                    <Box
                      sx={{
                        width: '2px',
                        height: '60px',
                        backgroundColor: '#e0e0e0',
                        position: 'absolute',
                        top: '32px',
                        left: '11px',
                        zIndex: 1
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ flex: 1 }}>
                  {/* Stage Label */}
                  {isEditingField(`steps.${idx}.stageLabel`) ? (
                    <TextField
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      onKeyDown={handleKeyPress}
                      onBlur={saveInlineEdit}
                      autoFocus
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{ mb: 1 }}
                    />
                  ) : (
                    <Box
                      sx={{
                        mb: 1,
                        cursor: 'pointer',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid transparent',
                        position: 'relative',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          border: '1px solid rgba(25, 118, 210, 0.3)',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onDoubleClick={() => handleDoubleClick(`steps.${idx}.stageLabel`, step.stageLabel)}
                      title="Double-click to edit stage label"
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          color: step.stageLabelColor,
                          fontWeight: 'bold'
                        }}
                      >
                        {step.stageLabel}
                      </Typography>
                    </Box>
                  )}

                  {/* Title */}
                  {isEditingField(`steps.${idx}.title`) ? (
                    <TextField
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      onKeyDown={handleKeyPress}
                      onBlur={saveInlineEdit}
                      autoFocus
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{ mb: 1 }}
                    />
                  ) : (
                    <Box
                      sx={{
                        mb: 1,
                        cursor: 'pointer',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid transparent',
                        position: 'relative',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          border: '1px solid rgba(25, 118, 210, 0.3)',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onDoubleClick={() => handleDoubleClick(`steps.${idx}.title`, step.title)}
                      title="Double-click to edit title"
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 'bold'
                        }}
                      >
                        {step.title}
                      </Typography>
                    </Box>
                  )}

                  {/* Description */}
                  {isEditingField(`steps.${idx}.description`) ? (
                    <TextField
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      onKeyDown={handleKeyPress}
                      onBlur={saveInlineEdit}
                      autoFocus
                      variant="outlined"
                      size="small"
                      fullWidth
                      multiline
                      rows={2}
                    />
                  ) : (
                    <Box
                      sx={{
                        cursor: 'pointer',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid transparent',
                        position: 'relative',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          border: '1px solid rgba(25, 118, 210, 0.3)',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onDoubleClick={() => handleDoubleClick(`steps.${idx}.description`, step.description)}
                      title="Double-click to edit description"
                    >
                      <Typography
                        variant="body1"
                      >
                        {step.description}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        );

      case ELEMENT_TYPES.PROCESS_STEPS:
        return (
          <Box
            sx={{
              ...element.styles,
              mb: 2,
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Process Steps clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
            title="Click to select and edit styles • Double-click to edit steps"
          >
            <ElementControls />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {element.steps.map((step, idx) => (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 3 }}>
                  {/* Image with Numbered Badge */}
                  <Box sx={{ flexShrink: 0, width: '150px', position: 'relative' }}>
                    {isEditingField(`steps.${idx}.image`) ? (
                      <TextField
                        value={tempValue}
                        onChange={(e) => setTempValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        onBlur={saveInlineEdit}
                        autoFocus
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder="Enter image URL"
                      />
                    ) : (
                      <Box
                        sx={{
                          cursor: 'pointer',
                          position: 'relative',
                          '&:hover': {
                            '& .image-overlay': {
                              opacity: 1
                            }
                          }
                        }}
                        onDoubleClick={() => handleDoubleClick(`steps.${idx}.image`, step.image)}
                        title="Double-click to edit image URL"
                      >
                        <img
                          src={step.image}
                          alt={`Step ${step.number}`}
                          style={{
                            width: '100%',
                            height: '120px',
                            objectFit: 'cover',
                            borderRadius: '12px',
                            border: '1px solid #e0e0e0'
                          }}
                          onError={(e) => {
                            if (e.target.src !== `https://via.placeholder.com/150x120?text=Step+${step.number}`) {
                              e.target.src = `https://via.placeholder.com/150x120?text=Step+${step.number}`;
                            }
                          }}
                        />

                        {/* Numbered Badge - Top Right Corner */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: step.numberColor || '#1976d2',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            border: '3px solid white',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            zIndex: 1
                          }}
                        >
                          {step.number}
                        </Box>

                        <Box
                          className="image-overlay"
                          sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '12px',
                            opacity: 0,
                            transition: 'opacity 0.2s ease',
                            fontSize: '20px'
                          }}
                        >
                        </Box>
                      </Box>
                    )}
                  </Box>

                  {/* Content Area */}
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1, pt: 1 }}>
                    {/* Title */}
                    {isEditingField(`steps.${idx}.title`) ? (
                      <TextField
                        value={tempValue}
                        onChange={(e) => setTempValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        onBlur={saveInlineEdit}
                        autoFocus
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    ) : (
                      <Box
                        sx={{
                          cursor: 'pointer',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          border: '1px solid transparent',
                          position: 'relative',
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            border: '1px solid rgba(25, 118, 210, 0.3)',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                          },
                          transition: 'all 0.2s ease',
                        }}
                        onDoubleClick={() => handleDoubleClick(`steps.${idx}.title`, step.title)}
                        title="Double-click to edit title"
                      >
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'inherit' }}>
                          {step.title}
                        </Typography>
                      </Box>
                    )}

                    {/* Description */}
                    {isEditingField(`steps.${idx}.description`) ? (
                      <TextField
                        value={tempValue}
                        onChange={(e) => setTempValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        onBlur={saveInlineEdit}
                        autoFocus
                        variant="outlined"
                        size="small"
                        fullWidth
                        multiline
                        rows={2}
                      />
                    ) : (
                      <Box
                        sx={{
                          cursor: 'pointer',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          border: '1px solid transparent',
                          position: 'relative',
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            border: '1px solid rgba(25, 118, 210, 0.3)',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                          },
                          transition: 'all 0.2s ease',
                        }}
                        onDoubleClick={() => handleDoubleClick(`steps.${idx}.description`, step.description)}
                        title="Double-click to edit description"
                      >
                        <Typography variant="body1" sx={{ color: 'inherit' }}>
                          {step.description}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE:
        return (
          <Box
            sx={{
              ...element.styles,
              mb: 2,
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Text with Right Image clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
            title="Click to select and edit styles • Double-click to edit content"
          >
            <ElementControls />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              {/* Text Content */}
              <Box sx={{ flex: 1 }}>
                {isEditingField('content.text') ? (
                  <TextField
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onBlur={saveInlineEdit}
                    autoFocus
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                ) : (
                  <Box
                    sx={{
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid transparent',
                      position: 'relative',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        border: '1px solid rgba(25, 118, 210, 0.3)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      },
                      transition: 'all 0.2s ease',
                    }}
                    onDoubleClick={() => handleDoubleClick('content.text', element.content.text)}
                    title="Double-click to edit text"
                  >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'inherit' }}>
                      {element.content.text}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Image */}
              <Box sx={{ flexShrink: 0, width: '180px' }}>
                {isEditingField('content.image') ? (
                  <TextField
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onBlur={saveInlineEdit}
                    autoFocus
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Enter image URL"
                  />
                ) : (
                  <Box
                    sx={{
                      cursor: 'pointer',
                      position: 'relative',
                      '&:hover': {
                        '& .image-overlay': {
                          opacity: 1
                        }
                      }
                    }}
                    onDoubleClick={() => handleDoubleClick('content.image', element.content.image)}
                    title="Double-click to edit image URL"
                  >
                    <img
                      src={element.content.image}
                      alt="Right side image"
                      style={{
                        width: '100%',
                        height: '120px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                      }}
                      onError={(e) => {
                        if (e.target.src !== 'https://via.placeholder.com/180x120?text=Image') {
                          e.target.src = 'https://via.placeholder.com/180x120?text=Image';
                        }
                      }}
                    />


                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.LEFT_IMAGE_TEXT:
        const currentAlignment = element.imageAlignment === 'top' ? 'flex-start' :
          element.imageAlignment === 'bottom' ? 'flex-end' : 'center';

        return (
          <Box
            sx={{
              ...element.styles,
              mb: 2,
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Left Image + Text clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
            title="Click to select and edit styles • Double-click to edit content"
          >
            <ElementControls />
            <Box sx={{
              ...element.styles,
              // Override with specific alignment - this must come after element.styles
              display: 'flex',
              alignItems: currentAlignment,
              gap: `${element.spacing || 20}px`
            }}>
              {/* Circular Image */}
              <Box sx={{
                flexShrink: 0,
                width: `${element.imageSize || 120}px`,
                height: `${element.imageSize || 120}px`
              }}>
                {isEditingField('content.image') ? (
                  <TextField
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onBlur={saveInlineEdit}
                    autoFocus
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Enter image URL"
                    sx={{
                      width: `${element.imageSize || 120}px`,
                      '& .MuiOutlinedInput-root': {
                        height: '40px'
                      }
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      cursor: 'pointer',
                      position: 'relative',
                      width: `${element.imageSize || 120}px`,
                      height: `${element.imageSize || 120}px`,
                      '&:hover': {
                        '& .image-overlay': {
                          opacity: 1
                        }
                      }
                    }}
                    onDoubleClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDoubleClick('content.image', element.content.image);
                    }}
                    title="Double-click to edit image URL"
                  >
                    <img
                      src={element.content.image}
                      alt="Profile image"
                      style={{
                        width: `${element.imageSize || 120}px`,
                        height: `${element.imageSize || 120}px`,
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '3px solid #e0e0e0',
                        display: 'block'
                      }}
                      onError={(e) => {
                        if (e.target.src !== 'https://via.placeholder.com/150x150?text=Profile') {
                          e.target.src = 'https://via.placeholder.com/150x150?text=Profile';
                        }
                      }}
                      onLoad={(e) => {
                        // Prevent ResizeObserver errors on image load
                        e.target.style.opacity = '1';
                      }}
                    />


                  </Box>
                )}
              </Box>

              {/* Text Content */}
              <Box sx={{ flex: 1, minHeight: '56px' }}>
                {isEditingField('content.text') ? (
                  <TextField
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onKeyDown={handleKeyPress}
                    onBlur={saveInlineEdit}
                    autoFocus
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    rows={3}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        minHeight: '56px'
                      }
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid transparent',
                      position: 'relative',
                      minHeight: '56px',
                      display: 'flex',
                      alignItems: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        border: '1px solid rgba(25, 118, 210, 0.3)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      },
                      transition: 'all 0.2s ease',
                    }}
                    onDoubleClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDoubleClick('content.text', element.content.text);
                    }}
                    title="Double-click to edit text"
                  >
                    <Typography variant="body1" sx={{
                      color: element.textStyles?.color || 'inherit',
                      lineHeight: element.textStyles?.lineHeight || 1.6,
                      flex: 1,
                      fontSize: element.textStyles?.fontSize || '16px',
                      fontWeight: element.textStyles?.fontWeight || 'normal',
                      fontFamily: element.textStyles?.fontFamily || 'inherit',
                      textAlign: element.textStyles?.textAlign || 'left',
                      backgroundColor: element.textStyles?.backgroundColor || 'transparent',
                      padding: element.textStyles?.padding || '0px',
                      borderRadius: element.textStyles?.borderRadius || '0px'
                    }}>
                      {element.content.text}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.LAYOUT:
        const config = LAYOUT_CONFIGS[element.layoutType];

        // Special handling for INLINE_ROW layout
        if (element.layoutType === LAYOUT_TYPES.INLINE_ROW) {
          return (
            <Box
              data-element-id={element.id}
              sx={{
                position: 'relative',
                '&:hover .element-controls': { opacity: 1 },
                ...getSelectionStyles(element.id)
              }}
            >
              <ElementControls />
              <InlineRowLayout
                element={element}
                updateElement={updateElement}
                renderInlineEditableElement={renderInlineEditableElement}
                isInZone={isInZone}
                layoutId={layoutId}
                zoneId={zoneId}
                handleDragOver={handleDragOver}
                handleDragLeave={handleDragLeave}
                handleDrop={handleDrop}
                isBrandsPage={isBrandsPage}
              />
            </Box>
          );
        }

        return (
          <Box
            data-element-id={element.id}
            sx={{
              backgroundColor: element.styles?.backgroundColor || 'transparent',
              border: element.styles?.border || '1px dashed #ccc',
              borderRadius: element.styles?.borderRadius || 1,
              margin: element.styles?.margin || '0 0 8px 0',
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              ...element.styles,
              p: 0, // Force zero padding - override any saved padding
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              console.log('🔴 Layout clicked - selecting element:', element.id);
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(1); // Set to Style tab
              setRightPanelOpen(true); // Ensure right panel is open
            }}
            title="Click to select layout"
          >
            <ElementControls />
            <Typography variant="body2" color="text.secondary" gutterBottom>
              📐 Layout: {config?.name}
            </Typography>
            <Box sx={{
              display: 'flex',
              gap: 0,
              flexWrap: element.layoutType === LAYOUT_TYPES.THREE_COLUMN ? 'wrap' : 'nowrap'
            }}>
              {element.zones.map((zone, zoneIndex) => (
                <Box
                  key={zone.id}
                  data-zone-id={zone.id}
                  sx={{
                    width: zone.width,
                    border: '1px dashed #ccc', // Default border
                    borderRadius: 1,
                    p: 0,
                    backgroundColor: pageSettings.backgroundColor,
                    textAlign: zone.textAlign || 'left',
                    position: 'relative',
                    overflow: 'visible', // Let content fit height without scrolling
                    ...getZoneHeightStyle(zone.id, zone.height || '60px') // Apply after so it can override border
                  }}
                  onDragOver={(e) => {
                    console.log('🎯 Zone onDragOver triggered', { layoutId: element.id, zoneId: zone.id });
                    handleDragOver(e, { layoutId: element.id, zoneId: zone.id });
                  }}
                  onDragLeave={(e) => {
                    console.log('🎯 Zone onDragLeave triggered');
                    handleDragLeave();
                  }}
                  onDrop={(e) => {
                    console.log('🎯 Zone onDrop triggered', { elementId: element.id, zoneId: zone.id });
                    handleDrop(e, element.id, zone.id);
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Zone {zoneIndex + 1} ({zone.elements.length} items){getHeightModeText(zone.id)}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleZoneHeight(zone.id);
                      }}
                      title={getHeightTooltip(zone.id)}
                      sx={{
                        fontSize: '12px',
                        minWidth: '20px',
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)',
                        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.2)' }
                      }}
                    >
                      {getExpandIcon(zone.id)}
                    </IconButton>
                  </Box>

                  {zone.elements.length === 0 && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                      Drop elements here
                    </Typography>
                  )}
                  {zone.elements.map((zoneElement, elemIndex) => (
                    <div key={zoneElement.id}>
                      {renderInlineEditableElement(zoneElement, true, element.id, zone.id, elemIndex)}
                    </div>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.MEDIA:
        return (
          <Box
            data-element-id={element.id}
            sx={{
              textAlign: 'center',
              position: 'relative',
              '&:hover .element-controls': { opacity: 1 },
              mb: 0,
              ...getSelectionStyles(element.id)
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedElement(element);
              setSelectedElementContext({ isInZone, layoutId, zoneId });
              setTabValue(0); // Show Content tab for MEDIA
              setRightPanelOpen(true);
            }}
          >
            <ElementControls />
            {element.mediaUrl ? (
              // Show uploaded media
              element.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) ? (
                <Box sx={{
                  textAlign: 'center',
                  mb: 0,
                  position: 'relative',
                  width: '100%',
                  aspectRatio: element.styles?.aspectRatio || 'auto',
                  overflow: 'hidden',
                  borderRadius: '8px'
                }}>
                  <video
                    src={element.mediaUrl}
                    controls
                    poster={element.thumbnailUrl || undefined}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{
                  textAlign: 'center',
                  mb: 0,
                  position: 'relative'
                }}>
                  <img
                    src={element.mediaUrl}
                    alt="Uploaded media"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      borderRadius: '8px',
                      display: 'block',
                      margin: '0 auto'
                    }}
                  />
                </Box>
              )
            ) : (
              // Show placeholder
              <Box sx={{
                textAlign: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 1,
                mb: 0,
                p: 3,
                border: '2px dashed #ccc',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#e8e8e8',
                  borderColor: '#1976d2'
                }
              }}>
                <Typography variant="body2" color="text.secondary">
                  📁 No media uploaded. Click to upload image or video.
                </Typography>
              </Box>
            )}
          </Box>
        );

      default:
        return null;
    }
  };

  const generateElementHTML = (element) => {
    const styles = element.styles || {};

    // Create enhanced styles that match the preview rendering
    const enhancedStyles = { ...styles };

    // Apply mobile-optimized styling to match preview
    switch (element.type) {
      case ELEMENT_TYPES.HEADING:
        // Preserve original heading styles
        enhancedStyles.marginBottom = enhancedStyles.margin || '16px';
        // Don't override fontSize - preserve original
        enhancedStyles.fontFamily = enhancedStyles.fontFamily || 'inherit';
        enhancedStyles.fontWeight = enhancedStyles.fontWeight || 'inherit';
        enhancedStyles.textAlign = enhancedStyles.textAlign || 'inherit';
        enhancedStyles.color = enhancedStyles.color || 'inherit';

        if (styles.backgroundColor && styles.backgroundColor !== 'transparent') {
          enhancedStyles.padding = enhancedStyles.padding || '8px 12px';
          enhancedStyles.borderRadius = enhancedStyles.borderRadius || '4px';
          enhancedStyles.display = 'inline-block';
        } else {
          enhancedStyles.padding = enhancedStyles.padding || '0';
          enhancedStyles.display = 'block';
        }
        break;

      case ELEMENT_TYPES.TEXT:
        // Preserve original text styles
        enhancedStyles.marginBottom = '0'; // Remove bottom margin for inline layout
        enhancedStyles.whiteSpace = 'pre-wrap';
        // Don't override fontSize - preserve original
        enhancedStyles.fontFamily = enhancedStyles.fontFamily || 'inherit';
        enhancedStyles.fontWeight = enhancedStyles.fontWeight || 'inherit';
        enhancedStyles.textAlign = enhancedStyles.textAlign || 'inherit';
        enhancedStyles.color = enhancedStyles.color || 'inherit';

        if (styles.backgroundColor && styles.backgroundColor !== 'transparent') {
          enhancedStyles.padding = enhancedStyles.padding || '8px 12px';
          enhancedStyles.borderRadius = enhancedStyles.borderRadius || '4px';
          enhancedStyles.display = 'block';
        } else {
          enhancedStyles.padding = enhancedStyles.padding || '0';
          enhancedStyles.display = 'block'; // Use block for full width
        }
        enhancedStyles.width = '100%'; // Take full width of the zone
        enhancedStyles.margin = enhancedStyles.margin || '0';
        break;
    }

    const styleString = Object.entries(enhancedStyles)
      .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
      .join('; ');

    switch (element.type) {
      case ELEMENT_TYPES.HEADING:
        return `<h1 style="${styleString}">${element.content}</h1>`;
      case ELEMENT_TYPES.TEXT:
        return `<p style="${styleString}">${element.content || ''}</p>`;
      case ELEMENT_TYPES.IMAGE:
        return `<div style="text-align: ${element.styles?.textAlign || 'center'}"><img src="${element.content}" alt="${element.alt || ''}" style="${styleString}" /></div>`;
      case ELEMENT_TYPES.CROPPABLE_IMAGE:
        return element.croppedImage
          ? `<img src="${element.croppedImage}" alt="Cropped" style="width:${element.styles?.width || 300}px;height:${element.styles?.height || 200}px;object-fit:cover;display:block;margin:auto;border-radius:${element.styles?.borderRadius || '8px'};" />`
          : '';
      case ELEMENT_TYPES.CIRCULAR_IMAGE:
        return element.croppedImage
          ? `<img src="${element.croppedImage}" alt="Cropped" style="width:${element.styles?.width || 200}px;height:${element.styles?.height || 200}px;border-radius:50%;object-fit:cover;display:block;margin:auto;" />`
          : '';
      case ELEMENT_TYPES.FITTABLE_IMAGE:
        // Use imageSrc or fallback to content property
        const imageSource = element.imageSrc || element.content;
        if (!imageSource) return '';

        // Handle responsive frame dimensions for HTML export
        const getFrameWidthHTML = (styleWidth) => {
          if (styleWidth === "100%" || styleWidth === "auto") {
            return "100%";
          }
          if (typeof styleWidth === 'number') return `${styleWidth}px`;
          if (typeof styleWidth === 'string') {
            const numValue = parseInt(styleWidth, 10);
            return isNaN(numValue) ? "400px" : `${numValue}px`;
          }
          return "400px";
        };

        const getFrameHeightHTML = (styleHeight) => {
          if (styleHeight === "auto") return "300px";
          if (typeof styleHeight === 'number') return `${styleHeight}px`;
          if (typeof styleHeight === 'string') {
            const numValue = parseInt(styleHeight, 10);
            return isNaN(numValue) ? "300px" : `${numValue}px`;
          }
          return "300px";
        };

        const frameWidth = getFrameWidthHTML(element.styles?.width);
        const frameHeight = getFrameHeightHTML(element.styles?.height);
        const position = element.imagePosition || { x: 0, y: 0 };
        const scale = element.imageScale || 1;
        return `<div style="width:${frameWidth};height:${frameHeight};border:none;border-radius:8px;overflow:hidden;position:relative;margin:auto;">
            <img src="${imageSource}" alt="Fittable Image" style="position:absolute;left:50%;top:0;transform:translate(-50%, 0) scale(${scale});transform-origin:top center;max-width:none;max-height:none;" />
          </div>`;
      case ELEMENT_TYPES.BUTTON:
        // Handle custom titlecase transformation for HTML export
        let buttonContent = element.content;
        let buttonStyles = enhancedStyles;

        if (element.styles?.textTransform === 'titlecase') {
          // Apply title case transformation to content
          buttonContent = element.content.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
          // Remove the custom textTransform from styles for HTML
          delete buttonStyles.textTransform;
          // Rebuild styleString without the custom textTransform
          const buttonStyleString = Object.entries(buttonStyles)
            .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
            .join('; ');
          // Add icons to button content for titlecase HTML generation
          let htmlButtonContent = buttonContent;
          if (element.iconLeft === 'cart') {
            htmlButtonContent = `<span style="color: #d4a000; font-size: 2.2rem; margin-right: 18px;">🛒</span>${htmlButtonContent}`;
          }
          if (element.iconRight === 'arrow') {
            htmlButtonContent = `${htmlButtonContent}<span style="color: #222; font-size: 2.2rem; margin-left: 18px;">➡️</span>`;
          }

          return `<div style="text-align: ${element.styles?.textAlign || 'center'}"><a href="${element.url}" style="${buttonStyleString}">${htmlButtonContent}</a></div>`;
        }

        // Add icons to button content for HTML generation
        let htmlButtonContent = buttonContent;
        if (element.iconLeft === 'cart') {
          htmlButtonContent = `<span style="color: #d4a000; font-size: 2.2rem; margin-right: 18px;">🛒</span>${htmlButtonContent}`;
        }
        if (element.iconRight === 'arrow') {
          htmlButtonContent = `${htmlButtonContent}<span style="color: #222; font-size: 2.2rem; margin-left: 18px;">➡️</span>`;
        }

        return `<div style="text-align: ${element.styles?.textAlign || 'center'}"><a href="${element.url}" style="${styleString}">${htmlButtonContent}</a></div>`;
      case ELEMENT_TYPES.VIDEO:
        // Handle video file uploads
        if (element.videoFile) {
          // Uploaded video file
          const videoWidth = element.styles?.width || '100%';
          const videoHeight = element.styles?.height || 315;

          if (videoWidth === '100%' || videoWidth === 'auto') {
            // Check if aspectRatio is explicitly set in styles (e.g., "1/1" for square)
            let paddingBottomPercent;
            if (element.styles?.aspectRatio && element.styles.aspectRatio !== 'auto') {
              // Parse aspect ratio string (e.g., "1/1", "16/9", "9/16")
              const [widthRatio, heightRatio] = element.styles.aspectRatio.split('/').map(Number);
              if (widthRatio && heightRatio) {
                // Calculate padding-bottom percentage: (height / width) * 100%
                paddingBottomPercent = (heightRatio / widthRatio) * 100;
              } else {
                // Invalid aspect ratio, fall back to height calculation
                const heightNum = typeof videoHeight === 'number' ? videoHeight : (typeof videoHeight === 'string' ? parseInt(videoHeight) : 315);
                paddingBottomPercent = (heightNum / 400) * 100;
              }
            } else {
              // No aspectRatio set, use padding-bottom technique based on height
              const heightNum = typeof videoHeight === 'number' ? videoHeight : (typeof videoHeight === 'string' ? parseInt(videoHeight) : 315);
              paddingBottomPercent = (heightNum / 400) * 100;
            }

            return `<div style="text-align: center; margin-bottom: 4px; width: calc(100% + 32px); max-width: calc(100% + 32px); padding: 0; margin-left: -16px; margin-right: -16px;">
              <div style="position: relative; width: 100%; max-width: 100%; padding-bottom: ${paddingBottomPercent}%; height: 0; overflow: hidden; margin: 0; padding-left: 0; padding-right: 0;">
                <video 
                  src="${element.videoFile}" 
                  style="position: absolute; top: 0; left: 0; width: 100%; max-width: 100%; height: 100%; margin: 0; padding: 0; object-fit: contain;" 
                  controls 
                  playsinline
                  webkit-playsinline="true"
                  preload="metadata"
                  ${element.thumbnailUrl ? `poster="${element.thumbnailUrl}"` : ''}
                ></video>
              </div>
            </div>`;
          } else {
            // Ensure full width even when custom width is set
            const fullWidthStyle = `${styleString}; width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 !important;`;
            return `<div style="text-align: center; margin-bottom: 4px; width: 100%; max-width: 100%; padding: 0; margin-left: 0; margin-right: 0;">
              <video 
                src="${element.videoFile}" 
                style="${fullWidthStyle}" 
                controls 
                playsinline
                webkit-playsinline="true"
                preload="metadata"
                ${element.thumbnailUrl ? `poster="${element.thumbnailUrl}"` : ''}
              ></video>
            </div>`;
          }
        } else {
          // No video uploaded
          return `<div style="text-align: center; margin-bottom: 4px; padding: 40px; background-color: #f5f5f5; border: 2px dashed #ccc; border-radius: 0;">
            <p style="color: #666; margin: 0;">No video uploaded</p>
          </div>`;
        }

      case ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY: {
        const videoWidth = element.styles?.width || '100%';
        const videoHeight = element.styles?.height || 315;

        let paddingBottomPercent = 100;
        if (element.styles?.aspectRatio && element.styles.aspectRatio !== 'auto') {
          const [widthRatio, heightRatio] = element.styles.aspectRatio.split('/').map(Number);
          if (widthRatio && heightRatio) {
            paddingBottomPercent = (heightRatio / widthRatio) * 100;
          }
        } else {
          const heightNum = typeof videoHeight === 'number' ? videoHeight : (typeof videoHeight === 'string' ? parseInt(videoHeight) : 315);
          paddingBottomPercent = (heightNum / 400) * 100;
        }

        const videoContent = element.videoFile ? `
          <video 
            src="${element.videoFile}" 
            style="position: absolute; top: 0; left: 0; width: 100%; max-width: 100%; height: 100%; margin: 0; padding: 0; object-fit: contain;" 
            controls 
            playsinline
            webkit-playsinline="true"
            preload="metadata"
            ${element.thumbnailUrl ? `poster="${element.thumbnailUrl}"` : ''}
          ></video>
        ` : `
          <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background-color: #000; color: #fff;">
            <p>No video uploaded</p>
          </div>
        `;

        // Generate styles for the overlay button
        const buttonStyles = {
          ...(element.styles || {}),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '44px',
          minHeight: '44px',
          textAlign: 'center',
          textDecoration: 'none',
          boxSizing: 'border-box'
        };

        const buttonStyleString = Object.entries(buttonStyles)
          .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
          .join('; ');

        return `
          <div style="text-align: center; margin-bottom: 4px; width: calc(100% + 32px); max-width: calc(100% + 32px); padding: 0; margin-left: -16px; margin-right: -16px; position: relative;">
            <div style="position: relative; width: 100%; max-width: 100%; padding-bottom: ${paddingBottomPercent}%; height: 0; overflow: hidden; margin: 0; padding-left: 0; padding-right: 0; border-radius: 0; background-color: #000;">
              ${videoContent}
              
              <div style="position: absolute; bottom: 32px; left: 32px; width: 66.6%; z-index: 20;">
                <a href="${element.url || '#'}" style="${buttonStyleString}">${element.content || 'Click Here'}</a>
              </div>
            </div>
          </div>
        `;
      }
      case ELEMENT_TYPES.HTML:
        return element.content;
      case ELEMENT_TYPES.DIVIDER:
        return `<hr style="${styleString}" />`;

      case ELEMENT_TYPES.COMPARISON_TABLE:
        const titlePreset = getPreset(element.titleStylePreset || 'compareTableTableTitle') || {};
        const productNamePreset = getPreset(element.productNameStylePreset || 'compareTableProdctName') || {};
        const featureTitlePreset = getPreset(element.featureTitleStylePreset || 'compareTableFeatureTitle') || {};
        const featureDescPreset = getPreset(element.featureDescStylePreset || 'compareTableFeatureDescription') || {};

        const comparisonTableHTML = `
          <div style="margin-bottom: 4px;">
            ${element.title ? `<h3 style="text-align: ${titlePreset.textAlign || 'center'}; margin-bottom: 20px; font-family: ${titlePreset.fontFamily || 'inherit'}; font-size: ${titlePreset.fontSize || 'inherit'}; font-weight: ${titlePreset.fontWeight || 'bold'}; color: ${titlePreset.color || 'inherit'}; line-height: ${titlePreset.lineHeight || 'inherit'}; letter-spacing: ${titlePreset.letterSpacing || 'inherit'};">${element.title}</h3>` : ''}
            <table style="width: 100%; border-collapse: collapse; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; overflow: hidden;">
              <thead>
                ${(element.productAImage || element.productBImage) ? `
                  <tr>
                    <td style="width: 40%; border: none; padding: 8px;"></td>
                    <td style="width: 30%; border: none; padding: 8px; text-align: center; background-color: #B8E6E1;">
                      ${element.productAImage ? `<img src="${element.productAImage}" alt="${element.productA}" style="width: 100px; height: 100px; object-fit: cover; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" />` : ''}
                    </td>
                    <td style="width: 30%; border: none; padding: 8px; text-align: center; background-color: #ffebee;">
                      ${element.productBImage ? `<img src="${element.productBImage}" alt="${element.productB}" style="width: 100px; height: 100px; object-fit: cover; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" />` : ''}
                    </td>
                  </tr>
                ` : ''}
                <tr>
                  <th style="padding: 16px; font-weight: bold; font-size: 16px; width: 40%; background-color: #f5f5f5; text-align: left;">Feature</th>
                  <th style="padding: 16px; width: 30%; background-color: #B8E6E1; text-align: ${productNamePreset.textAlign || 'center'}; font-family: ${productNamePreset.fontFamily || 'inherit'}; font-size: ${productNamePreset.fontSize || '16px'}; font-weight: ${productNamePreset.fontWeight || 'bold'}; color: ${productNamePreset.color || '#2D5A5A'}; line-height: ${productNamePreset.lineHeight || 'inherit'}; letter-spacing: ${productNamePreset.letterSpacing || 'inherit'};">${element.productA}</th>
                  <th style="padding: 16px; width: 30%; background-color: #ffebee; text-align: ${productNamePreset.textAlign || 'center'}; font-family: ${productNamePreset.fontFamily || 'inherit'}; font-size: ${productNamePreset.fontSize || '16px'}; font-weight: ${productNamePreset.fontWeight || 'bold'}; color: ${productNamePreset.color || '#c62828'}; line-height: ${productNamePreset.lineHeight || 'inherit'}; letter-spacing: ${productNamePreset.letterSpacing || 'inherit'};">${element.productB}</th>
                </tr>
              </thead>
              <tbody>
                ${element.rows.map((row, index) => `
                  <tr style="background-color: ${index % 2 === 0 ? '#fff' : '#f9f9f9'};">
                    <td style="padding: 16px; vertical-align: top;">
                      <div style="margin-bottom: 4px; font-family: ${featureTitlePreset.fontFamily || 'inherit'}; font-size: ${featureTitlePreset.fontSize || 'inherit'}; font-weight: ${featureTitlePreset.fontWeight || 'medium'}; color: ${featureTitlePreset.color || 'inherit'}; text-align: ${featureTitlePreset.textAlign || 'left'}; line-height: ${featureTitlePreset.lineHeight || 'inherit'}; letter-spacing: ${featureTitlePreset.letterSpacing || 'inherit'};">${row.feature}</div>
                      ${row.description ? `<div style="font-family: ${featureDescPreset.fontFamily || 'inherit'}; font-size: ${featureDescPreset.fontSize || '14px'}; font-weight: ${featureDescPreset.fontWeight || 'inherit'}; color: ${featureDescPreset.color || '#666'}; text-align: ${featureDescPreset.textAlign || 'left'}; line-height: ${featureDescPreset.lineHeight || 'inherit'}; letter-spacing: ${featureDescPreset.letterSpacing || 'inherit'};">${row.description}</div>` : ''}
                    </td>
                    <td style="padding: 16px; text-align: center; background-color: ${row.productA ? '#B8E6E1' : '#fff'};">
                      ${row.productA ? '✓' : '✗'}
                    </td>
                    <td style="padding: 16px; text-align: center; background-color: ${row.productB ? '#B8E6E1' : '#ffebee'};">
                      ${row.productB ? '✓' : '✗'}
                    </td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
        return comparisonTableHTML;

      case ELEMENT_TYPES.TWO_COLUMN_COMPARISON:
        const columnTitlePreset = getPreset(element.titleStylePreset || 'compareTableTwoColumnColumnTitle') || {};
        const itemPreset = getPreset(element.itemStylePreset || 'compareTableTwoColumnItemTitle') || {};

        const twoColumnComparisonHTML = `
          <div style="margin-bottom: 4px;">
            <div style="display: flex; min-height: 400px; border-radius: 16px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
              <!-- Left Column - Negative Points -->
              <div style="flex: 1; background-color: #fff; border: 1px solid #e0e0e0; border-right: 0.5px solid #e0e0e0; padding: 24px; display: flex; flex-direction: column;">
                ${element.leftColumnImage ? `
                  <div style="display: flex; justify-content: center; margin-bottom: 16px;">
                    <img src="${element.leftColumnImage}" alt="${element.leftColumnTitle}" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px;" />
                  </div>
                ` : ''}
                <h3 style="text-align: ${columnTitlePreset.textAlign || 'center'}; margin-bottom: 24px; font-family: ${columnTitlePreset.fontFamily || 'inherit'}; font-size: ${columnTitlePreset.fontSize || '16px'}; font-weight: ${columnTitlePreset.fontWeight || 'bold'}; color: ${columnTitlePreset.color || '#000'}; line-height: ${columnTitlePreset.lineHeight || 'inherit'}; letter-spacing: ${columnTitlePreset.letterSpacing || 'inherit'};">${element.leftColumnTitle}</h3>
                <div style="flex-grow: 1;">
                  ${element.leftItems.map(item => `
                    <div style="display: flex; align-items: flex-start; margin-bottom: 16px; gap: 16px;">
                      <svg style="width: 20px; height: 20px; margin-top: 2px; flex-shrink: 0;" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10" fill="#dc3545"/>
                        <path d="M15.59 7L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12z" fill="white"/>
                      </svg>
                      <div style="font-family: ${itemPreset.fontFamily || 'inherit'}; font-size: ${itemPreset.fontSize || '12px'}; font-weight: ${itemPreset.fontWeight || '500'}; color: ${itemPreset.color || '#000'}; text-align: ${itemPreset.textAlign || 'left'}; line-height: ${itemPreset.lineHeight || '1.4'}; letter-spacing: ${itemPreset.letterSpacing || 'inherit'};">${item}</div>
                    </div>
                  `).join('')}
                </div>
              </div>
              <!-- Right Column - Positive Points -->
              <div style="flex: 1; background-color: #f0f9f0; border: 1px solid #e0e0e0; border-left: 0.5px solid #e0e0e0; padding: 24px; display: flex; flex-direction: column;">
                ${element.rightColumnImage ? `
                  <div style="display: flex; justify-content: center; margin-bottom: 16px;">
                    <img src="${element.rightColumnImage}" alt="${element.rightColumnTitle}" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px;" />
                  </div>
                ` : ''}
                <h3 style="text-align: ${columnTitlePreset.textAlign || 'center'}; margin-bottom: 24px; font-family: ${columnTitlePreset.fontFamily || 'inherit'}; font-size: ${columnTitlePreset.fontSize || '16px'}; font-weight: ${columnTitlePreset.fontWeight || 'bold'}; color: ${columnTitlePreset.color || '#000'}; line-height: ${columnTitlePreset.lineHeight || 'inherit'}; letter-spacing: ${columnTitlePreset.letterSpacing || 'inherit'};">${element.rightColumnTitle}</h3>
                <div style="flex-grow: 1;">
                  ${element.rightItems.map(item => `
                    <div style="display: flex; align-items: flex-start; margin-bottom: 16px; gap: 16px;">
                      <svg style="color: #28a745; width: 20px; height: 20px; margin-top: 2px; flex-shrink: 0;" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                      <div style="font-family: ${itemPreset.fontFamily || 'inherit'}; font-size: ${itemPreset.fontSize || '12px'}; font-weight: ${itemPreset.fontWeight || '500'}; color: ${itemPreset.color || '#000'}; text-align: ${itemPreset.textAlign || 'left'}; line-height: ${itemPreset.lineHeight || '1.4'}; letter-spacing: ${itemPreset.letterSpacing || 'inherit'};">${item}</div>
                    </div>
                  `).join('')}
                </div>
              </div>
            </div>
          </div>
        `;
        return twoColumnComparisonHTML;

      case ELEMENT_TYPES.CHECKLIST:
        const checklistHTML = `
          <div style="${styleString}">
            ${element.title ? `<h2 style="text-align: center; color: #1976d2; margin-bottom: 24px;">${element.title}</h2>` : ''}
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 16px;">
              ${element.items.map(item => `
                <div style="display: flex; align-items: center; gap: 8px; padding: 8px; background-color: #f5f5f5; border-radius: 4px; margin-bottom: 8px;">
                  <span style="color: #4caf50;">✓</span>
                  <span style="font-weight: 500;">${item.text.replace(/\n/g, '<br>')}</span>
                </div>
              `).join('')}
            </div>
          </div>
        `;
        return checklistHTML;
      case ELEMENT_TYPES.BUTTON_WITH_NOTICE:
        const getVariantStylesHTML = (variant, styleVariant = 'default') => {
          const styleVariants = {
            'urgent-sale': {
              'default': {
                backgroundColor: '#ff69b4', // pink
                noticeColor: '#101022', // black text on pink
                buttonBg: '#101022', // black button
                buttonColor: '#ffffff', // white text on black
                border: 'none',
                borderRadius: '8px'
              },
              'modern': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white (changed from orange/yellow)
                buttonBg: '#ff69b4', // pink button
                buttonColor: '#101022', // black text on pink
                border: '2px solid #ff69b4',
                borderRadius: '12px'
              },
              'minimal': {
                backgroundColor: '#fafafa', // light gray (close to white)
                noticeColor: '#101022', // black text (changed from orange/yellow)
                buttonBg: '#ff69b4', // pink button
                buttonColor: '#101022', // black text on pink
                border: '1px solid #e0e0e0',
                borderRadius: '4px'
              },
              'gradient': {
                backgroundColor: 'linear-gradient(135deg, #ff69b4, #ff1493)', // pink gradient
                noticeColor: '#ffffff', // white text on pink gradient
                buttonBg: '#ffffff', // white button
                buttonColor: '#101022', // black text on white
                border: 'none',
                borderRadius: '16px'
              }
            },
            'membership-quiz': {
              'default': {
                backgroundColor: '#0000ff', // blue
                noticeColor: '#ffffff', // white text on blue
                buttonBg: '#ffffff', // white button
                buttonColor: '#0000ff', // blue text on white
                border: 'none',
                borderRadius: '8px'
              },
              'elegant': {
                backgroundColor: '#000080', // dark blue
                noticeColor: '#ffffff', // white text on dark blue
                buttonBg: '#ffffff', // white button
                buttonColor: '#000080', // dark blue text on white
                border: '2px solid #4169e1',
                borderRadius: '12px'
              },
              'soft': {
                backgroundColor: '#e6f3ff', // light blue
                noticeColor: '#0000ff', // blue text on light blue
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #b3d9ff',
                borderRadius: '8px'
              },
              'corporate': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '2px solid #e0e0e0',
                borderRadius: '6px'
              }
            },
            'media-buzz': {
              'default': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white
                buttonBg: '#ffff00', // yellow button
                buttonColor: '#101022', // black text on yellow
                border: '2px dashed #101022',
                borderRadius: '8px'
              },
              'news': {
                backgroundColor: '#f8f9fa', // light gray (close to white)
                noticeColor: '#101022', // black text
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #e0e0e0',
                borderRadius: '8px'
              },
              'viral': {
                backgroundColor: '#ffff00', // yellow
                noticeColor: '#101022', // black text on yellow
                buttonBg: '#101022', // black button
                buttonColor: '#ffffff', // white text on black
                border: '2px solid #ffd700',
                borderRadius: '12px'
              },
              'trending': {
                backgroundColor: '#e6f3ff', // light blue
                noticeColor: '#0000ff', // blue text on light blue
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #b3d9ff',
                borderRadius: '10px'
              }
            }
          };

          return styleVariants[variant]?.[styleVariant] || styleVariants[variant]?.['default'] || {
            backgroundColor: '#ff69b4',
            noticeColor: '#101022',
            buttonBg: '#101022',
            buttonColor: '#ffffff',
            border: 'none',
            borderRadius: '8px'
          };
        };

        const variantStylesHTML = getVariantStylesHTML(element.variant, element.styleVariant);
        const boxShadow = element.styleVariant === 'gradient' ? '0 8px 32px rgba(255, 107, 107, 0.3)' : '0 2px 8px rgba(0,0,0,0.1)';

        const buttonWithNoticeHTML = `
          <div style="background: ${variantStylesHTML.backgroundColor.includes('gradient') ? variantStylesHTML.backgroundColor : variantStylesHTML.backgroundColor}; padding: 20px; border-radius: ${variantStylesHTML.borderRadius}; text-align: center; margin-bottom: 4px; border: ${variantStylesHTML.border}; box-shadow: ${boxShadow};">
            <p style="color: ${variantStylesHTML.noticeColor}; font-weight: bold; margin-bottom: 16px; line-height: 1.5;">
              ${element.content?.notice?.replace(/\n/g, '<br>') || ''}
            </p>
            <p style="color: ${variantStylesHTML.noticeColor}; margin-bottom: 16px;">
              ${element.content?.callToAction || ''}
            </p>
            <a href="${element.content?.buttonUrl || '#'}" style="background-color: ${variantStylesHTML.buttonBg}; color: ${variantStylesHTML.buttonColor}; padding: 16px 32px; font-size: 18px; font-weight: bold; border: none; border-radius: 8px; text-decoration: none; display: inline-block; max-width: 400px; width: 100%; box-shadow: 0 2px 4px rgba(0,0,0,0.1); transition: all 0.2s ease;">
              ${element.content?.buttonText || ''}
            </a>
          </div>
        `;
        return buttonWithNoticeHTML;
      case ELEMENT_TYPES.BUTTON_HEADLINE_PRODUCT_IMAGE:
        const buttonHeadlineProductImageHTML = `
          <div style="background: ${element.content?.background || '#ffffff'}; color: ${element.content?.textColor || '#333333'}; border-radius: 16px; margin-bottom: 4px; text-align: center; padding: 20px; box-shadow: 0 2px 12px rgba(0,0,0,0.07);">
            <h2 style="color: ${element.content?.textColor || '#333333'}; font-weight: bold; margin-bottom: 16px; font-size: 1.5rem;">
              ${element.content?.headline || 'Amazing Product Offer'}
            </h2>
            <div style="margin-bottom: 16px;">
              <img src="${element.content?.productImage || '/api/placeholder/400/300'}" alt="Product" style="width: 100%; max-width: 400px; height: auto; border-radius: 8px; border: 2px dashed #e0e0e0;" />
            </div>
            ${element.content?.subheadline ? `
              <p style="color: ${element.content?.textColor || '#333333'}; margin-bottom: 16px; line-height: 1.5;">
                ${element.content.subheadline.replace(/\n/g, '<br>')}
              </p>
            ` : ''}
            <a href="${element.content?.buttonUrl || '#'}" style="background-color: ${element.content?.buttonColor || '#4caf50'}; color: #fff; padding: 18px 0; font-size: 1.3rem; font-weight: bold; border: none; border-radius: 8px; text-decoration: none; display: block; width: 100%; margin: 16px 0; box-shadow: 0 2px 4px rgba(0,0,0,0.1); transition: all 0.2s ease;">
              ${element.content?.buttonText || 'Get This Offer Now!'}
            </a>
          </div>
        `;
        return buttonHeadlineProductImageHTML;
      case ELEMENT_TYPES.CUSTOM_LIST:
        const customListHTML = `
          <div style="background-color: ${element.styles?.backgroundColor || '#181818'}; color: ${element.styles?.color || '#fff'}; font-family: ${element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${element.styles?.fontSize || '1.25rem'}; border-radius: ${element.styles?.borderRadius || '12px'}; padding: ${element.styles?.padding || '24px'}; margin: ${element.styles?.margin || '0 0 16px 0'};">
            ${element.rows.map((row, idx) => `
              <div key="${idx}" style="display: flex; align-items: center; margin-bottom: 8px;">
                ${getListIconHTML(row.icon, idx)}
                <span style="margin-left: 8px; font-family: ${getPreset(element.textStylePreset || 'paragraph1')?.fontFamily || element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${getPreset(element.textStylePreset || 'paragraph1')?.fontSize || element.styles?.fontSize || '1.25rem'}; color: ${getPreset(element.textStylePreset || 'paragraph1')?.color || element.styles?.color || '#fff'}; font-weight: ${getPreset(element.textStylePreset || 'paragraph1')?.fontWeight || 'inherit'}; line-height: ${getPreset(element.textStylePreset || 'paragraph1')?.lineHeight || 'inherit'}; letter-spacing: ${getPreset(element.textStylePreset || 'paragraph1')?.letterSpacing || 'inherit'};">${row.text}</span>
              </div>
            `).join('')}
          </div>
        `;
        return customListHTML;
      case ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE:
        const customListTwoLineHTML = `
          <div style="background-color: ${element.styles?.backgroundColor || '#181818'}; color: ${element.styles?.color || '#fff'}; font-family: ${element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${element.styles?.fontSize || '1.25rem'}; border-radius: ${element.styles?.borderRadius || '12px'}; padding: ${element.styles?.padding || '24px'}; margin: ${element.styles?.margin || '0 0 16px 0'};">
            ${element.rows.map((row, idx) => `
              <div key="${idx}" style="display: flex; align-items: flex-start; margin-bottom: 16px;">
                ${getListIconHTML(row.icon, idx)}
                <div style="margin-left: 8px; flex: 1;">
                  <div style="font-family: ${getPreset(element.textStylePreset1 || 'subheading1')?.fontFamily || element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${getPreset(element.textStylePreset1 || 'subheading1')?.fontSize || element.styles?.fontSize || '1.25rem'}; color: ${element.styles?.color || getPreset(element.textStylePreset1 || 'subheading1')?.color || '#fff'}; font-weight: ${getPreset(element.textStylePreset1 || 'subheading1')?.fontWeight || 'inherit'}; line-height: ${getPreset(element.textStylePreset1 || 'subheading1')?.lineHeight || 'inherit'}; letter-spacing: ${getPreset(element.textStylePreset1 || 'subheading1')?.letterSpacing || 'inherit'}; margin-bottom: 4px;">${row.text1}</div>
                  <div style="font-family: ${getPreset(element.textStylePreset2 || 'paragraph1')?.fontFamily || element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${getPreset(element.textStylePreset2 || 'paragraph1')?.fontSize || element.styles?.fontSize || '1.25rem'}; color: ${element.styles?.color || getPreset(element.textStylePreset2 || 'paragraph1')?.color || '#fff'}; font-weight: ${getPreset(element.textStylePreset2 || 'paragraph1')?.fontWeight || 'inherit'}; line-height: ${getPreset(element.textStylePreset2 || 'paragraph1')?.lineHeight || 'inherit'}; letter-spacing: ${getPreset(element.textStylePreset2 || 'paragraph1')?.letterSpacing || 'inherit'};">${row.text2}</div>
                </div>
              </div>
            `).join('')}
          </div>
        `;
        return customListTwoLineHTML;
      case ELEMENT_TYPES.TIMELINE_LIST:
        const timelineListHTML = `
          <div style="background-color: ${element.styles?.backgroundColor || '#fff'}; color: ${element.styles?.color || '#222'}; font-family: ${element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${element.styles?.fontSize || '1.1rem'}; border-radius: ${element.styles?.borderRadius || '12px'}; padding: ${element.styles?.padding || '24px'}; margin: ${element.styles?.margin || '0 0 16px 0'};">
            ${element.steps.map((step, idx) => `
              <div key="${idx}" style="display: flex; align-items: flex-start; margin-bottom: 16px;">
                <div style="margin-right: 16px; display: flex; align-items: center; flex-direction: column;">
                  <div style="width: 24px; height: 24px; border-radius: 50%; background-color: ${step.dotColor}; margin-bottom: 8px;"></div>
                  ${idx < element.steps.length - 1 ? '<div style="width: 2px; height: 100%; background-color: #e0e0e0;"></div>' : ''}
                </div>
                <div>
                  <p style="color: ${step.stageLabelColor}; font-weight: bold; margin-bottom: 8px;">${step.stageLabel}</p>
                  <h3 style="font-weight: bold; margin-bottom: 8px;">${step.title}</h3>
                  <p>${step.description}</p>
                </div>
              </div>
            `).join('')}
          </div>
        `;
        return timelineListHTML;
      case ELEMENT_TYPES.PROCESS_STEPS:
        const processStepsHTML = `
          <div style="background-color: ${element.styles?.backgroundColor || '#fff'}; color: ${element.styles?.color || '#333'}; font-family: ${element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${element.styles?.fontSize || '1rem'}; border-radius: ${element.styles?.borderRadius || '12px'}; padding: ${element.styles?.padding || '24px'}; margin: ${element.styles?.margin || '0 0 16px 0'};">
            ${element.steps.map((step, idx) => `
              <div key="${idx}" style="display: flex; align-items: flex-start; gap: 24px; margin-bottom: ${idx < element.steps.length - 1 ? '32px' : '0'};">
                <div style="flex-shrink: 0; width: 150px; position: relative;">
                  <img src="${step.image}" alt="Step ${step.number}" style="width: 100%; height: 120px; object-fit: cover; border-radius: 12px; border: 1px solid #e0e0e0;" onerror="this.src='https://via.placeholder.com/150x120?text=Step+${step.number}'" />
                  <div style="position: absolute; top: -8px; right: -8px; width: 36px; height: 36px; border-radius: 50%; background-color: ${step.numberColor || '#1976d2'}; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; font-weight: bold; border: 3px solid white; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
                    ${step.number}
                  </div>
                </div>
                <div style="flex: 1; padding-top: 8px;">
                  <h3 style="font-weight: bold; margin: 0 0 8px 0; color: inherit;">${step.title}</h3>
                  <p style="margin: 0; color: inherit; line-height: 1.5;">${step.description}</p>
                </div>
              </div>
            `).join('')}
          </div>
        `;
        return processStepsHTML;
      case ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE:
        const textWithRightImageHTML = `
          <div style="background-color: ${element.styles?.backgroundColor || '#fff'}; color: ${element.styles?.color || '#333'}; font-family: ${element.styles?.fontFamily || 'Inter, Arial, sans-serif'}; font-size: ${element.styles?.fontSize || '1.1rem'}; border-radius: ${element.styles?.borderRadius || '12px'}; padding: ${element.styles?.padding || '20px'}; margin: ${element.styles?.margin || '0 0 16px 0'}; display: flex; align-items: center; gap: 24px;">
            <div style="flex: 1;">
              <h3 style="margin: 0; font-weight: bold; color: inherit;">${element.content.text}</h3>
            </div>
            <div style="flex-shrink: 0; width: 180px;">
              <img src="${element.content.image}" alt="Right side image" style="width: 100%; height: 120px; object-fit: cover; border-radius: 8px; border: 1px solid #e0e0e0;" onerror="this.src='https://via.placeholder.com/180x120?text=Image'" />
            </div>
          </div>
        `;
        return textWithRightImageHTML;
      case ELEMENT_TYPES.LEFT_IMAGE_TEXT:
        const alignItems = element.imageAlignment === 'top' ? 'flex-start' :
          element.imageAlignment === 'bottom' ? 'flex-end' : 'center';
        const leftImageTextHTML = `
          <div style="display: flex; gap: ${element.spacing || 20}px; margin-bottom: 4px; ${Object.entries(element.styles || {})
            .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
            .join('; ')}; align-items: ${alignItems};">
            <div style="flex-shrink: 0;">
              <img src="${element.content.image}" alt="Profile image" style="width: ${element.imageSize || 120}px; height: ${element.imageSize || 120}px; object-fit: cover; border-radius: 50%; border: 3px solid #e0e0e0;" onerror="this.src='https://via.placeholder.com/150x150?text=Profile'" />
            </div>
            <div style="flex: 1;">
              <p style="margin: 0; color: ${element.textStyles?.color || 'inherit'}; line-height: ${element.textStyles?.lineHeight || '1.6'}; font-size: ${element.textStyles?.fontSize || '16px'}; font-weight: ${element.textStyles?.fontWeight || 'normal'}; font-family: ${element.textStyles?.fontFamily || 'inherit'}; text-align: ${element.textStyles?.textAlign || 'left'}; background-color: ${element.textStyles?.backgroundColor || 'transparent'}; padding: ${element.textStyles?.padding || '0px'}; border-radius: ${element.textStyles?.borderRadius || '0px'};">${element.content.text}</p>
            </div>
          </div>
        `;
        return leftImageTextHTML;
      case ELEMENT_TYPES.QUOTATION_BLOCK:
        return `
            <div style="
              position: relative;
              background: ${element.styles?.backgroundColor || '#fce7f3'};
              color: ${element.styles?.color || '#101022'};
              border-radius: ${element.styles?.borderRadius || '16px'};
              padding: ${element.styles?.padding || '24px 32px 24px 32px'};
              font-style: italic;
              min-height: 120px;
              margin-bottom: 16px;
              overflow: visible;
              font-size: ${element.styles?.fontSize || '18px'};
              font-weight: ${element.styles?.fontWeight || '400'};
              line-height: ${element.styles?.lineHeight || '1.5'};
              font-family: ${element.styles?.fontFamily || "'Inter', sans-serif"};
            ">
              <div style="
                position: absolute;
                top: -12px;
                left: 12px;
                width: 40px;
                height: 40px;
                background: #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                z-index: 2;
              ">
                <span style="font-size: 24px; font-family: serif; font-weight: bold; color: #101022;">&ldquo;</span>
              </div>
              <span style="
                font-style: italic;
                font-size: ${element.styles?.fontSize || '18px'};
                font-weight: ${element.styles?.fontWeight || '400'};
                line-height: ${element.styles?.lineHeight || '1.5'};
                font-family: ${element.styles?.fontFamily || "'Inter', sans-serif"};
                display: block;
              ">
                ${element.content || ''}
              </span>
            </div>
          `;
      case ELEMENT_TYPES.LAYOUT:
        const config = LAYOUT_CONFIGS[element.layoutType];
        if (!config) {
          console.warn('Invalid layout type for HTML generation:', element.layoutType);
          return '';
        }

        // Special handling for INLINE_ROW layout
        if (element.layoutType === LAYOUT_TYPES.INLINE_ROW) {
          const layoutStyle = Object.entries(element.styles || {})
            .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
            .join('; ');

          if (!element.zones || !Array.isArray(element.zones)) {
            console.warn('Inline row layout missing zones for HTML generation:', element);
            return `<div class="inline-row-container" style="${layoutStyle}">Inline row with no zones</div>`;
          }

          const zone = element.zones[0]; // Inline row has only one zone
          if (!zone) {
            console.warn('Invalid zone found for inline row HTML generation:', element);
            return `<div class="inline-row-container" style="${layoutStyle}">Invalid zone</div>`;
          }

          const zoneElements = (zone.elements || []).map(zoneElement => {
            if (!zoneElement) {
              console.warn('Invalid zone element found for inline row HTML generation:', zoneElement);
              return '';
            }
            return generateElementHTML(zoneElement);
          }).join('\n');

          return `<div class="inline-row-container" style="display: flex; align-items: center; gap: 10px; margin-bottom: 4px; ${layoutStyle}">${zoneElements}</div>`;
        }

        const layoutStyle = Object.entries(element.styles || {})
          .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
          .join('; ');

        // Add safety check for zones
        if (!element.zones || !Array.isArray(element.zones)) {
          console.warn('Layout element missing zones for HTML generation:', element);
          return `<div class="layout-container" style="${layoutStyle}">Layout with no zones</div>`;
        }

        // Determine if this is a multi-column layout (needed for zone styling)
        const isMultiColumn = element.layoutType === LAYOUT_TYPES.TWO_COLUMN ||
          element.layoutType === LAYOUT_TYPES.THREE_COLUMN ||
          element.layoutType === LAYOUT_TYPES.FEATURE ||
          element.layoutType === LAYOUT_TYPES.SINGLE_ROW_2 ||
          element.layoutType === LAYOUT_TYPES.SINGLE_ROW_3 ||
          element.layoutType === LAYOUT_TYPES.SINGLE_ROW_4 ||
          element.layoutType === LAYOUT_TYPES.SINGLE_ROW_5;

        const zonesHTML = element.zones.map((zone, index) => {
          if (!zone) {
            console.warn('Invalid zone found at index for HTML generation:', index);
            return '<div class="zone" style="flex: 1; padding: 10px; min-width: 280px;">Invalid zone</div>';
          }

          const zoneElements = (zone.elements || []).map(zoneElement => {
            if (!zoneElement) {
              console.warn('Invalid zone element found for HTML generation:', zoneElement);
              return '';
            }
            return generateElementHTML(zoneElement);
          }).join('\n');

          // Get zone width and height from config to match canvas/preview rendering
          const zoneConfig = config.zones[index];
          const zoneWidth = zoneConfig ? zoneConfig.width : '50%';

          // Get zone height style to match canvas/preview rendering
          const zoneHeightStyle = getZoneHeightStyle(zone.id, zoneConfig?.height || 'auto');
          const zoneHeightCSS = Object.entries(zoneHeightStyle)
            .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
            .join('; ');

          const zoneStyle = isMultiColumn
            ? `flex: 1; min-width: 0; padding: 6px; text-align: ${zoneConfig?.textAlign || zone.textAlign || 'left'}; border: 1px dashed #e0e0e0; border-radius: 4px; word-wrap: break-word; overflow-wrap: break-word; box-sizing: border-box; ${zoneHeightCSS};`
            : `width: 100%; padding: 6px; text-align: ${zoneConfig?.textAlign || zone.textAlign || 'left'}; border: 1px dashed #e0e0e0; border-radius: 4px; word-wrap: break-word; overflow-wrap: break-word; box-sizing: border-box; ${zoneHeightCSS};`;

          return `<div class="zone zone-${element.id}" style="${zoneStyle}">${zoneElements}</div>`;
        }).join('\n');

        // Apply responsive flexDirection and flexWrap based on layout type to match canvas behavior
        let flexDirection = 'row';
        let flexWrap = 'nowrap';
        if (element.layoutType === LAYOUT_TYPES.THREE_COLUMN) {
          flexDirection = 'wrap';
          flexWrap = 'wrap';
        }

        // Add responsive CSS to match preview mode behavior
        const responsiveCSS = `
          /* Mobile portrait mode - side-by-side for multi-column layouts */
          .layout-container-${element.id} {
            flex-direction: ${isMultiColumn ? 'row' : 'column'} !important;
            flex-wrap: nowrap !important;
            gap: 8px !important;
          }
          .zone-${element.id} {
            ${isMultiColumn ? 'flex: 1 !important; min-width: 0 !important;' : 'width: 100% !important;'}
            word-wrap: break-word !important;
            overflow-wrap: break-word !important;
          }
        `;

        // Get layout border to match canvas styling
        const layoutBorder = element.styles?.border || '1px dashed #ccc';
        const layoutBorderRadius = element.styles?.borderRadius || '4px';
        const layoutPadding = element.styles?.padding || '8px';
        const layoutBackgroundColor = element.styles?.backgroundColor || 'transparent';

        return `<style>${responsiveCSS}</style><div class="layout-container layout-container-${element.id}" style="display: flex; gap: 6px; margin-bottom: 4px; flex-direction: ${isMultiColumn ? 'row' : 'column'}; flex-wrap: nowrap; border: ${layoutBorder}; border-radius: ${layoutBorderRadius}; padding: ${layoutPadding}; background-color: ${layoutBackgroundColor}; ${layoutStyle}">${zonesHTML}</div>`;
      case ELEMENT_TYPES.FAQ_ACCORDION:
        const faqId = `faq-${element.id || Math.random().toString(36).substr(2, 9)}`;
        const faqHTML = `
          <div style="${styleString}; background-color: ${element.containerBackgroundColor || 'transparent'}; border-radius: ${element.itemBorderRadius || '4px'}; padding: ${element.containerBackgroundColor !== 'transparent' ? '16px' : '0'};">
            ${element.title ? `<h3 style="text-align: ${element.textAlign || 'center'}; margin-bottom: 24px; font-weight: bold; color: ${element.titleTextColor === 'primary' ? '#1976d2' : element.titleTextColor || '#1976d2'};">${element.title}</h3>` : ''}
            <div class="faq-container" id="${faqId}">
              ${element.items.map((item, index) => `
                <div class="faq-item" style="margin-bottom: ${element.itemSpacing || '12px'}; ${element.showDivider !== false && index < element.items.length - 1 ? `border-bottom: 2px solid ${element.dividerColor || '#C1A7F1'}; padding-bottom: 16px;` : ''}">
                  <div class="faq-question" style="display: flex; justify-content: space-between; align-items: center; padding: ${element.questionPadding || '16px'}; cursor: pointer; background-color: ${element.questionBackgroundColor || 'transparent'}; border-radius: ${element.itemBorderRadius || '4px'}; margin-bottom: 2px; transition: background-color 0.2s ease; text-align: ${element.textAlign || 'left'};" 
                       onclick="toggleFAQItem('${faqId}', ${index}, '${element.iconType || 'plusMinus'}')">
                    <span style="font-weight: bold; color: ${element.questionTextColor || '#4B329A'}; flex: 1; padding-right: ${element.showIcon !== false ? '16px' : '0'}; line-height: 1.4; text-align: ${element.textAlign || 'left'};">${item.question}</span>
                    ${element.showIcon !== false ? `
                      <span class="faq-icon" id="${faqId}-icon-${index}" style="color: ${element.iconColor || '#36C3D6'}; font-size: ${element.iconSize === 'small' ? '18px' : element.iconSize === 'medium' ? '24px' : '32px'}; font-weight: bold; flex-shrink: 0;">
                        ${element.iconType === 'expandMore' ? '▼' : element.iconType === 'arrow' ? '↓' : element.iconType === 'arrowDrop' ? '▼' : '+'}
                      </span>
                    ` : ''}
                  </div>
                  <div class="faq-answer" id="${faqId}-answer-${index}" style="display: none; padding: ${element.answerPadding || '16px'}; background-color: ${element.answerBackgroundColor || 'rgba(0, 0, 0, 0.02)'}; border-radius: ${element.itemBorderRadius || '4px'}; margin-top: 8px; line-height: 1.6; color: ${element.answerTextColor || '#4B329A'}; text-align: ${element.textAlign || 'left'};">
                    ${item.answer}
                  </div>
                </div>
              `).join('')}
            </div>
          </div>
        `;
        return faqHTML;
      default:
        return '';
    }
  };

  // Mobile-optimized HTML generation
  const generateHTML = useCallback(() => {
    let elementsHTML;

    if (paginationEnabled && pages.length > 0) {
      // Pagination mode - export with page breaks
      console.log('📄 Exporting paginated content with page breaks:', {
        pagesCount: pages.length,
        totalElements: pages.reduce((total, page) => total + page.elements.length, 0)
      });

      // Generate HTML for each page separately
      const pagesHTML = pages.map((page, pageIndex) => {
        const pageElementsHTML = page.elements.map(element => {
          if (!element || !element.type) {
            console.warn('Invalid element found:', element);
            return '';
          }
          return generateElementHTML(element);
        }).filter(html => html !== '').join('\n');

        return `
        <div class="page-container" data-page="${pageIndex + 1}">
          <div class="page-header">
            <span class="page-number">Page ${pageIndex + 1} of ${pages.length}</span>
          </div>
          <div class="page-content">
            ${pageElementsHTML}
          </div>
        </div>`;
      }).join('\n');

      elementsHTML = pagesHTML;
    } else {
      // Regular mode - export current elements
      console.log('📄 Exporting single page content:', {
        elementsCount: elements.length
      });

      elementsHTML = elements.map(element => {
        if (!element || !element.type) {
          console.warn('Invalid element found:', element);
          return '';
        }
        return generateElementHTML(element);
      }).filter(html => html !== '').join('\n');
    }

    return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=yes">
    <title>${pageSettings.title}</title>
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <style>
        * {
            box-sizing: border-box;
        }
        
        body {
            font-family: ${pageSettings.fontFamily};
            background-color: ${pageSettings.backgroundColor};
            margin: 0;
            padding: 0; /* Let container handle padding */
            line-height: 1.6;
            font-size: 16px;
            display: flex;
            justify-content: center;
            align-items: flex-start; /* Align to top like preview */
            min-height: 100vh;
            box-sizing: border-box;
        }
        
        /* Phone Frame Styles - Always mobile portrait */
        .phone-frame {
            width: ${STANDARD_MOBILE.displayWidth - 16}px; /* Fixed mobile width (389px) */
            min-height: ${STANDARD_MOBILE.displayHeight - 16}px; /* Mobile height (862px) */
            background-color: #fff; /* Match preview background */
            border-radius: 20px; /* Mobile frame border radius */
            padding: 8px; /* Reduced padding for more content space */
            box-shadow: 0 4px 12px rgba(0,0,0,0.15); /* Mobile frame shadow */
            position: relative;
            margin: 0 auto; /* Center like preview */
            overflow: visible; /* Allow content to breathe */
        }
        
        /* Remove phone decorative elements to match clean preview */
        
        .phone-screen {
            width: 100%;
            min-height: 100%;
            background-color: transparent; /* Let phone-frame handle background */
            border-radius: 0; /* Remove inner border radius */
            overflow: visible; /* Allow content expansion like preview */
            position: relative;
        }
        
        .offer-container {
            max-width: 100%;
            margin: 0;
            padding: 0; /* Remove padding, frame handles it */
            background: transparent; /* Frame handles background */
            box-shadow: none;
            border-radius: 0;
            height: 100%;
            overflow-y: auto;
        }
        
        .layout-container {
            display: flex;
            gap: 8px;
            margin-bottom: 4px;
            flex-direction: row; /* Side-by-side in mobile frame */
            flex-wrap: nowrap;
        }
        
        .zone {
            flex: 1;
            word-wrap: break-word;
            overflow-wrap: break-word;
            box-sizing: border-box;
            min-width: 0; /* Allow flex items to shrink below content width */
        }
        
        /* Mobile portrait optimizations */
        body {
            padding: 0;
            font-size: 14px;
        }
        
        .offer-container {
            padding: 16px; /* Match canvas exactly */
            border-radius: 0;
        }
        
        h1, h2, h3 {
            line-height: 1.3;
            margin: 0 0 2px 0;
            /* Preserve original font styles - don't force font-size */
        }
        
        p {
            line-height: 1.4;
            margin: 0 0 8px 0;
            overflow-wrap: break-word;
            /* Preserve original font styles - don't force font-size */
        }
        
        img {
            max-width: 100%;
            height: auto;
            /* Preserve original image dimensions when possible */
        }
        
        /* Ensure images in narrow columns don't become too small */
        .zone img {
            min-width: 80px;
            min-height: 60px;
        }
        
        a, button {
            display: block !important;
            text-align: center !important;
            margin: 0 0 8px 0 !important;
            border-radius: 6px !important;
            text-decoration: none !important;
            font-weight: bold !important;
            min-height: 36px !important;
            line-height: 1.2 !important;
            width: 100% !important;
            box-sizing: border-box !important;
            word-wrap: break-word !important;
            /* Preserve original padding and font-size from element styles */
        }
        
        iframe {
            width: 100% !important;
            max-width: 100% !important;
        }
        
        /* Only apply height override to iframes that are not in responsive video containers */
        iframe:not([style*="position: absolute"]) {
            height: 200px !important;
        }
        

        
        /* Desktop styles */
        @media (min-width: 1025px) {
            .layout-container {
                gap: 24px;
            }
            
            /* Only apply height override to iframes that are not in responsive video containers */
            iframe:not([style*="position: absolute"]) {
                height: 315px !important;
            }
        }
        
        /* Touch-friendly interactive elements */
        a, button {
            cursor: pointer;
            min-height: 44px;
            min-width: 44px;
        }
        
        img {
            max-width: 100%;
            height: auto;
        }
        
        /* FAQ Accordion specific styles */
        .faq-question:hover {
            background-color: rgba(0, 0, 0, 0.06) !important;
        }
        
        .faq-answer {
            transition: all 0.3s ease;
        }
        
        @media (max-width: 768px) {
            .faq-question {
                padding: 12px 8px !important;
            }
            
            .faq-answer {
                padding: 12px !important;
            }
            
            .faq-icon {
                font-size: 20px !important;
            }
        }
        
        /* Accessibility improvements */
        @media (prefers-reduced-motion: reduce) {
            * {
                animation-duration: 0.01ms !important;
                animation-iteration-count: 1 !important;
                transition-duration: 0.01ms !important;
            }
        }
        
        /* Pagination Styles */
        .page-container {
            width: 100%;
            margin-bottom: 40px;
            page-break-after: always;
            break-after: page;
            min-height: ${STANDARD_MOBILE.displayHeight - 16}px;
            display: flex;
            flex-direction: column;
        }
        
        .page-header {
            text-align: center;
            padding: 8px 0;
            margin-bottom: 16px;
            border-bottom: 2px solid #e0e0e0;
            background-color: #f5f5f5;
            border-radius: 8px 8px 0 0;
        }
        
        .page-number {
            font-size: 14px;
            font-weight: bold;
            color: #666;
            background-color: #fff;
            padding: 4px 12px;
            border-radius: 12px;
            border: 1px solid #ddd;
        }
        
        .page-content {
            flex: 1;
            padding: 16px;
            background-color: #fff;
            border-radius: 0 0 8px 8px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        
        /* Print styles for better page breaks */
        @media print {
            .page-container {
                page-break-after: always;
                margin-bottom: 0;
            }
            
            .page-header {
                background-color: transparent !important;
                border-bottom: 1px solid #ccc !important;
            }
        }
    </style>
    <script>
        function toggleFAQItem(faqId, index, iconType) {
            const answer = document.getElementById(faqId + '-answer-' + index);
            const icon = document.getElementById(faqId + '-icon-' + index);
            
            if (answer.style.display === 'none' || answer.style.display === '') {
                answer.style.display = 'block';
                if (icon) {
                    switch(iconType) {
                        case 'expandMore':
                            icon.innerHTML = '▲';
                            break;
                        case 'arrow':
                            icon.innerHTML = '↑';
                            break;
                        case 'arrowDrop':
                            icon.innerHTML = '▲';
                            break;
                        case 'plusMinus':
                        default:
                            icon.innerHTML = '−';
                            break;
                    }
                }
            } else {
                answer.style.display = 'none';
                if (icon) {
                    switch(iconType) {
                        case 'expandMore':
                            icon.innerHTML = '▼';
                            break;
                        case 'arrow':
                            icon.innerHTML = '↓';
                            break;
                        case 'arrowDrop':
                            icon.innerHTML = '▼';
                            break;
                        case 'plusMinus':
                        default:
                            icon.innerHTML = '+';
                            break;
                    }
                }
            }
        }
    </script>
</head>
<body>
    <div class="phone-frame">
        <div class="phone-screen">
            <div class="offer-container">
                ${elementsHTML}
            </div>
        </div>
    </div>
</body>
</html>`;
  }, [elements, pageSettings]);

  // Generate link for hosted page
  const handleGenerateLink = useCallback(async () => {
    if (elements.length === 0) return;

    setGeneratingLink(true);

    try {
      const htmlContent = generateHTML();
      const pageTitle = pageSettings.title || 'My Offer Page';

      const response = await fetch(`${API_URL}/offer-templates/host-page`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          htmlContent,
          pageTitle
        })
      });

      if (response.ok) {
        const data = await response.json();

        // Copy URL to clipboard
        await navigator.clipboard.writeText(data.url);

        // Show success message with the URL
        setStatusTitle('Success');
        setStatusMessage(`✅ Page hosted successfully!\n\n📋 URL copied to clipboard:\n${data.url}\n\nYou can share this link with anyone!`);
        setShowStatusAlert(true);
      } else {
        const errorData = await response.json();
        setStatusTitle('Error');
        setStatusMessage(`❌ Failed to generate link: ${errorData.message || 'Unknown error'}`);
        setShowStatusAlert(true);
      }
    } catch (error) {
      console.error('Error generating link:', error);
      setStatusTitle('Error');
      setStatusMessage('❌ Failed to generate link. Please try again.');
      setShowStatusAlert(true);
    } finally {
      setGeneratingLink(false);
    }
  }, [elements, generateHTML, pageSettings.title]);

  // Standard mobile preview styles (405×878 display, represents 1080×2340 logical)
  const getPreviewStyles = () => {
    switch (previewDevice) {
      case 'mobile':
        // For brands page, use blog editor dimensions (414×750)
        const mobileWidth = isBrandsPage ? 414 : STANDARD_MOBILE.displayWidth;
        const mobileHeight = isBrandsPage ? 750 : STANDARD_MOBILE.displayHeight;

        return {
          width: `${mobileWidth}px`, // 414px for brands page, 405px otherwise
          height: `${mobileHeight}px`, // 750px for brands page, 878px otherwise
          margin: '0 auto',
          backgroundColor: '#1a1a1a', // Phone frame
          borderRadius: '15px', // Scaled down rounded corners
          padding: `${STANDARD_MOBILE.displaySafeAreaTop}px 8px ${STANDARD_MOBILE.displaySafeAreaBottom}px 8px`, // Scaled safe areas
          boxShadow: '0 8px 16px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.1)', // Scaled shadow
          position: 'relative',
          overflow: 'hidden',
          border: '2px solid #333', // Phone frame border
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '12px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '120px', // Realistic notch width
            height: '6px',
            backgroundColor: '#1a1a1a',
            borderRadius: '3px',
            zIndex: 1,
            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.5)'
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '12px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '120px',
            height: '4px',
            backgroundColor: '#1a1a1a',
            borderRadius: '2px',
            zIndex: 1
          }
        };
      case 'desktop':
        return {
          width: '400px', // Realistic desktop width
          height: '600px', // Realistic desktop height
          margin: '0 auto',
          backgroundColor: '#fff',
          borderRadius: '12px',
          border: '1px solid #e0e0e0',
          boxShadow: '0 8px 24px rgba(0,0,0,0.2), 0 2px 8px rgba(0,0,0,0.1)', // Realistic desktop shadow
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            height: '32px',
            backgroundColor: '#f8f9fa',
            borderBottom: '1px solid #e0e0e0',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '16px',
            '&::after': {
              content: '""',
              display: 'flex',
              gap: '8px'
            }
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '8px',
            left: '16px',
            display: 'flex',
            gap: '8px',
            '&::before': {
              content: '""',
              width: '14px',
              height: '14px',
              borderRadius: '50%',
              backgroundColor: '#ff5f56',
              boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.2)'
            },
            '&::after': {
              content: '""',
              width: '14px',
              height: '14px',
              borderRadius: '50%',
              backgroundColor: '#ffbd2e',
              boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.2)'
            }
          }
        };
      case 'tablet':
        return {
          width: '480px', // iPad width
          height: '640px', // iPad height
          margin: '0 auto',
          backgroundColor: '#1a1a1a', // Dark tablet frame
          borderRadius: '24px', // Tablet rounded corners
          padding: '16px 12px', // Tablet bezels
          boxShadow: '0 16px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.1)', // Realistic tablet shadow
          position: 'relative',
          overflow: 'hidden',
          border: '2px solid #333', // Tablet frame border
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '8px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px', // Tablet camera
            height: '4px',
            backgroundColor: '#1a1a1a',
            borderRadius: '2px',
            zIndex: 1
          }
        };
      default: // desktop
        return { maxWidth: '100%' };
    }
  };

  // Get canvas styles with standard mobile frame (375×667 display, or 414×750 for brands page)
  const getCanvasStyles = () => {
    if (previewDevice === 'mobile') {
      return {
        backgroundColor: '#fff', // Match preview white background
        borderRadius: 0, // Match preview (no border radius)
        overflow: 'hidden', // No scrollbar
        minHeight: isBrandsPage ? '750px' : '667px', // Match blog height (750px) for brands page
        height: '100%', // Fill parent frame
        width: '100%', // Full width within frame
        position: 'relative',
        margin: '0 auto', // Center the canvas
        transform: 'scale(1)', // Ensure no additional scaling
        transformOrigin: 'center center',
        display: 'flex',
        flexDirection: 'column'
      };
    } else if (previewDevice === 'tablet') {
      return {
        backgroundColor: pageSettings.backgroundColor,
        borderRadius: '24px', // Match the tablet frame
        overflow: 'visible', // Allow content to expand without scrolling
        minHeight: '640px', // Minimum height to match frame, but can expand
        height: 'auto', // Allow dynamic height expansion
        width: '480px', // Match the tablet frame width
        position: 'relative',
        margin: '0 auto', // Center the canvas
        transform: 'scale(1)', // Ensure no additional scaling
        transformOrigin: 'center center',
        display: 'flex',
        flexDirection: 'column'
      };
    } else if (previewDevice === 'desktop') {
      return {
        backgroundColor: pageSettings.backgroundColor,
        borderRadius: '12px', // Match the desktop frame
        overflow: 'visible', // Allow content to expand without scrolling
        minHeight: '600px', // Minimum height to match frame, but can expand
        height: 'auto', // Allow dynamic height expansion
        width: '400px', // Match the desktop frame width
        position: 'relative',
        margin: '0 auto', // Center the canvas
        transform: 'scale(1)', // Ensure no additional scaling
        transformOrigin: 'center center',
        border: '1px solid #e0e0e0',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)', // Match the desktop shadow
        display: 'flex',
        flexDirection: 'column'
      };
    }
    return {};
  };

  // Helper function to calculate aspect ratio from element styles
  const calculateVideoAspectRatio = (element) => {
    const width = element.styles?.width || '100%';
    const height = element.styles?.height || 225;

    // If width is 100% or auto, use a base width for calculation
    const baseWidth = (width === '100%' || width === 'auto') ? 400 : (typeof width === 'number' ? width : 400);

    // Parse height - handle both number and string (e.g., '315px', '225', 225)
    let heightNum;
    if (typeof height === 'number') {
      heightNum = height;
    } else if (typeof height === 'string') {
      // Remove 'px' or other units and parse
      heightNum = parseInt(height.replace(/px|rem|em|%/, '')) || 225;
    } else {
      heightNum = 225;
    }

    // Ensure height is valid
    if (!heightNum || heightNum <= 0) {
      heightNum = 225; // Default to 16:9 aspect ratio (400/225 ≈ 16/9)
    }

    // Calculate aspect ratio (width:height)
    const aspectRatio = baseWidth / heightNum;

    console.log('📐 calculateVideoAspectRatio:', {
      width,
      height,
      baseWidth,
      heightNum,
      aspectRatio,
      elementStyles: element.styles
    });

    // Convert to common aspect ratio strings
    // Round to nearest common ratio
    if (Math.abs(aspectRatio - 1) < 0.1) {
      return '1/1'; // Square
    } else if (Math.abs(aspectRatio - 16 / 9) < 0.1) {
      return '16/9'; // 16:9
    } else if (Math.abs(aspectRatio - 9 / 16) < 0.1) {
      return '9/16'; // 9:16 (portrait)
    } else if (Math.abs(aspectRatio - 4 / 5) < 0.1) {
      return '4/5'; // 4:5 (portrait)
    } else if (Math.abs(aspectRatio - 4 / 3) < 0.1) {
      return '4/3'; // 4:3
    } else if (Math.abs(aspectRatio - 3 / 4) < 0.1) {
      return '3/4'; // 3:4
    } else {
      // Return calculated ratio as string
      // Simplify the fraction
      const gcd = (a, b) => b === 0 ? a : gcd(b, a % b);
      const divisor = gcd(baseWidth, heightNum);
      const calculatedRatio = `${baseWidth / divisor}/${heightNum / divisor}`;
      console.log('📐 Using calculated ratio:', calculatedRatio);
      return calculatedRatio;
    }
  };

  // Render element for preview mode (mobile-optimized)
  const renderPreviewElement = (element) => {
    switch (element.type) {
      case ELEMENT_TYPES.HEADING:
        return (
          <Box
            sx={{
              ...element.styles,
              mb: 0.25,
              fontSize: { xs: '1.5rem', md: element.styles?.fontSize || '2rem' },
              padding: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                ? element.styles?.padding || '8px 12px'
                : element.styles?.padding || 0,
              borderRadius: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                ? '4px'
                : 0,
              display: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                ? 'inline-block'
                : 'block',
              fontFamily: element.styles?.fontFamily || 'inherit',
              fontWeight: element.styles?.fontWeight || 'inherit',
              textAlign: element.styles?.textAlign || 'inherit',
              color: element.styles?.color || 'inherit',
              backgroundColor: element.styles?.backgroundColor || 'transparent',
              border: element.styles?.border || 'none',
              margin: element.styles?.margin || '0 0 2px 0'
            }}
            dangerouslySetInnerHTML={{ __html: element.content || 'Heading' }}
          />
        );

      case ELEMENT_TYPES.TEXT:
        return (
          <Box
            sx={{
              ...element.styles,
              mb: 0, // Remove bottom margin for inline layout
              whiteSpace: 'pre-wrap',
              fontSize: { xs: '0.875rem', md: element.styles?.fontSize || '1rem' },
              padding: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                ? element.styles?.padding || '8px 12px'
                : element.styles?.padding || 0,
              borderRadius: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                ? '4px'
                : 0,
              display: element.styles?.backgroundColor && element.styles?.backgroundColor !== 'transparent'
                ? 'block'
                : 'block', // Use block for full width
              fontFamily: element.styles?.fontFamily || 'inherit',
              fontWeight: element.styles?.fontWeight || 'inherit',
              textAlign: element.styles?.textAlign || 'inherit',
              color: element.styles?.color || 'inherit',
              backgroundColor: element.styles?.backgroundColor || 'transparent',
              border: element.styles?.border || 'none',
              margin: element.styles?.margin || '0',
              width: '100%', // Take full width of the zone
              wordWrap: 'break-word'
            }}
            dangerouslySetInnerHTML={{ __html: element.content || 'Text content' }}
          />
        );

      case ELEMENT_TYPES.QUOTATION_BLOCK:
        return (
          <Box
            sx={{
              position: 'relative',
              backgroundColor: element.styles?.backgroundColor || '#fce7f3',
              color: element.styles?.color || '#101022',
              borderRadius: element.styles?.borderRadius || '16px',
              padding: element.styles?.padding || '24px 32px 24px 32px',
              mb: 1,
              fontStyle: 'italic',
              minHeight: '120px',
              overflow: 'visible',
              fontSize: element.styles?.fontSize || { xs: '16px', md: '18px' },
              fontWeight: element.styles?.fontWeight || 400,
              lineHeight: element.styles?.lineHeight || 1.5,
              fontFamily: element.styles?.fontFamily || "'Inter', sans-serif",
              ...element.styles
            }}
          >
            {/* Quotation Icon Overlay */}
            <Box
              sx={{
                position: 'absolute',
                top: '-12px',
                left: '12px',
                width: { xs: 36, md: 40 },
                height: { xs: 36, md: 40 },
                background: '#fff',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                zIndex: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '20px', md: '24px' },
                  fontFamily: 'serif',
                  fontWeight: 'bold',
                  color: '#101022',
                  lineHeight: 1
                }}
              >
                &ldquo;
              </Typography>
            </Box>
            {/* Text Content */}
            <Box
              sx={{
                fontStyle: 'italic',
                fontSize: element.styles?.fontSize || { xs: '16px', md: '18px' },
                fontWeight: element.styles?.fontWeight || 400,
                lineHeight: element.styles?.lineHeight || 1.5,
                fontFamily: element.styles?.fontFamily || "'Inter', sans-serif",
                display: 'block'
              }}
              dangerouslySetInnerHTML={{ __html: element.content || 'Quote text here...' }}
            />
          </Box>
        );

      case ELEMENT_TYPES.IMAGE:
        return element.content ? (
          <Box sx={{
            textAlign: 'center',
            mb: 1,
            backgroundColor: element.styles?.backgroundColor || 'transparent',
            padding: element.styles?.padding || '0',
            margin: element.styles?.margin || '0 0 8px 0',
            border: element.styles?.border || 'none',
            borderRadius: element.styles?.borderRadius || '0'
          }}>
            <img
              src={element.content}
              alt={element.alt || 'Image'}
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: element.styles?.borderRadius || '8px',
                border: element.styles?.border || 'none',
                width: element.styles?.width || 'auto',
                height: element.styles?.height || 'auto',
                objectFit: element.styles?.objectFit || 'cover'
              }}
            />
          </Box>
        ) : (
          <Box sx={{
            textAlign: 'center',
            p: { xs: 2, md: 4 },
            backgroundColor: '#f0f0f0',
            borderRadius: 1,
            mb: 1
          }}>
            <Typography variant="body2" color="text.secondary">
              📷 Image placeholder
            </Typography>
          </Box>
        );

      case ELEMENT_TYPES.CROPPABLE_IMAGE:
        const croppableWidth = element.styles?.width || 300;
        const croppableHeight = element.styles?.height || 200;
        return element.croppedImage ? (
          <Box sx={{
            textAlign: 'center',
            mb: 0,
            backgroundColor: element.styles?.backgroundColor || 'transparent',
            padding: element.styles?.padding || '0',
            margin: element.styles?.margin || '0',
            border: element.styles?.border || 'none',
            borderRadius: element.styles?.borderRadius || '0',
            display: 'inline-block'
          }}>
            <img
              src={element.croppedImage}
              alt="Croppable Image"
              style={{
                width: `${croppableWidth}px`,
                height: `${croppableHeight}px`,
                objectFit: 'cover',
                border: element.styles?.border || 'none',
                borderRadius: element.styles?.borderRadius || '8px',
                display: 'block',
                margin: '0'
              }}
            />
          </Box>
        ) : (
          <Box sx={{
            textAlign: 'center',
            p: { xs: 2, md: 4 },
            backgroundColor: '#f0f0f0',
            borderRadius: '8px',
            width: `${croppableWidth}px`,
            height: `${croppableHeight}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0',
            mb: 0
          }}>
            <Typography variant="body2" color="text.secondary">
              📷 Croppable Image
            </Typography>
          </Box>
        );

      case ELEMENT_TYPES.CIRCULAR_IMAGE:
        const circularSize = element.styles?.width || 200;
        return element.croppedImage ? (
          <Box sx={{
            textAlign: 'center',
            mb: 0, // Remove bottom margin for inline layout
            backgroundColor: element.styles?.backgroundColor || 'transparent',
            padding: element.styles?.padding || '0',
            margin: element.styles?.margin || '0',
            border: element.styles?.border || 'none',
            borderRadius: element.styles?.borderRadius || '0',
            display: 'inline-block'
          }}>
            <img
              src={element.croppedImage}
              alt="Circular Image"
              style={{
                width: `${circularSize}px`,
                height: `${circularSize}px`,
                borderRadius: '50%',
                objectFit: 'cover',
                border: element.styles?.border || 'none',
                display: 'block',
                margin: '0'
              }}
            />
          </Box>
        ) : (
          <Box sx={{
            textAlign: 'center',
            p: { xs: 2, md: 4 },
            backgroundColor: '#f0f0f0',
            borderRadius: '50%',
            width: `${circularSize}px`,
            height: `${circularSize}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0',
            mb: 0 // Remove bottom margin for inline layout
          }}>
            <Typography variant="body2" color="text.secondary">
              📷 Circular Image
            </Typography>
          </Box>
        );

      case ELEMENT_TYPES.FITTABLE_IMAGE:
        // Handle responsive frame dimensions
        const getFrameWidth = (styleWidth) => {
          if (styleWidth === "100%" || styleWidth === "auto") {
            return "100%";
          }
          if (typeof styleWidth === 'number') return `${styleWidth}px`;
          if (typeof styleWidth === 'string') {
            const numValue = parseInt(styleWidth, 10);
            return isNaN(numValue) ? "400px" : `${numValue}px`;
          }
          return "400px";
        };

        const getFrameHeight = (styleHeight) => {
          if (styleHeight === "auto") return "300px";
          if (typeof styleHeight === 'number') return `${styleHeight}px`;
          if (typeof styleHeight === 'string') {
            const numValue = parseInt(styleHeight, 10);
            return isNaN(numValue) ? "300px" : `${numValue}px`;
          }
          return "300px";
        };

        const fittableFrameWidth = getFrameWidth(element.styles?.width);
        const fittableFrameHeight = getFrameHeight(element.styles?.height);
        const isFullWidth = element.styles?.width === "100%";
        const fittablePosition = element.imagePosition || { x: 0, y: 0 };
        const fittableScale = element.imageScale || 1;

        // Use imageSrc or fallback to content property
        const imageSource = element.imageSrc || element.content;



        return imageSource ? (
          <Box sx={{
            width: isFullWidth ? '100%' : 'auto',
            textAlign: isFullWidth ? 'left' : 'center',
            mb: 0,
            backgroundColor: element.styles?.backgroundColor || 'transparent',
            padding: element.styles?.padding || '0',
            margin: element.styles?.margin || '0',
            border: element.styles?.border || 'none',
            borderRadius: element.styles?.borderRadius || '0',
            display: isFullWidth ? 'block' : 'inline-block'
          }}>
            <Box sx={{
              position: 'relative',
              width: fittableFrameWidth,
              height: fittableFrameHeight,
              border: 'none',
              borderRadius: '8px',
              overflow: 'hidden',
              backgroundColor: 'transparent',
              margin: isFullWidth ? '0' : 'auto'
            }}>
              <img
                src={imageSource}
                alt="Fittable Image"
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: 0,
                  transform: `translate(-50%, 0) scale(${fittableScale})`,
                  transformOrigin: 'top center',
                  maxWidth: 'none',
                  maxHeight: 'none'
                }}

              />
            </Box>
          </Box>
        ) : (
          <Box sx={{
            textAlign: 'center',
            p: { xs: 2, md: 4 },
            backgroundColor: '#f0f0f0',
            border: 'none',
            borderRadius: '8px',
            width: fittableFrameWidth,
            height: fittableFrameHeight,
            display: 'flex',
            alignItems: 'flex-start', // Match top alignment
            pt: 4, // Add some top padding for the icon/label
            justifyContent: 'center',
            margin: '0',
            mb: 0
          }}>
            <Typography variant="body2" color="text.secondary">
              📷 Fittable Image Frame
            </Typography>
          </Box>
        );

      case ELEMENT_TYPES.LEFT_IMAGE_TEXT:
        const previewAlignment = element.imageAlignment === 'top' ? 'flex-start' :
          element.imageAlignment === 'bottom' ? 'flex-end' : 'center';
        return (
          <Box sx={{
            ...element.styles,
            display: 'flex',
            alignItems: previewAlignment,
            gap: `${element.spacing || 20}px`,
            mb: 1,
            flexWrap: 'wrap'
          }}>
            {/* Circular Image */}
            <Box sx={{
              flexShrink: 0,
              width: `${element.imageSize || 120}px`,
              height: `${element.imageSize || 120}px`
            }}>
              <img
                src={element.content.image}
                alt="Profile image"
                style={{
                  width: `${element.imageSize || 120}px`,
                  height: `${element.imageSize || 120}px`,
                  objectFit: 'cover',
                  borderRadius: '50%',
                  border: '3px solid #e0e0e0',
                  display: 'block'
                }}
                onError={(e) => {
                  if (e.target.src !== 'https://via.placeholder.com/150x150?text=Profile') {
                    e.target.src = 'https://via.placeholder.com/150x150?text=Profile';
                  }
                }}
              />
            </Box>

            {/* Text Content */}
            <Box sx={{ flex: 1, minHeight: '56px', display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{
                color: element.textStyles?.color || 'inherit',
                lineHeight: element.textStyles?.lineHeight || 1.6,
                fontSize: element.textStyles?.fontSize || '16px',
                fontWeight: element.textStyles?.fontWeight || 'normal',
                fontFamily: element.textStyles?.fontFamily || 'inherit',
                textAlign: element.textStyles?.textAlign || 'left',
                backgroundColor: element.textStyles?.backgroundColor || 'transparent',
                padding: element.textStyles?.padding || '0px',
                borderRadius: element.textStyles?.borderRadius || '0px'
              }}>
                {element.content.text}
              </Typography>
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.BUTTON:
        const previewButtonKey = `preview-btn-${element.id}-${JSON.stringify(element.styles)}-${forceRender}`;
        return (
          <Box key={previewButtonKey} sx={{
            textAlign: element.styles?.textAlign || 'center',
            mb: 1,
            backgroundColor: element.styles?.containerBackgroundColor || 'transparent',
            padding: element.styles?.containerPadding || '0',
            margin: element.styles?.containerMargin || '0 0 8px 0',
            border: element.styles?.containerBorder || 'none',
            borderRadius: element.styles?.containerBorderRadius || '0'
          }}>
            <button
              style={{
                backgroundColor: element.styles?.backgroundColor || '#ff6b35',
                color: element.styles?.color || '#ffffff',
                fontWeight: element.styles?.fontWeight || 400,
                fontFamily: element.styles?.fontFamily || 'inherit',
                borderRadius: element.styles?.borderRadius || '4px',
                fontSize: element.styles?.fontSize || '18px',
                padding: element.styles?.padding || '12px 32px',
                width: element.styles?.width || 'auto',
                minHeight: '44px',
                border: element.styles?.border || 'none',
                textTransform: element.styles?.textTransform || 'none',
                display: element.styles?.display || 'inline-block',
                textDecoration: element.styles?.textDecoration || 'none',
                cursor: element.styles?.cursor || 'pointer',
                transition: element.styles?.transition || 'all 0.2s ease',
                boxShadow: element.styles?.boxShadow || '0 2px 4px rgba(0,0,0,0.1)',
                textAlign: element.styles?.textAlign || 'center',
                margin: element.styles?.margin || '0',
                background: element.styles?.background || element.styles?.backgroundColor || '#ff6b35',
                alignItems: element.styles?.alignItems || undefined,
                justifyContent: element.styles?.justifyContent || undefined,
                gap: element.styles?.gap || undefined
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = '0.8';
                e.target.style.transform = 'translateY(-1px)';
                // Only apply hover shadow if no custom shadow is set
                if (!element.styles?.boxShadow) {
                  e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '1';
                e.target.style.transform = 'translateY(0)';
                // Restore original shadow from element.styles or default
                e.target.style.boxShadow = element.styles?.boxShadow || '0 2px 4px rgba(0,0,0,0.1)';
              }}
              onClick={() => {
                if (element.url && element.url !== '#') {
                  window.open(element.url, '_blank');
                }
              }}
            >
              {element.iconLeft === 'cart' && <ShoppingCartIcon sx={{ color: '#d4a000', fontSize: '2.2rem', mr: 1 }} />}
              <span style={{ fontWeight: 'bold', fontSize: element.styles?.fontSize || '2rem', color: element.styles?.color || '#222' }}>
                {element.styles?.textTransform === 'titlecase' && element.content
                  ? element.content.toLowerCase().replace(/\b\w/g, l => l.toUpperCase())
                  : element.content || 'Button'}
              </span>
              {element.iconRight === 'arrow' && <ArrowForwardIcon sx={{ color: '#222', fontSize: '2.2rem', ml: 1 }} />}
            </button>
          </Box>
        );

      case ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY: {
        const previewAspectRatio = calculateVideoAspectRatio(element);

        return (
          <Box
            sx={{
              position: 'relative',
              mb: 2,
              width: 'calc(100% + 32px)',
              maxWidth: 'calc(100% + 32px)',
              mx: -2,
              aspectRatio: previewAspectRatio,
              backgroundColor: '#000',
              borderRadius: 0,
              overflow: 'hidden'
            }}
          >
            {element.videoFile ? (
              <CenteredVideoPlayer
                src={element.videoFile}
                poster={element.thumbnailUrl || undefined}
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  margin: 0,
                  padding: 0
                }}
                videoProps={{ title: 'Uploaded Video' }}
              />
            ) : (
              <Box sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1
              }}>
                <Typography variant="body2" color="text.secondary">
                  🎥 No video uploaded
                </Typography>
              </Box>
            )}

            {/* Centered button at the bottom */}
            <Box
              sx={{
                position: 'absolute',
                bottom: '32px',
                left: element.styles?.textAlign === 'center' ? '50%' : (element.styles?.textAlign === 'right' ? 'auto' : '32px'),
                right: element.styles?.textAlign === 'right' ? '32px' : 'auto',
                transform: element.styles?.textAlign === 'center' ? 'translateX(-50%)' : 'none',
                width: '55%',
                zIndex: 20,
                display: 'flex',
                justifyContent: element.styles?.textAlign === 'center' ? 'center' : (element.styles?.textAlign === 'right' ? 'flex-end' : 'flex-start')
              }}
            >
              <button
                style={{
                  ...(element.styles || {}),
                  width: '100%',
                  height: '44px',
                  minHeight: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  textAlign: 'center',
                  border: element.styles?.border || 'none'
                }}
              >
                {element.content || 'Click Here'}
              </button>
            </Box>
          </Box>
        );
      }

      case ELEMENT_TYPES.VIDEO:
        console.log('🎥 renderPreviewElement VIDEO called for element:', element);

        console.log('🎥 element.videoFile:', element.videoFile);
        console.log('🎥 element.content:', element.content);

        // Calculate aspect ratio from element styles
        const previewAspectRatio = calculateVideoAspectRatio(element);

        console.log('🎥 Preview aspect ratio calculation:', {
          elementStyles: element.styles,
          calculatedAspectRatio: previewAspectRatio,
          width: element.styles?.width,
          height: element.styles?.height
        });

        if (element.videoFile) {
          // Show uploaded video with calculated aspect ratio
          // For brands page, always use full width regardless of preset
          console.log('🎥 Rendering uploaded video:', element.videoFile, 'with aspect ratio:', previewAspectRatio);

          // Remove height/width from element.styles to let the container's aspectRatio handle sizing
          // This prevents conflicting styles from overriding the aspect ratio
          const { height, width, maxWidth, ...otherStyles } = element.styles || {};
          const videoStyles = {
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 0,
            margin: 0,
            padding: 0,
            objectFit: 'contain', // Ensure video fits within container while maintaining aspect ratio
            ...otherStyles
          };

          return (
            <Box sx={{
              textAlign: 'center',
              mb: 2,
              width: 'calc(100% + 32px)',
              maxWidth: 'calc(100% + 32px)',
              aspectRatio: previewAspectRatio,
              mx: -2, // Negative margin to counteract container padding (16px = 2 * 8px)
              px: 0,
              backgroundColor: '#000', // Black background for video container
              borderRadius: 0,
              overflow: 'hidden'
            }}>
              <CenteredVideoPlayer
                src={element.videoFile}
                poster={element.thumbnailUrl || undefined}
                style={videoStyles}
                videoProps={{ title: 'Uploaded Video' }}
              />
            </Box>
          );
        } else {
          // Show placeholder with calculated aspect ratio
          return (
            <Box sx={{
              textAlign: 'center',
              backgroundColor: '#000',
              borderRadius: 0,
              mb: 2,
              width: 'calc(100% + 32px)',
              maxWidth: 'calc(100% + 32px)',
              mx: -2,
              aspectRatio: previewAspectRatio,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Typography variant="body2" color="text.secondary">
                🎥 No video uploaded
              </Typography>
            </Box>
          );
        }

      case ELEMENT_TYPES.MEDIA:
        if (element.mediaUrl) {
          // Check if it's a video or image
          const isMediaVideo = element.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i);
          const mediaAspectRatio = element.styles?.aspectRatio || 'auto';

          if (isMediaVideo) {
            // Render video with aspect ratio
            return (
              <Box sx={{
                textAlign: 'center',
                mb: 2,
                width: '100%',
                maxWidth: '100%',
                aspectRatio: mediaAspectRatio,
                overflow: 'hidden',
                borderRadius: '8px'
              }}>
                <video
                  src={element.mediaUrl}
                  controls
                  poster={element.thumbnailUrl || undefined}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </Box>
            );
          } else {
            // Render image
            return (
              <Box sx={{
                textAlign: 'center',
                mb: 2,
                width: '100%',
                maxWidth: '100%'
              }}>
                <img
                  src={element.mediaUrl}
                  alt="Media"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: '8px'
                  }}
                />
              </Box>
            );
          }
        } else {
          // Show placeholder
          return (
            <Box sx={{
              textAlign: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              mb: 2,
              p: 3,
              border: '2px dashed #ccc'
            }}>
              <Typography variant="body2" color="text.secondary">
                📁 No media uploaded. Click to upload image or video.
              </Typography>
            </Box>
          );
        }

      case ELEMENT_TYPES.HTML:
        return element.content ? (
          <Box sx={{ mb: 2 }}>
            <div dangerouslySetInnerHTML={{ __html: element.content }} />
          </Box>
        ) : (
          <Box sx={{
            p: { xs: 1, md: 2 },
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            mb: 2
          }}>
            <Typography variant="body2" color="text.secondary">
              💻 HTML content will appear here
            </Typography>
          </Box>
        );

      case ELEMENT_TYPES.DIVIDER:
        return (
          <Box sx={{
            height: '1px',
            backgroundColor: '#e0e0e0',
            margin: { xs: '20px 0', md: '30px 0' },
            ...element.styles
          }} />
        );

      case ELEMENT_TYPES.LAYOUT:
        const config = LAYOUT_CONFIGS[element.layoutType];

        // Special handling for INLINE_ROW layout - use same logic as main renderElement
        if (element.layoutType === LAYOUT_TYPES.INLINE_ROW) {
          return (
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                mb: 3,
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                backgroundColor: element.styles?.backgroundColor || 'transparent',
                padding: element.styles?.padding || '16px',
                margin: element.styles?.margin || '0 0 24px 0',
                border: element.styles?.border || 'none',
                borderRadius: element.styles?.borderRadius || '0',
                textAlign: element.styles?.textAlign || 'left',
                fontFamily: element.styles?.fontFamily || 'inherit',
                fontSize: element.styles?.fontSize || 'inherit',
                color: element.styles?.color || 'inherit',
                ...element.styles
              }}
            >
              {element.zones[0].elements.map((zoneElement, index) => (
                <Box key={zoneElement.id} sx={{
                  display: 'inline-block',
                  margin: '0 5px',
                  verticalAlign: 'top',
                  flexShrink: 0
                }}>
                  {renderPreviewElement(zoneElement)}
                </Box>
              ))}
            </Box>
          );
        }

        return (
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 1, md: 2 },
              mb: 3,
              flexDirection: { xs: 'column', md: element.layoutType === LAYOUT_TYPES.THREE_COLUMN ? 'wrap' : 'row' },
              backgroundColor: element.styles?.backgroundColor || 'transparent',
              padding: element.styles?.padding || '16px',
              margin: element.styles?.margin || '0 0 24px 0',
              border: element.styles?.border || 'none',
              borderRadius: element.styles?.borderRadius || '0',
              textAlign: element.styles?.textAlign || 'left',
              fontFamily: element.styles?.fontFamily || 'inherit',
              fontSize: element.styles?.fontSize || 'inherit',
              color: element.styles?.color || 'inherit',
              ...element.styles
            }}
          >
            {element.zones.map((zone, index) => {
              const zoneConfig = config.zones[index];
              return (
                <Box
                  key={zone.id}
                  data-zone-id={zone.id}
                  sx={{
                    width: { xs: '100%', md: zoneConfig.width },
                    textAlign: zoneConfig.textAlign || 'left',
                    p: { xs: 0.5, md: 1 },
                    border: '1px dashed #e0e0e0', // Default border
                    borderRadius: 1,
                    overflow: 'visible', // Let content fit height without scrolling
                    ...getZoneHeightStyle(zone.id, zoneConfig.height || 'auto') // Apply after so it can override border
                  }}
                >

                  {zone.elements.length === 0 ? (
                    <Box sx={{
                      minHeight: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'text.secondary',
                      fontStyle: 'italic'
                    }}>
                      <Typography variant="caption">
                        Empty zone
                      </Typography>
                    </Box>
                  ) : (
                    zone.elements.map((zoneElement) => (
                      <Box key={`${zoneElement.id}-${forceRender}`}>
                        {renderPreviewElement(zoneElement)}
                      </Box>
                    ))
                  )}
                </Box>
              );
            })}
          </Box>
        );

      case ELEMENT_TYPES.CHECKLIST:
        return <Checklist title={element.title} items={element.items} />;

      case ELEMENT_TYPES.COMPARISON_TABLE:

        return (
          <ComparisonTable
            key={`preview-${element.id}-${element.productAImage || 'noA'}-${element.productBImage || 'noB'}`}
            title={element.title}
            productA={element.productA}
            productB={element.productB}
            productAImage={element.productAImage}
            productBImage={element.productBImage}
            rows={element.rows}
            titleStylePreset={element.titleStylePreset}
            productNameStylePreset={element.productNameStylePreset}
            featureTitleStylePreset={element.featureTitleStylePreset}
            featureDescStylePreset={element.featureDescStylePreset}
          />
        );

      case ELEMENT_TYPES.TWO_COLUMN_COMPARISON:
        return (
          <TwoColumnComparisonTable
            key={`preview-${element.id}-${element.leftColumnImage || 'noLeft'}-${element.rightColumnImage || 'noRight'}`}
            leftColumnTitle={element.leftColumnTitle}
            rightColumnTitle={element.rightColumnTitle}
            leftColumnImage={element.leftColumnImage}
            rightColumnImage={element.rightColumnImage}
            leftItems={element.leftItems}
            rightItems={element.rightItems}
            titleStylePreset={element.titleStylePreset}
            itemStylePreset={element.itemStylePreset}
          />
        );

      case ELEMENT_TYPES.BUTTON_WITH_NOTICE:
        const getPreviewVariantStyles = (variant, styleVariant = 'default') => {
          const styleVariants = {
            'urgent-sale': {
              'default': {
                backgroundColor: '#ff69b4', // pink
                noticeColor: '#101022', // black text on pink
                buttonBg: '#101022', // black button
                buttonColor: '#ffffff', // white text on black
                border: 'none',
                borderRadius: '8px'
              },
              'modern': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white (changed from orange/yellow)
                buttonBg: '#ff69b4', // pink button
                buttonColor: '#101022', // black text on pink
                border: '2px solid #ff69b4',
                borderRadius: '12px'
              },
              'minimal': {
                backgroundColor: '#fafafa', // light gray (close to white)
                noticeColor: '#101022', // black text (changed from orange/yellow)
                buttonBg: '#ff69b4', // pink button
                buttonColor: '#101022', // black text on pink
                border: '1px solid #e0e0e0',
                borderRadius: '4px'
              },
              'gradient': {
                backgroundColor: 'linear-gradient(135deg, #ff69b4, #ff1493)', // pink gradient
                noticeColor: '#ffffff', // white text on pink gradient
                buttonBg: '#ffffff', // white button
                buttonColor: '#101022', // black text on white
                border: 'none',
                borderRadius: '16px'
              }
            },
            'membership-quiz': {
              'default': {
                backgroundColor: '#0000ff', // blue
                noticeColor: '#ffffff', // white text on blue
                buttonBg: '#ffffff', // white button
                buttonColor: '#0000ff', // blue text on white
                border: 'none',
                borderRadius: '8px'
              },
              'elegant': {
                backgroundColor: '#000080', // dark blue
                noticeColor: '#ffffff', // white text on dark blue
                buttonBg: '#ffffff', // white button
                buttonColor: '#000080', // dark blue text on white
                border: '2px solid #4169e1',
                borderRadius: '12px'
              },
              'soft': {
                backgroundColor: '#e6f3ff', // light blue
                noticeColor: '#0000ff', // blue text on light blue
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #b3d9ff',
                borderRadius: '8px'
              },
              'corporate': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '2px solid #e0e0e0',
                borderRadius: '6px'
              }
            },
            'media-buzz': {
              'default': {
                backgroundColor: '#ffffff', // white
                noticeColor: '#101022', // black text on white
                buttonBg: '#ffff00', // yellow button
                buttonColor: '#101022', // black text on yellow
                border: '2px dashed #101022',
                borderRadius: '8px'
              },
              'news': {
                backgroundColor: '#f8f9fa', // light gray (close to white)
                noticeColor: '#101022', // black text
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #e0e0e0',
                borderRadius: '8px'
              },
              'viral': {
                backgroundColor: '#ffff00', // yellow
                noticeColor: '#101022', // black text on yellow
                buttonBg: '#101022', // black button
                buttonColor: '#ffffff', // white text on black
                border: '2px solid #ffd700',
                borderRadius: '12px'
              },
              'trending': {
                backgroundColor: '#e6f3ff', // light blue
                noticeColor: '#0000ff', // blue text on light blue
                buttonBg: '#0000ff', // blue button
                buttonColor: '#ffffff', // white text on blue
                border: '1px solid #b3d9ff',
                borderRadius: '10px'
              }
            }
          };

          return styleVariants[variant]?.[styleVariant] || styleVariants[variant]?.['default'] || {
            backgroundColor: '#ff69b4',
            noticeColor: '#101022',
            buttonBg: '#101022',
            buttonColor: '#ffffff',
            border: 'none',
            borderRadius: '8px'
          };
        };

        const previewVariantStyles = getPreviewVariantStyles(element.variant, element.styleVariant);

        // Get custom styles from sub-element styling
        const noticeStyles = element.subElementStyles?.notice || {};
        const callToActionStyles = element.subElementStyles?.callToAction || {};
        const buttonStyles = element.subElementStyles?.button || {};
        const containerStyles = element.styles || {};

        return (
          <Box
            sx={{
              backgroundColor: element.styles?.backgroundColor || previewVariantStyles.backgroundColor,
              background: element.styles?.background || (previewVariantStyles.backgroundColor.includes('gradient')
                ? previewVariantStyles.backgroundColor
                : previewVariantStyles.backgroundColor),
              padding: element.styles?.padding || '20px',
              borderRadius: element.styles?.borderRadius || previewVariantStyles.borderRadius,
              textAlign: element.styles?.textAlign || 'center',
              marginBottom: '16px',
              border: element.styles?.border || previewVariantStyles.border,
              boxShadow: element.styleVariant === 'gradient' ? '0 8px 32px rgba(255, 107, 107, 0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
              margin: element.styles?.margin || '0',
              color: element.styles?.color || previewVariantStyles.noticeColor,
              fontFamily: element.styles?.fontFamily || 'inherit',
              fontSize: element.styles?.fontSize || 'inherit',
              fontWeight: element.styles?.fontWeight || 'inherit',
              ...element.styles
            }}
          >
            {/* Notice Text */}
            <Typography
              variant="body1"
              sx={{
                color: noticeStyles.color || previewVariantStyles.noticeColor,
                fontWeight: noticeStyles.fontWeight || 'bold',
                fontSize: noticeStyles.fontSize || 'inherit',
                fontFamily: noticeStyles.fontFamily || 'inherit',
                textAlign: noticeStyles.textAlign || 'inherit',
                backgroundColor: noticeStyles.backgroundColor || 'transparent',
                padding: noticeStyles.padding || '0',
                margin: noticeStyles.margin || '0 0 16px 0',
                border: noticeStyles.border || 'none',
                borderRadius: noticeStyles.borderRadius || '0',
                marginBottom: '16px',
                lineHeight: 1.5
              }}
            >
              {element.content?.notice?.split('\n').map((line, index) => (
                <span key={index}>
                  {line.includes('70%') ? (
                    <span style={{
                      color: noticeStyles.color || previewVariantStyles.noticeColor,
                      fontWeight: noticeStyles.fontWeight || 'bold'
                    }}>{line}</span>
                  ) : line.includes('exclusive link below') ? (
                    <span>
                      {line.replace('exclusive link below', '')}
                      <span style={{ color: '#1976d2', textDecoration: 'underline' }}>exclusive link below</span>
                    </span>
                  ) : (
                    line
                  )}
                  {index < element.content?.notice?.split('\n').length - 1 && <br />}
                </span>
              ))}
            </Typography>

            {/* Call to Action Text */}
            <Typography
              variant="body1"
              sx={{
                color: callToActionStyles.color || previewVariantStyles.noticeColor,
                fontWeight: callToActionStyles.fontWeight || 'inherit',
                fontSize: callToActionStyles.fontSize || 'inherit',
                fontFamily: callToActionStyles.fontFamily || 'inherit',
                textAlign: callToActionStyles.textAlign || 'inherit',
                backgroundColor: callToActionStyles.backgroundColor || 'transparent',
                padding: callToActionStyles.padding || '0',
                margin: callToActionStyles.margin || '0 0 16px 0',
                border: callToActionStyles.border || 'none',
                borderRadius: callToActionStyles.borderRadius || '0',
                marginBottom: '16px'
              }}
            >
              {element.content?.callToAction}
            </Typography>

            {/* Button */}
            <button
              style={{
                backgroundColor: buttonStyles.backgroundColor || previewVariantStyles.buttonBg,
                color: buttonStyles.color || previewVariantStyles.buttonColor,
                padding: buttonStyles.padding || '16px 32px',
                fontSize: buttonStyles.fontSize || '18px',
                fontWeight: buttonStyles.fontWeight || 'bold',
                fontFamily: buttonStyles.fontFamily || 'inherit',
                border: buttonStyles.border || 'none',
                borderRadius: buttonStyles.borderRadius || '8px',
                cursor: 'pointer',
                width: buttonStyles.width || '100%',
                maxWidth: '400px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
                textAlign: buttonStyles.textAlign || 'center',
                margin: buttonStyles.margin || '0'
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = '0.8';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '1';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              }}
              onClick={() => {
                if (element.content?.buttonUrl && element.content?.buttonUrl !== '#') {
                  window.open(element.content?.buttonUrl, '_blank');
                }
              }}
            >
              {element.content?.buttonText}
            </button>
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_IMAGE_CALLOUT:
        const getPreviewImageCalloutVariantStyles = (variant) => {
          const v = element.variants?.[variant] || {};
          return {
            background: v.background || '#fff',
            textColor: v.textColor || '#222',
            border: v.border || 'none',
            buttonColor: v.buttonColor || '#1976d2',
            badgeColor: v.badgeColor || '#ffcc00',
            badge2Color: v.badge2Color || '#ffcc00',
          };
        };
        const previewImageCalloutStyles = getPreviewImageCalloutVariantStyles(element.variant);

        // Get custom styles from sub-element styling
        const headlineStyles = element.subElementStyles?.headline || {};
        const subheadlineStyles = element.subElementStyles?.subheadline || {};
        const buttonCalloutStyles = element.subElementStyles?.button || {};
        const containerCalloutStyles = element.styles || {};

        return (
          <Box
            sx={{
              background: containerCalloutStyles.backgroundColor || previewImageCalloutStyles.background,
              color: containerCalloutStyles.color || previewImageCalloutStyles.textColor,
              border: containerCalloutStyles.border || previewImageCalloutStyles.border,
              borderRadius: containerCalloutStyles.borderRadius || '16px',
              mb: 2,
              textAlign: containerCalloutStyles.textAlign || 'center',
              p: { xs: 2, md: 4 },
              boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
              padding: containerCalloutStyles.padding || { xs: 2, md: 4 },
              margin: containerCalloutStyles.margin,
              ...containerCalloutStyles
            }}
          >
            {/* Headline */}
            <Typography
              variant="h6"
              sx={{
                color: headlineStyles.color || previewImageCalloutStyles.textColor,
                fontWeight: headlineStyles.fontWeight || 'bold',
                fontSize: headlineStyles.fontSize || 'inherit',
                fontFamily: headlineStyles.fontFamily || 'inherit',
                textAlign: headlineStyles.textAlign || 'inherit',
                backgroundColor: headlineStyles.backgroundColor || 'transparent',
                padding: headlineStyles.padding || '0',
                margin: headlineStyles.margin || '0 0 16px 0',
                border: headlineStyles.border || 'none',
                borderRadius: headlineStyles.borderRadius || '0',
                mb: 2
              }}
            >
              {element.content?.headline}
            </Typography>

            {/* Image and Badges */}
            <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
              <img
                src={element.content?.image}
                alt="callout"
                style={{
                  maxWidth: '260px',
                  width: '100%',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                  background: '#fff',
                  marginBottom: 0
                }}
              />
              {/* Badge 1 */}
              {element.content?.badge && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    background: element.content?.badgeColor || previewImageCalloutStyles.badgeColor,
                    color: '#222',
                    fontWeight: 'bold',
                    borderRadius: '50%',
                    px: 2,
                    py: 1,
                    fontSize: '1rem',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                  }}
                >
                  {element.content?.badge}
                </Box>
              )}
              {/* Badge 2 (for wellamoon) */}
              {element.content?.badge2 && (
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    right: 8,
                    background: element.content?.badge2Color || previewImageCalloutStyles.badge2Color,
                    color: '#222',
                    fontWeight: 'bold',
                    borderRadius: '16px',
                    px: 2,
                    py: 1,
                    fontSize: '0.95rem',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                  }}
                >
                  {element.content?.badge2}
                </Box>
              )}
            </Box>

            {/* Subheadline/Description */}
            {element.content?.subheadline && (
              <Typography
                variant="body1"
                sx={{
                  color: subheadlineStyles.color || previewImageCalloutStyles.textColor,
                  fontWeight: subheadlineStyles.fontWeight || 'inherit',
                  fontSize: subheadlineStyles.fontSize || 'inherit',
                  fontFamily: subheadlineStyles.fontFamily || 'inherit',
                  textAlign: subheadlineStyles.textAlign || 'inherit',
                  backgroundColor: subheadlineStyles.backgroundColor || 'transparent',
                  padding: subheadlineStyles.padding || '8px',
                  margin: subheadlineStyles.margin || '0 0 16px 0',
                  border: subheadlineStyles.border || 'none',
                  borderRadius: subheadlineStyles.borderRadius || '4px',
                  mb: 2,
                  p: 1,
                  borderRadius: 1
                }}
              >
                {element.content?.subheadline?.split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </Typography>
            )}

            {/* Button */}
            <button
              style={{
                backgroundColor: buttonCalloutStyles.backgroundColor || element.content?.buttonColor || previewImageCalloutStyles.buttonColor,
                color: buttonCalloutStyles.color || '#fff',
                padding: buttonCalloutStyles.padding || '18px 0',
                fontSize: buttonCalloutStyles.fontSize || '1.3rem',
                fontWeight: buttonCalloutStyles.fontWeight || 'bold',
                fontFamily: buttonCalloutStyles.fontFamily || 'inherit',
                border: buttonCalloutStyles.border || 'none',
                borderRadius: buttonCalloutStyles.borderRadius || '8px',
                cursor: 'pointer',
                width: buttonCalloutStyles.width || '100%',
                margin: buttonCalloutStyles.margin || '16px 0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
                textAlign: buttonCalloutStyles.textAlign || 'center'
              }}
              onClick={() => {
                if (element.content?.buttonUrl && element.content?.buttonUrl !== '#') {
                  window.open(element.content?.buttonUrl, '_blank');
                }
              }}
            >
              {element.content?.buttonText}
            </button>

            {/* Subheadline Icon (e.g., lock) */}
            {element.content?.subheadlineIcon === 'lock' && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
                <LockIcon fontSize="small" sx={{ color: '#888', mr: 0.5 }} />
                <Typography variant="caption" color="#888">
                  {element.content?.subheadline}
                </Typography>
              </Box>
            )}
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_TEXT_VARIANT:
        const getPreviewTextVariantStyles = (variant) => {
          switch (variant) {
            case 'red-shadow':
              return {
                buttonText: 'Push Me',
                buttonUrl: '#',
                buttonColor: '#f5003c',
                textColor: '#fff',
                fontWeight: 'bold',
                fontSize: '2rem',
                borderRadius: '20px',
                boxShadow: '0 6px 0 #a8002a',
                icon: '',
                iconPosition: 'none',
                padding: '24px 0',
                width: '260px',
                margin: '0 auto'
              };
            case 'orange-rounded':
              return {
                buttonText: 'Add To Cart',
                buttonUrl: '#',
                buttonColor: '#f53c00',
                textColor: '#fff',
                fontWeight: 'normal',
                fontSize: '2rem',
                borderRadius: '32px',
                boxShadow: 'none',
                icon: '',
                iconPosition: 'none',
                padding: '24px 0',
                width: '100%',
                margin: '0 auto'
              };
            case 'yellow-gradient':
              return {
                buttonText: 'Claim Your Supply Now',
                buttonUrl: '#',
                buttonColor: 'linear-gradient(180deg, #ffe066 0%, #ffb347 100%)',
                textColor: '#222',
                fontWeight: 'bold',
                fontSize: '2rem',
                borderRadius: '16px',
                boxShadow: 'none',
                icon: 'cart',
                iconPosition: 'left',
                iconColor: '#d4a000',
                padding: '20px 0',
                width: '100%',
                margin: '0 auto'
              };
            default:
              return {
                buttonText: 'Push Me',
                buttonUrl: '#',
                buttonColor: '#f5003c',
                textColor: '#fff',
                fontWeight: 'bold',
                fontSize: '2rem',
                borderRadius: '20px',
                boxShadow: '0 6px 0 #a8002a',
                icon: '',
                iconPosition: 'none',
                padding: '24px 0',
                width: '260px',
                margin: '0 auto'
              };
          }
        };

        const previewButtonTextVariantStyles = getPreviewTextVariantStyles(element.variant);

        // Get custom styles from sub-element styling
        const buttonTextStyles = element.subElementStyles?.button || {};
        const containerTextStyles = element.styles || {};

        return (
          <Box
            sx={{
              backgroundColor: containerTextStyles.backgroundColor || 'transparent',
              padding: containerTextStyles.padding || '20px',
              borderRadius: containerTextStyles.borderRadius || '8px',
              textAlign: containerTextStyles.textAlign || 'center',
              marginBottom: '16px',
              border: containerTextStyles.border || 'none',
              margin: containerTextStyles.margin,
              ...containerTextStyles
            }}
          >
            {/* Button */}
            <button
              style={{
                backgroundColor: buttonTextStyles.backgroundColor || previewButtonTextVariantStyles.buttonColor,
                color: buttonTextStyles.color || previewButtonTextVariantStyles.textColor,
                padding: buttonTextStyles.padding || previewButtonTextVariantStyles.padding,
                fontSize: buttonTextStyles.fontSize || previewButtonTextVariantStyles.fontSize,
                fontWeight: buttonTextStyles.fontWeight || previewButtonTextVariantStyles.fontWeight,
                fontFamily: buttonTextStyles.fontFamily || 'inherit',
                border: buttonTextStyles.border || 'none',
                borderRadius: buttonTextStyles.borderRadius || previewButtonTextVariantStyles.borderRadius,
                cursor: 'pointer',
                width: buttonTextStyles.width || previewButtonTextVariantStyles.width,
                boxShadow: buttonTextStyles.boxShadow || previewButtonTextVariantStyles.boxShadow || '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
                textAlign: buttonTextStyles.textAlign || 'center',
                margin: buttonTextStyles.margin || previewButtonTextVariantStyles.margin
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = '0.8';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '1';
                e.target.style.transform = 'translateY(0)';
              }}
              onClick={() => {
                if (element.content?.buttonUrl && element.content?.buttonUrl !== '#') {
                  window.open(element.content?.buttonUrl, '_blank');
                }
              }}
            >
              {element.content?.buttonText || previewButtonTextVariantStyles.buttonText}
            </button>
          </Box>
        );

      case ELEMENT_TYPES.BUTTON_HEADLINE_PRODUCT_IMAGE:
        return (
          <Box
            sx={{
              background: element.content?.background || '#ffffff',
              color: element.content?.textColor || '#333333',
              borderRadius: '16px',
              mb: 2,
              textAlign: 'center',
              p: { xs: 2, md: 4 },
              boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
            }}
          >
            {/* Headline */}
            <Typography
              variant="h6"
              sx={{
                color: element.content?.textColor || '#333333',
                fontWeight: 'bold',
                mb: 2
              }}
            >
              {element.content?.headline || 'Amazing Product Offer'}
            </Typography>

            {/* Product Image */}
            <Box sx={{ mb: 2 }}>
              <img
                src={element.content?.productImage || '/api/placeholder/400/300'}
                alt="Product"
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  borderRadius: '8px',
                  border: '2px dashed #e0e0e0'
                }}
              />
            </Box>

            {/* Subheadline */}
            {element.content?.subheadline && (
              <Typography
                variant="body1"
                sx={{
                  color: element.content?.textColor || '#333333',
                  mb: 2
                }}
              >
                {element.content?.subheadline?.split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </Typography>
            )}

            {/* Button */}
            <button
              style={{
                backgroundColor: element.content?.buttonColor || '#4caf50',
                color: '#fff',
                padding: '18px 0',
                fontSize: '1.3rem',
                fontWeight: 'bold',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                width: '100%',
                margin: '16px 0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease'
              }}
              onClick={() => {
                if (element.content?.buttonUrl && element.content?.buttonUrl !== '#') {
                  window.open(element.content?.buttonUrl, '_blank');
                }
              }}
            >
              {element.content?.buttonText || 'Get This Offer Now!'}
            </button>
          </Box>
        );


      case ELEMENT_TYPES.CUSTOM_LIST:
        return (
          <Box sx={{ ...element.styles, mb: 2, position: 'relative', '&:hover .element-controls': { opacity: 1 } }}>
            {element.rows.map((row, idx) => (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, fontFamily: element.styles?.fontFamily, fontSize: element.styles?.fontSize, color: element.styles?.color }}>
                <Box sx={{ mr: 1 }}>{getListIcon(row.icon, idx)}</Box>
                <span style={{
                  ...getPreset(element.textStylePreset || 'paragraph1'),
                  fontFamily: getPreset(element.textStylePreset || 'paragraph1')?.fontFamily || element.styles?.fontFamily || 'inherit',
                  fontSize: getPreset(element.textStylePreset || 'paragraph1')?.fontSize || element.styles?.fontSize || 'inherit',
                  color: getPreset(element.textStylePreset || 'paragraph1')?.color || element.styles?.color || 'inherit',
                  fontWeight: getPreset(element.textStylePreset || 'paragraph1')?.fontWeight || 'inherit',
                  lineHeight: getPreset(element.textStylePreset || 'paragraph1')?.lineHeight || 'inherit',
                  letterSpacing: getPreset(element.textStylePreset || 'paragraph1')?.letterSpacing || 'inherit',
                  textAlign: getPreset(element.textStylePreset || 'paragraph1')?.textAlign || 'inherit'
                }}>{row.text}</span>
              </Box>
            ))}
          </Box>
        );

      case ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE:
        return (
          <Box sx={{ ...element.styles, mb: 2, position: 'relative', '&:hover .element-controls': { opacity: 1 } }}>
            {element.rows.map((row, idx) => (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                <Box sx={{ mr: 1, mt: 0.5 }}>{getListIcon(row.icon, idx)}</Box>
                <Box sx={{ flex: 1 }}>
                  <Box style={{
                    ...getPreset(element.textStylePreset1 || 'subheading1'),
                    fontFamily: getPreset(element.textStylePreset1 || 'subheading1')?.fontFamily || element.styles?.fontFamily || 'inherit',
                    fontSize: getPreset(element.textStylePreset1 || 'subheading1')?.fontSize || element.styles?.fontSize || 'inherit',
                    color: element.styles?.color || getPreset(element.textStylePreset1 || 'subheading1')?.color || 'inherit',
                    fontWeight: getPreset(element.textStylePreset1 || 'subheading1')?.fontWeight || 'inherit',
                    lineHeight: getPreset(element.textStylePreset1 || 'subheading1')?.lineHeight || 'inherit',
                    letterSpacing: getPreset(element.textStylePreset1 || 'subheading1')?.letterSpacing || 'inherit',
                    textAlign: getPreset(element.textStylePreset1 || 'subheading1')?.textAlign || 'inherit',
                    marginBottom: '4px'
                  }}>{row.text1}</Box>
                  <Box style={{
                    ...getPreset(element.textStylePreset2 || 'paragraph1'),
                    fontFamily: getPreset(element.textStylePreset2 || 'paragraph1')?.fontFamily || element.styles?.fontFamily || 'inherit',
                    fontSize: getPreset(element.textStylePreset2 || 'paragraph1')?.fontSize || element.styles?.fontSize || 'inherit',
                    color: element.styles?.color || getPreset(element.textStylePreset2 || 'paragraph1')?.color || 'inherit',
                    fontWeight: getPreset(element.textStylePreset2 || 'paragraph1')?.fontWeight || 'inherit',
                    lineHeight: getPreset(element.textStylePreset2 || 'paragraph1')?.lineHeight || 'inherit',
                    letterSpacing: getPreset(element.textStylePreset2 || 'paragraph1')?.letterSpacing || 'inherit',
                    textAlign: getPreset(element.textStylePreset2 || 'paragraph1')?.textAlign || 'inherit'
                  }}>{row.text2}</Box>
                </Box>
              </Box>
            ))}
          </Box>
        );

      case ELEMENT_TYPES.TIMELINE_LIST:
        return (
          <Box sx={{
            ...element.styles,
            mb: 2,
            position: 'relative',
            '&:hover .element-controls': { opacity: 1 }
          }}>
            {element.steps.map((step, idx) => (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                <Box sx={{ mr: 2, display: 'flex', alignItems: 'center', flexDirection: 'column', position: 'relative' }}>
                  <Box
                    sx={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: step.dotColor,
                      mb: 1,
                      zIndex: 2,
                      position: 'relative'
                    }}
                  />
                  {idx < element.steps.length - 1 && (
                    <Box
                      sx={{
                        width: '2px',
                        height: '60px',
                        backgroundColor: '#e0e0e0',
                        position: 'absolute',
                        top: '32px',
                        left: '11px',
                        zIndex: 1
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: step.stageLabelColor,
                      fontWeight: 'bold',
                      mb: 1
                    }}
                  >
                    {step.stageLabel}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      mb: 1
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography variant="body1">
                    {step.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        );

      case ELEMENT_TYPES.PROCESS_STEPS:
        return (
          <Box sx={{
            ...element.styles,
            mb: 2,
            position: 'relative',
            '&:hover .element-controls': { opacity: 1 }
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {element.steps.map((step, idx) => (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 3 }}>
                  {/* Image with Numbered Badge */}
                  <Box sx={{ flexShrink: 0, width: '150px', position: 'relative' }}>
                    <img
                      src={step.image}
                      alt={`Step ${step.number}`}
                      style={{
                        width: '100%',
                        height: '120px',
                        objectFit: 'cover',
                        borderRadius: '12px',
                        border: '1px solid #e0e0e0'
                      }}
                      onError={(e) => {
                        if (e.target.src !== `https://via.placeholder.com/150x120?text=Step+${step.number}`) {
                          e.target.src = `https://via.placeholder.com/150x120?text=Step+${step.number}`;
                        }
                      }}
                    />

                    {/* Numbered Badge - Top Right Corner */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: step.numberColor || '#1976d2',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        border: '3px solid white',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        zIndex: 1
                      }}
                    >
                      {step.number}
                    </Box>
                  </Box>

                  {/* Content Area */}
                  <Box sx={{ flex: 1, pt: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: 'inherit' }}>
                      {step.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'inherit' }}>
                      {step.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE:
        return (
          <Box sx={{
            ...element.styles,
            mb: 2,
            position: 'relative',
            '&:hover .element-controls': { opacity: 1 }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              {/* Text Content */}
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'inherit' }}>
                  {element.content.text}
                </Typography>
              </Box>

              {/* Image */}
              <Box sx={{ flexShrink: 0, width: '180px' }}>
                <img
                  src={element.content.image}
                  alt="Right side image"
                  style={{
                    width: '100%',
                    height: '120px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0'
                  }}
                  onError={(e) => {
                    if (e.target.src !== 'https://via.placeholder.com/180x120?text=Image') {
                      e.target.src = 'https://via.placeholder.com/180x120?text=Image';
                    }
                  }}
                />
              </Box>
            </Box>
          </Box>
        );

      case ELEMENT_TYPES.FAQ_ACCORDION:
        return (
          <FAQAccordion
            title={element.title}
            items={element.items}
            iconType={element.iconType || 'plusMinus'}
            iconColor={element.iconColor || '#36C3D6'}
            iconSize={element.iconSize || 'large'}
            showIcon={element.showIcon !== false}
            textAlign={element.textAlign || 'left'}
            containerBackgroundColor={element.containerBackgroundColor || 'transparent'}
            questionBackgroundColor={element.questionBackgroundColor || 'transparent'}
            answerBackgroundColor={element.answerBackgroundColor || 'rgba(0, 0, 0, 0.02)'}
            questionTextColor={element.questionTextColor || '#4B329A'}
            answerTextColor={element.answerTextColor || '#4B329A'}
            titleTextColor={element.titleTextColor || 'primary'}
            showDivider={element.showDivider !== false}
            dividerColor={element.dividerColor || '#C1A7F1'}
            itemBorderRadius={element.itemBorderRadius || '4px'}
            itemSpacing={element.itemSpacing || '12px'}
            questionPadding={element.questionPadding || '16px'}
            answerPadding={element.answerPadding || '16px'}
          />
        );

      default:
        return null;
    }
  };

  // Mobile toolbar component
  const MobileToolbar = () => (
    <Card sx={{
      position: 'fixed',
      bottom: 16,
      left: 16,
      right: 16,
      zIndex: 1000,
      display: { xs: 'block', md: 'none' }
    }}>
      <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'space-between' }}>
          <IconButton
            size="small"
            onClick={() => setMobileDrawerOpen(true)}
            color="primary"
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              size="small"
              onClick={() => {
                if (previewDevice === 'mobile') setPreviewDevice('tablet');
                else if (previewDevice === 'tablet') setPreviewDevice('desktop');
                else setPreviewDevice('mobile');
              }}
              color={previewDevice === 'mobile' ? 'primary' : previewDevice === 'tablet' ? 'secondary' : 'default'}
              title={
                previewDevice === 'mobile' ? 'Switch to Tablet' :
                  previewDevice === 'tablet' ? 'Switch to Desktop' :
                    'Switch to Phone'
              }
            >
              {previewDevice === 'mobile' ? <PhoneIcon /> :
                previewDevice === 'tablet' ? <TabletIcon /> :
                  <ComputerIcon />}
            </IconButton>

            {/* Add Page Button - Always visible */}
            <IconButton
              size="small"
              onClick={addPage}
              color="primary"
              title="Add page"
            >
              <AddIcon />
            </IconButton>
          </Box>

          <IconButton
            size="small"
            onClick={() => {
              const html = generateHTML();
              const blob = new Blob([html], { type: 'text/html' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              const filename = paginationEnabled && pages.length > 1
                ? `${pageSettings.title.replace(/\s+/g, '_')}_${pages.length}pages.html`
                : `${pageSettings.title.replace(/\s+/g, '_')}.html`;
              a.download = filename;
              a.click();
              URL.revokeObjectURL(url);
            }}
            color="secondary"
          >
            <ExportIcon />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );

  const renderElement = (element, index) => {
    const isSelected = selectedElement?.id === element.id;
    if (element.type === ELEMENT_TYPES.FAQ_ACCORDION) {
      return (
        <Box key={element.id || index} sx={{ mb: 2 }}>
          <FAQAccordion
            title={element.title}
            items={element.items}
            iconType={element.iconType || 'plusMinus'}
            iconColor={element.iconColor || '#36C3D6'}
            iconSize={element.iconSize || 'large'}
            showIcon={element.showIcon !== false}
            textAlign={element.textAlign || 'left'}
            containerBackgroundColor={element.containerBackgroundColor || 'transparent'}
            questionBackgroundColor={element.questionBackgroundColor || 'transparent'}
            answerBackgroundColor={element.answerBackgroundColor || 'rgba(0, 0, 0, 0.02)'}
            questionTextColor={element.questionTextColor || '#4B329A'}
            answerTextColor={element.answerTextColor || '#4B329A'}
            titleTextColor={element.titleTextColor || 'primary'}
            showDivider={element.showDivider !== false}
            dividerColor={element.dividerColor || '#C1A7F1'}
            itemBorderRadius={element.itemBorderRadius || '4px'}
            itemSpacing={element.itemSpacing || '12px'}
            questionPadding={element.questionPadding || '16px'}
            answerPadding={element.answerPadding || '16px'}
          />
        </Box>
      );
    }
    if (element.type === ELEMENT_TYPES.COMPARISON_TABLE) {
      return (
        <Box key={element.id || index} sx={{ mb: 2 }}>
          <ComparisonTable
            title={element.title}
            productA={element.productA}
            productB={element.productB}
            rows={element.rows}
          />
        </Box>
      );
    }

    return (
      <Paper
        key={element.id}
        elevation={isSelected ? 3 : 1}
        sx={{
          p: 2,
          mb: 1,
          border: isSelected ? '3px solid #4caf50' : '1px solid #e0e0e0',
          backgroundColor: isSelected ? '#f1f8e9' : 'white',
          position: 'relative',
          cursor: 'pointer',
          '&:hover': {
            borderColor: isSelected ? '#4caf50' : '#1976d2',
            backgroundColor: isSelected ? '#f1f8e9' : '#f5f5f5'
          }
        }}
        onClick={(e) => {
          // Only select element if click is not on control buttons
          if (!e.target.closest('.MuiIconButton-root')) {
            console.log('📦 Paper wrapper clicked - selecting element:', element.id);
            console.log('📦 Event target:', e.target);
            console.log('📦 Before selection - selectedElement:', selectedElement?.id);
            setSelectedElement(element);
            setSelectedElementContext({ isInZone: false, layoutId: null, zoneId: null });
            setSelectedSubElement(null); // Clear sub-element selection when selecting whole element
            setTabValue(1); // Set to Style tab
            setRightPanelOpen(true); // Ensure right panel is open
            console.log('📦 After selection calls made');
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, backgroundColor: '#f8f9fa', borderRadius: 1, p: 1 }}>
          <Typography variant="caption" sx={{ flexGrow: 1, fontWeight: 'bold', color: '#1976d2' }}>
            {element.type.toUpperCase()} #{index + 1}
          </Typography>

          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setTabValue(2); // Go to "Add new element" tab
              setRightPanelOpen(true);
            }}
            title="Add new element"
            sx={{
              backgroundColor: '#4caf50',
              color: 'white',
              '&:hover': { backgroundColor: '#388e3c' },
              mr: 0.5
            }}
          >
            <AddIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              moveElement(element.id, 'up');
            }}
            disabled={index === 0}
            title="Move Up"
            sx={{
              backgroundColor: 'white',
              '&:hover': { backgroundColor: '#e3f2fd' },
              mr: 0.5
            }}
          >
            <MoveUpIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              moveElement(element.id, 'down');
            }}
            disabled={index === elements.length - 1}
            title="Move Down"
            sx={{
              backgroundColor: 'white',
              '&:hover': { backgroundColor: '#e3f2fd' },
              mr: 0.5
            }}
          >
            <MoveDownIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              // Duplicate the current element
              const duplicatedElement = {
                ...element,
                id: generateId(),
                content: element.content ? `${element.content} (copy)` : element.content,
                title: element.title ? `${element.title} (copy)` : element.title,
                rows: element.rows ? element.rows.map(row => ({
                  ...row,
                  text: `${row.text} (copy)`
                })) : element.rows,
                items: element.items ? element.items.map(item => ({
                  ...item,
                  question: item.question ? `${item.question} (copy)` : item.question,
                  answer: item.answer ? `${item.answer} (copy)` : item.answer
                })) : element.items,
                steps: element.steps ? element.steps.map(step => ({
                  ...step,
                  title: step.title ? `${step.title} (copy)` : step.title,
                  description: step.description ? `${step.description} (copy)` : step.description
                })) : element.steps
              };

              // Insert the duplicated element below the current one
              setElements(prev => {
                const insertIndex = index + 1; // Insert below current element
                const newElements = [...prev];
                newElements.splice(insertIndex, 0, duplicatedElement);
                return newElements;
              });
            }}
            title="Duplicate Element"
            sx={{
              backgroundColor: 'white',
              '&:hover': { backgroundColor: '#e8f5e8', color: '#4caf50' },
              mr: 0.5
            }}
          >
            <DuplicateIcon fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              deleteElement(element.id);
            }}
            title="Delete Element"
            sx={{
              backgroundColor: 'white',
              '&:hover': { backgroundColor: '#ffebee', color: '#d32f2f' }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ minHeight: '40px' }}>
          {element.type === ELEMENT_TYPES.LAYOUT ? (
            <Box
              sx={{
                backgroundColor: element.styles?.backgroundColor || 'transparent',
                margin: element.styles?.margin || '0 0 16px 0',
                ...element.styles,
                p: 0, // Force zero padding - override any saved padding
                ...(isBrandsPage && {
                  border: 'none', // Force no border in brands page
                  borderRadius: 0 // Force no border radius in brands page
                })
              }}
            >
              {!isBrandsPage && (
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  📐 Layout: {LAYOUT_CONFIGS[element.layoutType]?.name}
                </Typography>
              )}
              <Box sx={{
                display: 'flex',
                gap: 0,
                flexWrap: element.layoutType === LAYOUT_TYPES.THREE_COLUMN ? 'wrap' : 'nowrap'
              }}>
                {element.zones.map((zone, zoneIndex) => (
                  <Box
                    key={zone.id}
                    data-zone-id={zone.id}
                    sx={{
                      width: zone.width,
                      border: isBrandsPage ? 'none' : '1px dashed #ccc', // No border in brands page
                      borderRadius: isBrandsPage ? 0 : 1,
                      p: 0,
                      backgroundColor: dragOverZone?.zoneId === zone.id ? '#e3f2fd' : pageSettings.backgroundColor,
                      textAlign: zone.textAlign || 'left',
                      position: 'relative',
                      overflow: 'visible', // Let content fit height without scrolling
                      ...getZoneHeightStyle(zone.id, zone.height || '60px') // Apply after so it can override border
                    }}
                    onDragOver={(e) => handleDragOver(e, { layoutId: element.id, zoneId: zone.id })}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, element.id, zone.id)}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      {!isBrandsPage && (
                        <Typography variant="caption" color="text.secondary">
                          Zone {zoneIndex + 1} ({zone.elements.length} items)
                        </Typography>
                      )}
                      {!isBrandsPage && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleZoneHeight(zone.id);
                          }}
                          title={getHeightTooltip(zone.id)}
                          sx={{
                            fontSize: '12px',
                            minWidth: '20px',
                            width: '20px',
                            height: '20px',
                            backgroundColor: 'rgba(25, 118, 210, 0.1)',
                            '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.2)' }
                          }}
                        >
                          {getExpandIcon(zone.id)}
                        </IconButton>
                      )}
                    </Box>

                    {zone.elements.length === 0 && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        Drop elements here
                      </Typography>
                    )}
                    {zone.elements.map((zoneElement, elemIndex) => (
                      <Box
                        key={zoneElement.id}
                        sx={{
                          mt: 1,
                          p: 1,
                          backgroundColor: 'white',
                          borderRadius: 1,
                          border: '1px solid #e0e0e0',
                          position: 'relative',
                          '&:hover .element-controls': {
                            opacity: 1
                          }
                        }}
                      >
                        {/* Element controls */}
                        <Box
                          className="element-controls"
                          sx={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            opacity: 0,
                            transition: 'opacity 0.2s',
                            display: 'flex',
                            gap: 0.5,
                            zIndex: 1
                          }}
                        >
                          <IconButton
                            size="small"
                            sx={{
                              backgroundColor: 'rgba(255,255,255,0.9)',
                              '&:hover': { backgroundColor: 'white' }
                            }}
                            onClick={() => {
                              // Duplicate element in zone
                              const duplicatedElement = {
                                ...zoneElement,
                                id: generateId(),
                                content: zoneElement.content ? `${zoneElement.content} (copy)` : zoneElement.content,
                                title: zoneElement.title ? `${zoneElement.title} (copy)` : zoneElement.title,
                                rows: zoneElement.rows ? zoneElement.rows.map(row => ({
                                  ...row,
                                  text: `${row.text} (copy)`
                                })) : zoneElement.rows,
                                items: zoneElement.items ? zoneElement.items.map(item => ({
                                  ...item,
                                  question: item.question ? `${item.question} (copy)` : item.question,
                                  answer: item.answer ? `${item.answer} (copy)` : item.answer
                                })) : zoneElement.items,
                                steps: zoneElement.steps ? zoneElement.steps.map(step => ({
                                  ...step,
                                  title: step.title ? `${step.title} (copy)` : step.title,
                                  description: step.description ? `${step.description} (copy)` : step.description
                                })) : zoneElement.steps
                              };

                              // Find current element index and insert duplicate below
                              const currentIndex = zone.elements.findIndex(el => el.id === zoneElement.id);
                              const insertIndex = currentIndex + 1;
                              const newZoneElements = [...zone.elements];
                              newZoneElements.splice(insertIndex, 0, duplicatedElement);

                              // Update the zone with the duplicated element
                              setElements(prev =>
                                findAndUpdateLayout(prev, element.id, zone.id, (updatedZone) => ({
                                  ...updatedZone,
                                  elements: newZoneElements
                                }))
                              );
                            }}
                            title="Duplicate element"
                          >
                            <DuplicateIcon fontSize="small" />
                          </IconButton>
                          {/* Split Page Here button - only in editing mode with pagination enabled */}
                          {isEditingMode && paginationEnabled && (
                            <IconButton
                              size="small"
                              sx={{
                                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                                '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.2)' }
                              }}
                              onClick={() => splitPageAtElement(zoneElement.id)}
                              title="Split page here"
                            >
                              <CallSplitIcon fontSize="small" />
                            </IconButton>
                          )}
                          <IconButton
                            size="small"
                            sx={{
                              backgroundColor: 'rgba(255,255,255,0.9)',
                              '&:hover': { backgroundColor: 'white' }
                            }}
                            onClick={() => {
                              // Remove element from zone (supports deeply nested layouts)
                              deleteElementFromZone(zoneElement.id, element.id, zone.id);
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        {/* Inline editable element */}
                        {renderInlineEditableElement(zoneElement, true, element.id, zone.id)}
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            </Box>
          ) : (
            renderInlineEditableElement(element, false)
          )}
        </Box>
      </Paper>
    );
  };

  const elementLibrary = [
    { type: ELEMENT_TYPES.HEADING, icon: TitleIcon, label: 'Heading', desc: 'Main titles and headers' },
    { type: ELEMENT_TYPES.TEXT, icon: TextIcon, label: 'Text', desc: 'Paragraphs and descriptions' },
    { type: ELEMENT_TYPES.BUTTON, icon: ButtonIcon, label: 'Button', desc: 'Call-to-action buttons' },
    { type: ELEMENT_TYPES.FITTABLE_IMAGE, icon: ImageIcon, label: 'Fittable Image', desc: 'Upload image and position it within a fixed frame' },
    { type: ELEMENT_TYPES.VIDEO, icon: VideoIcon, label: 'Video', desc: 'YouTube and video embeds' },
    { type: ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY, icon: VideoIcon, label: 'Video with button overlay', desc: 'Video with interactive clickable buttons' },

    { type: ELEMENT_TYPES.QUOTATION_BLOCK, icon: TextIcon, label: 'Quotation Block', desc: 'Stylish quote/testimonial block with light pink background' },
    { type: ELEMENT_TYPES.CHECKLIST, icon: VerifiedIcon, label: 'Checklist' },

    { type: ELEMENT_TYPES.CUSTOM_LIST, icon: ListIcon, label: 'Custom List', desc: 'List with icons, editable rows, and background' },
    { type: ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE, icon: ListIcon, label: 'Two-Line List', desc: 'List with icons, titles, and descriptions - perfect for feature lists' },
    { type: ELEMENT_TYPES.TIMELINE_LIST, icon: TimelineIcon, label: 'Timeline List', desc: 'Step-by-step timeline with stages and descriptions' },
    { type: ELEMENT_TYPES.PROCESS_STEPS, icon: TimelineIcon, label: 'Process Steps', desc: 'Visual step-by-step process with numbered circles and images' },

    { type: ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE, icon: ImageIcon, label: 'Text + Right Image', desc: 'Text content with image positioned on the right' },
    { type: ELEMENT_TYPES.LEFT_IMAGE_TEXT, icon: ImageIcon, label: 'Left Image + Text', desc: 'Circular image on left with editable text on right' },
    { type: ELEMENT_TYPES.CIRCULAR_IMAGE, icon: ImageIcon, label: 'Circular Image', desc: 'Upload and crop a circular image' },
    { type: ELEMENT_TYPES.CROPPABLE_IMAGE, icon: ImageIcon, label: 'Croppable Image', desc: 'Upload and crop rectangular images' },

    { type: ELEMENT_TYPES.FAQ_ACCORDION, icon: InfoIcon, label: 'FAQ Accordion', desc: 'Expandable FAQ/accordion list' },
    { type: ELEMENT_TYPES.COMPARISON_TABLE, icon: InfoIcon, label: 'Comparison Table', desc: '3-column comparison table' },
    { type: ELEMENT_TYPES.TWO_COLUMN_COMPARISON, icon: InfoIcon, label: 'Two Column Comparison', desc: 'Side-by-side comparison with pros/cons' },
  ];

  // Custom Elements Library - Grouped structure from the image
  const customElementsLibrary = useMemo(() => [
    {
      id: 'faq-accordion',
      label: 'common questions',
      desc: 'Expandable FAQ/accordion list',
      icon: InfoIcon,
      category: 'FAQ',
      elements: [DEFAULT_ELEMENTS[ELEMENT_TYPES.FAQ_ACCORDION]]
    },
    // Buttons Group
    {
      id: 'button-with-notice',
      label: 'Button w/notice',
      desc: 'Button with notice text',
      icon: ButtonIcon,
      category: 'Buttons',
      elements: buttonNoticeTemplates.length > 0 ? [
        {
          id: generateId(),
          type: 'BUTTON_WITH_NOTICE',
          variant: 'default',
          styleVariant: 'default',
          variants: buttonNoticeTemplates.reduce((acc, template) => {
            const variant = template.elements[0]?.variant || template.name.toLowerCase().replace(/\s+/g, '-');
            acc[variant] = template.elements[0]?.content || {};
            return acc;
          }, {}),
          content: {
            notice: 'Special Notice',
            callToAction: 'Take action now!',
            buttonText: 'Click Here',
            buttonUrl: '#'
          },
          styles: {
            backgroundColor: '#fce4ec',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center'
          }
        }
      ] : [
        {
          id: generateId(),
          type: 'BUTTON_WITH_NOTICE',
          variant: 'default',
          styleVariant: 'default',
          variants: {},
          content: {
            notice: 'Loading templates...',
            callToAction: 'Please wait...',
            buttonText: 'Loading...',
            buttonUrl: '#'
          },
          styles: {
            backgroundColor: '#f5f5f5',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'button-with-image-callout',
      label: 'Button w/Image Call out',
      desc: 'Button with image and callout badge',
      icon: ButtonIcon,
      category: 'Buttons',
      elements: buttonImageCalloutTemplates.length > 0 ? [
        {
          id: generateId(),
          type: 'BUTTON_IMAGE_CALLOUT',
          variant: 'default',
          variants: buttonImageCalloutTemplates.reduce((acc, template) => {
            const variant = template.elements[0]?.variant || template.name.toLowerCase().replace(/\s+/g, '-');
            acc[variant] = template.elements[0]?.content || {};
            return acc;
          }, {}),
          content: {
            headline: 'Button w/Image Call out',
            image: '/api/placeholder/400/300',
            badge: '',
            badgeColor: '#4caf50',
            buttonText: 'Click Here',
            buttonUrl: '#',
            buttonColor: '#4caf50',
            subheadline: '',
            subheadlineIcon: '',
            background: '#ffffff',
            textColor: '#333333'
          },
          styles: {
            borderRadius: '16px',
            marginBottom: '20px',
            textAlign: 'center'
          }
        }
      ] : [
        {
          id: generateId(),
          type: 'BUTTON_IMAGE_CALLOUT',
          variant: 'default',
          variants: {},
          content: {
            headline: 'Loading templates...',
            image: '/api/placeholder/400/300',
            badge: '',
            badgeColor: '',
            buttonText: 'Loading...',
            buttonUrl: '#',
            buttonColor: '#4caf50',
            subheadline: '',
            subheadlineIcon: '',
            background: '#f5f5f5',
            textColor: '#333333'
          },
          styles: {
            borderRadius: '16px',
            marginBottom: '20px',
            textAlign: 'center'
          }
        }
      ]
    },

    {
      id: 'button-with-text',
      label: 'Button w/text',
      desc: 'Single button with text and style variants',
      icon: ButtonIcon,
      category: 'Buttons',
      elements: buttonTextTemplates.length > 0 ? [
        {
          id: generateId(),
          type: 'BUTTON_TEXT_VARIANT',
          variant: 'default',
          variants: buttonTextTemplates.reduce((acc, template) => {
            const variant = template.elements[0]?.variant || template.name.toLowerCase().replace(/\s+/g, '-');
            acc[variant] = template.elements[0]?.content || {};
            return acc;
          }, {}),
          content: {
            buttonText: 'Button Text',
            buttonUrl: '#',
            buttonColor: '#4caf50',
            textColor: '#ffffff',
            fontWeight: 'normal',
            fontSize: '1rem',
            borderRadius: '8px',
            boxShadow: 'none',
            icon: '',
            iconPosition: 'none',
            padding: '16px 32px',
            width: 'auto',
            margin: '0 auto'
          },
          styles: {
            marginBottom: '20px',
            textAlign: 'center'
          }
        }
      ] : [
        {
          id: generateId(),
          type: 'BUTTON_TEXT_VARIANT',
          variant: 'default',
          variants: {},
          content: {
            buttonText: 'Loading...',
            buttonUrl: '#',
            buttonColor: '#f5f5f5',
            textColor: '#333333',
            fontWeight: 'normal',
            fontSize: '1rem',
            borderRadius: '8px',
            boxShadow: 'none',
            icon: '',
            iconPosition: 'none',
            padding: '16px 32px',
            width: 'auto',
            margin: '0 auto'
          },
          styles: {
            marginBottom: '20px',
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'button-headline-product-image',
      label: 'Button + headline + Product Image',
      desc: 'Complete button section with headline and product image',
      icon: ButtonIcon,
      category: 'Buttons',
      elements: [
        {
          id: generateId(),
          type: 'BUTTON_HEADLINE_PRODUCT_IMAGE',
          variant: 'default',
          variants: {},
          content: {
            headline: 'Amazing Product Offer',
            productImage: 'https://images.unsplash.com/photo-1584361853901-dd1904265ba8?w=400&h=300&fit=crop&q=80',
            buttonText: 'Get This Offer Now!',
            buttonUrl: '#',
            buttonColor: '#4caf50',
            subheadline: 'Limited time offer - Don\'t miss out!',
            background: '#ffffff',
            textColor: '#333333'
          },
          styles: {
            borderRadius: '16px',
            marginBottom: '20px',
            textAlign: 'center',
            padding: '20px'
          }
        }
      ]
    },

    // Lists Group
    {
      id: 'list-bad-things',
      label: 'List - Bad things',
      desc: 'List of negative points',
      icon: TextIcon,
      category: 'Lists',
      elements: [
        {
          type: 'text',
          content: '• Expensive compared to alternatives',
          styles: { fontSize: '16px', color: '#d32f2f', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: '• Not available in all regions',
          styles: { fontSize: '16px', color: '#d32f2f', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: '• May cause side effects in rare cases',
          styles: { fontSize: '16px', color: '#d32f2f', marginBottom: '8px' }
        }
      ]
    },
    {
      id: 'list-check-boxes',
      label: 'List - Check boxes',
      desc: 'List with checkboxes',
      icon: VerifiedIcon,
      category: 'Lists',
      elements: [
        {
          type: 'checklist',
          title: 'What you get:',
          items: [
            { icon: 'verified', text: 'Free shipping' },
            { icon: 'verified', text: '30-day money-back guarantee' },
            { icon: 'verified', text: '24/7 customer support' }
          ],
          styles: { marginBottom: '20px' }
        }
      ]
    },
    {
      id: 'list-numbered',
      label: 'List - Numbered',
      desc: 'Numbered list',
      icon: TextIcon,
      category: 'Lists',
      elements: [
        {
          type: 'text',
          content: '1. Step one: Sign up for an account',
          styles: { fontSize: '16px', color: '#333', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: '2. Step two: Choose your plan',
          styles: { fontSize: '16px', color: '#333', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: '3. Step three: Enjoy the benefits',
          styles: { fontSize: '16px', color: '#333', marginBottom: '8px' }
        }
      ]
    },
    {
      id: 'list-steps-how-to',
      label: 'List - steps/how to',
      desc: 'Step-by-step instructions',
      icon: TextIcon,
      category: 'Lists',
      elements: [
        {
          type: 'text',
          content: 'Step 1: Open the box',
          styles: { fontSize: '16px', color: '#1976d2', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: 'Step 2: Remove the product',
          styles: { fontSize: '16px', color: '#1976d2', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: 'Step 3: Follow the instructions',
          styles: { fontSize: '16px', color: '#1976d2', marginBottom: '8px' }
        }
      ]
    },

    // Icons Group
    {
      id: 'feature-icons',
      label: 'Feature Icons',
      desc: 'Icons for features',
      icon: VerifiedIcon,
      category: 'Icons',
      elements: [{
        type: 'icon',
        icon: 'verified',
        styles: { color: '#1976d2', fontSize: '32px' }
      }
      ]
    },
    {
      id: 'features-guaranteed-service-icons',
      label: 'Features - Guaranteed Service Icons',
      desc: 'Service guarantee icons',
      icon: VerifiedIcon,
      category: 'Icons',
      elements: [
        {
          type: 'icon',
          icon: 'verified',
          styles: { color: '#43a047', fontSize: '32px' }
        }
      ]
    },


    // Features Group
    {
      id: 'features-header-paragraph-expandable',
      label: 'Features - Header + paragraph + expandable',
      desc: 'Expandable feature section',
      icon: TextIcon,
      category: 'Features',
      elements: [
        {
          type: 'heading',
          content: 'Product Features',
          styles: { fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '16px' }
        },
        {
          type: 'text',
          content: 'Discover the key features that make our product stand out from the competition.',
          styles: { fontSize: '16px', color: '#666', marginBottom: '20px' }
        },
        {
          type: 'text',
          content: '✓ Premium Quality Materials',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        },
        {
          type: 'text',
          content: '✓ Advanced Technology',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        },
        {
          type: 'text',
          content: '✓ Lifetime Warranty',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        }
      ]
    },
    {
      id: 'features-media-awards',
      label: 'Features - Media Awards',
      desc: 'Media awards section',
      icon: ImageIcon,
      category: 'Features',
      elements: [
        {
          type: 'heading',
          content: 'Award-Winning Product',
          styles: { fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '16px', textAlign: 'center' }
        },
        {
          type: 'text',
          content: '🏆 Best Product 2024',
          styles: { fontSize: '18px', color: '#1976d2', marginBottom: '8px', textAlign: 'center', fontWeight: 'bold' }
        },
        {
          type: 'text',
          content: '⭐ 5-Star Rating from TechReview',
          styles: { fontSize: '16px', color: '#666', marginBottom: '8px', textAlign: 'center' }
        },
        {
          type: 'text',
          content: '🎯 Editor\'s Choice Award',
          styles: { fontSize: '16px', color: '#666', marginBottom: '20px', textAlign: 'center' }
        }
      ]
    },
    {
      id: 'ingredients',
      label: 'Ingredients',
      desc: 'Product ingredients list',
      icon: TextIcon,
      category: 'Features',
      elements: [
        {
          type: 'heading',
          content: 'Natural Ingredients',
          styles: { fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '16px' }
        },
        {
          type: 'text',
          content: '🌿 Organic Extract - 100mg',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        },
        {
          type: 'text',
          content: '💧 Pure Water - 50ml',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        },
        {
          type: 'text',
          content: '🌱 Natural Preservatives',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        },
        {
          type: 'text',
          content: '🚫 No Artificial Additives',
          styles: { fontSize: '14px', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }
        }
      ]
    },

    // Images Group
    {
      id: 'image-headline-text-bullets-button',
      label: 'Image + headline + text + bullets + Button',
      desc: 'Image with headline, supporting text, bullets, and a CTA button',
      icon: ImageIcon,
      category: 'Images',
      elements: [
        {
          type: 'image',
          content: 'https://via.placeholder.com/600x350?text=Your+Image',
          alt: 'Featured Image',
          styles: { width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '16px' }
        },
        {
          type: 'heading',
          content: 'Compelling Headline Goes Here',
          styles: { fontSize: '22px', fontWeight: 'bold', color: '#333', marginBottom: '8px', textAlign: 'left' }
        },
        {
          type: 'text',
          content: 'Short supporting paragraph that explains the value proposition in one or two sentences.',
          styles: { fontSize: '16px', color: '#555', marginBottom: '12px', textAlign: 'left' }
        },
        {
          type: 'checklist',
          title: '',
          items: [
            { icon: 'verified', text: 'Key benefit number one' },
            { icon: 'verified', text: 'Another strong selling point' },
            { icon: 'verified', text: 'Short and easy to scan bullet' }
          ],
          styles: { marginBottom: '16px' }
        },
        {
          type: 'button',
          content: 'Get Started',
          url: '#',
          styles: { backgroundColor: '#1976d2', color: '#fff', padding: '12px 20px', borderRadius: '8px', border: 'none' }
        }
      ]
    },

    // Videos Group
    {
      id: 'video-headline-text-bullets-button',
      label: 'Video + headline + text + bullets + Button',
      desc: 'Video with headline, supporting text, bullets, and a CTA button',
      icon: VideoIcon,
      category: 'Videos',
      elements: [
        {
          type: 'video',
          content: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          styles: { width: '100%', height: '315px', marginBottom: '16px' }
        },
        {
          type: 'heading',
          content: 'Watch How It Works',
          styles: { fontSize: '22px', fontWeight: 'bold', color: '#333', marginBottom: '8px', textAlign: 'left' }
        },
        {
          type: 'text',
          content: 'A short description about what the viewer will learn or see in the video.',
          styles: { fontSize: '16px', color: '#555', marginBottom: '12px', textAlign: 'left' }
        },
        {
          type: 'checklist',
          title: '',
          items: [
            { icon: 'verified', text: 'Quick overview of the product' },
            { icon: 'verified', text: 'Real results and use cases' },
            { icon: 'verified', text: 'Clear next steps' }
          ],
          styles: { marginBottom: '16px' }
        },
        {
          type: 'button',
          content: 'Try It Now',
          url: '#',
          styles: { backgroundColor: '#1976d2', color: '#fff', padding: '12px 20px', borderRadius: '8px', border: 'none' }
        }
      ]
    },

    // Video with Button Overlay
    {
      id: 'video-single-button-overlay',
      label: 'Single button overlay',
      desc: 'Video with a single clickable button overlaid',
      icon: VideoIcon,
      category: 'Video with button overlay',
      elements: [
        {
          id: generateId(),
          type: ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY,
          content: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          videoFile: '',
          thumbnailUrl: '',
          buttons: [
            {
              id: 'button-1',
              text: 'Shop Now',
              url: '#',
              icon: 'shopping_cart',
              position: 'bottom-right',
              customX: 50,
              customY: 50,
              backgroundColor: '#ff0050',
              textColor: '#ffffff',
              size: 'medium',
              borderRadius: '24px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: 'bold'
            }
          ],
          styles: {
            width: '100%',
            height: '500px',
            marginBottom: '16px'
          }
        }
      ]
    },
    {
      id: 'video-multiple-buttons-overlay',
      label: 'Multiple buttons overlay',
      desc: 'Video with multiple clickable buttons overlaid',
      icon: VideoIcon,
      category: 'Video with button overlay',
      elements: [
        {
          id: generateId(),
          type: ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY,
          content: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          videoFile: '',
          thumbnailUrl: '',
          buttons: [
            {
              id: 'button-1',
              text: 'Shop Now',
              url: '#',
              icon: 'shopping_cart',
              position: 'bottom-right',
              customX: 85,
              customY: 85,
              backgroundColor: '#ff0050',
              textColor: '#ffffff',
              size: 'medium',
              borderRadius: '24px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: 'bold'
            },
            {
              id: 'button-2',
              text: 'Learn More',
              url: '#',
              icon: 'info',
              position: 'top-right',
              customX: 85,
              customY: 15,
              backgroundColor: '#2196f3',
              textColor: '#ffffff',
              size: 'small',
              borderRadius: '20px',
              padding: '8px 16px',
              fontSize: '12px',
              fontWeight: 'bold'
            },
            {
              id: 'button-3',
              text: 'Save',
              url: '#',
              icon: 'favorite',
              position: 'top-left',
              customX: 15,
              customY: 15,
              backgroundColor: '#ffffff',
              textColor: '#ff0050',
              size: 'small',
              borderRadius: '50%',
              padding: '10px',
              fontSize: '12px',
              fontWeight: 'bold'
            }
          ],
          styles: {
            width: '100%',
            height: '500px',
            marginBottom: '16px'
          }
        }
      ]
    },
    {
      id: 'video-interactive-hotspots',
      label: 'Interactive hotspots',
      desc: 'Video with interactive hotspot buttons',
      icon: VideoIcon,
      category: 'Video with button overlay',
      elements: [
        {
          id: generateId(),
          type: ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY,
          content: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          videoFile: '',
          thumbnailUrl: '',
          buttons: [
            {
              id: 'button-1',
              text: '1',
              url: '#product1',
              icon: '',
              position: 'custom',
              customX: 30,
              customY: 40,
              backgroundColor: '#ffffff',
              textColor: '#000000',
              size: 'small',
              borderRadius: '50%',
              padding: '10px',
              fontSize: '12px',
              fontWeight: 'bold'
            },
            {
              id: 'button-2',
              text: '2',
              url: '#product2',
              icon: '',
              position: 'custom',
              customX: 70,
              customY: 60,
              backgroundColor: '#ffffff',
              textColor: '#000000',
              size: 'small',
              borderRadius: '50%',
              padding: '10px',
              fontSize: '12px',
              fontWeight: 'bold'
            }
          ],
          styles: {
            width: '100%',
            height: '500px',
            marginBottom: '16px'
          }
        }
      ]
    },

    // Testimonial Group
    {
      id: 'testimonial-headline-images',
      label: 'Testimonial - headline + customer images',
      desc: 'Testimonial section with headline and customer images',
      icon: TextIcon,
      category: 'Testimonial',
      elements: [
        {
          type: 'heading',
          content: 'What Our Customers Say',
          styles: { fontSize: '22px', fontWeight: 'bold', color: '#1976d2', marginBottom: '12px' }
        },
        {
          type: 'image',
          src: 'https://randomuser.me/api/portraits/men/32.jpg',
          styles: { width: '48px', height: '48px', borderRadius: '50%', marginRight: '8px' }
        },
        {
          type: 'text',
          content: '“This product changed my life!”',
          styles: { fontSize: '16px', color: '#333', fontStyle: 'italic', marginBottom: '8px' }
        }
      ]
    },
    {
      id: 'testimonial-single',
      label: 'Testimonial - single',
      desc: 'Single testimonial block',
      icon: TextIcon,
      category: 'Testimonial',
      elements: [
        {
          type: 'text',
          content: '“Absolutely love it! Highly recommend.”',
          styles: { fontSize: '16px', color: '#333', fontStyle: 'italic', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: '- Jane Doe',
          styles: { fontSize: '14px', color: '#888', marginBottom: '8px' }
        }
      ]
    },
    // Comparison Group
    {
      id: 'comparison-competitor',
      label: 'comparison w competitor',
      desc: 'Comparison with competitor',
      icon: TextIcon,
      category: 'Comparison',
      elements: [
        {
          type: 'heading',
          content: 'How We Compare',
          styles: { fontSize: '20px', fontWeight: 'bold', color: '#1976d2', marginBottom: '10px' }
        },
        {
          type: 'text',
          content: 'Our Product vs. Competitor',
          styles: { fontSize: '16px', color: '#333', marginBottom: '8px' }
        }
      ]
    },
    // Highlight block Group
    {
      id: 'highlight-pull-quote',
      label: 'pull quote',
      desc: 'Highlighted pull quote',
      icon: TextIcon,
      category: 'Highlight block',
      elements: [
        {
          type: 'text',
          content: '“A must-have for everyone!”',
          styles: { fontSize: '18px', color: '#fff', backgroundColor: '#1976d2', padding: '12px', borderRadius: '8px', fontStyle: 'italic', marginBottom: '8px' }
        }
      ]
    },
    {
      id: 'headline-highlight-bg',
      label: 'Headline w/ highlight bg color, Subheadline',
      desc: 'Headline with highlighted background and subheadline',
      icon: TextIcon,
      category: 'Headline/Subheadline',
      elements: [
        {
          type: 'heading',
          content: 'Stand Out Headline',
          styles: { fontSize: '22px', fontWeight: 'bold', color: '#fff', backgroundColor: '#f5003c', padding: '8px', borderRadius: '6px', marginBottom: '8px' }
        },
        {
          type: 'text',
          content: 'Subheadline goes here',
          styles: { fontSize: '16px', color: '#333', marginBottom: '8px' }
        }
      ]
    },
    {
      id: 'subheadline-paragraph',
      label: 'subheadline + paragraph text',
      desc: 'Subheadline with paragraph text',
      icon: TextIcon,
      category: 'Headline/Subheadline',
      elements: [
        {
          type: 'text',
          content: 'Subheadline',
          styles: { fontSize: '16px', fontWeight: 'bold', color: '#1976d2', marginBottom: '4px' }
        },
        {
          type: 'text',
          content: 'This is a supporting paragraph for the subheadline.',
          styles: { fontSize: '15px', color: '#333' }
        }
      ]
    },
    {
      id: 'subheadline-highlight-bg',
      label: 'Subheadline w/ highlight bg color',
      desc: 'Subheadline with highlighted background color',
      icon: TextIcon,
      category: 'Headline/Subheadline',
      elements: [
        {
          type: 'text',
          content: 'Subheadline Highlighted',
          styles: { fontSize: '16px', color: '#fff', backgroundColor: '#1976d2', padding: '6px', borderRadius: '6px' }
        }
      ]
    },
  ], [buttonImageCalloutTemplates, buttonNoticeTemplates, buttonTextTemplates]);

  // Get unique categories from customElementsLibrary
  const customCategories = Array.from(new Set(customElementsLibrary.map(item => item.category)));

  const addCustomElement = useCallback((customElement) => {
    console.log('🎯 addCustomElement called with:', customElement);
    let newElements = customElement.elements.map(element => ({
      ...element,
      id: generateId() // Ensure unique IDs
    }));

    // Auto-populate offer link if selected
    if (selectedOffer && offers.length > 0) {
      const selectedOfferObj = offers.find(o => o._id === selectedOffer);
      if (selectedOfferObj && selectedOfferObj.purchaseUrl && selectedOfferObj.purchaseUrl !== '#' && selectedOfferObj.purchaseUrl !== '') {
        console.log('🔗 Auto-populating offer link for new custom element:', selectedOfferObj.purchaseUrl);
        newElements = populateOfferLinkInElements(newElements, selectedOfferObj.purchaseUrl);
      }
    }

    console.log('🎯 Setting elements to:', newElements);
    console.log('🎯 Using shared state:', setSharedElements !== null);
    // Reset the canvas to only the new custom element
    setElements(newElements);
  }, [setElements, selectedOffer, offers, populateOfferLinkInElements]);


  // Template selection only mode
  if (templateSelectionOnly) {
    // Show only type and subtype (for top section)
    if (typeAndSubtypeOnly) {
      return (
        <Box>
          {!hideCustomElements && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, height: '100%' }}>
              {/* Row 0: Brand and Offer Selection */}
              <Box sx={{ borderBottom: '1px solid #e0e0e0', pb: 1.5 }}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 1.5
                }}>
                  <Typography variant="subtitle2" sx={{
                    color: 'primary.main',
                    fontWeight: 600,
                    fontSize: '0.9rem'
                  }}>
                    Brand & Offer
                  </Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={() => {
                      // Reset all states
                      setSelectedBrand('');
                      setSelectedOffer('');
                      setSelectedCustomCategory(null);
                      setSelectedCustomSubtype(null);
                      setSelectedTemplateId(null);
                      setSelectedVariantKey(null);

                      // Also reset filters if any
                      setFilteredTemplates([]);

                      // Reset Canvas content
                      if (setSharedPages) {
                        setSharedPages([{ id: 1, elements: [] }]);
                      }
                      if (setSharedElements) {
                        setSharedElements([]);
                      }

                      // Reset local pagination and elements
                      setPages([{ id: 1, elements: [] }]);
                      setCurrentPageIndex(0);
                      setPaginationEnabled(true);
                      setElements([]);
                    }}
                    sx={{
                      fontSize: '0.7rem',
                      py: 0.2,
                      minHeight: 0,
                      textTransform: 'none'
                    }}
                  >
                    New Element
                  </Button>
                </Box>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5
                }}>
                  {/* Brand Selection */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 600,
                      color: 'text.secondary',
                      minWidth: '50px'
                    }}>
                      Brand:
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 120, flex: 1 }}>
                      <Select
                        value={selectedBrand}
                        onChange={(e) => {
                          console.log('🏷️ Brand selection changed to:', e.target.value);
                          handleBrandChange(e.target.value);
                        }}
                        displayEmpty
                        disabled={loadingBrands}
                        sx={{ fontSize: '0.8rem' }}
                      >
                        <MenuItem value="" disabled>
                          <em>{loadingBrands ? 'Loading...' : 'Select Brand'}</em>
                        </MenuItem>
                        {brands.map(brand => (
                          <MenuItem key={brand._id} value={brand._id}>
                            {brand.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {/* Offer Selection */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 600,
                      color: 'text.secondary',
                      minWidth: '50px'
                    }}>
                      Offer:
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 120, flex: 1 }}>
                      <Select
                        value={selectedOffer}
                        onChange={(e) => {
                          console.log('🎯 Offer selection changed to:', e.target.value);
                          setSelectedOffer(e.target.value);
                        }}
                        displayEmpty
                        disabled={!selectedBrand || loadingOffers}
                        sx={{ fontSize: '0.8rem' }}
                      >
                        <MenuItem value="" disabled>
                          <em>
                            {!selectedBrand ? 'Select Brand First' :
                              loadingOffers ? 'Loading...' : 'Select Offer'}
                          </em>
                        </MenuItem>
                        {offers.map(offer => (
                          <MenuItem key={offer._id} value={offer._id}>
                            {offer.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                </Box>
              </Box>

              {/* Row 1: Offer Element type */}
              <Box sx={{ borderBottom: '1px solid #e0e0e0', pb: 1.5 }}>
                <Typography variant="subtitle2" sx={{
                  mb: 1.5,
                  color: 'primary.main',
                  fontWeight: 600,
                  textAlign: 'left',
                  fontSize: '0.9rem'
                }}>
                  Offer Element Type
                </Typography>
                <Box sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1.5
                }}>
                  {customCategories.map(category => (
                    <Button
                      key={category}
                      variant={selectedCustomCategory === category ? 'contained' : 'outlined'}
                      color={selectedCustomCategory === category ? 'primary' : 'primary'}
                      size="medium"
                      sx={{
                        fontWeight: 500,
                        fontSize: '0.8rem',
                        minHeight: '32px',
                        py: 0.75,
                        px: 1.5,
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => {
                        setSelectedCustomCategory(category);
                        setSelectedCustomSubtype(null);
                        setSelectedVariantKey(null);
                        setSelectedTemplateId(null);
                      }}
                    >
                      {category}
                    </Button>
                  ))}
                </Box>
              </Box>

              {/* Row 2: Offer Element subtype */}
              <Box sx={{ pt: 1.5, pb: 1.5 }}>
                <Typography variant="subtitle2" sx={{
                  mb: 1.5,
                  color: 'primary.main',
                  fontWeight: 600,
                  textAlign: 'left',
                  fontSize: '0.9rem'
                }}>
                  Offer Element Subtype
                </Typography>
                <Box sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1.5
                }}>
                  {selectedCustomCategory ?
                    customElementsLibrary.filter(item => item.category === selectedCustomCategory).map(item => (
                      <Button
                        key={item.id}
                        variant={selectedCustomSubtype?.id === item.id ? 'contained' : 'outlined'}
                        color={selectedCustomSubtype?.id === item.id ? 'warning' : (item.label === 'Button w/text' ? 'warning' : 'primary')}
                        size="medium"
                        sx={{
                          fontWeight: 500,
                          fontSize: '0.8rem',
                          minHeight: '32px',
                          py: 0.75,
                          px: 1.5,
                          whiteSpace: 'nowrap'
                        }}
                        onClick={() => {
                          setSelectedCustomSubtype(item);
                          setSelectedVariantKey(null);
                          setSelectedTemplateId(null);
                        }}
                        disabled={item.elements.length === 0}
                      >
                        {item.label}
                      </Button>
                    )) :
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      fontStyle: 'italic',
                      py: 2
                    }}>
                      Select a type first
                    </Typography>
                  }
                </Box>
              </Box>

              {/* Row 3: Template Selection */}
              {selectedCustomSubtype && (
                <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 1.5, pb: 1.5 }}>
                  <Typography variant="subtitle2" sx={{
                    mb: 1.5,
                    color: 'primary.main',
                    fontWeight: 600,
                    textAlign: 'left',
                    fontSize: '0.9rem'
                  }}>
                    Select Template
                  </Typography>
                  {(filteredTemplates.length > 0) ? (
                    (() => {
                      // Get both user templates and prebuilt templates
                      const userTemplates = filteredTemplates.filter(t => !t.isPreBuilt);
                      const prebuiltTemplates = filteredTemplates.filter(t => t.isPreBuilt);

                      // Remove duplicates
                      const uniqueUserTemplates = userTemplates.filter((template, index, self) =>
                        index === self.findIndex(t => t._id === template._id)
                      );

                      const uniquePrebuiltTemplates = prebuiltTemplates.filter((template, index, self) =>
                        index === self.findIndex(t => t._id === template._id)
                      );

                      console.log('🎯 Template Selection Debug:', {
                        userTemplatesCount: uniqueUserTemplates.length,
                        prebuiltTemplatesCount: uniquePrebuiltTemplates.length,
                        userTemplates: uniqueUserTemplates.map(t => t.name),
                        prebuiltTemplates: uniquePrebuiltTemplates.map(t => t.name),
                        hasVariants: selectedCustomSubtype?.elements?.[0]?.variants ? Object.keys(selectedCustomSubtype.elements[0].variants).length : 0
                      });

                      return (
                        <Box>
                          {/* Show user templates */}
                          {uniqueUserTemplates.length > 0 && (
                            <Box sx={{ mb: 1.5 }}>

                              <Box sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1.5
                              }}>
                                {uniqueUserTemplates.map(template => (
                                  <Button
                                    key={template._id}
                                    variant={selectedTemplateId === template._id ? 'contained' : 'outlined'}
                                    size="medium"
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: '0.8rem',
                                      minHeight: '32px',
                                      py: 0.75,
                                      px: 1.5,
                                      whiteSpace: 'nowrap'
                                    }}
                                    onClick={() => {
                                      setSelectedTemplateId(template._id);
                                    }}
                                  >
                                    {template.name}
                                  </Button>
                                ))}
                              </Box>
                            </Box>
                          )}

                          {/* Show prebuilt templates */}
                          {uniquePrebuiltTemplates.length > 0 && (
                            <Box sx={{ mb: 1.5 }}>
                              <Typography variant="caption" sx={{
                                display: 'block',
                                color: 'primary.main',
                                fontWeight: 600,
                                mb: 0.75,
                                fontSize: '0.75rem'
                              }}>
                                🎨 Prebuilt Templates
                              </Typography>
                              <Box sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1.5
                              }}>
                                {uniquePrebuiltTemplates.map(template => (
                                  <Button
                                    key={template._id}
                                    variant={selectedTemplateId === template._id ? 'contained' : 'outlined'}
                                    size="medium"
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: '0.8rem',
                                      minHeight: '32px',
                                      py: 0.75,
                                      px: 1.5,
                                      whiteSpace: 'nowrap'
                                    }}
                                    onClick={() => {
                                      setSelectedTemplateId(template._id);
                                    }}
                                  >
                                    {template.name}
                                  </Button>
                                ))}
                              </Box>
                            </Box>
                          )}

                          {/* Show built-in variants if no templates exist */}
                          {uniqueUserTemplates.length === 0 && uniquePrebuiltTemplates.length === 0 && selectedCustomSubtype?.elements?.[0]?.variants && (
                            <Box>
                              <Typography variant="caption" sx={{
                                display: 'block',
                                color: 'primary.main',
                                fontWeight: 600,
                                mb: 0.75,
                                fontSize: '0.75rem'
                              }}>
                                ⚡ Built-in Variants
                              </Typography>
                              <Box sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1.5
                              }}>
                                {Object.keys(selectedCustomSubtype.elements[0].variants).map(variantKey => (
                                  <Button
                                    key={variantKey}
                                    variant={selectedVariantKey === variantKey ? 'contained' : 'outlined'}
                                    size="medium"
                                    onClick={() => {
                                      setSelectedVariantKey(variantKey);
                                      const variantData = selectedCustomSubtype.elements[0].variants[variantKey];
                                      if (variantData) {
                                        addCustomElement({ elements: [variantData] });
                                      }
                                    }}
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: '0.8rem',
                                      minHeight: '32px',
                                      py: 0.75,
                                      px: 1.5,
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    {variantKey.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                  </Button>
                                ))}
                              </Box>
                            </Box>
                          )}

                          {/* Show message when no templates or variants available */}
                          {uniqueUserTemplates.length === 0 && uniquePrebuiltTemplates.length === 0 && (!selectedCustomSubtype?.elements?.[0]?.variants || Object.keys(selectedCustomSubtype.elements[0].variants).length === 0) && (
                            <Typography variant="body2" sx={{
                              color: 'text.secondary',
                              textAlign: 'center',
                              fontStyle: 'italic',
                              py: 3
                            }}>
                              No templates available for {selectedCustomSubtype ? selectedCustomSubtype.label : selectedCustomCategory}
                            </Typography>
                          )}
                        </Box>
                      );
                    })()
                  ) : (
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      textAlign: 'center',
                      fontStyle: 'italic',
                      py: 3
                    }}>
                      {selectedCustomCategory
                        ? 'No templates available for this category'
                        : 'Select a category from the top section'
                      }
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          )
          }
        </Box >
      );
    }




    // Default combined view (original layout)
    return (
      <Box>
        {/* Combined view with all sections */}
        {!hideCustomElements && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
            {/* Type, Subtype, and Templates in original layout */}
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
              Combined template selection view
            </Typography>
          </Box>
        )}
      </Box>
    );
  }

  return (
    // Drag-and-drop removed; static canvas
    <Box key={`offer-builder-${forceRender}`} sx={{ position: 'relative' }}>

      <Box sx={{
        display: 'flex',
        height: { xs: 'calc(100vh - 200px)', md: 'calc(100vh - 250px)' },
        position: 'relative'
      }}>
        {/* Mobile Drawer */}
        {isMobile ? (
          <SwipeableDrawer
            anchor="bottom"
            open={mobileDrawerOpen}
            onClose={() => setMobileDrawerOpen(false)}
            onOpen={() => setMobileDrawerOpen(true)}
            PaperProps={{
              sx: { maxHeight: '70vh', borderRadius: '16px 16px 0 0' }
            }}
          >
            <Box sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">🧩 Elements & Templates</Typography>
                <IconButton onClick={() => setMobileDrawerOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>

              {/* Mobile element library */}
              <Box sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
                {!templatesOnly && (
                  <>
                    {/* Custom Elements Section - Only show if not hidden */}
                    {!hideCustomElements && (
                      <Box sx={{ display: 'flex', gap: 2, mb: 3, minHeight: 200 }}>
                        {/* Left: Offer Element type */}
                        <Box sx={{ minWidth: 120, borderRight: '2px solid #e0e0e0', pr: 1 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1, color: 'primary.main', fontWeight: 600, textAlign: 'center' }}>Offer Element type</Typography>
                          {customCategories.map(category => (
                            <Button
                              key={category}
                              variant={selectedCustomCategory === category ? 'contained' : 'outlined'}
                              color={selectedCustomCategory === category ? 'warning' : 'primary'}
                              fullWidth
                              sx={{ mb: 1, justifyContent: 'flex-start', fontWeight: selectedCustomCategory === category ? 700 : 400 }}
                              onClick={() => {
                                setSelectedCustomCategory(category);
                                setSelectedCustomSubtype(null);
                                setSelectedVariantKey(null);
                              }}
                            >
                              {category}
                            </Button>
                          ))}
                        </Box>
                        {/* Middle: Offer Element subtype */}
                        <Box sx={{ minWidth: 120, borderRight: selectedCustomSubtype ? '2px solid #e0e0e0' : 'none', pr: selectedCustomSubtype ? 1 : 0 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1, color: 'primary.main', fontWeight: 600, textAlign: 'center' }}>Offer Element subtype</Typography>
                          {customElementsLibrary.filter(item => item.category === selectedCustomCategory).map(item => (
                            <Button
                              key={item.id}
                              variant={selectedCustomSubtype?.id === item.id ? 'contained' : 'outlined'}
                              color={selectedCustomSubtype?.id === item.id ? 'warning' : (item.label === 'Button w/text' ? 'warning' : 'primary')}
                              fullWidth
                              sx={{ mb: 1, justifyContent: 'flex-start', fontWeight: 500 }}
                              onClick={() => {
                                setSelectedCustomSubtype(item);
                                setSelectedVariantKey(null);
                                setSelectedTemplateId(null);
                              }}
                              disabled={item.elements.length === 0}
                            >
                              {item.label}
                            </Button>
                          ))}
                        </Box>
                        {/* Right: Variants */}
                        {selectedCustomSubtype && selectedCustomSubtype.elements.length > 0 && selectedCustomSubtype.elements[0].variants && (
                          <Box sx={{ flex: 1, pl: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, color: 'primary.main', fontWeight: 600, textAlign: 'center' }}>Select a template</Typography>

                            {/* Show prebuilt templates for this subtype (Mobile) */}
                            {(() => {
                              // Get templates based on type and subtype
                              const relevantTemplates = filteredTemplates.filter(t => !t.isPreBuilt);

                              // Debug: Log all templates to identify duplicates
                              console.log('🔍 Mobile Template Debug:', {
                                selectedCategory: selectedCustomCategory,
                                selectedSubtype: selectedCustomSubtype.label,
                                filteredTemplates: filteredTemplates.map(t => ({ name: t.name, id: t._id, type: t.type, subtype: t.subtype }))
                              });

                              // Remove duplicates by ID
                              const uniqueTemplates = relevantTemplates.filter((template, index, self) =>
                                index === self.findIndex(t => t._id === template._id)
                              );

                              console.log('🔍 Mobile Unique Templates:', {
                                original: relevantTemplates.length,
                                unique: uniqueTemplates.length
                              });

                              return (
                                <Box key="mobile-templates">
                                  {/* Templates */}
                                  {uniqueTemplates.length > 0 && (
                                    <Box sx={{ mb: 2 }}>
                                      <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mb: 1, fontSize: '0.65rem', color: 'primary.main', fontWeight: 600 }}>
                                        🎨 {selectedCustomSubtype.label} Templates
                                      </Typography>
                                      {uniqueTemplates.map(template => (
                                        <Button
                                          key={template._id}
                                          variant={selectedTemplateId === template._id ? 'contained' : 'outlined'}
                                          color="primary"
                                          fullWidth
                                          sx={{
                                            mb: 1,
                                            justifyContent: 'flex-start',
                                            fontWeight: 500,
                                            borderColor: '#1976d2',
                                            color: selectedTemplateId === template._id ? '#ffffff' : '#1976d2',
                                            backgroundColor: selectedTemplateId === template._id ? '#1976d2' : undefined,
                                            '&:hover': {
                                              backgroundColor: selectedTemplateId === template._id ? '#1565c0' : '#e3f2fd',
                                              borderColor: '#1565c0'
                                            }
                                          }}
                                          onClick={() => {
                                            // Load the prebuilt template
                                            loadPreBuiltTemplate(template);
                                            setMobileDrawerOpen(false);
                                          }}
                                        >
                                          {template.name}
                                        </Button>
                                      ))}
                                    </Box>
                                  )}

                                  {/* Empty state when no templates */}
                                  {uniqueTemplates.length === 0 && (
                                    <Box sx={{ textAlign: 'center', py: 3 }}>
                                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                        No {selectedCustomSubtype.label} templates yet
                                      </Typography>
                                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                        Drag your templates to the conversion area below to create prebuilt templates
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              );
                            })()}

                            {/* Existing variants */}
                            {Object.keys(selectedCustomSubtype.elements[0].variants).map(variantKey => {
                              const variantContent = selectedCustomSubtype.elements[0].variants[variantKey];

                              // Debug log for variant content
                              console.log('🔍 Mobile Variant Debug:', {
                                subtype: selectedCustomSubtype.label,
                                variantKey: variantKey,
                                variantContent: variantContent,
                                variantContentType: typeof variantContent,
                                variantContentKeys: variantContent ? Object.keys(variantContent) : []
                              });

                              return (
                                <Button
                                  key={variantKey}
                                  variant={selectedVariantKey === variantKey ? 'contained' : 'outlined'}
                                  color={selectedVariantKey === variantKey ? 'primary' : 'primary'}
                                  fullWidth
                                  sx={{
                                    mb: 1,
                                    justifyContent: 'flex-start',
                                    fontWeight: 500,
                                    backgroundColor: selectedVariantKey === variantKey ? '#1976d2' : undefined,
                                    color: selectedVariantKey === variantKey ? '#ffffff' : undefined,
                                    '&:hover': {
                                      backgroundColor: selectedVariantKey === variantKey ? '#1565c0' : undefined
                                    }
                                  }}
                                  onClick={() => {
                                    console.log('🎯 Mobile Variant Click:', {
                                      subtype: selectedCustomSubtype.label,
                                      variantKey: variantKey,
                                      variantContent: variantContent,
                                      elementVariants: selectedCustomSubtype.elements[0].variants
                                    });

                                    setSelectedVariantKey(variantKey);
                                    setSelectedTemplateId(null); // Clear template selection

                                    // Create deep copy of variant content to prevent reference issues
                                    const contentCopy = variantContent ? JSON.parse(JSON.stringify(variantContent)) : {};

                                    const elementWithVariant = {
                                      ...selectedCustomSubtype,
                                      elements: selectedCustomSubtype.elements.map(el => ({
                                        ...el,
                                        variant: variantKey,
                                        content: contentCopy
                                      }))
                                    };
                                    addCustomElement(elementWithVariant);
                                    setMobileDrawerOpen(false);
                                  }}
                                >
                                  {variantKey.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                </Button>
                              );
                            })}
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* Regular Elements Section - Only show if not customElementsOnly */}
                    {!customElementsOnly && (
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle1" gutterBottom>🧩 Elements</Typography>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
                          {elementLibrary.map((item) => (
                            <Button
                              key={item.type}
                              variant="outlined"
                              size="small"
                              startIcon={item.icon ? <item.icon /> : <AddIcon />}
                              onClick={() => {
                                addElement(item.type);
                                setMobileDrawerOpen(false);
                              }}
                              sx={{ flexDirection: 'column', p: 1, minHeight: '60px' }}
                            >
                              <Typography variant="caption">{item.label}</Typography>
                            </Button>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </>
                )}


              </Box>
            </Box>
          </SwipeableDrawer>
        ) : (
          // Desktop drawer - only render in template creation context
          !templatesOnly ? <Box sx={{
            width: drawerOpen ? (customElementsOnly ? 700 : 280) : 0,
            flexShrink: 0,
            overflow: 'hidden',
            transition: 'width 0.3s ease'
          }}>
            <Drawer
              variant="persistent"
              anchor="left"
              open={drawerOpen}
              sx={{
                width: customElementsOnly ? 700 : 280, // Increased width for Element section
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: customElementsOnly ? 700 : 280,
                  position: 'relative',
                  height: '100%',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': { width: '5px' },
                  '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
                  '&::-webkit-scrollbar-thumb': { background: '#ccc', borderRadius: '10px' },
                  '&::-webkit-scrollbar-thumb:hover': { background: '#999' }
                }
              }}
            >
              <Box sx={{ p: 2, pb: 8 }}>
                {!templatesOnly && (
                  <>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="h6" gutterBottom sx={{ fontSize: '1rem', borderBottom: '1px solid #e0e0e0', pb: 1 }}>
                        📐 Layouts
                      </Typography>
                      <Button
                        variant="outlined"
                        fullWidth
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => setShowLayoutSelector(true)}
                      >
                        Add Layout Container
                      </Button>
                    </Box>
                    {/* Custom Elements Section - Only show if not hidden */}
                    {!hideCustomElements && (
                      <Box sx={{
                        display: 'flex',
                        gap: 1,
                        mb: 3,
                        minHeight: 500,
                        width: '100%',
                        overflowX: 'auto',
                        pb: 1,
                        '&::-webkit-scrollbar': { height: '6px' },
                        '&::-webkit-scrollbar-thumb': { background: '#ddd', borderRadius: '10px' }
                      }}>
                        {/* Left: Offer Element type */}
                        <Box sx={{
                          flex: 0.8,
                          minWidth: customElementsOnly ? 160 : 140,
                          borderRight: '1px solid #e0e0e0',
                          pr: 1,
                          maxHeight: 750,
                          overflowY: 'auto',
                          '&::-webkit-scrollbar': { width: '4px' },
                          '&::-webkit-scrollbar-thumb': { background: '#eee', borderRadius: '10px' }
                        }}>
                          <Typography variant="caption" sx={{
                            mb: 1,
                            color: 'primary.main',
                            fontWeight: 600,
                            textAlign: 'center',
                            display: 'block',
                            fontSize: '0.8rem',
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'white',
                            zIndex: 1,
                            py: 0.5,
                            borderBottom: '1px solid #f0f0f0'
                          }}>Offer Element type</Typography>
                          {customCategories.map(category => (
                            <Button
                              key={category}
                              variant={selectedCustomCategory === category ? 'contained' : 'outlined'}
                              color={selectedCustomCategory === category ? 'warning' : 'primary'}
                              fullWidth
                              size="small"
                              sx={{
                                mb: 0.5,
                                justifyContent: 'flex-start',
                                fontWeight: selectedCustomCategory === category ? 600 : 400,
                                fontSize: '0.7rem',
                                minHeight: '28px',
                                py: 0.5
                              }}
                              onClick={() => {
                                setSelectedCustomCategory(category);
                                setSelectedCustomSubtype(null);
                                setSelectedVariantKey(null);
                                setSelectedTemplateId(null);
                              }}
                            >
                              {category}
                            </Button>
                          ))}
                        </Box>

                        {/* Middle: Offer Element subtype - Always visible */}
                        <Box sx={{
                          flex: 0.9,
                          minWidth: customElementsOnly ? 180 : 160,
                          borderRight: '1px solid #e0e0e0',
                          pr: 1,
                          maxHeight: 750,
                          overflowY: 'auto',
                          '&::-webkit-scrollbar': { width: '4px' },
                          '&::-webkit-scrollbar-thumb': { background: '#eee', borderRadius: '10px' }
                        }}>
                          <Typography variant="caption" sx={{
                            mb: 1,
                            color: 'primary.main',
                            fontWeight: 600,
                            textAlign: 'center',
                            display: 'block',
                            fontSize: '0.8rem',
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'white',
                            zIndex: 1,
                            py: 0.5,
                            borderBottom: '1px solid #f0f0f0'
                          }}>Offer Element subtype</Typography>
                          {selectedCustomCategory ? (
                            customElementsLibrary.filter(item => item.category === selectedCustomCategory).map(item => (
                              <Button
                                key={item.id}
                                variant={selectedCustomSubtype?.id === item.id ? 'contained' : 'outlined'}
                                color={selectedCustomSubtype?.id === item.id ? 'warning' : (item.label === 'Button w/text' ? 'warning' : 'primary')}
                                fullWidth
                                size="small"
                                sx={{
                                  mb: 0.5,
                                  justifyContent: 'flex-start',
                                  fontWeight: 500,
                                  fontSize: '0.7rem',
                                  minHeight: '28px',
                                  py: 0.5
                                }}
                                onClick={() => {
                                  setSelectedCustomSubtype(item);
                                  setSelectedVariantKey(null);
                                  setSelectedTemplateId(null);
                                }}
                                disabled={item.elements.length === 0}
                              >
                                {item.label}
                              </Button>
                            ))
                          ) : (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 2, fontSize: '0.65rem' }}>
                              Select a category to see subtypes
                            </Typography>
                          )}
                        </Box>

                        {/* Right: Variants - Always visible */}
                        <Box sx={{
                          flex: 1.3,
                          minWidth: customElementsOnly ? 220 : 160,
                          pr: 1,
                          maxHeight: 750,
                          overflowY: 'auto',
                          '&::-webkit-scrollbar': { width: '4px' },
                          '&::-webkit-scrollbar-thumb': { background: '#eee', borderRadius: '10px' }
                        }}>
                          <Typography variant="caption" sx={{
                            mb: 1,
                            color: 'primary.main',
                            fontWeight: 600,
                            textAlign: 'center',
                            display: 'block',
                            fontSize: '0.8rem',
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'white',
                            zIndex: 1,
                            py: 0.5,
                            borderBottom: '1px solid #f0f0f0'
                          }}>Select a template</Typography>

                          {/* Show prebuilt templates for this subtype */}
                          {(selectedCustomCategory && filteredTemplates.length > 0) && (() => {
                            // Get templates based on type and subtype
                            const relevantTemplates = filteredTemplates.filter(t => !t.isPreBuilt);

                            // Debug: Log all templates to identify duplicates
                            console.log('🔍 Desktop Template Debug:', {
                              selectedCategory: selectedCustomCategory,
                              selectedSubtype: selectedCustomSubtype.label,
                              filteredTemplates: filteredTemplates.map(t => ({ name: t.name, id: t._id, type: t.type, subtype: t.subtype, isPreBuilt: t.isPreBuilt }))
                            });

                            console.log('🔍 Relevant Templates (non-prebuilt):', relevantTemplates.map(t => ({ name: t.name, id: t._id, type: t.type, subtype: t.subtype })));

                            // Remove duplicates by ID
                            const uniqueTemplates = relevantTemplates.filter((template, index, self) =>
                              index === self.findIndex(t => t._id === template._id)
                            );

                            console.log('🔍 Desktop Unique Templates:', {
                              original: relevantTemplates.length,
                              unique: uniqueTemplates.length,
                              templates: uniqueTemplates.map(t => ({ name: t.name, id: t._id, type: t.type, subtype: t.subtype }))
                            });

                            return (
                              <Box key="desktop-templates">
                                {/* Templates */}
                                {uniqueTemplates.length > 0 && (
                                  <Box sx={{ mb: 2 }}>
                                    <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mb: 1, fontSize: '0.65rem', color: 'primary.main', fontWeight: 600 }}>
                                      🎨 {selectedCustomSubtype.label} Templates
                                    </Typography>
                                    {uniqueTemplates.map(template => (
                                      <Button
                                        key={template._id}
                                        variant={selectedTemplateId === template._id ? 'contained' : 'outlined'}
                                        color="primary"
                                        fullWidth
                                        size="small"
                                        sx={{
                                          mb: 0.5,
                                          justifyContent: 'flex-start',
                                          fontWeight: 500,
                                          fontSize: '0.7rem',
                                          minHeight: '28px',
                                          py: 0.5,
                                          borderColor: '#1976d2',
                                          color: selectedTemplateId === template._id ? '#ffffff' : '#1976d2',
                                          backgroundColor: selectedTemplateId === template._id ? '#1976d2' : undefined,
                                          '&:hover': {
                                            backgroundColor: selectedTemplateId === template._id ? '#1565c0' : '#e3f2fd',
                                            borderColor: '#1565c0'
                                          }
                                        }}
                                        onClick={() => {
                                          // Load the prebuilt template
                                          loadPreBuiltTemplate(template);
                                        }}
                                      >
                                        {template.name}
                                      </Button>
                                    ))}
                                  </Box>
                                )}

                                {/* Empty state when no templates */}
                                {uniqueTemplates.length === 0 && (
                                  <Box sx={{ textAlign: 'center', py: 3 }}>
                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                      No {selectedCustomSubtype.label} templates yet
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                      Drag your templates to the conversion area below to create prebuilt templates
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            );
                          })()}



                          {/* Default message when no templates available */}
                          {!(selectedCustomCategory && filteredTemplates.length > 0) && (
                            <Box>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 1, mb: 2, fontSize: '0.65rem' }}>
                                {selectedCustomCategory
                                  ? 'No templates available for this category'
                                  : 'Select a category to see templates'
                                }
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}

                    {/* Regular Elements Section - Only show if not customElementsOnly */}
                    {!customElementsOnly && (
                      <>
                        <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: '1rem', borderBottom: '1px solid #e0e0e0', pb: 1 }}>
                          🧩 Elements
                        </Typography>
                        <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                          maxHeight: 600,
                          overflowY: 'auto',
                          pr: 1,
                          '&::-webkit-scrollbar': { width: '4px' },
                          '&::-webkit-scrollbar-thumb': { background: '#eee', borderRadius: '10px' }
                        }}>
                          {elementLibrary.map((item) => (
                            <Button
                              key={item.type}
                              variant="outlined"
                              size="small"
                              startIcon={item.icon ? <item.icon /> : <AddIcon />}
                              onClick={() => addElement(item.type)}
                              onDragStart={(e) => handleDragStart(e, item.type)}
                              draggable
                              sx={{
                                justifyContent: 'flex-start',
                                textTransform: 'none',
                                fontSize: '0.8rem',
                                py: 1,
                                px: 2
                              }}
                            >
                              {item.label}
                            </Button>
                          ))}
                        </Box>

                      </>
                    )}
                  </>
                )}


              </Box>
            </Drawer>
          </Box> : null
        )}

        {/* Editor Column */}
        <Box sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          borderRight: '1px solid #e0e0e0',
          maxWidth: drawerOpen ? '100%' : '850px' // Increased from 700px to give toolbar more room
        }}>
          {/* Desktop Toolbar */}
          <Box sx={{
            p: { xs: 0.5, md: 1 },
            borderBottom: '1px solid #e0e0e0',
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            gap: 1.5,
            flexWrap: 'nowrap',
            backgroundColor: '#f8f9fa'
          }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main', mr: 1, fontSize: '0.95rem' }}>
              Editor
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mr: 1 }}>
              <Typography variant="caption" color="text.secondary">Preview:</Typography>
              <IconButton
                size="small"
                onClick={() => setPreviewDevice('mobile')}
                color={previewDevice === 'mobile' ? 'primary' : 'default'}
                title="Phone View"
              >
                <PhoneIcon />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => setPreviewDevice('desktop')}
                color={previewDevice === 'desktop' ? 'primary' : 'default'}
                title="Desktop View"
              >
                <ComputerIcon />
              </IconButton>
            </Box>

            {/* Add Page Button - Always visible */}
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={addPage}
              color="primary"
              sx={{ py: 0.4, px: 1.2, fontSize: '0.75rem' }}
              title="Add a new page for elements"
            >
              Add page
            </Button>

            {/* Delete Page Button - Show when pagination is enabled */}
            {paginationEnabled && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={() => deletePage(currentPageIndex)}
                color="error"
                sx={{ py: 0.4, px: 1.2, fontSize: '0.75rem' }}
                title={pages.length > 1 ? "Delete the current page" : "Clear the current page"}
              >
                Delete page
              </Button>
            )}




            {/* Insert Template Button - Only show in Brands page */}
            {!templateSelectionOnly && isBrandsPage && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<TemplateIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  if (!selectedTemplateId) {
                    setShowLoadTemplateAlert(true);
                    setLoadTemplateError('Please select a template first from the library above.');
                    return;
                  }

                  try {
                    console.log('🔍 Insert Template Clicked');
                    let templateToLoad = null;

                    // 1. Try to find in filteredTemplates state
                    if (filteredTemplates && filteredTemplates.length > 0) {
                      templateToLoad = filteredTemplates.find(t => t._id === selectedTemplateId || t.id === selectedTemplateId);
                    }

                    // 2. If not found, try savedOfferElements
                    if (!templateToLoad && savedOfferElements && savedOfferElements.length > 0) {
                      templateToLoad = savedOfferElements.find(t => t._id === selectedTemplateId || t.id === selectedTemplateId);
                    }

                    // 2b. If not found, try savedTemplates
                    if (!templateToLoad && savedTemplates && savedTemplates.length > 0) {
                      templateToLoad = savedTemplates.find(t => t._id === selectedTemplateId || t.id === selectedTemplateId);
                    }

                    // 3. customElementsLibrary
                    if (!templateToLoad) {
                      for (const subtype of customElementsLibrary) {
                        if (subtype.elements) {
                          const found = subtype.elements.find(t => t._id === selectedTemplateId || t.id === selectedTemplateId);
                          if (found) {
                            templateToLoad = found;
                            break;
                          }
                        }
                      }
                    }

                    if (templateToLoad) {
                      loadPreBuiltTemplate(templateToLoad, true);
                    } else {
                      setShowLoadTemplateAlert(true);
                      setLoadTemplateError('Could not find the selected template data. Please try selecting it again.');
                    }
                  } catch (err) {
                    console.error('❌ Error in Insert Template:', err);
                    setShowLoadTemplateAlert(true);
                    setLoadTemplateError('An error occurred while inserting the template.');
                  }
                }}
                disabled={!selectedTemplateId}
                color="secondary"
                sx={{ py: 0.4, px: 1.2, fontSize: '0.75rem' }}
                title="Insert selected template into a new page"
              >
                Insert Template
              </Button>
            )}

            {/* Save Element / Update Element Button - Only show in Brands page */}
            {!templateSelectionOnly && isBrandsPage && (
              <Button
                type="button"
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  if (!selectedBrand || !selectedOffer) {
                    setShowBrandOfferAlert(true);
                    return;
                  }

                  // If updating, directly save without showing dialog
                  if (isUpdatingElement) {
                    saveCurrentElement();
                  } else {
                    // If creating new, show dialog
                    setShowSaveElementDialog(true);
                  }
                }}
                disabled={!selectedElement}
                size="small"
                sx={{
                  py: 0.4,
                  px: 1.2,
                  fontSize: '0.75rem',
                  flexShrink: 0,
                  whiteSpace: 'nowrap',
                  textAlign: 'center',
                  minHeight: 'auto',
                  lineHeight: 1.2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: '100px',
                  maxWidth: '200px'
                }}
                title={isUpdatingElement ? `Update "${currentElementName}"` : 'Save current element to library'}
              >
                {isUpdatingElement ? `Update "${currentElementName}"` : 'Save Element'}
              </Button>
            )}

            {/* Undo Buttons - Moved from canvas to toolbar */}
            {showUndoNotification && deletedElementsHistory.length > 0 && (
              <Box
                sx={{
                  backgroundColor: '#2e7d32',
                  color: 'white',
                  borderRadius: '50px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2,
                  py: 0.5,
                  animation: 'slideInRight 0.3s ease-out',
                  '@keyframes slideInRight': {
                    from: { transform: 'translateX(100%)', opacity: 0 },
                    to: { transform: 'translateX(0)', opacity: 1 }
                  },
                  '&:hover': {
                    backgroundColor: '#1b5e20',
                    transform: 'scale(1.05)',
                    transition: 'all 0.2s ease'
                  }
                }}
              >
                <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 500, color: 'white' }}>
                  Undo ({deletedElementsHistory.length})
                </Typography>
                <Button
                  size="small"
                  onClick={undoDelete}
                  sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
                    minWidth: 'auto',
                    px: 1.5,
                    py: 0.5,
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    borderRadius: '20px'
                  }}
                >
                  Undo delete
                </Button>
                <IconButton
                  size="small"
                  onClick={dismissUndoNotification}
                  sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                    width: 24,
                    height: 24,
                    ml: 0.5
                  }}
                >
                  <CloseIcon sx={{ fontSize: 14 }} />
                </IconButton>
              </Box>
            )}




            {/* Add Elements Button for Desktop - Only show in template creation context */}
            {!isMobile && !templatesOnly && (
              <Button
                variant={drawerOpen ? 'contained' : 'outlined'}
                size="small"
                startIcon={drawerOpen ? <CloseIcon /> : <AddIcon />}
                onClick={() => setDrawerOpen(!drawerOpen)}
                color={drawerOpen ? 'secondary' : 'primary'}
                sx={{ py: 0.4, px: 1.2, fontSize: '0.75rem', whiteSpace: 'nowrap', flexShrink: 0 }}
              >
                {drawerOpen ? 'Hide Side Bar' : 'Show Side Bar'}
              </Button>
            )}

            {!hideLoadTemplate && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<TemplateIcon />}
                onClick={() => setShowTemplatesList(true)}
                sx={{ py: 0.4, px: 1.2, fontSize: '0.75rem', whiteSpace: 'nowrap', flexShrink: 0 }}
              >
                Load Template
              </Button>
            )}

            {!templatesOnly && (
              <>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<SaveIcon />}
                  onClick={() => setShowSaveDialog(true)}
                  disabled={elements.length === 0}
                  title={elements.length === 0 ? 'Add elements to enable saving' : 'Save template with type and subtype'}
                  sx={{ py: 0.4, px: 1.2, fontSize: '0.75rem', whiteSpace: 'nowrap', flexShrink: 0 }}
                >
                  {currentTemplateId ? 'Update Template' : 'Save Template'}
                </Button>

                {/* New Template Button */}
                {currentTemplateId && (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setConfirmDialogTitle('Start New Template');
                      setConfirmDialogMessage('Start a new template? This will clear your current work.');
                      setConfirmAction(() => () => {
                        createNewTemplate();
                      });
                      setShowConfirmDialog(true);
                    }}
                    sx={{ ml: 1, py: 0.4, px: 1.2, fontSize: '0.75rem', whiteSpace: 'nowrap', flexShrink: 0 }}
                  >
                    New Template
                  </Button>
                )}
              </>
            )}

            {/* Right-aligned buttons */}
            <Box sx={{ marginLeft: 'auto', display: 'flex', gap: 0.5, alignItems: 'center' }}>
              {/* Editing Title - Shows which item is being edited */}
              {selectedElement && (
                <Box sx={{
                  mr: 2,
                  px: 1.5,
                  py: 0.5,
                  backgroundColor: '#f8f9fa',
                  borderRadius: 1,
                  border: '1px solid #e0e0e0'
                }}>
                  <Typography variant="body2" sx={{
                    fontWeight: 600,
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    fontSize: '0.75rem'
                  }}>
                    <EditIcon fontSize="small" />
                    {isUpdatingElement && currentElementName
                      ? `Editing: "${currentElementName}"`
                      : `Editing: unsaved item`
                    }
                  </Typography>
                </Box>
              )}



            </Box>


          </Box>

          {/* Canvas and Right Panel Container */}
          <Box sx={{ flexGrow: 1, display: 'flex', height: '100%', overflow: 'visible' }}>
            {/* Live Preview Panel - Left Side */}
            {!isMobile && previewPanelOpen && (
              <Box sx={{
                width: !templatesOnly
                  ? (drawerOpen ? 400 : 440) // Increased width for better preview
                  : 380, // Increased width for better preview
                flexShrink: 0,
                borderRight: '1px solid #e0e0e0',
                overflow: 'visible', // Changed to visible to prevent cutoff
                backgroundColor: '#f8f9fa',
                p: 1
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 1,
                  pb: 0.5,
                  borderBottom: '1px solid #e0e0e0'
                }}>
                  <PreviewIcon color="primary" />
                  <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
                    Live Preview - Standard Mobile
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    ({isBrandsPage ? '414×750' : '375×667'} display)
                  </Typography>

                </Box>

                <Paper
                  elevation={2}
                  sx={{
                    backgroundColor: pageSettings.backgroundColor,
                    ...getPreviewStyles(),
                    width: previewDevice === 'mobile' ? (isBrandsPage ? '414px' : '375px') : 'auto', // Match blog width (414px) for brands page
                    height: previewDevice === 'mobile' ? (isBrandsPage ? '750px' : '667px') : 'auto', // Match blog height (750px) for brands page
                    minHeight: previewDevice === 'mobile' ? (isBrandsPage ? '750px' : '667px') : '600px', // Match blog height for brands page
                    position: 'relative',
                    overflow: 'hidden', // Match device bounds
                    margin: '0 auto',
                    // Inner content area styling
                    ...(previewDevice === 'mobile' && {
                      display: 'flex',
                      flexDirection: 'column',
                      p: 0, // Remove default padding when in mobile mode
                    }),
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      background: 'linear-gradient(45deg, transparent 49%, rgba(0,0,0,0.02) 50%, transparent 51%)',
                      pointerEvents: 'none',
                      zIndex: 1
                    }
                  }}
                >
                  <Box sx={{
                    // Match device inner content area dimensions exactly
                    ...(previewDevice === 'mobile' && {
                      width: '100%',
                      height: '100%', // Fill parent Paper
                      minHeight: isBrandsPage ? '750px' : '667px', // Match blog height (750px) for brands page
                      maxHeight: isBrandsPage ? '750px' : '667px', // Fixed height to match canvas
                      margin: '0 auto',
                      backgroundColor: '#fff',
                      borderRadius: 0,
                      overflow: 'hidden', // No scrollbar
                      padding: '20px', // Increased content padding
                      paddingBottom: '80px', // Space for bottom bar
                      display: 'flex',
                      flexDirection: 'column',
                      boxSizing: 'border-box' // Include padding in height calculation
                    }),
                    ...(previewDevice !== 'mobile' && {
                      maxWidth: pageSettings.maxWidth === '100%' ? '100%' : pageSettings.maxWidth,
                      margin: '0 auto'
                    }),
                    position: 'relative',
                    zIndex: 2,
                    pointerEvents: 'none' // Prevent interaction with preview elements
                  }}>
                    {elements.length === 0 ? (
                      <Box sx={{ textAlign: 'center', py: 8 }}>
                        <Typography variant="h6" color="text.secondary">
                          📱 Live Preview
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Add elements to see live preview
                        </Typography>
                      </Box>
                    ) : (
                      elements.map((element, index) => (
                        <Box key={element.id} sx={{ mb: index === elements.length - 1 ? 0 : 1 }}>
                          {element.type === ELEMENT_TYPES.LAYOUT ? (
                            <Box sx={{
                              backgroundColor: element.styles?.backgroundColor || 'transparent',
                              margin: element.styles?.margin || '0 0 16px 0',
                              ...element.styles,
                              p: 0, // Force zero padding - override any saved padding
                              border: 'none', // Force no border in preview - override any saved border
                              borderRadius: 0 // Force no border radius in preview
                            }}>
                              <Box sx={{
                                display: 'flex',
                                gap: 0,
                                flexDirection: { xs: 'column', md: 'row' }
                              }}>
                                {element.zones.map((zone, zoneIndex) => (
                                  <Box key={zone.id} sx={{
                                    flex: 1,
                                    border: 'none', // No border in preview
                                    borderRadius: 0,
                                    p: 0,
                                    minHeight: '100px',
                                    position: 'relative'
                                  }}>
                                    {zone.elements.map((zoneElement) => (
                                      <Box key={`${zoneElement.id}-${forceRender}`} sx={{ mb: 1 }}>
                                        {renderPreviewElement(zoneElement)}
                                      </Box>
                                    ))}
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          ) : (
                            renderPreviewElement(element)
                          )}
                        </Box>
                      ))
                    )}
                  </Box>

                  {/* Fixed Bottom Bar - Same as blog */}
                  {previewDevice === 'mobile' && (
                    <Box sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: '60px',
                      backgroundColor: '#000000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 4,
                      zIndex: 10000,
                      width: '100%',
                      px: 2,
                      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
                    }}>
                    </Box>
                  )}
                </Paper>
              </Box>
            )}

            {/* Editable Canvas - Right Side */}
            <Box sx={{
              flexGrow: 1,
              overflow: 'visible', // Changed from 'auto' to 'visible' to prevent cutoff
              p: { xs: 0.5, md: 0.5 }, // Reduced padding to give more space
              pb: { xs: 10, md: 0.5 }, // Reduced bottom padding
              backgroundColor: previewDevice === 'mobile' ? '#f0f0f0' : 'transparent'
            }}>
              {/* Canvas Header with Pagination Controls */}
              {!isMobile && (
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 1,
                  pb: 0.5,
                  borderBottom: '1px solid #e0e0e0'
                }}>
                  <EditIcon color="primary" />
                  <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
                    Editable Canvas - Standard Mobile
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    ({isBrandsPage ? '414×750' : '375×667'} display)
                  </Typography>

                  {/* Pagination Controls in Header */}
                  <Box sx={{ ml: 'auto' }}>
                    <PaginationControls />
                  </Box>
                </Box>
              )}

              {/* Editable Canvas with Device Frame */}
              <Box sx={{
                // Device frame container - matches preview frame exactly
                ...(previewDevice === 'mobile' && {
                  width: isBrandsPage ? '414px' : '375px', // Match blog width (414px) for brands page
                  height: isBrandsPage ? '750px' : '667px', // Fixed height to match preview (750px) for brands page
                  minHeight: isBrandsPage ? '750px' : '667px', // Match blog height (750px) for brands page
                  margin: '0 auto',
                  backgroundColor: '#1a1a1a', // Phone frame
                  borderRadius: '15px', // Scaled down rounded corners
                  padding: 0, // No padding to match preview exactly
                  boxShadow: '0 8px 16px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.1)', // Scaled shadow
                  position: 'relative',
                  overflow: 'hidden', // Match preview overflow behavior
                  border: '2px solid #333', // Phone frame border
                }),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                {/* Static canvas container (no Droppable) */}
                <Box
                  sx={{
                    // Use only canvas styles, not preview styles to avoid conflicts
                    ...getCanvasStyles(),
                    // Override with editing-specific styles
                    border: '2px dashed #e0e0e0',
                    overflow: 'hidden', // No scrollbar
                    position: 'relative', // For absolute positioning of undo button
                    backgroundColor: '#fff', // Match preview background
                    // Match blog dimensions and preview styling exactly
                    ...(previewDevice === 'mobile' && {
                      width: '100%',
                      height: '100%', // Fill parent frame
                      minHeight: isBrandsPage ? '750px' : '667px', // Match blog height (750px) for brands page
                      maxHeight: isBrandsPage ? '750px' : '667px', // Fixed height to match preview content area
                      padding: '20px', // Match preview padding exactly
                      paddingBottom: '80px', // Space for bottom bar
                      display: 'flex',
                      flexDirection: 'column',
                      boxSizing: 'border-box', // Include padding in height calculation
                      overflow: 'hidden' // No scrollbar
                      // Note: Last element margin is handled by wrapper Box, not here
                    }),
                    // Fallback for non-mobile modes
                    ...(previewDevice !== 'mobile' && {
                      minHeight: '400px',
                      borderRadius: 2,
                      p: 0.5
                    })
                  }}
                >

                  {/* Canvas Overflow Alert */}
                  {getCanvasOverflowAlert() && (
                    <Alert
                      severity="warning"
                      sx={{
                        mb: 2,
                        fontSize: '0.75rem',
                        py: 0.5,
                        '& .MuiAlert-message': {
                          fontSize: '0.75rem'
                        }
                      }}
                    >
                      {getCanvasOverflowAlert()}
                    </Alert>
                  )}

                  {/* Brands Page Height Limit Red Line */}
                  {isBrandsPage && getBrandsPageOverflowInfo() && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: `${BRANDS_PAGE_MAX_HEIGHT}px`,
                        left: 0,
                        right: 0,
                        height: '2px',
                        backgroundColor: '#e53e3e',
                        zIndex: 1000,
                        boxShadow: '0 0 4px rgba(229, 62, 62, 0.5)',
                        '&::before': {
                          content: '"Height Limit"',
                          position: 'absolute',
                          top: '-20px',
                          left: '8px',
                          fontSize: '10px',
                          color: '#e53e3e',
                          fontWeight: 'bold',
                          backgroundColor: 'white',
                          padding: '2px 4px',
                          borderRadius: '2px',
                          border: '1px solid #e53e3e'
                        }
                      }}
                    />
                  )}

                  {/* Brands Page Overflow Alert */}
                  {isBrandsPage && getBrandsPageOverflowInfo() && (
                    <Alert
                      severity="error"
                      sx={{
                        mb: 2,
                        fontSize: '0.75rem',
                        py: 0.5,
                        '& .MuiAlert-message': {
                          fontSize: '0.75rem'
                        }
                      }}
                    >
                      ⚠️ Content exceeds brands page height limit by {getBrandsPageOverflowInfo().overflowHeight}px (Current: {getBrandsPageOverflowInfo().totalHeight}px, Max: {getBrandsPageOverflowInfo().maxHeight}px)
                    </Alert>
                  )}




                  {elements.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 8 }}>
                      <Typography variant="h6" color="text.secondary">
                        📱 Editable Canvas
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {isMobile
                          ? 'Tap the menu button to add elements'
                          : !templatesOnly
                            ? (drawerOpen
                              ? 'Drag elements here or click to add'
                              : 'Click "Add Elements" in the toolbar to get started')
                            : 'Edit content directly or load templates for more options'
                        }
                      </Typography>
                      {isMobile && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                          💡 Live preview available on desktop
                        </Typography>
                      )}
                      {!isMobile && !previewPanelOpen && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                          💡 Click "Show Preview" in the toolbar to see live changes
                        </Typography>
                      )}
                    </Box>
                  ) : (
                    elements.map((element, index) => {
                      console.log('🎨 Rendering canvas element:', element.id, 'type:', element.type, 'forceRender:', forceRender);
                      if (element.type === ELEMENT_TYPES.VIDEO) {
                        console.log('🎥 Canvas VIDEO element details:', {
                          id: element.id,
                          videoFile: element.videoFile,
                          content: element.content
                        });
                      }
                      const isVideo = element.type === ELEMENT_TYPES.VIDEO;
                      return (
                        <Box
                          key={element.id}
                          sx={{
                            mt: index === 0 ? 0 : undefined,
                            mb: index === elements.length - 1 ? 0 : (element.type === ELEMENT_TYPES.HEADING ? 0.25 : 1), // Tight 2px gap after headings, 8px elsewhere
                            display: 'block', // Ensure margins work properly
                            // Override element's margin-bottom to match preview spacing
                            '& > *': {
                              marginBottom: '0 !important' // Remove element's own margin-bottom, use wrapper spacing
                            },
                            // Ensure video elements maintain their margin-bottom spacing (4px = mb: 0.5)
                            ...(isVideo && {
                              '& [data-element-id]': {
                                mb: '4px !important' // Force 4px margin-bottom for videos
                              }
                            })
                          }}
                        >
                          {renderInlineEditableElement(element, false, null, null, index)}
                        </Box>
                      );
                    })
                  )}

                  {/* Fixed Bottom Bar - Same as blog */}
                  {previewDevice === 'mobile' && (
                    <Box sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: '60px',
                      backgroundColor: '#000000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 4,
                      zIndex: 10000,
                      width: '100%',
                      px: 2,
                      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
                    }}>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>


            {/* Right Panel - Advanced Style Editor - Available in both contexts when rightPanelOpen is true */}
            {rightPanelOpen && !isMobile && (selectedElement || tabValue === 2) && (
              <Box sx={{
                width: customElementsOnly
                  ? 400 // Increased width for better usability
                  : previewPanelOpen
                    ? 350 // Increased width for better usability
                    : 400, // Increased width for better usability
                flexShrink: 0,
                borderLeft: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
                overflow: 'auto',
                p: 2,
                height: '110vh',


              }}>
                {selectedElement && (
                  <Box sx={{ mb: 2, p: 2, backgroundColor: '#e8f5e8', borderRadius: 1, border: '2px solid #4caf50' }}>
                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#2e7d32' }}>
                      ✏️ Editing: {selectedElement?.type?.toUpperCase()}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Changes will only affect this specific element
                    </Typography>
                  </Box>
                )}

                {/* Page Management Section - Always visible when pagination is enabled and element is selected */}
                {(() => {
                  return paginationEnabled && selectedElement;
                })() && (
                    <Box sx={{
                      mb: 2,
                      p: 2,
                      backgroundColor: '#f0f8ff',
                      border: '1px solid #1976d2',
                      borderRadius: 1
                    }}>
                      <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                        📄 Page Management
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CallSplitIcon />}
                        onClick={() => {
                          console.log('🔴 Move to New Page button clicked!');
                          console.log('🔍 Current state:', {
                            paginationEnabled,
                            isEditingMode,
                            selectedElement: selectedElement?.id,
                            currentPageIndex,
                            pagesLength: pages.length
                          });
                          moveToNewPage();
                        }}
                        sx={{ width: '100%', mb: 1 }}
                      >
                        Move to New Page
                      </Button>


                    </Box>
                  )}

                <Tabs value={tabValue} onChange={(e, v) => {
                  setTabValue(v);
                  if (v === 2 && !rightPanelOpen) {
                    setRightPanelOpen(true);
                  }
                }} sx={{ mb: 2 }}>
                  <Tab label="Content" />
                  <Tab label="Style" />
                  {isBrandsPage && <Tab label="Add new element" />}
                </Tabs>

                {/* Content Tab */}
                {tabValue === 0 && selectedElement && (
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      📝 Content Settings
                    </Typography>
                    {selectedElement.type === ELEMENT_TYPES.FAQ_ACCORDION && (
                      <Box>
                        <TextField
                          fullWidth
                          label="FAQ Title"
                          value={selectedElement.title}
                          onChange={e => updateElement(selectedElement.id, { title: e.target.value })}
                          sx={{ mb: 2 }}
                        />

                        {/* Icon Customization */}
                        <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Icon Settings
                          </Typography>

                          <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Icon Type</InputLabel>
                            <Select
                              value={selectedElement.iconType || 'plusMinus'}
                              onChange={e => updateElement(selectedElement.id, { iconType: e.target.value })}
                              label="Icon Type"
                            >
                              <MenuItem value="plusMinus">Plus/Minus</MenuItem>
                              <MenuItem value="expandMore">Expand More/Less</MenuItem>
                              <MenuItem value="arrow">Arrow Up/Down</MenuItem>
                              <MenuItem value="arrowDrop">Arrow Drop</MenuItem>
                            </Select>
                          </FormControl>

                          <TextField
                            fullWidth
                            label="Icon Color"
                            value={selectedElement.iconColor || '#36C3D6'}
                            onChange={e => updateElement(selectedElement.id, { iconColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />

                          <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Icon Size</InputLabel>
                            <Select
                              value={selectedElement.iconSize || 'large'}
                              onChange={e => updateElement(selectedElement.id, { iconSize: e.target.value })}
                              label="Icon Size"
                            >
                              <MenuItem value="small">Small</MenuItem>
                              <MenuItem value="medium">Medium</MenuItem>
                              <MenuItem value="large">Large</MenuItem>
                            </Select>
                          </FormControl>

                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedElement.showIcon !== false}
                                onChange={e => updateElement(selectedElement.id, { showIcon: e.target.checked })}
                              />
                            }
                            label="Show expand/collapse icon"
                          />
                        </Box>

                        {/* Layout & Alignment */}
                        <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Layout & Alignment
                          </Typography>

                          <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Text Alignment</InputLabel>
                            <Select
                              value={selectedElement.textAlign || 'left'}
                              onChange={e => updateElement(selectedElement.id, { textAlign: e.target.value })}
                              label="Text Alignment"
                            >
                              <MenuItem value="left">Left</MenuItem>
                              <MenuItem value="center">Center</MenuItem>
                              <MenuItem value="right">Right</MenuItem>
                            </Select>
                          </FormControl>

                          <TextField
                            fullWidth
                            label="Item Spacing"
                            value={selectedElement.itemSpacing || '12px'}
                            onChange={e => updateElement(selectedElement.id, { itemSpacing: e.target.value })}
                            sx={{ mb: 2 }}
                            placeholder="e.g., 12px, 1rem"
                          />

                          <TextField
                            fullWidth
                            label="Border Radius"
                            value={selectedElement.itemBorderRadius || '4px'}
                            onChange={e => updateElement(selectedElement.id, { itemBorderRadius: e.target.value })}
                            sx={{ mb: 2 }}
                            placeholder="e.g., 4px, 8px, 12px"
                          />

                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedElement.showDivider !== false}
                                onChange={e => updateElement(selectedElement.id, { showDivider: e.target.checked })}
                              />
                            }
                            label="Show divider lines"
                          />

                          {selectedElement.showDivider !== false && (
                            <TextField
                              fullWidth
                              label="Divider Color"
                              value={selectedElement.dividerColor || '#C1A7F1'}
                              onChange={e => updateElement(selectedElement.id, { dividerColor: e.target.value })}
                              sx={{ mt: 2 }}
                              inputProps={{ type: 'color' }}
                            />
                          )}
                        </Box>

                        {/* Colors */}
                        <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Colors
                          </Typography>

                          <TextField
                            fullWidth
                            label="Container Background"
                            value={selectedElement.containerBackgroundColor || 'transparent'}
                            onChange={e => updateElement(selectedElement.id, { containerBackgroundColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />

                          <TextField
                            fullWidth
                            label="Question Background"
                            value={selectedElement.questionBackgroundColor || 'transparent'}
                            onChange={e => updateElement(selectedElement.id, { questionBackgroundColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />

                          <TextField
                            fullWidth
                            label="Answer Background"
                            value={selectedElement.answerBackgroundColor || 'rgba(0, 0, 0, 0.02)'}
                            onChange={e => updateElement(selectedElement.id, { answerBackgroundColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />

                          <TextField
                            fullWidth
                            label="Question Text Color"
                            value={selectedElement.questionTextColor || '#4B329A'}
                            onChange={e => updateElement(selectedElement.id, { questionTextColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />

                          <TextField
                            fullWidth
                            label="Answer Text Color"
                            value={selectedElement.answerTextColor || '#4B329A'}
                            onChange={e => updateElement(selectedElement.id, { answerTextColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />

                          <TextField
                            fullWidth
                            label="Title Text Color"
                            value={selectedElement.titleTextColor || 'primary'}
                            onChange={e => updateElement(selectedElement.id, { titleTextColor: e.target.value })}
                            sx={{ mb: 2 }}
                            inputProps={{ type: 'color' }}
                          />
                        </Box>

                        {/* Spacing */}
                        <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Spacing
                          </Typography>

                          <TextField
                            fullWidth
                            label="Question Padding"
                            value={selectedElement.questionPadding || '16px'}
                            onChange={e => updateElement(selectedElement.id, { questionPadding: e.target.value })}
                            sx={{ mb: 2 }}
                            placeholder="e.g., 16px, 1rem, 8px 16px"
                          />

                          <TextField
                            fullWidth
                            label="Answer Padding"
                            value={selectedElement.answerPadding || '16px'}
                            onChange={e => updateElement(selectedElement.id, { answerPadding: e.target.value })}
                            placeholder="e.g., 16px, 1rem, 8px 16px"
                          />
                        </Box>

                        {selectedElement.items.map((item, idx) => (
                          <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
                            <TextField
                              fullWidth
                              label={`Question ${idx + 1}`}
                              value={item.question}
                              onChange={e => {
                                const newItems = [...selectedElement.items];
                                newItems[idx] = { ...newItems[idx], question: e.target.value };
                                updateElement(selectedElement.id, { items: newItems });
                              }}
                              sx={{ mb: 1 }}
                            />
                            <TextField
                              fullWidth
                              label={`Answer ${idx + 1}`}
                              value={item.answer}
                              onChange={e => {
                                const newItems = [...selectedElement.items];
                                newItems[idx] = { ...newItems[idx], answer: e.target.value };
                                updateElement(selectedElement.id, { items: newItems });
                              }}
                              multiline
                              rows={2}
                            />
                            <Button
                              color="error"
                              size="small"
                              sx={{ mt: 1 }}
                              onClick={() => {
                                const newItems = selectedElement.items.filter((_, i) => i !== idx);
                                updateElement(selectedElement.id, { items: newItems });
                              }}
                            >
                              Remove
                            </Button>
                          </Box>
                        ))}
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            const newItems = [...selectedElement.items, { question: '', answer: '' }];
                            updateElement(selectedElement.id, { items: newItems });
                          }}
                        >
                          Add FAQ Item
                        </Button>
                      </Box>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.COMPARISON_TABLE && (
                      <Box>
                        <TextField
                          fullWidth
                          label="Table Title"
                          value={selectedElement.title}
                          onChange={e => updateElement(selectedElement.id, { title: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Product A Name"
                          value={selectedElement.productA}
                          onChange={e => updateElement(selectedElement.id, { productA: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Product B Name"
                          value={selectedElement.productB}
                          onChange={e => updateElement(selectedElement.id, { productB: e.target.value })}
                          sx={{ mb: 2 }}
                        />

                        {/* Product A Image */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Product A Image (Optional)
                          </Typography>
                          <TextField
                            fullWidth
                            label="Product A Image URL"
                            value={selectedElement.productAImage || ''}
                            onChange={(e) => updateElement(selectedElement.id, { productAImage: e.target.value })}
                            sx={{ mb: 1 }}
                          />
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'productAImage');
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`product-a-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`product-a-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                disabled={imageUploading && uploadingElementId === selectedElement.id}
                                size="small"
                              >
                                Upload
                              </Button>
                            </label>
                            {selectedElement.productAImage && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => updateElement(selectedElement.id, { productAImage: '' })}
                              >
                                Remove
                              </Button>
                            )}
                          </Box>
                        </Box>

                        {/* Product B Image */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Product B Image (Optional)
                          </Typography>
                          <TextField
                            fullWidth
                            label="Product B Image URL"
                            value={selectedElement.productBImage || ''}
                            onChange={(e) => updateElement(selectedElement.id, { productBImage: e.target.value })}
                            sx={{ mb: 1 }}
                          />
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'productBImage');
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`product-b-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`product-b-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                disabled={imageUploading && uploadingElementId === selectedElement.id}
                                size="small"
                              >
                                Upload
                              </Button>
                            </label>
                            {selectedElement.productBImage && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => updateElement(selectedElement.id, { productBImage: '' })}
                              >
                                Remove
                              </Button>
                            )}
                          </Box>
                        </Box>
                        {selectedElement.rows.map((row, idx) => (
                          <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
                            <TextField
                              fullWidth
                              label={`Feature ${idx + 1}`}
                              value={row.feature}
                              onChange={e => {
                                const newRows = [...selectedElement.rows];
                                newRows[idx] = { ...newRows[idx], feature: e.target.value };
                                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              sx={{ mb: 1 }}
                            />
                            <TextField
                              fullWidth
                              label={`Description ${idx + 1}`}
                              value={row.description}
                              onChange={e => {
                                const newRows = [...selectedElement.rows];
                                newRows[idx] = { ...newRows[idx], description: e.target.value };
                                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              sx={{ mb: 1 }}
                            />
                            <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <InputLabel>Product A</InputLabel>
                                <Select
                                  value={row.productA}
                                  onChange={e => {
                                    const newRows = [...selectedElement.rows];
                                    newRows[idx] = { ...newRows[idx], productA: e.target.value };
                                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  }}
                                >
                                  <MenuItem value={true}>✓ Yes</MenuItem>
                                  <MenuItem value={false}>✗ No</MenuItem>
                                </Select>
                              </FormControl>
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <InputLabel>Product B</InputLabel>
                                <Select
                                  value={row.productB}
                                  onChange={e => {
                                    const newRows = [...selectedElement.rows];
                                    newRows[idx] = { ...newRows[idx], productB: e.target.value };
                                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  }}
                                >
                                  <MenuItem value={true}>✓ Yes</MenuItem>
                                  <MenuItem value={false}>✗ No</MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                            <Button
                              color="error"
                              size="small"
                              onClick={() => {
                                const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                            >
                              Remove Row
                            </Button>
                          </Box>
                        ))}
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            const newRows = [...selectedElement.rows, { feature: '', description: '', productA: true, productB: false }];
                            updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                          }}
                        >
                          Add Row
                        </Button>
                      </Box>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.TWO_COLUMN_COMPARISON && (
                      <Box>
                        <TextField
                          fullWidth
                          label="Left Column Title"
                          value={selectedElement.leftColumnTitle}
                          onChange={e => updateElement(selectedElement.id, { leftColumnTitle: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Right Column Title"
                          value={selectedElement.rightColumnTitle}
                          onChange={e => updateElement(selectedElement.id, { rightColumnTitle: e.target.value })}
                          sx={{ mb: 2 }}
                        />

                        {/* Left Column Image */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Left Column Image (Optional)
                          </Typography>
                          <TextField
                            fullWidth
                            label="Left Column Image URL"
                            value={selectedElement.leftColumnImage || ''}
                            onChange={(e) => updateElement(selectedElement.id, { leftColumnImage: e.target.value })}
                            sx={{ mb: 1 }}
                          />
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'leftColumnImage');
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`left-column-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`left-column-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                disabled={imageUploading && uploadingElementId === selectedElement.id}
                                size="small"
                              >
                                Upload
                              </Button>
                            </label>
                            {selectedElement.leftColumnImage && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => updateElement(selectedElement.id, { leftColumnImage: '' })}
                              >
                                Remove
                              </Button>
                            )}
                          </Box>
                        </Box>

                        {/* Right Column Image */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Right Column Image (Optional)
                          </Typography>
                          <TextField
                            fullWidth
                            label="Right Column Image URL"
                            value={selectedElement.rightColumnImage || ''}
                            onChange={(e) => updateElement(selectedElement.id, { rightColumnImage: e.target.value })}
                            sx={{ mb: 1 }}
                          />
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  handleImageUpload(file, selectedElement.id, false, selectedElementContext, 'rightColumnImage');
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`right-column-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`right-column-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                disabled={imageUploading && uploadingElementId === selectedElement.id}
                                size="small"
                              >
                                Upload
                              </Button>
                            </label>
                            {selectedElement.rightColumnImage && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => updateElement(selectedElement.id, { rightColumnImage: '' })}
                              >
                                Remove
                              </Button>
                            )}
                          </Box>
                        </Box>

                        {/* Left Column Items */}
                        <Typography variant="h6" sx={{ mb: 1, mt: 3 }}>Left Column Items (Negative Points)</Typography>
                        {selectedElement.leftItems && selectedElement.leftItems.map((item, idx) => (
                          <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
                            <TextField
                              fullWidth
                              label={`Negative Point ${idx + 1}`}
                              value={item}
                              onChange={e => {
                                const newItems = [...selectedElement.leftItems];
                                newItems[idx] = e.target.value;
                                updateElement(selectedElement.id, { leftItems: newItems });
                              }}
                              sx={{ mb: 1 }}
                              multiline
                              rows={2}
                            />
                            <Button
                              color="error"
                              size="small"
                              onClick={() => {
                                const newItems = selectedElement.leftItems.filter((_, i) => i !== idx);
                                updateElement(selectedElement.id, { leftItems: newItems });
                              }}
                            >
                              Remove Item
                            </Button>
                          </Box>
                        ))}
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{ mb: 2 }}
                          onClick={() => {
                            const newItems = [...(selectedElement.leftItems || []), 'New negative point'];
                            updateElement(selectedElement.id, { leftItems: newItems });
                          }}
                        >
                          Add Left Item
                        </Button>

                        {/* Right Column Items */}
                        <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Right Column Items (Positive Points)</Typography>
                        {selectedElement.rightItems && selectedElement.rightItems.map((item, idx) => (
                          <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
                            <TextField
                              fullWidth
                              label={`Positive Point ${idx + 1}`}
                              value={item}
                              onChange={e => {
                                const newItems = [...selectedElement.rightItems];
                                newItems[idx] = e.target.value;
                                updateElement(selectedElement.id, { rightItems: newItems });
                              }}
                              sx={{ mb: 1 }}
                              multiline
                              rows={2}
                            />
                            <Button
                              color="error"
                              size="small"
                              onClick={() => {
                                const newItems = selectedElement.rightItems.filter((_, i) => i !== idx);
                                updateElement(selectedElement.id, { rightItems: newItems });
                              }}
                            >
                              Remove Item
                            </Button>
                          </Box>
                        ))}
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            const newItems = [...(selectedElement.rightItems || []), 'New positive point'];
                            updateElement(selectedElement.id, { rightItems: newItems });
                          }}
                        >
                          Add Right Item
                        </Button>
                      </Box>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.HEADING && (
                      <TextField
                        fullWidth
                        label="Heading Text"
                        value={contentTabTempValue !== '' ? contentTabTempValue : selectedElement.content}
                        onChange={(e) => setContentTabTempValue(e.target.value)}
                        onKeyDown={handleContentTabKeyPress}
                        onBlur={saveContentTabEdit}
                        sx={{ mb: 2 }}
                      />
                    )}
                    {selectedElement.type === ELEMENT_TYPES.TEXT && (
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Text Content"
                        value={contentTabTempValue !== '' ? contentTabTempValue : selectedElement.content}
                        onChange={(e) => setContentTabTempValue(e.target.value)}
                        onKeyDown={handleContentTabKeyPress}
                        onBlur={saveContentTabEdit}
                        sx={{ mb: 2 }}
                      />
                    )}
                    {selectedElement.type === ELEMENT_TYPES.IMAGE && (
                      <>
                        <TextField
                          fullWidth
                          label="Image URL"
                          value={selectedElement.content}
                          onChange={(e) => updateElement(selectedElement.id, { content: e.target.value })}
                          sx={{ mb: 2 }}
                        />

                        {/* File Upload Section */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Or Upload Image
                          </Typography>
                          <S3FileUpload
                            onUploadComplete={({ url }) => {
                              console.log('🖼️ Image upload completed:', { url, elementId: selectedElement.id });
                              updateElement(selectedElement.id, { content: url }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              // Also update selectedElement directly to ensure immediate UI update
                              setSelectedElement(prev => ({ ...prev, content: url }));
                            }}
                            onUploadError={(error) => {
                              console.error('❌ Image upload failed:', error);
                              setStatusTitle('Image Upload Failed');
                              setStatusMessage(`Image upload failed: ${error.message}`);
                              setShowStatusAlert(true);
                            }}
                            acceptedTypes="image/*"
                            buttonText="Upload Image"
                            buttonSize="medium"
                            startIcon={<UploadIcon />}
                            folder="offer-templates/images"
                            showProgress={true}
                            fullWidth={false}
                          />
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            Supported formats: JPG, PNG, GIF, WEBP (max 5MB)
                          </Typography>
                        </Box>

                        <TextField
                          fullWidth
                          label="Alt Text"
                          value={selectedElement.alt || ''}
                          onChange={(e) => updateElement(selectedElement.id, { alt: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                      </>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.CROPPABLE_IMAGE && (
                      <>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Croppable Image
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Upload an image and use the crop tool to adjust the view. The cropped image will be saved automatically.
                        </Typography>

                        {/* File Upload Section */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Upload Image
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (ev) => {
                                    const imageSrc = ev.target.result;
                                    updateElement(selectedElement.id, {
                                      imageSrc,
                                      croppedImage: '',
                                      crop: { x: 0, y: 0 },
                                      zoom: 1,
                                      croppedAreaPixels: null
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  };
                                  reader.readAsDataURL(file);
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`croppable-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`croppable-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                sx={{ minWidth: 120 }}
                              >
                                Upload Image
                              </Button>
                            </label>
                          </Box>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            Supported formats: JPG, PNG, GIF, WEBP (max 5MB)
                          </Typography>
                        </Box>
                      </>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.FITTABLE_IMAGE && (
                      <>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Fittable Image
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Upload an image and position it within a fixed frame. Drag to position, scroll to zoom, and use presets for common aspect ratios.
                        </Typography>

                        {/* File Upload Section */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Upload Image
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (ev) => {
                                    const imageSrc = ev.target.result;
                                    updateElement(selectedElement.id, {
                                      imageSrc,
                                      imagePosition: { x: 0, y: 0 },
                                      imageScale: 1
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  };
                                  reader.readAsDataURL(file);
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`fittable-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`fittable-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                sx={{ minWidth: 120 }}
                              >
                                Upload Image
                              </Button>
                            </label>
                          </Box>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                          </Typography>
                        </Box>

                        {/* Frame Dimensions */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Frame Dimensions
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <TextField
                              label="Width"
                              type="number"
                              value={selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400)}
                              onChange={(e) => {
                                const newWidth = parseInt(e.target.value) || 400;
                                updateElement(selectedElement.id, {
                                  styles: {
                                    ...selectedElement.styles,
                                    width: newWidth
                                  }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              sx={{ flex: 1 }}
                              inputProps={{ min: 100, max: 1200 }}
                            />
                            <Typography variant="body2">×</Typography>
                            <TextField
                              label="Height"
                              type="number"
                              value={selectedElement.styles?.height || 300}
                              onChange={(e) => {
                                const newHeight = parseInt(e.target.value) || 300;
                                updateElement(selectedElement.id, {
                                  styles: {
                                    ...selectedElement.styles,
                                    height: newHeight
                                  }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              sx={{ flex: 1 }}
                              inputProps={{ min: 50, max: 800 }}
                            />
                          </Box>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={selectedElement.styles?.width === "100%"}
                                onChange={(e) => {
                                  updateElement(selectedElement.id, {
                                    styles: {
                                      ...selectedElement.styles,
                                      width: e.target.checked ? "100%" : 400
                                    }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                              />
                            }
                            label="Full Width (Responsive)"
                            sx={{ mt: 1 }}
                          />
                        </Box>

                        {/* Image Scale Slider */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Image Scale (Zoom)
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Slider
                              value={selectedElement.imageScale || 1}
                              min={0.1}
                              max={3}
                              step={0.01}
                              onChangeCommitted={(_, value) => {
                                updateElement(selectedElement.id, {
                                  imageScale: value,
                                  imagePosition: { x: 0, y: 0 }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              sx={{ flex: 1 }}
                            />
                            <Typography variant="caption" sx={{ minWidth: 40 }}>
                              {Math.round((selectedElement.imageScale || 1) * 100)}%
                            </Typography>
                          </Box>
                        </Box>
                      </>
                    )}
                    {(selectedElement.type === ELEMENT_TYPES.BUTTON || selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY) && (
                      <>
                        <TextField
                          fullWidth
                          label="Button Text"
                          value={buttonContentTabTempValue !== '' ? buttonContentTabTempValue : selectedElement.content}
                          onChange={(e) => setButtonContentTabTempValue(e.target.value)}
                          onKeyDown={handleButtonContentTabKeyPress}
                          onBlur={saveButtonContentTabEdit}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          fullWidth
                          label="Button URL"
                          value={buttonUrlTabTempValue !== '' ? buttonUrlTabTempValue : selectedElement.url}
                          onChange={(e) => setButtonUrlTabTempValue(e.target.value)}
                          onKeyDown={handleButtonUrlTabKeyPress}
                          onBlur={saveButtonUrlTabEdit}
                          disabled={isBrandsPage}
                          sx={{ mb: 2 }}
                        />
                      </>
                    )}

                    {/* Two-Line Custom List Content Controls */}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE && (
                      <>
                        {selectedElement.rows.map((row, idx) => (
                          <Box key={idx} sx={{ display: 'flex', flexDirection: 'column', mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                            {/* Icon Selector */}
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Typography variant="body2" sx={{ mr: 1, minWidth: 40 }}>Icon:</Typography>
                              <Select
                                value={row.icon}
                                onChange={e => {
                                  const newRows = [...selectedElement.rows];
                                  newRows[idx].icon = e.target.value;
                                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                sx={{ minWidth: 120 }}
                                size="small"
                              >
                                <MenuItem value="check"><VerifiedIcon sx={{ color: '#b6ff3c' }} /></MenuItem>
                                <MenuItem value="red-x"><CancelIcon sx={{ color: '#f44336' }} /></MenuItem>
                                <MenuItem value="pink-check"><CheckCircleIcon sx={{ color: '#eabbc3' }} /></MenuItem>
                                <MenuItem value="dark-check"><CheckCircleIcon sx={{ color: '#333' }} /></MenuItem>
                                <MenuItem value="green-badge">
                                  <Box sx={{
                                    width: 20, height: 20, borderRadius: '50%', background: '#22c55e',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '0.8rem', color: 'white', fontWeight: 'bold'
                                  }}>
                                    ✓
                                  </Box>
                                </MenuItem>
                                <MenuItem value="star-badge">
                                  <Box sx={{
                                    width: 20, height: 20, borderRadius: '50%', background: '#5a67d8',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '0.8rem', color: 'white', fontWeight: 'bold'
                                  }}>
                                    ⭐
                                  </Box>
                                </MenuItem>
                                <MenuItem value="star"><StarIcon sx={{ color: '#ffe066' }} /></MenuItem>
                                <MenuItem value="info"><InfoIcon sx={{ color: '#40c4ff' }} /></MenuItem>
                                <MenuItem value="warning"><WarningIcon sx={{ color: '#ffb347' }} /></MenuItem>
                              </Select>
                            </Box>

                            {/* First Text Line (Title) */}
                            <Box sx={{ mb: 1 }}>
                              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 'bold' }}>Title (Line 1):</Typography>
                              <TextField
                                value={listItemTextValues[`${selectedElement.id}-${idx}-text1`] !== undefined
                                  ? listItemTextValues[`${selectedElement.id}-${idx}-text1`]
                                  : row.text1}
                                onChange={e => {
                                  const key = `${selectedElement.id}-${idx}-text1`;
                                  setListItemTextValues(prev => ({
                                    ...prev,
                                    [key]: e.target.value
                                  }));
                                }}
                                onBlur={() => {
                                  const key = `${selectedElement.id}-${idx}-text1`;
                                  const newValue = listItemTextValues[key];
                                  if (newValue !== undefined) {
                                    const newRows = [...selectedElement.rows];
                                    newRows[idx].text1 = newValue;
                                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setListItemTextValues(prev => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    const key = `${selectedElement.id}-${idx}-text1`;
                                    const newValue = listItemTextValues[key];
                                    if (newValue !== undefined) {
                                      const newRows = [...selectedElement.rows];
                                      newRows[idx].text1 = newValue;
                                      updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                      setListItemTextValues(prev => {
                                        const updated = { ...prev };
                                        delete updated[key];
                                        return updated;
                                      });
                                      e.target.blur();
                                    }
                                  }
                                }}
                                fullWidth
                                size="small"
                                placeholder="Feature title"
                                autoFocus={false}
                              />
                            </Box>

                            {/* Second Text Line (Description) */}
                            <Box sx={{ mb: 1 }}>
                              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 'bold' }}>Description (Line 2):</Typography>
                              <TextField
                                value={listItemTextValues[`${selectedElement.id}-${idx}-text2`] !== undefined
                                  ? listItemTextValues[`${selectedElement.id}-${idx}-text2`]
                                  : row.text2}
                                onChange={e => {
                                  const key = `${selectedElement.id}-${idx}-text2`;
                                  setListItemTextValues(prev => ({
                                    ...prev,
                                    [key]: e.target.value
                                  }));
                                }}
                                onBlur={() => {
                                  const key = `${selectedElement.id}-${idx}-text2`;
                                  const newValue = listItemTextValues[key];
                                  if (newValue !== undefined) {
                                    const newRows = [...selectedElement.rows];
                                    newRows[idx].text2 = newValue;
                                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setListItemTextValues(prev => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });
                                  }
                                }}
                                fullWidth
                                size="small"
                                multiline
                                rows={2}
                                placeholder="Feature description"
                                autoFocus={false}
                              />
                            </Box>

                            {/* Row Actions */}
                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  // Duplicate the current row and insert it below
                                  const newRows = [...selectedElement.rows];
                                  const duplicatedRow = {
                                    ...row,
                                    text1: `${row.text1} (copy)`,
                                    text2: `${row.text2} (copy)`
                                  };
                                  newRows.splice(idx + 1, 0, duplicatedRow);
                                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                title="Duplicate row"
                              >
                                <DuplicateIcon />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                title="Remove row"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </Box>
                        ))}

                        <Button
                          onClick={() => {
                            const newRows = [...selectedElement.rows, {
                              icon: 'check',
                              text1: 'New Feature',
                              text2: 'Description of the new feature'
                            }];
                            updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            setSelectedElement({ ...selectedElement, rows: newRows });
                          }}
                          startIcon={<AddIcon />}
                          sx={{ mb: 2 }}
                        >
                          Add Row
                        </Button>
                      </>
                    )}

                    {selectedElement.type === ELEMENT_TYPES.VIDEO && (
                      <>
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video File</Typography>
                          <S3FileUpload
                            onUploadComplete={({ url }) => {
                              console.log('🎥 Video upload completed:', { url, elementId: selectedElement.id });
                              updateElement(selectedElement.id, { videoFile: url }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              // Force immediate re-render for video updates
                              console.log('🔄 Forcing immediate re-render after video upload');
                              setForceRender(prev => prev + 1);
                              // Also update selectedElement directly to ensure immediate UI update
                              setSelectedElement(prev => ({ ...prev, videoFile: url }));
                            }}
                            onUploadError={(error) => {
                              console.error('❌ Video upload failed:', error);
                              setStatusTitle('Video Upload Failed');
                              setStatusMessage(`Video upload failed: ${error.message}`);
                              setShowStatusAlert(true);
                            }}
                            acceptedTypes="video/*"
                            buttonText="Choose Video File"
                            buttonSize="small"
                            startIcon={<VideoIcon />}
                            folder="offer-templates/videos"
                            showProgress={true}
                          />
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
                            {selectedElement.videoFile && (
                              <Button
                                variant="text"
                                color="error"
                                size="small"
                                onClick={() => updateElement(selectedElement.id, { videoFile: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                              >
                                Remove Video
                              </Button>
                            )}
                          </Box>
                          {selectedElement.videoFile && (
                            <>
                              <Box sx={{ border: '1px solid #eee', borderRadius: 1, p: 1, display: 'inline-block' }}>
                                <video
                                  src={selectedElement.videoFile}
                                  controls
                                  style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                                />
                              </Box>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                Video uploaded successfully! It will be displayed in the exported HTML.
                              </Typography>
                            </>
                          )}
                        </Box>

                        {/* Video Thumbnail Upload - MANDATORY for video elements */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video Thumbnail (Required)</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                            Upload a thumbnail image that will be displayed before the video plays. This is required for video elements.
                          </Typography>
                          {selectedElement.videoFile && !selectedElement.thumbnailUrl && (
                            <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                              ⚠️ Thumbnail is required for video elements. Please upload a thumbnail before saving.
                            </Typography>
                          )}

                          {(!selectedElement.thumbnailUrl) && (
                            <Box sx={{ mb: 1 }}>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                                    if (uploadedUrl) {
                                      console.log('🖼️ Thumbnail upload completed:', uploadedUrl);
                                      updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                      setForceRender(prev => prev + 1);
                                      setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                                    }
                                  }
                                }}
                                style={{ display: 'none' }}
                                id={`thumbnail-upload-${selectedElement.id}`}
                              />
                              <label htmlFor={`thumbnail-upload-${selectedElement.id}`}>
                                <Button
                                  variant="outlined"
                                  component="span"
                                  size="small"
                                  fullWidth
                                  startIcon={<ImageIcon />}
                                  disabled={imageUploading && uploadingElementId === selectedElement.id}
                                >
                                  {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Choose Thumbnail Image'}
                                </Button>
                              </label>
                            </Box>
                          )}

                          {selectedElement.thumbnailUrl && (
                            <>
                              <Box sx={{ textAlign: 'center', mb: 1 }}>
                                <img
                                  src={selectedElement.thumbnailUrl}
                                  alt="Video thumbnail"
                                  style={{ maxWidth: '200px', height: 'auto', display: 'block', margin: '0 auto' }}
                                />
                              </Box>
                              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 1 }}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={async (e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                      const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                                      if (uploadedUrl) {
                                        console.log('🖼️ Thumbnail replacement completed:', uploadedUrl);
                                        updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                        setForceRender(prev => prev + 1);
                                        setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                                      }
                                    }
                                  }}
                                  style={{ display: 'none' }}
                                  id={`thumbnail-replace-${selectedElement.id}`}
                                />
                                <label htmlFor={`thumbnail-replace-${selectedElement.id}`}>
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    size="small"
                                    disabled={imageUploading && uploadingElementId === selectedElement.id}
                                  >
                                    {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Replace Thumbnail'}
                                  </Button>
                                </label>
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => {
                                    updateElement(selectedElement.id, { thumbnailUrl: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setForceRender(prev => prev + 1);
                                    setSelectedElement(prev => ({ ...prev, thumbnailUrl: '' }));
                                  }}
                                >
                                  Remove Thumbnail
                                </Button>
                              </Box>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                                Thumbnail uploaded successfully! It will be used as the video poster.
                              </Typography>
                            </>
                          )}
                        </Box>
                      </>
                    )}


                    {selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY && (
                      <>
                        {/* Video Upload Section - Same as VIDEO element */}


                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video File</Typography>
                          <S3FileUpload
                            onUploadComplete={({ url }) => {
                              updateElement(selectedElement.id, { videoFile: url }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              setForceRender(prev => prev + 1);
                              setSelectedElement(prev => ({ ...prev, videoFile: url }));
                            }}
                            onUploadError={(error) => {
                              setStatusTitle('Video Upload Failed');
                              setStatusMessage(`Video upload failed: ${error.message}`);
                              setShowStatusAlert(true);
                            }}
                            acceptedTypes="video/*"
                            buttonText="Choose Video File"
                            buttonSize="small"
                            startIcon={<VideoIcon />}
                            folder="offer-templates/videos"
                            showProgress={true}
                          />
                          {selectedElement.videoFile && (
                            <Button
                              variant="text"
                              color="error"
                              size="small"
                              onClick={() => updateElement(selectedElement.id, { videoFile: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                              sx={{ mt: 1 }}
                            >
                              Remove Video
                            </Button>
                          )}
                        </Box>

                        {/* Thumbnail Upload */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>Video Thumbnail</Typography>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                                if (uploadedUrl) {
                                  updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  setForceRender(prev => prev + 1);
                                  setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                                }
                              }
                            }}
                            style={{ display: 'none' }}
                            id={`thumbnail-upload-overlay-${selectedElement.id}`}
                          />
                          <label htmlFor={`thumbnail-upload-overlay-${selectedElement.id}`}>
                            <Button
                              variant="outlined"
                              component="span"
                              size="small"
                              fullWidth
                              startIcon={<ImageIcon />}
                            >
                              {selectedElement.thumbnailUrl ? 'Change Thumbnail' : 'Upload Thumbnail'}
                            </Button>
                          </label>
                          {selectedElement.thumbnailUrl && (
                            <Box sx={{ mt: 1, textAlign: 'center' }}>
                              <img
                                src={selectedElement.thumbnailUrl}
                                alt="Thumbnail"
                                style={{ maxWidth: '200px', height: 'auto' }}
                              />
                            </Box>
                          )}
                        </Box>

                      </>
                    )}

                    {selectedElement.type === ELEMENT_TYPES.MEDIA && (
                      <>
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" gutterBottom>
                            Upload image or video file
                          </Typography>

                          {/* File Input */}
                          <input
                            type="file"
                            accept="image/*,video/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                handleMediaUploadForElement(file, selectedElement.id, selectedElementContext);
                              }
                              // Reset input to allow selecting the same file again
                              e.target.value = '';
                            }}
                            style={{ display: 'none' }}
                            id={`media-upload-${selectedElement.id}`}
                            disabled={imageUploading && uploadingElementId === selectedElement.id}
                          />
                          <label htmlFor={`media-upload-${selectedElement.id}`}>
                            <Button
                              variant="outlined"
                              component="span"
                              fullWidth
                              sx={{ mb: 1 }}
                              disabled={imageUploading && uploadingElementId === selectedElement.id}
                              startIcon={<UploadIcon />}
                            >
                              {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Choose image or video file'}
                            </Button>
                          </label>

                          {/* Selected File Display */}
                          {selectedElement.mediaUrl && (
                            <Box sx={{
                              mb: 1,
                              p: 2,
                              backgroundColor: '#e3f2fd',
                              borderRadius: 1,
                              border: '1px solid #1976d2'
                            }}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}>
                                ✅ Media uploaded successfully
                              </Typography>
                              {selectedElement.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) ? (
                                <Box sx={{ textAlign: 'center', mb: 1 }}>
                                  <video
                                    src={selectedElement.mediaUrl}
                                    controls
                                    poster={selectedElement.thumbnailUrl || undefined}
                                    style={{
                                      maxWidth: '100%',
                                      maxHeight: '200px',
                                      borderRadius: '8px'
                                    }}
                                  />
                                </Box>
                              ) : (
                                <Box sx={{ textAlign: 'center', mb: 1 }}>
                                  <img
                                    src={selectedElement.mediaUrl}
                                    alt="Media preview"
                                    style={{
                                      maxWidth: '100%',
                                      maxHeight: '200px',
                                      borderRadius: '8px'
                                    }}
                                  />
                                </Box>
                              )}
                              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mt: 1 }}>
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => {
                                    updateElement(selectedElement.id, { mediaUrl: '', thumbnailUrl: '' }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setForceRender(prev => prev + 1);
                                    setSelectedElement(prev => ({ ...prev, mediaUrl: '', thumbnailUrl: '' }));
                                  }}
                                >
                                  Remove Media
                                </Button>
                              </Box>
                            </Box>
                          )}

                          {/* Video Thumbnail Upload - MANDATORY for videos */}
                          {selectedElement.mediaUrl && selectedElement.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) && (
                            <Box sx={{ mb: 2 }}>
                              <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Video Thumbnail (Required)</Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                                Upload a thumbnail image that will be displayed before the video plays. This is required for video elements.
                              </Typography>
                              {!selectedElement.thumbnailUrl && (
                                <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                                  ⚠️ Thumbnail is required for video elements. Please upload a thumbnail.
                                </Typography>
                              )}

                              {(!selectedElement.thumbnailUrl) && (
                                <Box sx={{ mb: 1 }}>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={async (e) => {
                                      const file = e.target.files[0];
                                      if (file) {
                                        const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                                        if (uploadedUrl) {
                                          console.log('🖼️ Thumbnail upload completed:', uploadedUrl);
                                          updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                          setForceRender(prev => prev + 1);
                                          setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                                        }
                                      }
                                    }}
                                    style={{ display: 'none' }}
                                    id={`media-thumbnail-upload-${selectedElement.id}`}
                                  />
                                  <label htmlFor={`media-thumbnail-upload-${selectedElement.id}`}>
                                    <Button
                                      variant="outlined"
                                      component="span"
                                      size="small"
                                      fullWidth
                                      startIcon={<ImageIcon />}
                                      disabled={imageUploading && uploadingElementId === selectedElement.id}
                                    >
                                      {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Choose Thumbnail Image'}
                                    </Button>
                                  </label>
                                </Box>
                              )}

                              {selectedElement.thumbnailUrl && (
                                <>
                                  <Box sx={{ textAlign: 'center', mb: 1 }}>
                                    <img
                                      src={selectedElement.thumbnailUrl}
                                      alt="Video thumbnail"
                                      style={{ maxWidth: '200px', height: 'auto', display: 'block', margin: '0 auto' }}
                                    />
                                  </Box>
                                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 1 }}>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={async (e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                          const uploadedUrl = await handleThumbnailUpload(file, selectedElement.id, selectedElementContext);
                                          if (uploadedUrl) {
                                            console.log('🖼️ Thumbnail replacement completed:', uploadedUrl);
                                            updateElement(selectedElement.id, { thumbnailUrl: uploadedUrl }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                            setForceRender(prev => prev + 1);
                                            setSelectedElement(prev => ({ ...prev, thumbnailUrl: uploadedUrl }));
                                          }
                                        }
                                      }}
                                      style={{ display: 'none' }}
                                      id={`media-thumbnail-replace-${selectedElement.id}`}
                                    />
                                    <label htmlFor={`media-thumbnail-replace-${selectedElement.id}`}>
                                      <Button
                                        variant="outlined"
                                        component="span"
                                        size="small"
                                        startIcon={<ImageIcon />}
                                        disabled={imageUploading && uploadingElementId === selectedElement.id}
                                      >
                                        Replace Thumbnail
                                      </Button>
                                    </label>
                                  </Box>
                                </>
                              )}
                            </Box>
                          )}

                          {/* Frame Presets for Video - Only show when video is uploaded */}
                          {selectedElement.mediaUrl && selectedElement.mediaUrl.match(/\.(mp4|avi|mov|wmv|flv|webm)$/i) && (
                            <Box sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <ImageIcon sx={{ fontSize: 20, color: '#666' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                  Frame Presets
                                </Typography>
                              </Box>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                                Choose a frame style for your media.
                              </Typography>

                              <Box sx={{ display: 'flex', gap: 0, border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                                <Button
                                  variant={selectedElement.styles?.aspectRatio === '1/1' ? 'contained' : 'text'}
                                  size="small"
                                  onClick={() => {
                                    updateElement(selectedElement.id, {
                                      styles: {
                                        ...selectedElement.styles,
                                        aspectRatio: '1/1'
                                      }
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '1/1' } }));
                                  }}
                                  sx={{
                                    flex: 1,
                                    borderRadius: 0,
                                    borderRight: '1px solid #e0e0e0',
                                    fontSize: '0.65rem',
                                    fontWeight: selectedElement.styles?.aspectRatio === '1/1' ? 'bold' : 'normal',
                                    py: 1
                                  }}
                                >
                                  SQUARE
                                </Button>
                                <Button
                                  variant={selectedElement.styles?.aspectRatio === '16/9' ? 'contained' : 'text'}
                                  size="small"
                                  onClick={() => {
                                    updateElement(selectedElement.id, {
                                      styles: {
                                        ...selectedElement.styles,
                                        aspectRatio: '16/9'
                                      }
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '16/9' } }));
                                  }}
                                  sx={{
                                    flex: 1,
                                    borderRadius: 0,
                                    borderRight: '1px solid #e0e0e0',
                                    fontSize: '0.65rem',
                                    fontWeight: selectedElement.styles?.aspectRatio === '16/9' ? 'bold' : 'normal',
                                    py: 1
                                  }}
                                >
                                  LANDSCAPE
                                </Button>
                                <Button
                                  variant={selectedElement.styles?.aspectRatio === '9/16' ? 'contained' : 'text'}
                                  size="small"
                                  onClick={() => {
                                    updateElement(selectedElement.id, {
                                      styles: {
                                        ...selectedElement.styles,
                                        aspectRatio: '9/16'
                                      }
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '9/16' } }));
                                  }}
                                  sx={{
                                    flex: 1,
                                    borderRadius: 0,
                                    borderRight: '1px solid #e0e0e0',
                                    fontSize: '0.65rem',
                                    fontWeight: selectedElement.styles?.aspectRatio === '9/16' ? 'bold' : 'normal',
                                    py: 1
                                  }}
                                >
                                  PORTRAIT
                                </Button>
                                <Button
                                  variant={selectedElement.styles?.aspectRatio === '4/5' ? 'contained' : 'text'}
                                  size="small"
                                  onClick={() => {
                                    updateElement(selectedElement.id, {
                                      styles: {
                                        ...selectedElement.styles,
                                        aspectRatio: '4/5'
                                      }
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    setSelectedElement(prev => ({ ...prev, styles: { ...prev.styles, aspectRatio: '4/5' } }));
                                  }}
                                  sx={{
                                    flex: 1,
                                    borderRadius: 0,
                                    fontSize: '0.65rem',
                                    fontWeight: selectedElement.styles?.aspectRatio === '4/5' ? 'bold' : 'normal',
                                    py: 1
                                  }}
                                >
                                  PORTRAIT45
                                </Button>
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </>
                    )}

                    {selectedElement.type === ELEMENT_TYPES.HTML && (
                      <TextField
                        fullWidth
                        multiline
                        rows={6}
                        label="HTML Content"
                        value={selectedElement.content}
                        onChange={(e) => updateElement(selectedElement.id, { content: e.target.value })}
                        sx={{ mb: 2 }}
                      />
                    )}
                    {/* Custom Button Elements */}
                    {(selectedElement.type === 'BUTTON_WITH_NOTICE' ||
                      selectedElement.type === 'BUTTON_IMAGE_CALLOUT' ||
                      selectedElement.type === 'BUTTON_TEXT_VARIANT' ||
                      selectedElement.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE') && (
                        <>
                          <TextField
                            fullWidth
                            label="Button Text"
                            value={selectedElement.content?.buttonText || ''}
                            onChange={(e) => updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, buttonText: e.target.value }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                            sx={{ mb: 2 }}
                          />
                          <TextField
                            fullWidth
                            label="Button URL"
                            value={selectedElement.content?.buttonUrl || ''}
                            onChange={(e) => updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, buttonUrl: e.target.value }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                            disabled={isBrandsPage}
                            sx={{ mb: 2 }}
                          />
                          {selectedElement.type === 'BUTTON_WITH_NOTICE' && (
                            <>
                              <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Notice Text"
                                value={selectedElement.content?.notice || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, notice: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />
                              <TextField
                                fullWidth
                                label="Call to Action"
                                value={selectedElement.content?.callToAction || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, callToAction: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />
                            </>
                          )}
                          {selectedElement.type === 'BUTTON_IMAGE_CALLOUT' && (
                            <>
                              <TextField
                                fullWidth
                                label="Headline"
                                value={selectedElement.content?.headline || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, headline: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />
                              <TextField
                                fullWidth
                                label="Image URL"
                                value={selectedElement.content?.image || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, image: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />

                              {/* File Upload Section for BUTTON_IMAGE_CALLOUT */}
                              <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                                  Or Upload Image
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={async (e) => {
                                      const file = e.target.files[0];
                                      if (file) {
                                        const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                                        if (imageUrl) {
                                          updateElement(selectedElement.id, {
                                            content: { ...selectedElement.content, image: imageUrl }
                                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                        }
                                      }
                                    }}
                                    style={{ display: 'none' }}
                                    id={`image-upload-callout-${selectedElement.id}`}
                                  />
                                  <label htmlFor={`image-upload-callout-${selectedElement.id}`}>
                                    <Button
                                      variant="outlined"
                                      component="span"
                                      startIcon={<UploadIcon />}
                                      disabled={imageUploading && uploadingElementId === selectedElement.id}
                                      sx={{ minWidth: 120 }}
                                    >
                                      {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                                    </Button>
                                  </label>
                                  {imageUploading && uploadingElementId === selectedElement.id && (
                                    <Box sx={{ ml: 1 }}>
                                      <CircularProgress size={20} />
                                    </Box>
                                  )}
                                </Box>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                  Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                                </Typography>
                              </Box>

                              <TextField
                                fullWidth
                                label="Badge Text"
                                value={selectedElement.content?.badge || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, badge: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />
                            </>
                          )}
                          {selectedElement.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE' && (
                            <>
                              <TextField
                                fullWidth
                                label="Headline"
                                value={selectedElement.content?.headline || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, headline: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />
                              <TextField
                                fullWidth
                                label="Product Image URL"
                                value={selectedElement.content?.productImage || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, productImage: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />

                              {/* File Upload Section for BUTTON_HEADLINE_PRODUCT_IMAGE */}
                              <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                                  Or Upload Product Image
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={async (e) => {
                                      const file = e.target.files[0];
                                      if (file) {
                                        const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                                        if (imageUrl) {
                                          updateElement(selectedElement.id, {
                                            content: { ...selectedElement.content, productImage: imageUrl }
                                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                        }
                                      }
                                    }}
                                    style={{ display: 'none' }}
                                    id={`product-image-upload-${selectedElement.id}`}
                                  />
                                  <label htmlFor={`product-image-upload-${selectedElement.id}`}>
                                    <Button
                                      variant="outlined"
                                      component="span"
                                      startIcon={<UploadIcon />}
                                      disabled={imageUploading && uploadingElementId === selectedElement.id}
                                      sx={{ minWidth: 120 }}
                                    >
                                      {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                                    </Button>
                                  </label>
                                  {imageUploading && uploadingElementId === selectedElement.id && (
                                    <Box sx={{ ml: 1 }}>
                                      <CircularProgress size={20} />
                                    </Box>
                                  )}
                                </Box>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                  Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                                </Typography>
                              </Box>

                              <TextField
                                fullWidth
                                multiline
                                rows={2}
                                label="Subheadline (Optional)"
                                value={selectedElement.content?.subheadline || ''}
                                onChange={(e) => updateElement(selectedElement.id, {
                                  content: { ...selectedElement.content, subheadline: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                                sx={{ mb: 2 }}
                              />
                            </>
                          )}
                        </>
                      )}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST && (
                      <>
                        {selectedElement.rows.length > 1 && (
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const iconToApply = selectedElement.rows[0].icon;
                                const newRows = selectedElement.rows.map(row => ({ ...row, icon: iconToApply }));
                                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              title="Apply this icon to all items"
                            >
                              <span role="img" aria-label="apply to all">🔄</span>
                            </IconButton>
                            <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', ml: 1 }}>
                              Apply first icon to all items
                            </Box>
                          </Box>
                        )}
                        {selectedElement.rows.map((row, idx) => (
                          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Select
                              value={row.icon}
                              onChange={e => {
                                const newRows = [...selectedElement.rows];
                                newRows[idx].icon = e.target.value;
                                updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              sx={{ mr: 1, minWidth: 64 }}
                            >
                              <MenuItem value="check"><VerifiedIcon sx={{ color: '#b6ff3c' }} /></MenuItem>
                              <MenuItem value="red-x">
                                <Box sx={{
                                  width: '24px',
                                  height: '24px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '1.5rem',
                                  color: '#e53e3e',
                                  fontWeight: 'bold'
                                }}>
                                  ✗
                                </Box>
                              </MenuItem>
                              <MenuItem value="pink-check">
                                <Box sx={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '50%',
                                  backgroundColor: '#ff9a9e',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '1rem',
                                  color: 'white',
                                  fontWeight: 'bold'
                                }}>
                                  ✓
                                </Box>
                              </MenuItem>
                              <MenuItem value="dark-check">
                                <Box sx={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '4px',
                                  backgroundColor: '#2d3748',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '1rem',
                                  color: 'white',
                                  fontWeight: 'bold'
                                }}>
                                  ✓
                                </Box>
                              </MenuItem>
                              <MenuItem value="green-badge">
                                <Box sx={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  backgroundColor: '#68d391',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '1.2rem',
                                  color: 'white',
                                  fontWeight: 'bold',
                                  border: '2px solid #48bb78'
                                }}>
                                  ✓
                                </Box>
                              </MenuItem>
                              <MenuItem value="star-badge">
                                <Box sx={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '1.2rem',
                                  color: 'white',
                                  fontWeight: 'bold',
                                  border: '2px solid #5a67d8'
                                }}>
                                  ⭐
                                </Box>
                              </MenuItem>
                              <MenuItem value="star"><StarIcon sx={{ color: '#ffe066' }} /></MenuItem>
                              <MenuItem value="info"><InfoIcon sx={{ color: '#40c4ff' }} /></MenuItem>
                              <MenuItem value="warning"><WarningIcon sx={{ color: '#ffb347' }} /></MenuItem>
                              <MenuItem value="green-number">
                                <Box sx={{
                                  width: 28, height: 28, borderRadius: '6px', background: '#22c55e',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  color: 'white', fontWeight: 'bold', fontSize: '1.2rem'
                                }}>
                                  {idx + 1}
                                </Box>
                              </MenuItem>
                              <MenuItem value="circle-number">
                                <Box sx={{
                                  width: 28, height: 28, borderRadius: '50%', border: '2px solid #22c55e',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  color: '#22c55e', fontWeight: 'bold', fontSize: '1.2rem', background: 'white'
                                }}>
                                  {idx + 1}
                                </Box>
                              </MenuItem>
                            </Select>
                            <TextField
                              value={listItemTextValues[`${selectedElement.id}-${idx}`] !== undefined
                                ? listItemTextValues[`${selectedElement.id}-${idx}`]
                                : row.text}
                              onChange={e => {
                                const key = `${selectedElement.id}-${idx}`;
                                setListItemTextValues(prev => ({
                                  ...prev,
                                  [key]: e.target.value
                                }));
                              }}
                              onBlur={() => {
                                const key = `${selectedElement.id}-${idx}`;
                                const newValue = listItemTextValues[key];
                                if (newValue !== undefined) {
                                  const newRows = [...selectedElement.rows];
                                  newRows[idx].text = newValue;
                                  updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  // Clear the temp value after saving
                                  setListItemTextValues(prev => {
                                    const updated = { ...prev };
                                    delete updated[key];
                                    return updated;
                                  });
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  const key = `${selectedElement.id}-${idx}`;
                                  const newValue = listItemTextValues[key];
                                  if (newValue !== undefined) {
                                    const newRows = [...selectedElement.rows];
                                    newRows[idx].text = newValue;
                                    updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    // Clear the temp value after saving
                                    setListItemTextValues(prev => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });
                                    e.target.blur();
                                  }
                                }
                              }}
                              sx={{ flex: 1 }}
                              autoFocus={false}
                            />
                            <IconButton onClick={() => {
                              // Duplicate the current row and insert it below
                              const newRows = [...selectedElement.rows];
                              const duplicatedRow = { ...row, text: `${row.text} (copy)` };
                              newRows.splice(idx + 1, 0, duplicatedRow);
                              updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              setSelectedElement({ ...selectedElement, rows: newRows });
                            }} title="Duplicate row">
                              <DuplicateIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                              const newRows = selectedElement.rows.filter((_, i) => i !== idx);
                              updateElement(selectedElement.id, { rows: newRows }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              setSelectedElement({ ...selectedElement, rows: newRows });
                            }} title="Remove row"><DeleteIcon /></IconButton>
                          </Box>
                        ))}
                        <Button onClick={() => {
                          updateElement(selectedElement.id, { rows: [...selectedElement.rows, { icon: 'check', text: 'New item' }] });
                        }} startIcon={<AddIcon />} sx={{ mb: 2 }}>Add Row</Button>

                      </>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.PROCESS_STEPS && (
                      <>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
                          📋 Process Steps Content
                        </Typography>
                        {selectedElement.steps.map((step, idx) => (
                          <Box key={idx} sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                              Step {step.number}
                            </Typography>

                            <TextField
                              fullWidth
                              label="Step Title"
                              value={step.title}
                              onChange={(e) => {
                                const newSteps = [...selectedElement.steps];
                                newSteps[idx].title = e.target.value;
                                updateElement(selectedElement.id, { steps: newSteps });
                              }}
                              sx={{ mb: 2 }}
                            />

                            <TextField
                              fullWidth
                              multiline
                              rows={2}
                              label="Step Description"
                              value={step.description}
                              onChange={(e) => {
                                const newSteps = [...selectedElement.steps];
                                newSteps[idx].description = e.target.value;
                                updateElement(selectedElement.id, { steps: newSteps });
                              }}
                              sx={{ mb: 2 }}
                            />

                            <TextField
                              fullWidth
                              label="Image URL"
                              value={step.image}
                              onChange={(e) => {
                                const newSteps = [...selectedElement.steps];
                                newSteps[idx].image = e.target.value;
                                updateElement(selectedElement.id, { steps: newSteps });
                              }}
                              sx={{ mb: 2 }}
                            />

                            {/* File Upload Section for Process Step Image */}
                            <Box sx={{ mb: 2 }}>
                              <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Or Upload Step Image
                              </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={async (e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                      const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                                      if (imageUrl) {
                                        const newSteps = [...selectedElement.steps];
                                        newSteps[idx].image = imageUrl;
                                        updateElement(selectedElement.id, { steps: newSteps });
                                      }
                                    }
                                  }}
                                  style={{ display: 'none' }}
                                  id={`process-step-image-upload-${selectedElement.id}-${idx}`}
                                />
                                <label htmlFor={`process-step-image-upload-${selectedElement.id}-${idx}`}>
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<UploadIcon />}
                                    disabled={imageUploading && uploadingElementId === selectedElement.id}
                                    sx={{ minWidth: 120 }}
                                  >
                                    {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                                  </Button>
                                </label>
                                {imageUploading && uploadingElementId === selectedElement.id && (
                                  <Box sx={{ ml: 1 }}>
                                    <CircularProgress size={20} />
                                  </Box>
                                )}
                              </Box>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                              </Typography>
                            </Box>

                            <TextField
                              fullWidth
                              label="Number Badge Color"
                              value={step.numberColor || '#1976d2'}
                              onChange={(e) => {
                                const newSteps = [...selectedElement.steps];
                                newSteps[idx].numberColor = e.target.value;
                                updateElement(selectedElement.id, { steps: newSteps });
                              }}
                              placeholder="#1976d2"
                            />
                          </Box>
                        ))}
                      </>
                    )}
                    {selectedElement.type === ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE && (
                      <>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
                          📝 Text + Right Image Content
                        </Typography>

                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          label="Text Content"
                          value={selectedElement.content.text}
                          onChange={(e) => {
                            updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, text: e.target.value }
                            });
                          }}
                          sx={{ mb: 2 }}
                        />

                        <TextField
                          fullWidth
                          label="Image URL"
                          value={selectedElement.content.image}
                          onChange={(e) => {
                            updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, image: e.target.value }
                            });
                          }}
                          sx={{ mb: 2 }}
                        />

                        {/* File Upload Section for Text + Right Image */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="button" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Or Upload Image
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                                  if (imageUrl) {
                                    updateElement(selectedElement.id, {
                                      content: { ...selectedElement.content, image: imageUrl }
                                    });
                                  }
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`text-right-image-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`text-right-image-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                disabled={imageUploading && uploadingElementId === selectedElement.id}
                                sx={{ minWidth: 120 }}
                              >
                                {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                              </Button>
                            </label>
                            {imageUploading && uploadingElementId === selectedElement.id && (
                              <Box sx={{ ml: 1 }}>
                                <CircularProgress size={20} />
                              </Box>
                            )}
                          </Box>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                          </Typography>
                        </Box>
                      </>
                    )}



                    {selectedElement.type === ELEMENT_TYPES.LEFT_IMAGE_TEXT && (
                      <>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
                          🖼️ Left Image + Text Content
                        </Typography>

                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          label="Text Content"
                          value={selectedElement.content.text}
                          onChange={(e) => {
                            updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, text: e.target.value }
                            });
                          }}
                          sx={{ mb: 2 }}
                        />

                        <TextField
                          fullWidth
                          label="Image URL"
                          value={selectedElement.content.image}
                          onChange={(e) => {
                            updateElement(selectedElement.id, {
                              content: { ...selectedElement.content, image: e.target.value }
                            });
                          }}
                          sx={{ mb: 2 }}
                        />

                        {/* File Upload Section for Left Image + Text */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Or Upload Image
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                                  if (imageUrl) {
                                    updateElement(selectedElement.id, {
                                      content: { ...selectedElement.content, image: imageUrl }
                                    });
                                  }
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`left-image-text-upload-${selectedElement.id}`}
                            />
                            <label htmlFor={`left-image-text-upload-${selectedElement.id}`}>
                              <Button
                                variant="outlined"
                                component="span"
                                startIcon={<UploadIcon />}
                                disabled={imageUploading && uploadingElementId === selectedElement.id}
                                sx={{ minWidth: 120 }}
                              >
                                {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Image'}
                              </Button>
                            </label>
                            {imageUploading && uploadingElementId === selectedElement.id && (
                              <Box sx={{ ml: 1 }}>
                                <CircularProgress size={20} />
                              </Box>
                            )}
                          </Box>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            Supported formats: JPG, PNG, GIF, WEBP (max 5MB) • Images stored locally
                          </Typography>
                        </Box>

                        {/* Image Size Control */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Image Size
                          </Typography>
                          <Box sx={{ px: 2 }}>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                              Size: {selectedElement.imageSize || 120}px
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <Typography variant="caption">60</Typography>
                              <Box sx={{ flex: 1 }}>
                                <input
                                  type="range"
                                  min="60"
                                  max="300"
                                  value={selectedElement.imageSize || 120}
                                  onChange={(e) => {
                                    const newSize = parseInt(e.target.value);
                                    // Debounce updates to prevent ResizeObserver errors
                                    clearTimeout(window.imageSizeTimeout);
                                    window.imageSizeTimeout = setTimeout(() => {
                                      updateElement(selectedElement.id, {
                                        imageSize: newSize
                                      });
                                    }, 50);
                                  }}
                                  style={{ width: '100%' }}
                                />
                              </Box>
                              <Typography variant="caption">300</Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* Spacing Control */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Spacing Between Image and Text
                          </Typography>
                          <Box sx={{ px: 2 }}>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                              Gap: {selectedElement.spacing || 20}px
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <Typography variant="caption">0</Typography>
                              <Box sx={{ flex: 1 }}>
                                <input
                                  type="range"
                                  min="0"
                                  max="80"
                                  value={selectedElement.spacing || 20}
                                  onChange={(e) => {
                                    const newSpacing = parseInt(e.target.value);
                                    // Debounce updates to prevent ResizeObserver errors
                                    clearTimeout(window.spacingTimeout);
                                    window.spacingTimeout = setTimeout(() => {
                                      updateElement(selectedElement.id, {
                                        spacing: newSpacing
                                      });
                                    }, 50);
                                  }}
                                  style={{ width: '100%' }}
                                />
                              </Box>
                              <Typography variant="caption">80</Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* Image Alignment Control */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Image Vertical Alignment
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose how the image aligns with the text content
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            {[
                              { value: 'top', label: 'Top', icon: '⬆️' },
                              { value: 'center', label: 'Center', icon: '↔️' },
                              { value: 'bottom', label: 'Bottom', icon: '⬇️' }
                            ].map((option) => (
                              <Button
                                key={option.value}
                                variant={selectedElement.imageAlignment === option.value ? 'contained' : 'outlined'}
                                size="small"
                                onClick={() => {
                                  updateElement(selectedElement.id, {
                                    imageAlignment: option.value
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                sx={{
                                  minWidth: 70,
                                  backgroundColor: selectedElement.imageAlignment === option.value ? '#1976d2' : '#ffffff',
                                  color: selectedElement.imageAlignment === option.value ? '#ffffff' : '#1976d2',
                                  border: `1px solid #1976d2`,
                                  '&:hover': {
                                    backgroundColor: selectedElement.imageAlignment === option.value ? '#1565c0' : '#e3f2fd'
                                  }
                                }}
                              >
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                  <Typography variant="caption" sx={{ fontSize: '10px' }}>
                                    {option.icon}
                                  </Typography>
                                  <Typography variant="caption" sx={{ fontSize: '10px' }}>
                                    {option.label}
                                  </Typography>
                                </Box>
                              </Button>
                            ))}
                          </Box>
                        </Box>


                      </>
                    )}
                  </Box>
                )}


                {/* Style Tab */}
                {tabValue === 1 && selectedElement && (
                  <Box>
                    {/* Header with Title */}
                    <Box sx={{
                      mb: 2,
                      pb: 1.5,
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <Typography variant="subtitle1" sx={{ mb: 0 }}>
                        🎨 Styling Options
                      </Typography>
                    </Box>

                    {/* Custom List Text Style Presets */}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST && (
                      <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🎨 List Item Text Style
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Choose a preset style that applies to all list items
                        </Typography>

                        <SimplePresetSelector
                          onStyleSelect={(presetName, styles) => {
                            console.log('🎨 Custom list preset selected:', presetName, styles);
                            updateElement(selectedElement.id, { textStylePreset: presetName });
                          }}
                          currentStyle={selectedElement.textStylePreset}
                          presetFilter={(presetName) => {
                            // Only show presets that text elements have (exclude quotation and bullet presets)
                            return !presetName.includes('quotation') &&
                              !presetName.includes('bullet');
                          }}
                        />
                      </Box>
                    )}

                    {/* Custom List Background Color Settings */}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST && (
                      <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🎨 Background Color
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Choose a preset color or enter a custom value
                        </Typography>

                        {/* Enhanced Color Palette */}
                        <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${isBrandsPage ? 6 : 8}, 1fr)`, gap: 1, mb: 2 }}>
                          {getInlineBackgroundColors().map((color) => {
                            const currentBgColor = selectedElement.styles?.backgroundColor || 'transparent';
                            const isSelected = currentBgColor === color.value;

                            return (
                              <Box
                                key={color.name}
                                onClick={() => {
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, backgroundColor: color.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                sx={{
                                  width: '100%',
                                  height: '32px',
                                  backgroundColor: color.value === 'transparent' ? '#f5f5f5' : color.value,
                                  border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  '&:hover': {
                                    opacity: 0.8,
                                    transform: 'scale(1.05)'
                                  },
                                  ...(color.value === 'transparent' && {
                                    backgroundImage: 'linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(-45deg, transparent 75%, #ccc 75%)',
                                    backgroundSize: '8px 8px',
                                    backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px'
                                  })
                                }}
                                title={`${color.name} (${color.value})`}
                              />
                            );
                          })}
                        </Box>

                        {/* Custom color input - Hide in Brands page */}
                        {!isBrandsPage && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                            <input
                              type="color"
                              value={(() => {
                                const bgColor = selectedElement.styles?.backgroundColor || 'transparent';
                                if (bgColor === 'transparent' || bgColor === 'none') return '#ffffff';
                                if (bgColor.startsWith('#')) return bgColor;
                                return '#ffffff';
                              })()}
                              onChange={(e) => {
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, backgroundColor: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              style={{
                                width: '50px',
                                height: '40px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title="Pick a color"
                            />
                            <TextField
                              fullWidth
                              label="Custom Background Color"
                              value={selectedElement.styles?.backgroundColor || 'transparent'}
                              onChange={(e) => {
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, backgroundColor: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              placeholder="e.g., #181818, rgb(24,24,24), or transparent"
                              helperText="Enter any valid CSS color value"
                            />
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* Custom List Text Transform Settings */}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST && (
                      <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🔤 Text Transform
                        </Typography>

                        <TextField
                          fullWidth
                          label="Text Transform"
                          select
                          value={selectedElement.styles?.textTransform || 'none'}
                          onChange={e => updateElement(selectedElement.id, { styles: { ...selectedElement.styles, textTransform: e.target.value } })}
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="none">Normal</MenuItem>
                          <MenuItem value="uppercase">ALL CAPITAL</MenuItem>
                          <MenuItem value="capitalize">First Letter Capital</MenuItem>
                          <MenuItem value="titlecase">Title Case</MenuItem>
                          <MenuItem value="lowercase">all lowercase</MenuItem>
                        </TextField>
                      </Box>
                    )}

                    {/* Custom List Text Color Settings */}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST && (
                      <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🎨 Text Color
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Choose a preset color or enter a custom value
                        </Typography>

                        {/* Text Color Palette */}
                        <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${isBrandsPage ? 5 : 8}, 1fr)`, gap: 1, mb: 2 }}>
                          {getInlineTextColors().map((color) => {
                            const currentTextColor = selectedElement.styles?.color || '#ffffff';
                            const isSelected = currentTextColor === color.value;

                            return (
                              <Box
                                key={color.name}
                                onClick={() => {
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, color: color.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                sx={{
                                  width: '100%',
                                  height: '32px',
                                  backgroundColor: color.value,
                                  border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  '&:hover': {
                                    opacity: 0.8,
                                    transform: 'scale(1.05)'
                                  }
                                }}
                                title={`${color.name} (${color.value})`}
                              />
                            );
                          })}
                        </Box>

                        {/* Custom text color input - Hide in Brands page */}
                        {!isBrandsPage && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                            <input
                              type="color"
                              value={(() => {
                                const textColor = selectedElement.styles?.color || '#ffffff';
                                if (textColor.startsWith('#')) return textColor;
                                return '#ffffff';
                              })()}
                              onChange={(e) => {
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, color: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              style={{
                                width: '50px',
                                height: '40px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title="Pick a color"
                            />
                            <TextField
                              fullWidth
                              label="Custom Text Color"
                              value={selectedElement.styles?.color || '#ffffff'}
                              onChange={(e) => {
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, color: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }}
                              placeholder="e.g., #ffffff, rgb(255,255,255), or white"
                              helperText="Enter any valid CSS color value"
                            />
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* Two-Line Custom List Text Style Presets */}
                    {selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE && (
                      <>
                        {/* First Line (Title) Preset Selector */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            🎯 Title Text Style (Line 1)
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for feature titles
                          </Typography>

                          <SimplePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Two-line list title preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { textStylePreset1: presetName });
                            }}
                            currentStyle={selectedElement.textStylePreset1}
                            presetFilter={(presetName) => {
                              // Only show presets that text elements have (exclude quotation and bullet presets)
                              return !presetName.includes('quotation') &&
                                !presetName.includes('bullet');
                            }}
                          />
                        </Box>

                        {/* Second Line (Description) Preset Selector */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f0f9ff' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            📝 Description Text Style (Line 2)
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for feature descriptions
                          </Typography>

                          <SimplePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Two-line list description preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { textStylePreset2: presetName });
                            }}
                            currentStyle={selectedElement.textStylePreset2}
                            presetFilter={(presetName) => {
                              // Only show presets that text elements have (exclude quotation and bullet presets)
                              return !presetName.includes('quotation') &&
                                !presetName.includes('bullet');
                            }}
                          />
                        </Box>
                      </>
                    )}

                    {/* Preset Text Styles - Show for text-based elements except quotation blocks and buttons */}
                    {(selectedElement.type === ELEMENT_TYPES.TEXT ||
                      selectedElement.type === ELEMENT_TYPES.HEADING ||
                      selectedElement.type === ELEMENT_TYPES.TEXT_WITH_RIGHT_IMAGE ||
                      selectedElement.type === ELEMENT_TYPES.LEFT_IMAGE_TEXT ||
                      selectedElement.type === 'text' ||
                      selectedElement.type === 'heading') && (
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            🎨 Preset Text Styles
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Click any style to quickly apply a complete typography set.
                          </Typography>

                          <SimplePresetSelector
                            onStyleSelect={(presetName, preset) => {
                              console.log('🎨 Preset applied:', presetName, preset);
                              console.log('🎯 Current selectedElement:', selectedElement);
                              console.log('🎨 Preset fontFamily:', preset.fontFamily);
                              console.log('🎨 Preset fontSize:', preset.fontSize);

                              // List of preset-related properties that should be completely replaced
                              const presetProperties = [
                                'fontFamily',
                                'fontSize',
                                'fontWeight',
                                'lineHeight',
                                'letterSpacing',
                                'color',
                                'textAlign',
                                'textTransform',
                                'fontStyle'
                              ];

                              // Different elements store styles in different places
                              if (selectedElement.type === ELEMENT_TYPES.TEXT ||
                                selectedElement.type === ELEMENT_TYPES.HEADING ||
                                selectedElement.type === ELEMENT_TYPES.BUTTON ||
                                selectedElement.type === 'text' ||
                                selectedElement.type === 'heading' ||
                                selectedElement.type === 'button') {
                                // These elements use 'styles' property
                                // Start with existing styles, but remove all preset-related properties
                                const existingStyles = selectedElement.styles || {};
                                const nonPresetStyles = {};

                                // Copy only non-preset properties from existing styles
                                Object.keys(existingStyles).forEach(key => {
                                  if (!presetProperties.includes(key) && key !== 'presetStyle') {
                                    nonPresetStyles[key] = existingStyles[key];
                                  }
                                });

                                // Build new styles: non-preset properties + preset properties + presetStyle
                                const newStyles = {
                                  ...nonPresetStyles,
                                  ...preset,
                                  presetStyle: presetName
                                };

                                // Explicitly remove textTransform if not in preset (to clear uppercase from previous preset)
                                if (!preset.hasOwnProperty('textTransform')) {
                                  newStyles.textTransform = 'none';
                                }

                                console.log('📝 Previous styles:', existingStyles);
                                console.log('📝 New styles for main element:', newStyles);

                                // Check if element is in a zone
                                if (selectedElementContext?.isInZone && selectedElementContext?.layoutId && selectedElementContext?.zoneId) {
                                  updateElement(selectedElement.id, {
                                    styles: newStyles
                                  }, true, selectedElementContext.layoutId, selectedElementContext.zoneId);
                                } else {
                                  updateElement(selectedElement.id, {
                                    styles: newStyles
                                  });
                                }

                                // Debug: Check if selectedElement updates after a delay
                                setTimeout(() => {
                                  console.log('⏰ Delayed check - selectedElement styles:', selectedElement?.styles);
                                  console.log('⏰ Delayed check - selectedElement fontFamily:', selectedElement?.styles?.fontFamily);
                                  console.log('⏰ Delayed check - selectedElement fontSize:', selectedElement?.styles?.fontSize);
                                  console.log('⏰ Delayed check - selectedElement textTransform:', selectedElement?.styles?.textTransform);
                                }, 100);
                              } else {
                                // Other elements like TEXT_WITH_RIGHT_IMAGE use 'textStyles' property
                                // Start with existing textStyles, but remove all preset-related properties
                                const existingTextStyles = selectedElement.textStyles || {};
                                const nonPresetTextStyles = {};

                                // Copy only non-preset properties from existing textStyles
                                Object.keys(existingTextStyles).forEach(key => {
                                  if (!presetProperties.includes(key) && key !== 'presetStyle') {
                                    nonPresetTextStyles[key] = existingTextStyles[key];
                                  }
                                });

                                // Build new textStyles: non-preset properties + preset properties + presetStyle
                                const newTextStyles = {
                                  ...nonPresetTextStyles,
                                  ...preset,
                                  presetStyle: presetName
                                };

                                // Explicitly remove textTransform if not in preset (to clear uppercase from previous preset)
                                if (!preset.hasOwnProperty('textTransform')) {
                                  newTextStyles.textTransform = 'none';
                                }

                                console.log('📝 Previous textStyles:', existingTextStyles);
                                console.log('📝 New textStyles for composite element:', newTextStyles);

                                // Check if element is in a zone
                                if (selectedElementContext?.isInZone && selectedElementContext?.layoutId && selectedElementContext?.zoneId) {
                                  updateElement(selectedElement.id, {
                                    textStyles: newTextStyles
                                  }, true, selectedElementContext.layoutId, selectedElementContext.zoneId);
                                } else {
                                  updateElement(selectedElement.id, {
                                    textStyles: newTextStyles
                                  });
                                }

                                // Debug: Check if selectedElement updates after a delay
                                setTimeout(() => {
                                  console.log('⏰ Delayed check - selectedElement textStyles:', selectedElement?.textStyles);
                                  console.log('⏰ Delayed check - selectedElement textTransform:', selectedElement?.textStyles?.textTransform);
                                }, 100);
                              }
                            }}
                            currentStyle={
                              selectedElement.textStyles?.presetStyle ||
                              selectedElement.styles?.presetStyle ||
                              selectedElement.textStylePreset
                            }
                            presetFilter={(presetName) => !presetName.startsWith('quotation') && !presetName.startsWith('bullet')}
                          />
                        </Box>
                      )}

                    {/* Preset Button Styles - Show for button-based elements */}
                    {(selectedElement.type === ELEMENT_TYPES.BUTTON ||
                      selectedElement.type === 'button' ||
                      selectedElement.type === 'BUTTON_TEXT_VARIANT' ||
                      selectedElement.type === 'BUTTON_IMAGE_CALLOUT' ||
                      selectedElement.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE' ||
                      selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY) && (
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            🎨 Preset Button Styles
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Click any style to quickly apply a complete button styling set.
                          </Typography>

                          <ButtonPresetSelector
                            currentStyle={selectedElement?.styles?.presetStyle}
                            onStyleSelect={(presetName, preset) => {
                              console.log('🎨 Button preset applied:', presetName, preset);
                              console.log('🎯 Current selectedElement:', selectedElement);
                              console.log('🎨 Preset fontFamily:', preset.fontFamily);
                              console.log('🎨 Preset fontSize:', preset.fontSize);
                              console.log('🎨 Preset textTransform:', preset.textTransform);
                              console.log('🎨 Preset backgroundColor:', preset.backgroundColor);
                              console.log('🎨 Preset color:', preset.color);

                              // Button elements use 'styles' property
                              // Completely replace styles instead of merging to avoid conflicts

                              // Separate styles from icon properties
                              const { iconLeft, iconRight, ...styleProperties } = preset;

                              // For VIDEO_WITH_BUTTON_OVERLAY, we want to preserve video-related styles
                              // while applying the button content styles
                              let newStyles;
                              if (selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY) {
                                const videoStyles = {};
                                // Keep existing video frame properties if they exist
                                if (selectedElement.styles?.width) videoStyles.width = selectedElement.styles.width;
                                if (selectedElement.styles?.height) videoStyles.height = selectedElement.styles.height;
                                if (selectedElement.styles?.aspectRatio) videoStyles.aspectRatio = selectedElement.styles.aspectRatio;
                                if (selectedElement.styles?.marginBottom) videoStyles.marginBottom = selectedElement.styles.marginBottom;

                                newStyles = {
                                  ...styleProperties,
                                  ...videoStyles,
                                  presetStyle: presetName
                                };
                              } else {
                                // Start with a completely clean slate - no previous styles
                                newStyles = {
                                  ...styleProperties,
                                  presetStyle: presetName
                                };
                              }

                              console.log('🧹 Clearing all previous styles and applying preset:', presetName);
                              console.log('🧹 Previous styles:', selectedElement.styles);
                              console.log('🧹 New styles:', newStyles);

                              console.log('📝 New styles for button element:', newStyles);
                              console.log('📝 New textTransform:', newStyles.textTransform);
                              console.log('📝 New backgroundColor:', newStyles.backgroundColor);
                              console.log('📝 New boxShadow:', newStyles.boxShadow);
                              console.log('📝 Icon properties:', { iconLeft, iconRight });

                              // Prepare element update with both styles and icon properties
                              const elementUpdate = {
                                styles: newStyles
                              };

                              // Always explicitly set icon properties to clear any previous icons
                              elementUpdate.iconLeft = iconLeft || null;
                              elementUpdate.iconRight = iconRight || null;

                              // Check if element is in a zone
                              if (selectedElementContext?.isInZone && selectedElementContext?.layoutId && selectedElementContext?.zoneId) {
                                updateElement(selectedElement.id, elementUpdate, true, selectedElementContext.layoutId, selectedElementContext.zoneId);
                              } else {
                                updateElement(selectedElement.id, elementUpdate);
                              }

                              // Force a re-render to see the changes immediately
                              setForceRender(prev => prev + 1);

                              // Log the final result after update
                              setTimeout(() => {
                                console.log('🎯 Final selectedElement after update:', selectedElement);
                                console.log('🎨 Final styles:', selectedElement?.styles);
                              }, 100);

                              // Debug: Check if selectedElement updates after a delay
                              setTimeout(() => {
                                console.log('⏰ Delayed check - selectedElement styles:', selectedElement?.styles);
                                console.log('⏰ Delayed check - selectedElement fontFamily:', selectedElement?.styles?.fontFamily);
                                console.log('⏰ Delayed check - selectedElement fontSize:', selectedElement?.styles?.fontSize);
                                console.log('⏰ Delayed check - selectedElement textTransform:', selectedElement?.styles?.textTransform);
                              }, 100);
                            }}
                          />
                        </Box>
                      )}

                    {/* Preset Button Text Styles */}
                    {selectedElement.type === ELEMENT_TYPES.BUTTON && (
                      <Box sx={{ mb: 3, p: 2, backgroundColor: '#f0f9ff', borderRadius: 1, border: '1px solid #0ea5e9' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          📝 Preset Button Text Styles
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Apply text styling presets to button text content.
                        </Typography>

                        <SimplePresetSelector
                          currentStyle={selectedElement?.styles?.textPresetStyle}
                          presetFilter={(presetName) => {
                            // Filter out quotation and bullet-related presets for button text
                            return !presetName.includes('quotation') &&
                              !presetName.includes('bullet');
                          }}
                          onStyleSelect={(presetName, preset) => {
                            console.log('📝 Button text preset applied:', presetName, preset);
                            console.log('🎯 Current selectedElement:', selectedElement);
                            console.log('📝 Preset fontFamily:', preset.fontFamily);
                            console.log('📝 Preset fontSize:', preset.fontSize);
                            console.log('📝 Preset fontWeight:', preset.fontWeight);
                            console.log('📝 Preset color:', preset.color);
                            console.log('📝 Preset textAlign:', preset.textAlign);
                            console.log('📝 Preset textTransform:', preset.textTransform);

                            // List of preset-related properties that should be completely replaced
                            const presetProperties = [
                              'fontFamily',
                              'fontSize',
                              'fontWeight',
                              'lineHeight',
                              'letterSpacing',
                              'color',
                              'textAlign',
                              'textTransform',
                              'fontStyle'
                            ];

                            // Start with existing styles, but remove all preset-related properties
                            const existingStyles = selectedElement.styles || {};
                            const nonPresetStyles = {};

                            // Copy only non-preset properties from existing styles (preserve button-specific properties)
                            Object.keys(existingStyles).forEach(key => {
                              if (!presetProperties.includes(key) && key !== 'presetStyle' && key !== 'textPresetStyle') {
                                nonPresetStyles[key] = existingStyles[key];
                              }
                            });

                            // Build new styles: non-preset properties + preset properties + textPresetStyle
                            const newStyles = {
                              ...nonPresetStyles,
                              ...preset,
                              textPresetStyle: presetName
                            };

                            // Explicitly remove textTransform if not in preset (to clear uppercase from previous preset)
                            if (!preset.hasOwnProperty('textTransform')) {
                              newStyles.textTransform = 'none';
                            }

                            console.log('📝 Previous styles:', existingStyles);
                            console.log('📝 New styles:', newStyles);

                            // Check if element is in a zone
                            if (selectedElementContext?.isInZone && selectedElementContext?.layoutId && selectedElementContext?.zoneId) {
                              updateElement(selectedElement.id, { styles: newStyles }, true, selectedElementContext.layoutId, selectedElementContext.zoneId);
                            } else {
                              updateElement(selectedElement.id, { styles: newStyles });
                            }

                            // Force a re-render to see the changes immediately
                            setForceRender(prev => prev + 1);

                            // Log the final result after update
                            setTimeout(() => {
                              console.log('🎯 Final selectedElement after text preset update:', selectedElement);
                              console.log('📝 Final text styles:', selectedElement?.styles);
                              console.log('📝 Final textTransform:', selectedElement?.styles?.textTransform);
                            }, 100);
                          }}
                        />
                      </Box>
                    )}

                    {/* Quotation Block Specific Presets */}
                    {selectedElement.type === ELEMENT_TYPES.QUOTATION_BLOCK && (
                      <Box sx={{ mb: 3, p: 2, backgroundColor: '#f0f9ff', borderRadius: 1, border: '1px solid #0ea5e9' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold', color: '#0369a1' }}>
                          💬 Quotation Style Presets
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Quick styles designed specifically for quotation blocks.
                        </Typography>
                        <SimplePresetSelector
                          onStyleSelect={(presetName, preset) => {
                            console.log('🎨 Quotation preset applied:', presetName, preset);

                            // List of preset-related properties that should be completely replaced
                            const presetProperties = [
                              'fontFamily',
                              'fontSize',
                              'fontWeight',
                              'lineHeight',
                              'letterSpacing',
                              'color',
                              'textAlign',
                              'textTransform',
                              'fontStyle'
                            ];

                            // Start with existing styles, but remove all preset-related properties
                            const existingStyles = selectedElement.styles || {};
                            const nonPresetStyles = {};

                            // Copy only non-preset properties from existing styles
                            Object.keys(existingStyles).forEach(key => {
                              if (!presetProperties.includes(key) && key !== 'presetStyle' && key !== 'textStylePreset') {
                                nonPresetStyles[key] = existingStyles[key];
                              }
                            });

                            // Build new styles: non-preset properties + preset properties + textStylePreset
                            const newStyles = {
                              ...nonPresetStyles,
                              ...preset,
                              textStylePreset: presetName
                            };

                            // Explicitly remove textTransform if not in preset (to clear uppercase from previous preset)
                            if (!preset.hasOwnProperty('textTransform')) {
                              newStyles.textTransform = 'none';
                            }

                            console.log('📝 Previous styles:', existingStyles);
                            console.log('📝 New styles:', newStyles);

                            // Check if element is in a zone
                            if (selectedElementContext?.isInZone && selectedElementContext?.layoutId && selectedElementContext?.zoneId) {
                              updateElement(selectedElement.id, {
                                styles: newStyles,
                                textStylePreset: presetName
                              }, true, selectedElementContext.layoutId, selectedElementContext.zoneId);
                            } else {
                              updateElement(selectedElement.id, {
                                styles: newStyles,
                                textStylePreset: presetName
                              });
                            }
                          }}
                          currentStyle={selectedElement.textStylePreset}
                          presetFilter={(presetName) => presetName.startsWith('quotation')}
                        />
                      </Box>
                    )}

                    {/* Comparison Table Style Presets */}
                    {selectedElement.type === ELEMENT_TYPES.COMPARISON_TABLE && (
                      <>
                        {/* Table Title Preset */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            🏆 Table Title Style
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for the table title
                          </Typography>

                          <ComparisonTablePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Table title preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { titleStylePreset: presetName });
                            }}
                            currentStyle={selectedElement.titleStylePreset}
                            presetFilter={(presetName) => presetName === 'compareTableTableTitle'}
                          />
                        </Box>

                        {/* Product Names Preset */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#e8f5e8' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            🏷️ Product Names Style
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for product A and B names
                          </Typography>

                          <ComparisonTablePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Product names preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { productNameStylePreset: presetName });
                            }}
                            currentStyle={selectedElement.productNameStylePreset}
                            presetFilter={(presetName) => presetName === 'compareTableProdctName'}
                          />
                        </Box>

                        {/* Feature Title Preset */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#fff3e0' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            ⭐ Feature Titles Style
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for feature names
                          </Typography>

                          <ComparisonTablePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Feature title preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { featureTitleStylePreset: presetName });
                            }}
                            currentStyle={selectedElement.featureTitleStylePreset}
                            presetFilter={(presetName) => presetName === 'compareTableFeatureTitle'}
                          />
                        </Box>

                        {/* Feature Description Preset */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f0f9ff' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            📝 Feature Descriptions Style
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for feature descriptions
                          </Typography>

                          <ComparisonTablePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Feature description preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { featureDescStylePreset: presetName });
                            }}
                            currentStyle={selectedElement.featureDescStylePreset}
                            presetFilter={(presetName) => presetName === 'compareTableFeatureDescription'}
                          />
                        </Box>
                      </>
                    )}

                    {/* Two Column Comparison Style Presets */}
                    {selectedElement.type === ELEMENT_TYPES.TWO_COLUMN_COMPARISON && (
                      <>
                        {/* Column Title Preset */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#e8f5e8' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            🏷️ Column Titles Style
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for left and right column titles
                          </Typography>

                          <ComparisonTablePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Column title preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { titleStylePreset: presetName });
                            }}
                            currentStyle={selectedElement.titleStylePreset}
                            presetFilter={(presetName) => presetName === 'compareTableTwoColumnColumnTitle'}
                          />
                        </Box>

                        {/* Item Text Preset */}
                        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#fff3e0' }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            📝 Item Text Style
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset style for comparison items (positive and negative points)
                          </Typography>

                          <ComparisonTablePresetSelector
                            onStyleSelect={(presetName, styles) => {
                              console.log('🎨 Item text preset selected:', presetName, styles);
                              updateElement(selectedElement.id, { itemStylePreset: presetName });
                            }}
                            currentStyle={selectedElement.itemStylePreset}
                            presetFilter={(presetName) => presetName === 'compareTableTwoColumnItemTitle'}
                          />
                        </Box>
                      </>
                    )}

                    {/* Style Variant Selector for BUTTON_WITH_NOTICE */}
                    {selectedElement.type === 'BUTTON_WITH_NOTICE' && (
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🎨 Style Variants
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Choose a style variation for the current template
                        </Typography>

                        {/* Style Variant Selector */}
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-start', flexWrap: 'wrap', mb: 2 }}>
                          {(() => {
                            const styleOptions = {
                              'urgent-sale': ['default', 'modern', 'minimal', 'gradient'],
                              'membership-quiz': ['default', 'elegant', 'soft', 'corporate'],
                              'media-buzz': ['default', 'news', 'viral', 'trending']
                            };

                            return styleOptions[selectedElement.variant]?.map((styleVariant) => (
                              <Chip
                                key={styleVariant}
                                label={styleVariant.charAt(0).toUpperCase() + styleVariant.slice(1)}
                                size="small"
                                variant={selectedElement.styleVariant === styleVariant ? 'filled' : 'outlined'}
                                onClick={() => {
                                  const updatedElement = {
                                    ...selectedElement,
                                    styleVariant
                                  };
                                  updateElement(selectedElement.id, updatedElement, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }}
                                sx={{
                                  fontSize: '0.7rem',
                                  cursor: 'pointer',
                                  backgroundColor: selectedElement.styleVariant === styleVariant ? '#1976d2' : '#ffffff',
                                  color: selectedElement.styleVariant === styleVariant ? '#ffffff' : '#1976d2',
                                  border: `1px solid #1976d2`,
                                  '&:hover': {
                                    backgroundColor: selectedElement.styleVariant === styleVariant ? '#1565c0' : '#e3f2fd'
                                  }
                                }}
                              />
                            )) || [];
                          })()}
                        </Box>
                      </Box>
                    )}



                    {/* Size Controls for Circular Image */}
                    {selectedElement.type === ELEMENT_TYPES.CIRCULAR_IMAGE && (
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          📏 Size Settings
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Adjust the size of your circular image
                        </Typography>

                        {/* Size Presets */}
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel>Size Preset</InputLabel>
                          <Select
                            value={(() => {
                              const currentSize = selectedElement.styles?.width || 200;
                              const preset = [
                                { label: 'Small (100px)', value: 100 },
                                { label: 'Medium (150px)', value: 150 },
                                { label: 'Large (200px)', value: 200 },
                                { label: 'Extra Large (250px)', value: 250 },
                                { label: 'Custom', value: 'custom' }
                              ].find(p => p.value === currentSize);
                              return preset ? preset.value : 'custom';
                            })()}
                            label="Size Preset"
                            onChange={(e) => {
                              const newSize = e.target.value;
                              const sizeValue = newSize === 'custom' ? (selectedElement.styles?.width || 200) : newSize;
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  width: sizeValue,
                                  height: sizeValue
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                          >
                            <MenuItem value={100}>Small (100px)</MenuItem>
                            <MenuItem value={150}>Medium (150px)</MenuItem>
                            <MenuItem value={200}>Large (200px)</MenuItem>
                            <MenuItem value={250}>Extra Large (250px)</MenuItem>
                            <MenuItem value="custom">Custom</MenuItem>
                          </Select>
                        </FormControl>

                        {/* Custom Size Input */}
                        <TextField
                          fullWidth
                          label="Custom Size (px)"
                          type="number"
                          value={selectedElement.styles?.width || 200}
                          onChange={(e) => {
                            const newSize = Number(e.target.value);
                            if (newSize >= 50 && newSize <= 500) {
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  width: newSize,
                                  height: newSize
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }
                          }}
                          inputProps={{ min: 50, max: 500 }}
                          sx={{ mb: 2 }}
                        />
                      </Box>
                    )}

                    {/* Frame Preset Options for Fittable Image */}
                    {selectedElement.type === ELEMENT_TYPES.FITTABLE_IMAGE && (
                      <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🖼️ Frame Presets
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Choose a preset frame size for common aspect ratios
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = baseWidth;
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  height: newHeight
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            Square (1:1)
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = Math.round(baseWidth * 9 / 16);
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  height: newHeight
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            16:9
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = Math.round(baseWidth * 16 / 9);
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  height: newHeight
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            9:16
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = Math.round(baseWidth * 5 / 4);
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  height: newHeight
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            4:5
                          </Button>
                        </Box>

                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                          Current: {selectedElement.styles?.width === "100%" ? '100%' : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400)} × {selectedElement.styles?.height || 300}
                        </Typography>
                      </Box>
                    )}

                    {/* Frame Preset Options for Video */}
                    {(selectedElement.type === ELEMENT_TYPES.VIDEO || selectedElement.type === ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY) && (
                      <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f8f9fa' }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          🎥 Video Frame Presets
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                          Choose a preset frame size for common video aspect ratios{isBrandsPage ? ' (videos always display at full width)' : ''}
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = baseWidth;
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  width: isBrandsPage ? '100%' : selectedElement.styles?.width,
                                  height: newHeight,
                                  aspectRatio: '1/1' // Set aspect ratio for square
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            Square (1:1)
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = Math.round(baseWidth * 9 / 16);
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  width: isBrandsPage ? '100%' : selectedElement.styles?.width,
                                  height: newHeight,
                                  aspectRatio: '16/9' // Set aspect ratio for landscape
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            16:9
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = Math.round(baseWidth * 16 / 9);
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  width: isBrandsPage ? '100%' : selectedElement.styles?.width,
                                  height: newHeight,
                                  aspectRatio: '9/16' // Set aspect ratio for portrait
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            9:16
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const baseWidth = selectedElement.styles?.width === "100%" ? 400 : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400);
                              const newHeight = Math.round(baseWidth * 5 / 4);
                              updateElement(selectedElement.id, {
                                styles: {
                                  ...selectedElement.styles,
                                  width: isBrandsPage ? '100%' : selectedElement.styles?.width,
                                  height: newHeight,
                                  aspectRatio: '4/5' // Set aspect ratio for 4:5
                                }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                            }}
                            sx={{ fontSize: '0.75rem' }}
                          >
                            4:5
                          </Button>
                        </Box>

                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                          Current: {selectedElement.styles?.width === "100%" ? '100%' : (typeof selectedElement.styles?.width === 'number' ? selectedElement.styles.width : 400)} × {selectedElement.styles?.height || 300}
                        </Typography>
                      </Box>
                    )}



                    {/* Background Color Section - Show for text, heading, button elements, layouts, and specific sub-elements */}
                    {(selectedElement.type === ELEMENT_TYPES.TEXT ||
                      selectedElement.type === ELEMENT_TYPES.HEADING ||
                      selectedElement.type === ELEMENT_TYPES.QUOTATION_BLOCK ||
                      selectedElement.type === ELEMENT_TYPES.BUTTON ||
                      selectedElement.type === ELEMENT_TYPES.LAYOUT ||
                      selectedElement.type === ELEMENT_TYPES.CUSTOM_LIST_TWO_LINE ||
                      (selectedElement.type === 'BUTTON_WITH_NOTICE' && (selectedSubElement === 'notice' || selectedSubElement === 'callToAction' || selectedSubElement === 'button')) ||
                      selectedElement.type === 'BUTTON_IMAGE_CALLOUT' ||
                      selectedElement.type === 'BUTTON_TEXT_VARIANT' ||
                      selectedElement.type === 'BUTTON_HEADLINE_PRODUCT_IMAGE') && (
                        <Box sx={{ mb: 3 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Background Color
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                            Choose a preset color or enter a custom value
                          </Typography>

                          {/* Enhanced Color Palette */}
                          <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${isBrandsPage ? 6 : 8}, 1fr)`, gap: 1, mb: 2 }}>
                            {getInlineBackgroundColors().map((color) => {
                              const currentBgColor = selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                ? selectedElement.subElementStyles?.[selectedSubElement]?.backgroundColor || 'transparent'
                                : selectedElement.styles?.backgroundColor || 'transparent';

                              const isSelected = currentBgColor === color.value;

                              return (
                                <Box
                                  key={color.name}
                                  onClick={() => {
                                    // Handle sub-element styling for composite elements
                                    if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                      const subElementStyles = selectedElement.subElementStyles || {};
                                      const updatedSubElementStyles = {
                                        ...subElementStyles,
                                        [selectedSubElement]: {
                                          ...subElementStyles[selectedSubElement],
                                          backgroundColor: color.value
                                        }
                                      };
                                      updateElement(selectedElement.id, {
                                        subElementStyles: updatedSubElementStyles
                                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    } else {
                                      // Regular element styling
                                      updateElement(selectedElement.id, {
                                        styles: { ...selectedElement.styles, backgroundColor: color.value }
                                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    }
                                  }}
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    backgroundColor: color.value === 'transparent' ? '#ffffff' : color.value,
                                    border: color.value === 'transparent' ? '2px dashed #ccc' : `2px solid ${isSelected ? '#1976d2' : '#e0e0e0'}`,
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    position: 'relative',
                                    '&:hover': {
                                      transform: 'scale(1.1)',
                                      borderColor: '#1976d2',
                                      zIndex: 1
                                    },
                                    ...(isSelected && {
                                      transform: 'scale(1.1)',
                                      boxShadow: '0 0 0 2px #1976d2'
                                    })
                                  }}
                                  title={color.name}
                                >
                                  {color.value === 'transparent' && (
                                    <Box sx={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      fontSize: '10px',
                                      color: '#666',
                                      fontWeight: 'bold'
                                    }}>
                                      ∅
                                    </Box>
                                  )}
                                  {isSelected && (
                                    <Box sx={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      color: color.value === '#ffffff' || color.value === 'transparent' ? '#1976d2' : '#ffffff',
                                      fontSize: '14px',
                                      fontWeight: 'bold'
                                    }}>
                                      ✓
                                    </Box>
                                  )}
                                </Box>
                              );
                            })}
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                            <input
                              type="color"
                              value={(() => {
                                const bgColor = selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.backgroundColor || 'transparent'
                                  : selectedElement.styles?.backgroundColor || 'transparent';
                                // Convert common CSS colors to hex for color picker
                                if (bgColor === 'transparent' || bgColor === 'none') return '#ffffff';
                                if (bgColor.startsWith('#')) return bgColor;
                                // For named colors, return a default
                                return '#ffffff';
                              })()}
                              onChange={(e) => {
                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      backgroundColor: e.target.value
                                    }
                                  };
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                } else {
                                  // Regular element styling
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, backgroundColor: e.target.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }
                              }}
                              style={{
                                width: '50px',
                                height: '40px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title="Pick a color"
                            />
                            <TextField
                              fullWidth
                              label="Custom Background Color"
                              value={
                                selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.backgroundColor || 'transparent'
                                  : selectedElement.styles?.backgroundColor || 'transparent'
                              }
                              onChange={(e) => {
                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      backgroundColor: e.target.value
                                    }
                                  };
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                } else {
                                  // Regular element styling
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, backgroundColor: e.target.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }
                              }}
                              placeholder="e.g., #ffffff, rgb(255,255,255), or transparent"
                              helperText="Use color picker or enter any valid CSS color value"
                              size="small"
                            />
                          </Box>
                        </Box>
                      )}

                    {/* Text Color Section - Show for text, heading, button elements, and specific sub-elements */}
                    {(selectedElement.type === ELEMENT_TYPES.TEXT ||
                      selectedElement.type === ELEMENT_TYPES.HEADING ||
                      selectedElement.type === ELEMENT_TYPES.QUOTATION_BLOCK ||
                      selectedElement.type === ELEMENT_TYPES.BUTTON ||
                      (selectedElement.type === 'BUTTON_WITH_NOTICE' && (selectedSubElement === 'notice' || selectedSubElement === 'callToAction' || selectedSubElement === 'button')) ||
                      selectedElement.type === 'BUTTON_IMAGE_CALLOUT' ||
                      selectedElement.type === 'BUTTON_TEXT_VARIANT') && (
                        <Box sx={{ mb: 1.5 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Text Color
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                            Choose a preset color or enter a custom value
                          </Typography>

                          {/* Enhanced Text Color Palette */}
                          <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${isBrandsPage ? 5 : 8}, 1fr)`, gap: 1, mb: 1.5 }}>
                            {getInlineTextColors().map((color) => {
                              const currentTextColor = selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                ? selectedElement.subElementStyles?.[selectedSubElement]?.color || '#101022'
                                : selectedElement.styles?.color || '#101022';

                              const isSelected = currentTextColor === color.value;

                              return (
                                <Box
                                  key={color.name}
                                  onClick={() => {
                                    // Handle sub-element styling for composite elements
                                    if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                      const subElementStyles = selectedElement.subElementStyles || {};
                                      const updatedSubElementStyles = {
                                        ...subElementStyles,
                                        [selectedSubElement]: {
                                          ...subElementStyles[selectedSubElement],
                                          color: color.value
                                        }
                                      };
                                      updateElement(selectedElement.id, {
                                        subElementStyles: updatedSubElementStyles
                                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    } else {
                                      // Regular element styling
                                      updateElement(selectedElement.id, {
                                        styles: { ...selectedElement.styles, color: color.value }
                                      }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                    }
                                  }}
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    backgroundColor: color.value,
                                    border: `2px solid ${isSelected ? '#1976d2' : '#e0e0e0'}`,
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    position: 'relative',
                                    '&:hover': {
                                      transform: 'scale(1.1)',
                                      borderColor: '#1976d2',
                                      zIndex: 1
                                    },
                                    ...(isSelected && {
                                      transform: 'scale(1.1)',
                                      boxShadow: '0 0 0 2px #1976d2'
                                    })
                                  }}
                                  title={color.name}
                                >
                                  {isSelected && (
                                    <Box sx={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      color: color.value === '#ffffff' || color.value === '#e7cb16' || color.value === '#fbc02d' ? '#101022' : '#ffffff',
                                      fontSize: '14px',
                                      fontWeight: 'bold'
                                    }}>
                                      ✓
                                    </Box>
                                  )}
                                </Box>
                              );
                            })}
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
                            <input
                              type="color"
                              value={(() => {
                                const textColor = selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.color || '#101022'
                                  : selectedElement.styles?.color || '#101022';
                                // Convert common CSS colors to hex for color picker
                                if (textColor.startsWith('#')) return textColor;
                                // For named colors, return a default
                                return '#101022';
                              })()}
                              onChange={(e) => {
                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      color: e.target.value
                                    }
                                  };
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                } else {
                                  // Regular element styling
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, color: e.target.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }
                              }}
                              style={{
                                width: '50px',
                                height: '40px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title="Pick a text color"
                            />
                            <TextField
                              fullWidth
                              label="Custom Text Color"
                              value={
                                selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.color || '#101022'
                                  : selectedElement.styles?.color || '#101022'
                              }
                              onChange={(e) => {
                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      color: e.target.value
                                    }
                                  };
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                } else {
                                  // Regular element styling
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, color: e.target.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }
                              }}
                              placeholder="e.g., #101022, rgb(0,0,0), or black"
                              helperText="Use color picker or enter any valid CSS color value"
                              size="small"
                            />
                          </Box>
                        </Box>
                      )}

                    {/* Typography Section - Show for text, heading, button elements, and specific sub-elements */}
                    {(selectedElement.type === ELEMENT_TYPES.TEXT ||
                      selectedElement.type === ELEMENT_TYPES.HEADING ||
                      selectedElement.type === ELEMENT_TYPES.QUOTATION_BLOCK ||
                      selectedElement.type === ELEMENT_TYPES.BUTTON ||
                      (selectedElement.type === 'BUTTON_WITH_NOTICE' && (selectedSubElement === 'notice' || selectedSubElement === 'callToAction' || selectedSubElement === 'button')) ||
                      selectedElement.type === 'BUTTON_IMAGE_CALLOUT' ||
                      selectedElement.type === 'BUTTON_TEXT_VARIANT') && (
                        <Box sx={{ mb: 1.5 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Typography
                          </Typography>

                          {/* Font Family and Font Size - Hide for text, button, heading, and custom list elements */}
                          {selectedElement.type !== ELEMENT_TYPES.TEXT && selectedElement.type !== ELEMENT_TYPES.BUTTON && selectedElement.type !== ELEMENT_TYPES.HEADING && selectedElement.type !== ELEMENT_TYPES.CUSTOM_LIST && (
                            <>
                              <TextField
                                key={`font-family-3-${selectedElement?.id}-${selectedElement?.styles?.fontFamily || 'empty'}`}
                                fullWidth
                                label="Font Family"
                                select
                                value={getCurrentFontFamily(selectedElement, selectedSubElement)}
                                onFocus={() => {
                                  console.log('🎯 Select Font Family focused. Value:', getCurrentFontFamily(selectedElement, selectedSubElement));
                                  console.log('🎯 Select Font Family full styles:', selectedElement.styles);
                                }}
                                onChange={(e) => {
                                  // Handle sub-element styling for composite elements
                                  if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                    const subElementStyles = selectedElement.subElementStyles || {};
                                    const updatedSubElementStyles = {
                                      ...subElementStyles,
                                      [selectedSubElement]: {
                                        ...subElementStyles[selectedSubElement],
                                        fontFamily: e.target.value
                                      }
                                    };
                                    updateElement(selectedElement.id, {
                                      subElementStyles: updatedSubElementStyles
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  } else {
                                    // Regular element styling
                                    updateElement(selectedElement.id, {
                                      styles: { ...selectedElement.styles, fontFamily: e.target.value }
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  }
                                }}
                                sx={{ mb: 1.5 }}
                              >
                                <MenuItem value="inherit">Default</MenuItem>
                                {getPresetFontFamilies().map((fontFamily) => (
                                  <MenuItem key={fontFamily} value={fontFamily}>
                                    {fontFamily.replace(/['"]/g, '').replace(', sans-serif', '').replace(', serif', '').replace(', monospace', '')}
                                  </MenuItem>
                                ))}
                              </TextField>

                              <TextField
                                fullWidth
                                label="Font Size"
                                select
                                value={
                                  selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                    ? selectedElement.subElementStyles?.[selectedSubElement]?.fontSize || (selectedElement.type === ELEMENT_TYPES.HEADING ? '24px' : '18px')
                                    : selectedElement.styles?.fontSize || (selectedElement.type === ELEMENT_TYPES.HEADING ? '24px' : '18px')
                                }
                                onChange={(e) => {
                                  // Handle sub-element styling for composite elements
                                  if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                    const subElementStyles = selectedElement.subElementStyles || {};
                                    const updatedSubElementStyles = {
                                      ...subElementStyles,
                                      [selectedSubElement]: {
                                        ...subElementStyles[selectedSubElement],
                                        fontSize: e.target.value
                                      }
                                    };
                                    updateElement(selectedElement.id, {
                                      subElementStyles: updatedSubElementStyles
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  } else {
                                    // Regular element styling
                                    updateElement(selectedElement.id, {
                                      styles: { ...selectedElement.styles, fontSize: e.target.value }
                                    }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                  }
                                }}
                                sx={{ mb: 1.5 }}
                              >
                                <MenuItem value="12px">12px - Small</MenuItem>
                                <MenuItem value="14px">14px - Small+</MenuItem>
                                <MenuItem value="16px">16px - Medium</MenuItem>
                                <MenuItem value="18px">18px - Medium+</MenuItem>
                                <MenuItem value="20px">20px - Large</MenuItem>
                                <MenuItem value="22px">22px - Large+</MenuItem>
                                <MenuItem value="24px">24px - Extra Large</MenuItem>
                                <MenuItem value="28px">28px - Extra Large+</MenuItem>
                                <MenuItem value="32px">32px - Huge</MenuItem>
                              </TextField>
                            </>
                          )}

                          <TextField
                            fullWidth
                            label="Text Transform"
                            select
                            value={
                              selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                ? selectedElement.subElementStyles?.[selectedSubElement]?.textTransform || 'none'
                                : selectedElement.styles?.textTransform || 'none'
                            }
                            onChange={(e) => {
                              // Handle sub-element styling for composite elements
                              if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                const subElementStyles = selectedElement.subElementStyles || {};
                                const updatedSubElementStyles = {
                                  ...subElementStyles,
                                  [selectedSubElement]: {
                                    ...subElementStyles[selectedSubElement],
                                    textTransform: e.target.value
                                  }
                                };
                                updateElement(selectedElement.id, {
                                  subElementStyles: updatedSubElementStyles
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              } else {
                                // Regular element styling
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, textTransform: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }
                            }}
                            sx={{ mb: 1.5 }}
                          >
                            <MenuItem value="none">Normal</MenuItem>
                            <MenuItem value="uppercase">ALL CAPITAL</MenuItem>
                            <MenuItem value="capitalize">First Letter Capital</MenuItem>
                            <MenuItem value="titlecase">Title Case</MenuItem>
                            <MenuItem value="lowercase">all lowercase</MenuItem>
                          </TextField>

                          <TextField
                            fullWidth
                            label="Font Weight"
                            select
                            value={
                              selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                ? selectedElement.subElementStyles?.[selectedSubElement]?.fontWeight || 400
                                : selectedElement.styles?.fontWeight || 400
                            }
                            onChange={(e) => {
                              // Handle sub-element styling for composite elements
                              if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                const subElementStyles = selectedElement.subElementStyles || {};
                                const updatedSubElementStyles = {
                                  ...subElementStyles,
                                  [selectedSubElement]: {
                                    ...subElementStyles[selectedSubElement],
                                    fontWeight: e.target.value
                                  }
                                };
                                console.log('🎨 Updating sub-element styles:', updatedSubElementStyles);
                                updateElement(selectedElement.id, {
                                  subElementStyles: updatedSubElementStyles
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              } else {
                                // Regular element styling
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, fontWeight: e.target.value }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }
                            }}
                            sx={{ mb: 1.5 }}
                          >
                            <MenuItem value={400}>Normal</MenuItem>
                            <MenuItem value={100}>Lighter</MenuItem>
                            <MenuItem value={900}>Bold</MenuItem>
                          </TextField>

                          {selectedElement.type !== ELEMENT_TYPES.BUTTON && (
                            <TextField
                              fullWidth
                              label="Text Align"
                              select
                              value={
                                selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.textAlign || 'left'
                                  : selectedElement.styles?.textAlign || 'left'
                              }
                              onChange={(e) => {
                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      textAlign: e.target.value
                                    }
                                  };
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                } else {
                                  // Regular element styling
                                  updateElement(selectedElement.id, {
                                    styles: { ...selectedElement.styles, textAlign: e.target.value }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }
                              }}
                              sx={{ mb: 1.5 }}
                            >
                              <MenuItem value="left">Left</MenuItem>
                              <MenuItem value="center">Center</MenuItem>
                              <MenuItem value="right">Right</MenuItem>
                              <MenuItem value="justify">Justify</MenuItem>
                            </TextField>
                          )}
                        </Box>
                      )}

                    {/* Spacing Section - Show for all elements except buttons, text, heading, and video elements */}
                    {selectedElement.type !== ELEMENT_TYPES.BUTTON &&
                      selectedElement.type !== ELEMENT_TYPES.TEXT &&
                      selectedElement.type !== ELEMENT_TYPES.HEADING &&
                      selectedElement.type !== ELEMENT_TYPES.VIDEO &&
                      selectedElement.type !== ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY && (
                        <Box sx={{ mb: 1.5 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Spacing & Layout
                          </Typography>

                          <TextField
                            fullWidth
                            label="Padding"
                            defaultValue={
                              selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                ? selectedElement.subElementStyles?.[selectedSubElement]?.padding || '8px'
                                : selectedElement.styles?.padding || '8px'
                            }
                            onChange={(e) => {
                              // Only update on blur to prevent focus loss
                            }}
                            onBlur={(e) => {
                              const newValue = e.target.value;
                              console.log('🔍 Padding field onBlur - newValue:', newValue);
                              console.log('🔍 Padding field onBlur - selectedElement.type:', selectedElement.type);
                              console.log('🔍 Padding field onBlur - selectedElement.styles before:', selectedElement.styles);

                              if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                const subElementStyles = selectedElement.subElementStyles || {};
                                const updatedSubElementStyles = {
                                  ...subElementStyles,
                                  [selectedSubElement]: {
                                    ...subElementStyles[selectedSubElement],
                                    padding: newValue
                                  }
                                };
                                updateElement(selectedElement.id, {
                                  subElementStyles: updatedSubElementStyles
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              } else {
                                updateElement(selectedElement.id, {
                                  styles: { ...selectedElement.styles, padding: newValue }
                                }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                              }
                            }}
                            placeholder="e.g., 8px, 10px 15px, 5px 10px 15px 20px"
                            helperText="Space inside the element"
                            sx={{ mb: 1.5 }}
                          />

                        </Box>
                      )}

                    {/* Border Section - Show for all elements except video elements */}
                    {selectedElement.type !== ELEMENT_TYPES.VIDEO &&
                      selectedElement.type !== ELEMENT_TYPES.VIDEO_WITH_BUTTON_OVERLAY && (
                        <Box sx={{ mb: 1.5 }}>
                          <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Border & Shape
                          </Typography>

                          <FormControl fullWidth sx={{ mb: 1.5 }}>
                            <InputLabel>Border</InputLabel>
                            <Select
                              value={
                                selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.border || 'none'
                                  : selectedElement.styles?.border || 'none'
                              }
                              label="Border"
                              onOpen={() => console.log('🎨 Select opened')}
                              onClose={() => console.log('🎨 Select closed')}
                              onClick={() => console.log('🎨 Select clicked')}
                              onChange={(e) => {
                                console.log('🎨🎨🎨 BORDER CHANGE TRIGGERED! 🎨🎨🎨');
                                console.log('🎨 Event object:', e);
                                console.log('🎨 Event target:', e.target);
                                console.log('🎨 New value:', e.target.value);
                                console.log('🎨 Selected element:', selectedElement);
                                console.log('🎨 Selected element type:', selectedElement?.type);
                                console.log('🎨 Selected sub element:', selectedSubElement);
                                console.log('🎨 Selected element context:', selectedElementContext);

                                const borderValue = e.target.value;
                                console.log('🎨 Setting border to:', borderValue);

                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  console.log('🎨 Using sub-element styling path');
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      border: borderValue
                                    }
                                  };
                                  console.log('🎨 Updated sub-element styles:', updatedSubElementStyles);
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);

                                  // Force aggressive re-render for sub-element border changes
                                  console.log('🎨 Forcing aggressive re-render for sub-element border change');
                                  setTimeout(() => {
                                    setForceRender(prev => {
                                      const newValue = prev + 1;
                                      console.log('🎨 Sub-element border forceRender updated from', prev, 'to', newValue);
                                      return newValue;
                                    });
                                  }, 50);
                                } else {
                                  // Regular element styling
                                  console.log('🎨 Using regular element styling path');
                                  console.log('🎨 Current element styles:', selectedElement.styles);
                                  const newStyles = { ...selectedElement.styles, border: borderValue };
                                  console.log('🎨 New element styles:', newStyles);
                                  updateElement(selectedElement.id, {
                                    styles: newStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);

                                  // Force aggressive re-render for border changes
                                  console.log('🎨 Forcing aggressive re-render for border change');
                                  setTimeout(() => {
                                    setForceRender(prev => {
                                      const newValue = prev + 1;
                                      console.log('🎨 Border forceRender updated from', prev, 'to', newValue);
                                      return newValue;
                                    });
                                  }, 50);
                                }

                                console.log('🎨🎨🎨 BORDER CHANGE COMPLETED! 🎨🎨🎨');
                              }}
                            >
                              <MenuItem value="none">No Border</MenuItem>
                              <MenuItem value="1px dotted #101022">1px Dotted Black</MenuItem>
                              <MenuItem value="1px dotted #ff0000">1px Dotted Red</MenuItem>
                              <MenuItem value="1px dotted #808080">1px Dotted Grey</MenuItem>
                            </Select>
                          </FormControl>

                          {selectedElement.type !== ELEMENT_TYPES.BUTTON && (
                            <TextField
                              fullWidth
                              label="Border Radius"
                              select
                              value={
                                selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE'
                                  ? selectedElement.subElementStyles?.[selectedSubElement]?.borderRadius || '0px'
                                  : selectedElement.styles?.borderRadius || '0px'
                              }
                              onChange={(e) => {
                                console.log('🔄🔄🔄 BORDER RADIUS CHANGE TRIGGERED! 🔄🔄🔄');
                                console.log('🔄 New border radius value:', e.target.value);
                                console.log('🔄 Selected element:', selectedElement);

                                // Handle sub-element styling for composite elements
                                if (selectedSubElement && selectedElement.type === 'BUTTON_WITH_NOTICE') {
                                  console.log('🔄 Using sub-element styling path');
                                  const subElementStyles = selectedElement.subElementStyles || {};
                                  const updatedSubElementStyles = {
                                    ...subElementStyles,
                                    [selectedSubElement]: {
                                      ...subElementStyles[selectedSubElement],
                                      borderRadius: e.target.value
                                    }
                                  };
                                  console.log('🔄 Updated sub-element styles:', updatedSubElementStyles);
                                  updateElement(selectedElement.id, {
                                    subElementStyles: updatedSubElementStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                } else {
                                  // Regular element styling
                                  console.log('🔄 Using regular element styling path');
                                  console.log('🔄 Current element styles:', selectedElement.styles);
                                  const newStyles = { ...selectedElement.styles, borderRadius: e.target.value };
                                  console.log('🔄 New element styles:', newStyles);
                                  updateElement(selectedElement.id, {
                                    styles: newStyles
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }

                                console.log('🔄🔄🔄 BORDER RADIUS CHANGE COMPLETED! 🔄🔄🔄');
                              }}
                              helperText="Choose corner roundness"
                              sx={{ mb: 1.5 }}
                            >
                              <MenuItem value="0px">No Rounded</MenuItem>
                              <MenuItem value="12px">Rounded</MenuItem>
                            </TextField>
                          )}
                        </Box>
                      )}

                    {/* Background Image Section - Show only for Layout elements */}
                    {selectedElement.type === ELEMENT_TYPES.LAYOUT && (
                      <Box sx={{ mb: 1.5 }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Background Image
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                          Add a background image to your layout. Use 'Cover' or 'Contain' to maintain image aspect ratio.
                        </Typography>

                        <TextField
                          fullWidth
                          label="Background Image URL"
                          value={selectedElement.styles?.backgroundImage?.replace('url(', '').replace(')', '') || ''}
                          onChange={(e) => {
                            const imageUrl = e.target.value;
                            updateElement(selectedElement.id, {
                              styles: {
                                ...selectedElement.styles,
                                backgroundImage: imageUrl ? `url(${imageUrl})` : 'none'
                              }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                          }}
                          placeholder="https://example.com/image.jpg"
                          helperText="Enter image URL or upload a file below"
                          sx={{ mb: 1.5 }}
                        />

                        {/* File Upload for Background Image */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const imageUrl = await handleImageUpload(file, selectedElement.id, true);
                                if (imageUrl) {
                                  updateElement(selectedElement.id, {
                                    styles: {
                                      ...selectedElement.styles,
                                      backgroundImage: `url(${imageUrl})`
                                    }
                                  }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId);
                                }
                              }
                            }}
                            style={{ display: 'none' }}
                            id={`layout-bg-upload-${selectedElement.id}`}
                          />
                          <label htmlFor={`layout-bg-upload-${selectedElement.id}`}>
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={<UploadIcon />}
                              disabled={imageUploading && uploadingElementId === selectedElement.id}
                              sx={{ minWidth: 120 }}
                            >
                              {imageUploading && uploadingElementId === selectedElement.id ? 'Uploading...' : 'Upload Background'}
                            </Button>
                          </label>
                          {imageUploading && uploadingElementId === selectedElement.id && (
                            <Box sx={{ ml: 1 }}>
                              <CircularProgress size={20} />
                            </Box>
                          )}
                        </Box>

                        {/* Background Image Options */}
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, mb: 1.5 }}>
                          <FormControl fullWidth size="small">
                            <InputLabel>Background Size</InputLabel>
                            <Select
                              value={selectedElement.styles?.backgroundSize || 'cover'}
                              onChange={(e) => updateElement(selectedElement.id, {
                                styles: { ...selectedElement.styles, backgroundSize: e.target.value }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                              label="Background Size"
                            >
                              <MenuItem value="cover">Cover (Keep Aspect Ratio)</MenuItem>
                              <MenuItem value="contain">Contain (Keep Aspect Ratio)</MenuItem>
                              <MenuItem value="auto">Auto (Original Size)</MenuItem>
                              <MenuItem value="100% 100%">Stretch (Distort Image)</MenuItem>
                            </Select>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                              Cover: Fills layout, may crop image • Contain: Fits entire image, may show background
                            </Typography>
                          </FormControl>

                          <FormControl fullWidth size="small">
                            <InputLabel>Background Position</InputLabel>
                            <Select
                              value={selectedElement.styles?.backgroundPosition || 'center'}
                              onChange={(e) => updateElement(selectedElement.id, {
                                styles: { ...selectedElement.styles, backgroundPosition: e.target.value }
                              }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                              label="Background Position"
                            >
                              <MenuItem value="center">Center</MenuItem>
                              <MenuItem value="top">Top</MenuItem>
                              <MenuItem value="bottom">Bottom</MenuItem>
                              <MenuItem value="left">Left</MenuItem>
                              <MenuItem value="right">Right</MenuItem>
                              <MenuItem value="top left">Top Left</MenuItem>
                              <MenuItem value="top right">Top Right</MenuItem>
                              <MenuItem value="bottom left">Bottom Left</MenuItem>
                              <MenuItem value="bottom right">Bottom Right</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>

                        <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                          <InputLabel>Background Repeat</InputLabel>
                          <Select
                            value={selectedElement.styles?.backgroundRepeat || 'no-repeat'}
                            onChange={(e) => updateElement(selectedElement.id, {
                              styles: { ...selectedElement.styles, backgroundRepeat: e.target.value }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                            label="Background Repeat"
                          >
                            <MenuItem value="no-repeat">No Repeat</MenuItem>
                            <MenuItem value="repeat">Repeat</MenuItem>
                            <MenuItem value="repeat-x">Repeat X</MenuItem>
                            <MenuItem value="repeat-y">Repeat Y</MenuItem>
                          </Select>
                        </FormControl>

                        {/* Clear Background Image Button */}
                        {selectedElement.styles?.backgroundImage && selectedElement.styles?.backgroundImage !== 'none' && (
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => updateElement(selectedElement.id, {
                              styles: {
                                ...selectedElement.styles,
                                backgroundImage: 'none'
                              }
                            }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                            sx={{ mt: 1 }}
                          >
                            Remove Background Image
                          </Button>
                        )}
                      </Box>
                    )}


                    {/* Image-specific styling options */}
                    {selectedElement.type === ELEMENT_TYPES.IMAGE && (
                      <Box sx={{ mb: 1.5 }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Image Specific
                        </Typography>

                        <TextField
                          fullWidth
                          label="Image Width"
                          value={selectedElement.styles?.width || 'auto'}
                          onChange={(e) => updateElement(selectedElement.id, {
                            styles: { ...selectedElement.styles, width: e.target.value }
                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                          placeholder="e.g., 100px, 50%, auto"
                          sx={{ mb: 1.5 }}
                        />

                        <TextField
                          fullWidth
                          label="Image Height"
                          value={selectedElement.styles?.height || 'auto'}
                          onChange={(e) => updateElement(selectedElement.id, {
                            styles: { ...selectedElement.styles, height: e.target.value }
                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                          placeholder="e.g., 100px, 50%, auto"
                          sx={{ mb: 1.5 }}
                        />

                        <TextField
                          fullWidth
                          label="Object Fit"
                          select
                          value={selectedElement.styles?.objectFit || 'cover'}
                          onChange={(e) => updateElement(selectedElement.id, {
                            styles: { ...selectedElement.styles, objectFit: e.target.value }
                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                          sx={{ mb: 1.5 }}
                        >
                          <MenuItem value="cover">Cover</MenuItem>
                          <MenuItem value="contain">Contain</MenuItem>
                          <MenuItem value="fill">Fill</MenuItem>
                          <MenuItem value="none">None</MenuItem>
                          <MenuItem value="scale-down">Scale Down</MenuItem>
                        </TextField>
                      </Box>
                    )}

                    {/* Croppable Image-specific styling options */}
                    {selectedElement.type === ELEMENT_TYPES.CROPPABLE_IMAGE && (
                      <Box sx={{ mb: 1.5 }}>
                        <Typography variant="body2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Croppable Image Specific
                        </Typography>

                        <TextField
                          fullWidth
                          label="Image Width (px)"
                          type="number"
                          value={selectedElement.styles?.width || 300}
                          onChange={(e) => updateElement(selectedElement.id, {
                            styles: { ...selectedElement.styles, width: parseInt(e.target.value) || 300 }
                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                          sx={{ mb: 1.5 }}
                        />

                        <TextField
                          fullWidth
                          label="Image Height (px)"
                          type="number"
                          value={selectedElement.styles?.height || 200}
                          onChange={(e) => updateElement(selectedElement.id, {
                            styles: { ...selectedElement.styles, height: parseInt(e.target.value) || 200 }
                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                          sx={{ mb: 1.5 }}
                        />

                        <TextField
                          fullWidth
                          label="Border Radius"
                          value={selectedElement.styles?.borderRadius || '8px'}
                          onChange={(e) => updateElement(selectedElement.id, {
                            styles: { ...selectedElement.styles, borderRadius: e.target.value }
                          }, selectedElementContext?.isInZone, selectedElementContext?.layoutId, selectedElementContext?.zoneId)}
                          placeholder="e.g., 8px, 50%, 0"
                          sx={{ mb: 1.5 }}
                        />


                      </Box>
                    )}
                  </Box>
                )}

                {/* Add Element Tab */}
                {tabValue === 2 && (
                  <Box>
                    <Box sx={{ mt: 2 }}>
                      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => addElement(ELEMENT_TYPES.HEADING)}
                          startIcon={<TitleIcon />}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#1976d2',
                            borderColor: '#1976d2',
                            fontSize: '0.65rem',
                            padding: '4px 2px',
                            minWidth: 0,
                            flexDirection: 'column',
                            '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
                          }}
                        >
                          ADD TITLE
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => addElement(ELEMENT_TYPES.TEXT)}
                          startIcon={<TextIcon />}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#1976d2',
                            borderColor: '#1976d2',
                            fontSize: '0.65rem',
                            padding: '4px 2px',
                            minWidth: 0,
                            flexDirection: 'column',
                            '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
                          }}
                        >
                          ADD TEXT
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => addElement(ELEMENT_TYPES.MEDIA)}
                          startIcon={<VideoIcon />}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#1976d2',
                            borderColor: '#1976d2',
                            fontSize: '0.65rem',
                            padding: '4px 2px',
                            minWidth: 0,
                            flexDirection: 'column',
                            '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
                          }}
                        >
                          ADD MEDIA
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => addElement(ELEMENT_TYPES.BUTTON)}
                          startIcon={<ShoppingCartIcon />}
                          sx={{
                            textTransform: 'none',
                            color: '#1976d2',
                            borderColor: '#1976d2',
                            fontSize: '0.65rem',
                            padding: '4px 2px',
                            minWidth: 0,
                            flexDirection: 'column',
                            '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
                          }}
                        >
                          insert button
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => addElement(ELEMENT_TYPES.CUSTOM_LIST)}
                          startIcon={<ListIcon />}
                          sx={{
                            textTransform: 'none',
                            color: '#1976d2',
                            borderColor: '#1976d2',
                            fontSize: '0.65rem',
                            padding: '4px 2px',
                            minWidth: 0,
                            flexDirection: 'column',
                            '& .MuiButton-startIcon': { margin: 0, mb: 0.5 }
                          }}
                        >
                          insert bullets
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {/* Fourth Column - Saved Offer Elements */}
            {!isMobile && selectedBrand && selectedOffer && (
              <Box sx={{
                width: 220, // Reduced from 300 to 220
                flexShrink: 0,
                borderLeft: '1px solid #e0e0e0',
                backgroundColor: '#f9f9f9',
                overflow: 'auto',
                p: 1.5,
                height: '110vh'
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                  <Typography variant="h6" sx={{
                    fontWeight: 600,
                    color: 'primary.main'
                  }}>
                    💾 Saved Items
                  </Typography>
                  {/* {(selectedBrand || selectedOffer) && (
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        setSelectedBrand('');
                        setSelectedOffer('');
                        setOffers([]);
                      }}
                      sx={{ fontSize: '0.7rem' }}
                    >
                      Clear Filter
                    </Button>
                  )} */}
                </Box>

                {(() => {
                  console.log('🎨 Rendering saved elements display:', {
                    filteredCount: filteredSavedElements.length,
                    totalCount: savedOfferElements.length,
                    selectedBrand,
                    selectedOffer,
                    filteredElements: filteredSavedElements.map(el => ({ id: el._id, name: el.name, brandId: el.brandId, offerId: el.offerId })),
                    actualElementsBeingRendered: filteredSavedElements.length,
                    forceRender
                  });
                  console.log('🎨 filteredSavedElements state:', filteredSavedElements);
                  console.log('🎨 About to render:', filteredSavedElements.length === 0 ? 'EMPTY STATE' : `${filteredSavedElements.length} ELEMENTS`);
                  console.log('🎨 DEBUG: What items are being rendered:', filteredSavedElements.map(el => `${el.name} (${el.brandId}/${el.offerId})`));
                  console.log('🎨 DEBUG: Current selectedBrand:', selectedBrand, 'selectedOffer:', selectedOffer);
                  console.log('🎨 DEBUG: State update timestamp:', Date.now());
                  console.log('🎨 DEBUG: Force render count:', forceRender);
                  return filteredSavedElements.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {savedOfferElements.length === 0 ? 'No saved items yet' : 'No items match the selected brand/offer'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {savedOfferElements.length === 0
                          ? 'Save individual elements or entire templates for reuse'
                          : 'Try selecting a different brand or offer, or clear the selection'
                        }
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 1.5 }}>
                      {filteredSavedElements.map((element) => (
                        <Box
                          key={element._id}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            width: '100%',
                            backgroundColor: 'background.paper',
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            p: 0.5
                          }}
                        >
                          <Button
                            variant="outlined"
                            size="small"
                            fullWidth
                            onClick={() => loadSavedElement(element)}
                            startIcon={element.type === 'template' && element.properties?.isTemplate ? <TemplateIcon /> : <AddIcon />}
                            color={element.type === 'template' && element.properties?.isTemplate ? 'primary' : 'inherit'}
                            sx={{
                              py: 0.75,
                              px: 1.5,
                              flex: 1,
                              minWidth: 0,
                              textTransform: 'none',
                              justifyContent: 'flex-start'
                            }}
                          >
                            {element.name}
                          </Button>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setRenameElementId(element._id);
                              setRenameElementValue(element.name);
                              setShowRenameDialog(true);
                            }}
                            sx={{
                              color: 'primary.main',
                              '&:hover': {
                                backgroundColor: 'primary.light',
                                color: 'primary.contrastText'
                              }
                            }}
                            title="Rename saved item"
                          >
                            <EditIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setConfirmDialogTitle('Delete Saved Item');
                              setConfirmDialogMessage(`Are you sure you want to delete "${element.name}"?`);
                              setConfirmAction(() => () => {
                                deleteSavedElement(element._id);
                              });
                              setShowConfirmDialog(true);
                            }}
                            sx={{
                              color: 'error.main',
                              '&:hover': {
                                backgroundColor: 'error.light',
                                color: 'error.contrastText'
                              }
                            }}
                            title="Delete saved item"
                          >
                            <DeleteIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  );
                })()}
              </Box>
            )}

          </Box>

        </Box>

        {/* Mobile Toolbar */}
        {isMobile && <MobileToolbar />}
      </Box >

      {/* Layout Selector Dialog */}
      < Dialog
        open={showLayoutSelector}
        onClose={() => {
          console.log('❌ Layout selector dialog closed');
          setShowLayoutSelector(false);
          setTargetZone(null); // Clear target zone on close
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          📐 Choose a Layout {targetZone ? '(Nested Layout)' : ''}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            {targetZone
              ? 'Select a layout structure to nest inside the current layout zone'
              : 'Select a layout structure, then drag elements into the zones'
            }
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 1.5 }}>
            {Object.entries(LAYOUT_CONFIGS).slice(0, 5).map(([layoutType, config]) => (
              <Paper
                key={layoutType}
                elevation={1}
                sx={{
                  p: 1.5,
                  cursor: 'pointer',
                  border: '2px solid transparent',
                  '&:hover': {
                    borderColor: '#1976d2',
                    backgroundColor: '#f5f5f5'
                  }
                }}
                onClick={() => addLayout(layoutType)}
              >
                <Typography variant="h6" gutterBottom>
                  {config.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                  {config.description}
                </Typography>

                {/* Visual representation */}
                <Box sx={{
                  display: 'flex',
                  gap: 1,
                  height: '60px',
                  flexWrap: layoutType === LAYOUT_TYPES.THREE_COLUMN ? 'wrap' : 'nowrap'
                }}>
                  {config.zones.map((zone, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: zone.width,
                        height: zone.height || '100%',
                        backgroundColor: '#e3f2fd',
                        border: '1px dashed #1976d2',
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography variant="caption" color="primary">
                        Zone {index + 1}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setShowLayoutSelector(false);
            setTargetZone(null); // Clear target zone on cancel
          }}>Cancel</Button>
        </DialogActions>
      </Dialog >

      {/* Save Element Dialog */}
      < Dialog
        open={showSaveElementDialog}
        onClose={() => {
          setShowSaveElementDialog(false);
          setCurrentElementName('');
          setIsUpdatingElement(false);
          setSelectedSavedElementId(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {isUpdatingElement ? '✏️ Update Saved Item' : '💾 Save for Reuse'}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            {isUpdatingElement
              ? 'Update the selected saved item with current modifications'
              : 'Choose what to save for reuse in other designs'
            }
          </Typography>



          {/* Preview Section */}
          {elements.length > 0 && (
            <Box sx={{ mb: 1.5, p: 1.5, backgroundColor: '#e8f5e8', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                Offer Elements Preview: {elements.length} Elements
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {elements.map(el => el.type).join(', ')}
              </Typography>
            </Box>
          )}



          <TextField
            fullWidth
            label="Offer Elements Name"
            value={currentElementName}
            onChange={(e) => setCurrentElementName(e.target.value)}
            placeholder="e.g., Complete Product Landing Page, Hero Section Elements"
            sx={{ mb: 1.5 }}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setShowSaveElementDialog(false);
            setCurrentElementName('');
            setIsUpdatingElement(false);
            setSelectedSavedElementId(null);
            setSaveType('template'); // Reset to default
          }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={saveCurrentElement}
            disabled={
              !currentElementName.trim() ||
              elements.length === 0
            }
          >
            {isUpdatingElement
              ? 'Update Saved Item'
              : 'Save Offer Elements'
            }
          </Button>
        </DialogActions>
      </Dialog >

      {/* Brand/Offer Validation Dialog */}
      < Dialog
        open={showBrandOfferAlert}
        onClose={() => setShowBrandOfferAlert(false)}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" /> Missing Information
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            ⚠️ Please select both a brand and offer before saving an element.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This helps organize your saved elements properly in the library.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowBrandOfferAlert(false)} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog >

      {/* Template Loading Validation Dialog */}
      < Dialog
        open={showLoadTemplateAlert}
        onClose={() => setShowLoadTemplateAlert(false)}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" /> Template Interaction
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {loadTemplateError || 'Please select a template first.'}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLoadTemplateAlert(false)} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog >

      {/* Replace Content Confirmation Dialog */}
      < Dialog
        open={showReplaceConfirm}
        onClose={() => setShowReplaceConfirm(false)}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" /> Replace Content?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            This will load "{pendingTemplateData?.name}" with {pendingTemplateData?.elements?.length} elements.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, fontWeight: 500, color: 'error.main' }}>
            Warning: This will replace your current editor content. Do you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowReplaceConfirm(false)}>Cancel</Button>
          <Button
            onClick={() => {
              const data = pendingTemplateData;
              if (!data) return;

              const newElements = data.elements.map(element => ({
                ...element,
                id: Date.now() + Math.random()
              }));

              setElements(newElements);

              if (data.pagination && data.pagination.enabled) {
                const savedPagination = data.pagination;
                const reconstructedPages = [];
                let elementIndex = 0;

                for (let i = 0; i < savedPagination.pages.length; i++) {
                  const pageInfo = savedPagination.pages[i];
                  const pageElements = newElements.slice(elementIndex, elementIndex + pageInfo.elementCount);
                  reconstructedPages.push({ id: pageInfo.id, elements: pageElements });
                  elementIndex += pageInfo.elementCount;
                }

                setPages(reconstructedPages);
                setCurrentPageIndex(savedPagination.currentPageIndex || 0);
                setNextPageId(Math.max(...reconstructedPages.map(p => p.id)) + 1);
                setPaginationEnabled(true);
              } else {
                setPages([{ id: 1, elements: newElements }]);
                setCurrentPageIndex(0);
                setNextPageId(2);
                setPaginationEnabled(false);
              }

              if (data.pageSettings) setPageSettings(data.pageSettings);
              setSelectedSavedElementId(data.id);
              setCurrentElementName(data.name);
              setIsUpdatingElement(true);
              setShowReplaceConfirm(false);
              setPendingTemplateData(null);
            }}
            variant="contained"
            color="error"
          >
            Yes, Replace
          </Button>
        </DialogActions>
      </Dialog >

      <Dialog
        open={showStatusAlert}
        onClose={() => setShowStatusAlert(false)}
        PaperProps={{
          sx: { borderRadius: 3, p: 1, minWidth: 300 }
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, fontWeight: 'bold' }}>
          {statusTitle === 'Success' ? <VerifiedIcon color="success" /> : (statusTitle === 'Error' || statusTitle === 'Error Saving' ? <CloseIcon color="error" /> : (statusTitle === 'Missing Information' || statusTitle === 'Missing Thumbnails' ? <WarningIcon color="warning" /> : <InfoIcon color="primary" />))}
          {statusTitle}
        </DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', color: 'text.secondary' }}>
            {statusMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={() => setShowStatusAlert(false)}
            variant="contained"
            color="primary"
            sx={{ px: 3, borderRadius: 2 }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        PaperProps={{
          sx: { borderRadius: 3, p: 1, minWidth: 320 }
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, fontWeight: 'bold' }}>
          <WarningIcon sx={{ color: '#ff9800' }} /> {confirmDialogTitle}
        </DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {confirmDialogMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={() => setShowConfirmDialog(false)}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (confirmAction) confirmAction();
              setShowConfirmDialog(false);
            }}
            variant="contained"
            color="primary"
            sx={{ px: 3, borderRadius: 2 }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Rename Dialog */}
      <Dialog
        open={showRenameDialog}
        onClose={() => setShowRenameDialog(false)}
        PaperProps={{
          sx: { borderRadius: 3, p: 1, minWidth: 400 }
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, fontWeight: 'bold' }}>
          <EditIcon color="primary" /> Rename Saved Item
        </DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            Enter a new name for this saved element:
          </Typography>
          <TextField
            autoFocus
            fullWidth
            variant="outlined"
            size="medium"
            value={renameElementValue}
            onChange={(e) => setRenameElementValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && renameElementValue.trim()) {
                renameSavedElement(renameElementId, renameElementValue);
                setShowRenameDialog(false);
              }
            }}
            placeholder="Enter element name"
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={() => setShowRenameDialog(false)}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              renameSavedElement(renameElementId, renameElementValue);
              setShowRenameDialog(false);
            }}
            variant="contained"
            color="primary"
            disabled={!renameElementValue.trim()}
            sx={{ px: 3, borderRadius: 2 }}
          >
            Rename
          </Button>
        </DialogActions>
      </Dialog>

      {/* Prompt Dialog */}
      <Dialog
        open={showPromptDialog}
        onClose={() => setShowPromptDialog(false)}
      >
        <DialogTitle>{promptDialogTitle}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>{promptDialogMessage}</Typography>
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            variant="outlined"
            size="small"
            value={promptDialogValue}
            onChange={(e) => setPromptDialogValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (promptAction) promptAction(promptDialogValue);
                setShowPromptDialog(false);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowPromptDialog(false)}>Cancel</Button>
          <Button
            onClick={() => {
              if (promptAction) promptAction(promptDialogValue);
              setShowPromptDialog(false);
            }}
            variant="contained"
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Save Template Dialog */}
      <Dialog
        open={showSaveDialog}
        onClose={() => setShowSaveDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {currentTemplateId ? '📝 Update Template' : '💾 Save Template'}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            {currentTemplateId ? 'Update your template with the current page design' : 'Save your current page design as a reusable template'}
          </Typography>
          <Typography variant="body2" color="primary" sx={{ mb: 1.5, fontWeight: 500 }}>
            💡 Select a type and subtype to organize your template for easy discovery in the Brands section
          </Typography>
          <TextField
            fullWidth
            label="Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            placeholder="e.g., Product Launch Page"
            sx={{ mb: 1.5 }}
          />
          <FormControl fullWidth sx={{ mb: 1.5 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={templateType}
              onChange={(e) => setTemplateType(e.target.value)}
              label="Type"
            >
              {Object.keys(TEMPLATE_TYPE_OPTIONS).map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 1.5 }} disabled={!templateType}>
            <InputLabel>Subtype</InputLabel>
            <Select
              value={templateSubtype}
              onChange={(e) => setTemplateSubtype(e.target.value)}
              label="Subtype"
            >
              {templateType && TEMPLATE_TYPE_OPTIONS[templateType] ?
                TEMPLATE_TYPE_OPTIONS[templateType].map((subtype) => (
                  <MenuItem key={subtype} value={subtype}>
                    {subtype}
                  </MenuItem>
                )) : []
              }
            </Select>
          </FormControl>
          <Typography variant="body2" color="text.secondary">
            This template will include {elements.length} elements and your page settings.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowSaveDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={saveTemplate}
            disabled={!templateName.trim() || !templateType || !templateSubtype}
            title={!templateName.trim() ? 'Enter template name' : !templateType ? 'Select template type' : !templateSubtype ? 'Select template subtype' : 'Save template'}
          >
            {currentTemplateId ? 'Update Template' : 'Save Template'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Templates List Dialog */}
      <Dialog
        open={showTemplatesList}
        onClose={() => setShowTemplatesList(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          📋 Load Template
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            Choose a template to load. This will replace your current design.
          </Typography>

          {/* Pre-built templates section */}
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              🎨 Pre-built Templates
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 1.5 }}>
              {preBuiltTemplates.map((template) => (
                <Button
                  key={template.id}
                  variant="outlined"
                  size="small"
                  fullWidth
                  onClick={() => loadPreBuiltTemplate(template)}
                  startIcon={<TemplateIcon />}
                  color="primary"
                  sx={{ py: 0.75, px: 1.5 }}
                >
                  {template.name}
                </Button>
              ))}
            </Box>
          </Box>

          {/* Divider */}
          <Divider sx={{ mb: 1.5 }}>
            <Typography variant="body2" color="text.secondary">
              Your Saved Templates
            </Typography>
          </Divider>

          {savedTemplates.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 2 }}>
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No templates saved yet
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create your first template by designing a page and clicking "Save Template"
              </Typography>
            </Box>
          ) : (
            (() => {
              const groupedTemplates = groupTemplatesByType(savedTemplates);
              return (
                <Box>
                  {Object.entries(groupedTemplates).map(([type, subtypes]) => {
                    const totalTemplates = Object.values(subtypes).reduce((sum, templates) => sum + templates.length, 0);
                    return (
                      <Accordion key={type} defaultExpanded sx={{ mb: 1.5 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            variant="h6"
                            sx={{
                              color: 'primary.main',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1
                            }}
                          >
                            📁 {type} Templates ({totalTemplates})
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box>
                            {Object.entries(subtypes).map(([subtype, templates]) => (
                              <Box key={subtype} sx={{ mb: 1.5 }}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    mb: 1.5,
                                    color: 'text.primary',
                                    fontWeight: 500,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    pl: 1
                                  }}
                                >
                                  📂 {subtype} ({templates.length})
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, pl: 2 }}>
                                  {templates.map((template) => (
                                    <Paper
                                      key={template._id}
                                      elevation={1}
                                      sx={{
                                        p: 1.5,
                                        cursor: 'pointer',
                                        border: '2px solid transparent',
                                        '&:hover': {
                                          borderColor: '#1976d2',
                                          backgroundColor: '#f5f5f5'
                                        }
                                      }}
                                    >
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                        <Typography variant="h6" sx={{ flexGrow: 1 }}>
                                          {template.name}
                                        </Typography>
                                        <IconButton
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            deleteTemplate(template._id);
                                          }}
                                          sx={{ color: 'error.main' }}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </Box>

                                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                                        {template.description}
                                      </Typography>

                                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                                        Created: {new Date(template.createdAt).toLocaleDateString()}
                                      </Typography>

                                      <Button
                                        variant="contained"
                                        size="small"
                                        fullWidth
                                        onClick={() => loadTemplate(template._id)}
                                        sx={{ py: 0.75, px: 1.5 }}
                                      >
                                        Load Template
                                      </Button>
                                    </Paper>
                                  ))}
                                </Box>
                              </Box>
                            ))}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </Box>
              );
            })()
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowTemplatesList(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box >



  );
});

export default OfferPageBuilderSimple;